export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
};

export type ActivateHeadAgreementResult = ActivateHeadAgreementSuccessResult | ErrorResult;

export type ActivateHeadAgreementSuccessResult = {
  __typename?: 'ActivateHeadAgreementSuccessResult';
  headAgreement: HeadAgreement;
};

export type ActivateMultiLegAgreementInput = {
  id: Scalars['ID']['input'];
  rowVersion: Scalars['String']['input'];
};

export type ActivateRouteAgreementInput = {
  id: Scalars['ID']['input'];
  rowVersion: Scalars['String']['input'];
};

export type ActualPriceChangeSearchRoot = {
  __typename?: 'ActualPriceChangeSearchRoot';
  calculateActualPriceChange: Maybe<Scalars['Float']['output']>;
};


export type ActualPriceChangeSearchRootCalculateActualPriceChangeArgs = {
  additionalFrom: Scalars['Float']['input'];
  avgGrossPrice: InputMaybe<Scalars['Float']['input']>;
  avgLength: InputMaybe<Scalars['Float']['input']>;
  meterPrice: Scalars['Float']['input'];
  newPrice: Scalars['Float']['input'];
  oldAdditionalFrom: InputMaybe<Scalars['Float']['input']>;
  oldFixPrice: InputMaybe<Scalars['Float']['input']>;
  oldVarPrice: InputMaybe<Scalars['Float']['input']>;
};

export type AddCustomerParentInput = {
  customerNo: Scalars['Int']['input'];
  parentCustomerNo: Scalars['Int']['input'];
  /** yyyy-MM-dd. */
  validFrom: Scalars['String']['input'];
};

export type AdditionalCharges = {
  __typename?: 'AdditionalCharges';
  additionalChargeType: Maybe<Scalars['String']['output']>;
  createdBy: Maybe<Scalars['String']['output']>;
  createdDate: Maybe<Scalars['String']['output']>;
  currency: Maybe<Scalars['String']['output']>;
  fileName: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  seaArea: Maybe<PartialSeaArea>;
  validFrom: Maybe<Scalars['String']['output']>;
};

export type AdditionalChargesMutationRoot = {
  __typename?: 'AdditionalChargesMutationRoot';
  deleteAdditionalCharges: DeleteAdditionalChargesResult;
};


export type AdditionalChargesMutationRootDeleteAdditionalChargesArgs = {
  additionalCharges: Array<Scalars['String']['input']>;
};

export type AdditionalChargesSearchRoot = {
  __typename?: 'AdditionalChargesSearchRoot';
  all: Array<AdditionalCharges>;
};

export type AdminTarget = {
  __typename?: 'AdminTarget';
  id: Scalars['ID']['output'];
  offPeakAcc: Maybe<Scalars['Float']['output']>;
  offPeakUnAcc: Maybe<Scalars['Float']['output']>;
  peakAcc: Maybe<Scalars['Float']['output']>;
  peakUnAcc: Maybe<Scalars['Float']['output']>;
  routePair: RoutePair;
  routePairCode: Scalars['String']['output'];
  shoulderAcc: Maybe<Scalars['Float']['output']>;
  shoulderUnAcc: Maybe<Scalars['Float']['output']>;
  volumeTarget: Maybe<Scalars['Float']['output']>;
  year: Scalars['Int']['output'];
};

export type AdminTargetMutationRoot = {
  __typename?: 'AdminTargetMutationRoot';
  updateGroupFreightTargets: UpdateGroupFreightTargetSuccessResult;
};


export type AdminTargetMutationRootUpdateGroupFreightTargetsArgs = {
  input: Array<UpdateGroupFreightTargetInput>;
};

export type AgrRouteSailingTypes = {
  __typename?: 'AgrRouteSailingTypes';
  code: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  dateCreated: Scalars['String']['output'];
  dateModified: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  modifiedBy: Scalars['String']['output'];
  notValidDate: Maybe<Scalars['String']['output']>;
  presentationOrder: Scalars['Int']['output'];
};

export type AgrRouteSailingTypesSearchRoot = {
  __typename?: 'AgrRouteSailingTypesSearchRoot';
  all: Array<AgrRouteSailingTypes>;
  byId: Maybe<AgrRouteSailingTypes>;
};


export type AgrRouteSailingTypesSearchRootByIdArgs = {
  id: Scalars['ID']['input'];
};

export type AgreedVolumePerformance = {
  __typename?: 'AgreedVolumePerformance';
  agreedVolume: Scalars['Int']['output'];
  performanceInPercent: Scalars['Float']['output'];
  routePairCode: Scalars['String']['output'];
  shippedVolume: Scalars['Int']['output'];
};

export type AgreedVolumePerformanceResult = {
  __typename?: 'AgreedVolumePerformanceResult';
  performanceByRouteCode: Array<AgreedVolumePerformance>;
};

export type AgreedVolumeSummary = {
  __typename?: 'AgreedVolumeSummary';
  agreedVolume: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  routePairCode: Scalars['String']['output'];
  routePairDescription: Scalars['String']['output'];
};

export type AgreedVolumeSummaryResult = {
  __typename?: 'AgreedVolumeSummaryResult';
  volumes: Array<AgreedVolumeSummary>;
};

export type AgreementArticlePriceChangesInput = {
  agrRouteArticleId?: InputMaybe<OptionalStringInput>;
  agrRouteArticlePriceId?: InputMaybe<OptionalStringInput>;
  agrRouteArticlePriceValidityId?: InputMaybe<OptionalStringInput>;
  agrRouteName?: InputMaybe<OptionalStringInput>;
  agrRouteValidFrom?: InputMaybe<OptionalStringInput>;
  agrRouteValidTo?: InputMaybe<OptionalStringInput>;
  articleCode?: InputMaybe<OptionalStringInput>;
  currencyCode?: InputMaybe<OptionalStringInput>;
  distanceTypeCode?: InputMaybe<OptionalStringInput>;
  distanceTypeDescription?: InputMaybe<OptionalStringInput>;
  lengthFrom?: InputMaybe<OptionalFloatInput>;
  lengthTo?: InputMaybe<OptionalFloatInput>;
  price?: InputMaybe<RequiredPriceInput>;
  routeDescription?: InputMaybe<OptionalStringInput>;
  routePairCode?: InputMaybe<OptionalStringInput>;
  routePairDescription?: InputMaybe<OptionalStringInput>;
  sailingTypesString?: InputMaybe<OptionalStringInput>;
  validFrom?: InputMaybe<RequiredStringInput>;
  vehicleTypeCode?: InputMaybe<OptionalStringInput>;
  vehicleTypeDescription?: InputMaybe<OptionalStringInput>;
  weightFrom?: InputMaybe<OptionalFloatInput>;
  weightTo?: InputMaybe<OptionalFloatInput>;
};

export type AgreementArticlesChanges = {
  created: Array<CreateAgreementArticlePriceItemInput>;
  deleted?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  updated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type AgreementDocumentMutationRoot = {
  __typename?: 'AgreementDocumentMutationRoot';
  deleteAgreementDocument: DeleteAgreementDocumentResult;
  deleteRebateAgreementDocument: DeleteAgreementDocumentResult;
};


export type AgreementDocumentMutationRootDeleteAgreementDocumentArgs = {
  customerNumber: Scalars['Int']['input'];
  documentId: Scalars['ID']['input'];
};


export type AgreementDocumentMutationRootDeleteRebateAgreementDocumentArgs = {
  customerNumber: Scalars['Int']['input'];
  documentId: Scalars['ID']['input'];
};

export type AgreementDocuments = {
  __typename?: 'AgreementDocuments';
  agreementDocumentType: Scalars['String']['output'];
  agreementId: Scalars['String']['output'];
  agreementValidFromDate: Scalars['String']['output'];
  agreementValidToDate: Scalars['String']['output'];
  customerNumber: Scalars['Int']['output'];
  fileName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  negotiationYear: Scalars['Int']['output'];
  writeHistory: WriteHistory;
};

export type AgreementDocumentsSearchRoot = {
  __typename?: 'AgreementDocumentsSearchRoot';
  agreementDocumentsByCustomerNo: Array<AgreementDocuments>;
  rebateAgreementDocumentsByCustomerNo: Array<RebateAgreementDocuments>;
};


export type AgreementDocumentsSearchRootAgreementDocumentsByCustomerNoArgs = {
  id: Scalars['ID']['input'];
};


export type AgreementDocumentsSearchRootRebateAgreementDocumentsByCustomerNoArgs = {
  id: Scalars['ID']['input'];
};

export type AgreementFlags = {
  __typename?: 'AgreementFlags';
  useReportMessageSubscription: Scalars['Boolean']['output'];
};

export type AgreementText = {
  __typename?: 'AgreementText';
  headAgreement: HeadAgreement;
  text: Scalars['String']['output'];
  typeCode: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type AgreementTexts = {
  __typename?: 'AgreementTexts';
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  value: Scalars['String']['output'];
};

export type AgreementTextsSearchRoot = {
  __typename?: 'AgreementTextsSearchRoot';
  byAgreementTextCodes: Array<AgreementTexts>;
};


export type AgreementTextsSearchRootByAgreementTextCodesArgs = {
  codes: Array<Scalars['ID']['input']>;
};

export type AncillaryChargeV2 = {
  __typename?: 'AncillaryChargeV2';
  ancillaryCode: Scalars['String']['output'];
  ancillaryPrice: Scalars['Float']['output'];
  ancillaryVatAmount: Maybe<Scalars['Float']['output']>;
  ancillaryVatRate: Maybe<Scalars['Float']['output']>;
  quantity: Scalars['Int']['output'];
};

export type AncillaryRecordV2 = {
  ancillaryCode: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
};

export type ArticleItemChangesInput = {
  articleTypeId?: InputMaybe<RequiredIdInput>;
  formulaData?: InputMaybe<RequiredFormulaDataFormInput>;
  formulaTypeId?: InputMaybe<OptionalIdInput>;
  includedInPrice?: InputMaybe<RequiredBooleanInput>;
  maxNumberOf?: InputMaybe<OptionalIntInput>;
  maxPrice?: InputMaybe<OptionalPriceInput>;
  prices: ArticlePriceInput;
};

export type ArticlePrice = {
  __typename?: 'ArticlePrice';
  id: Scalars['ID']['output'];
  lengthFrom: Maybe<Scalars['Float']['output']>;
  lengthTo: Maybe<Scalars['Float']['output']>;
  percent: Maybe<Scalars['Float']['output']>;
  price: Price;
  rowVersion: Scalars['String']['output'];
  vehicleType: Maybe<VehicleType>;
  weightFrom: Maybe<Scalars['Float']['output']>;
  weightTo: Maybe<Scalars['Float']['output']>;
};

export type ArticlePriceChangesInput = {
  lengthFrom?: InputMaybe<RequiredFloatInput>;
  lengthTo?: InputMaybe<RequiredFloatInput>;
  percent?: InputMaybe<OptionalFloatInput>;
  price?: InputMaybe<RequiredPriceInput>;
  vehicleTypeId?: InputMaybe<OptionalIdInput>;
  weightFrom?: InputMaybe<RequiredIntInput>;
  weightTo?: InputMaybe<RequiredIntInput>;
};

export type ArticlePriceInput = {
  created: Array<ArticlePriceChangesInput>;
  deleted: Array<DeleteArticlePriceInput>;
  updated: Array<UpdateArticlePriceInput>;
};

export type ArticlePriceValidity = {
  __typename?: 'ArticlePriceValidity';
  agrRouteArticlePriceId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  percentage: Maybe<Scalars['Float']['output']>;
  price: Maybe<Scalars['Float']['output']>;
  validFrom: Maybe<Scalars['String']['output']>;
};

export type ArticleType = {
  __typename?: 'ArticleType';
  cashScreen: Scalars['String']['output'];
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  includeInAgreement: Maybe<Scalars['String']['output']>;
  longDescription: Scalars['String']['output'];
  name: Scalars['String']['output'];
  needsPricingData: Scalars['Boolean']['output'];
  notValidDate: Maybe<Scalars['String']['output']>;
  shortDescription: Scalars['String']['output'];
  tax: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  updatable: Maybe<Scalars['Boolean']['output']>;
  usageCode: Maybe<Scalars['String']['output']>;
  usesPercent: Scalars['Boolean']['output'];
  writeHistory: WriteHistory;
};

export type ArticleTypeSearchRoot = {
  __typename?: 'ArticleTypeSearchRoot';
  all: Array<ArticleType>;
  ancillaries: Array<ArticleType>;
  byId: Maybe<ArticleType>;
};


export type ArticleTypeSearchRootByIdArgs = {
  id: Scalars['ID']['input'];
};

export type ArticlesFormInput = {
  created: Array<ArticleItemChangesInput>;
  deleted: Array<DeleteArticleItemInput>;
  updated: Array<UpdateArticleItemInput>;
};

export type AverageMeterPricesData = {
  __typename?: 'AverageMeterPricesData';
  averageMeterPriceDiffInPercentFromPreviousYear: Maybe<Scalars['Float']['output']>;
  averageMeterPriceDiffInPercentFromPreviousYearMinus1: Maybe<Scalars['Float']['output']>;
  averageMeterPriceDiffInPercentFromPreviousYearMinus2: Maybe<Scalars['Float']['output']>;
  averageMeterPriceRequestedYear: Maybe<Scalars['Float']['output']>;
  averageMeterPriceRequestedYearMinus1: Maybe<Scalars['Float']['output']>;
  averageMeterPriceRequestedYearMinus2: Maybe<Scalars['Float']['output']>;
};

export type BackendVersion = {
  __typename?: 'BackendVersion';
  version: Scalars['String']['output'];
};

export type BookingArticle = {
  __typename?: 'BookingArticle';
  articleCode: Scalars['String']['output'];
  articleType: ArticleType;
  id: Scalars['ID']['output'];
  quantity: Scalars['Int']['output'];
};

export type BookingGoods = {
  __typename?: 'BookingGoods';
  description: Scalars['String']['output'];
  goodsCode: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  version: Scalars['Int']['output'];
  weight: Scalars['Int']['output'];
};

export type BookingVersion = {
  __typename?: 'BookingVersion';
  versions: Array<Scalars['Int']['output']>;
};

export type BookingVersionsSearchRoot = {
  __typename?: 'BookingVersionsSearchRoot';
  byId: Maybe<BookingVersion>;
};


export type BookingVersionsSearchRootByIdArgs = {
  id: Scalars['ID']['input'];
};

export type BookingsSearchRoot = {
  __typename?: 'BookingsSearchRoot';
  byId: Array<PriceCalculatorBooking>;
};


export type BookingsSearchRootByIdArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['Int']['input'];
};

export type BuildVersion = {
  __typename?: 'BuildVersion';
  backend: BackendVersion;
  frontend: FrontendVersion;
};

export enum BulkUpdateExpectedVolumesActionEnum {
  Copylast12Months = 'COPYLAST12MONTHS',
  Copylast12Monthsandadjust = 'COPYLAST12MONTHSANDADJUST',
  Settozero = 'SETTOZERO'
}

export type BulkUpdateExpectedVolumesInput = {
  action: BulkUpdateExpectedVolumesActionEnum;
  adjustBy?: InputMaybe<Scalars['Float']['input']>;
  customerNumbers: Array<Scalars['Int']['input']>;
  negotiationYear: Scalars['Int']['input'];
};

export type BulkUpdateExpectedVolumesResult = BulkUpdateExpectedVolumesSuccessResult | ErrorResult;

export type BulkUpdateExpectedVolumesSuccessResult = {
  __typename?: 'BulkUpdateExpectedVolumesSuccessResult';
  success: Scalars['Boolean']['output'];
};

export type ByPublicOverviewPeriodInput = {
  month: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};

export type CalculateActualPriceChangeForAllBulkEditRatesInput = {
  headAgreementId: Scalars['String']['input'];
  routeAgreementsByRoutePairCode: Array<RouteAgreementsByRoutePairCode>;
  validFromYear: Scalars['Int']['input'];
};

export type CalculateActualPriceChangeForAllRatesInput = {
  headAgreementId: Scalars['String']['input'];
  routeAgreements: Array<CalculatePriceRouteAgreementInput>;
  routePairCode: Scalars['String']['input'];
  validFromYear: Scalars['Int']['input'];
};

export type CalculatePriceRouteAgreementInput = {
  routeAgreementPrices: Array<CalculatePriceRouteAgreementPriceInput>;
  sailingTypeCodes: Array<Scalars['String']['input']>;
};

export type CalculatePriceRouteAgreementPriceInput = {
  actual?: InputMaybe<Scalars['Float']['input']>;
  additionalFrom?: InputMaybe<Scalars['Float']['input']>;
  avgGrossPrice?: InputMaybe<PriceInput>;
  avgLength?: InputMaybe<Scalars['Float']['input']>;
  avgRebate?: InputMaybe<PriceInput>;
  cargoStatusCode?: InputMaybe<CargoStatusCode>;
  lastChargedFrom?: InputMaybe<Scalars['Float']['input']>;
  lastMeterPrice?: InputMaybe<PriceInput>;
  lastPrice?: InputMaybe<PriceInput>;
  lengthFrom?: InputMaybe<Scalars['Float']['input']>;
  lengthTo?: InputMaybe<Scalars['Float']['input']>;
  meterPrice?: InputMaybe<PriceInput>;
  newPrice?: InputMaybe<PriceInput>;
  percent?: InputMaybe<Scalars['Float']['input']>;
  routeAgreementId: Scalars['ID']['input'];
  routeAgreementPriceId: Scalars['ID']['input'];
  routePairCode?: InputMaybe<Scalars['String']['input']>;
  sailingCategoryCode?: InputMaybe<SailingTypeCode>;
  unaccompanied?: InputMaybe<Scalars['Boolean']['input']>;
  vehicleTypeCode?: InputMaybe<Scalars['String']['input']>;
  volume?: InputMaybe<Scalars['Int']['input']>;
  weightFrom?: InputMaybe<Scalars['Float']['input']>;
  weightTo?: InputMaybe<Scalars['Float']['input']>;
};

export type CalculateThresholdData = {
  bookingNo: Scalars['Int']['input'];
  custNo: Scalars['Int']['input'];
};

export type CalculateThresholdErrorResult = {
  __typename?: 'CalculateThresholdErrorResult';
  errors: Array<ErrorDetail>;
};

export type CalculateThresholdInput = {
  bookings: Array<CalculateThresholdData>;
  month: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};

export type CalculateThresholdResult = CalculateThresholdErrorResult | CalculateThresholdSuccessResult;

export type CalculateThresholdSuccessResult = {
  __typename?: 'CalculateThresholdSuccessResult';
  success: Scalars['Boolean']['output'];
};

export enum CargoStatusCode {
  Both = 'BOTH',
  Empty = 'EMPTY',
  Loaded = 'LOADED'
}

export type ChangeMultiLegRouteAgreementStatusInput = {
  multiLegRouteAgreementId: Scalars['ID']['input'];
  rowVersion: Scalars['String']['input'];
  status: HeadAgreementStatusCode;
};

export type ChangeMultiLegRouteAgreementWorkFlowStatusInput = {
  multiLegRouteAgreementId: Scalars['ID']['input'];
  rowVersion: Scalars['String']['input'];
  workFlowStatusCode?: InputMaybe<WorkFlowStatusCode>;
};

export type ChildCustomersByStatusParam = {
  __typename?: 'ChildCustomersByStatusParam';
  allowedStatuses: Array<Scalars['String']['output']>;
  customerNumber: Scalars['String']['output'];
};

export type CodeNoShowLateHandlingType = {
  __typename?: 'CodeNoShowLateHandlingType';
  code: Scalars['String']['output'];
  dateCreated: Scalars['String']['output'];
  dateModified: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  modifiedBy: Maybe<Scalars['String']['output']>;
  notValidDate: Maybe<Scalars['String']['output']>;
  presentationOrder: Scalars['Int']['output'];
};

export type CodeNoShowLateType = {
  __typename?: 'CodeNoShowLateType';
  code: Scalars['String']['output'];
  dateCreated: Scalars['String']['output'];
  dateModified: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  modifiedBy: Maybe<Scalars['String']['output']>;
  notValidDate: Maybe<Scalars['String']['output']>;
  presentationOrder: Scalars['Int']['output'];
};

export type ConditionsFormInput = {
  countryReceiver?: InputMaybe<RequiredStringArrayInput>;
  countrySender?: InputMaybe<RequiredStringArrayInput>;
  goods?: InputMaybe<RequiredStringArrayInput>;
  standby?: InputMaybe<RequiredBooleanInput>;
  transit?: InputMaybe<RequiredBooleanInput>;
};

export type Consignment = {
  __typename?: 'Consignment';
  agrRouteId: Maybe<Scalars['String']['output']>;
  altSailDate: Maybe<Scalars['String']['output']>;
  altSailRouteCode: Maybe<Scalars['String']['output']>;
  altSailTime: Maybe<Scalars['String']['output']>;
  auctionPrice: Maybe<Scalars['String']['output']>;
  bookedRouteDateTime: Scalars['String']['output'];
  bookingLegNumber: Scalars['Int']['output'];
  bookingNum: Scalars['Int']['output'];
  cargoTransportUnit: Scalars['String']['output'];
  cash: Scalars['Boolean']['output'];
  checkedForRebate: Scalars['Boolean']['output'];
  checkinBy: Scalars['String']['output'];
  coastCancelledCode: Maybe<Scalars['String']['output']>;
  coastServiceId: Maybe<Scalars['String']['output']>;
  coastServiceVer: Scalars['Int']['output'];
  consignmentAddresses: Array<ConsignmentAddress>;
  consignmentArticles: Array<ConsignmentArticle>;
  consignmentGoods: Array<ConsignmentGoods>;
  consignmentHazardousGoods: Array<ConsignmentHazardousGoods>;
  consignmentLegInvoice: Maybe<ConsignmentLegInvoice>;
  consignmentLoadingPreferences: Array<ConsignmentLoadingPreference>;
  consignmentTradeVehicles: Array<ConsignmentTradeVehicle>;
  consignmentTypeCode: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  creditNoteAuthorizedBy: Maybe<Scalars['String']['output']>;
  custNo: Scalars['Int']['output'];
  customerReference: Maybe<Scalars['String']['output']>;
  dateCheckin: Scalars['String']['output'];
  dateCreated: Scalars['String']['output'];
  dateModified: Scalars['String']['output'];
  dateModifiedManual: Maybe<Scalars['String']['output']>;
  genericOwnerId: Scalars['String']['output'];
  hasPlugIn: Scalars['Boolean']['output'];
  hazardousGoods: Scalars['String']['output'];
  height: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  internalReasonCode: Maybe<Scalars['String']['output']>;
  invoiceCurrencyCode: Maybe<Scalars['String']['output']>;
  invoiceDate: Maybe<Scalars['String']['output']>;
  invoiceDueDate: Maybe<Scalars['String']['output']>;
  invoiceNum: Maybe<Scalars['Int']['output']>;
  lbSplitPercentageLeg1: Scalars['Int']['output'];
  lbSplitRouteCodeLeg2: Maybe<Scalars['String']['output']>;
  length: Scalars['Float']['output'];
  livestock: Scalars['Boolean']['output'];
  livestockType: Maybe<LiveStock>;
  manualPricing: Scalars['Boolean']['output'];
  modifiedBefFirstInv: Scalars['Boolean']['output'];
  modifiedBy: Scalars['String']['output'];
  modifiedByManual: Maybe<Scalars['String']['output']>;
  movementType: MovementType;
  multiLegBookingNumber: Scalars['Int']['output'];
  multiLegRoute: Maybe<Route>;
  notificationDate: Maybe<Scalars['String']['output']>;
  numOfAdults: Scalars['Int']['output'];
  numOfChildren: Scalars['Int']['output'];
  numOfDrivers: Scalars['Int']['output'];
  numOfFoc: Scalars['Int']['output'];
  numOfInfants: Scalars['Int']['output'];
  numOfPlugIn: Maybe<Scalars['Int']['output']>;
  numOfSleepers: Scalars['Int']['output'];
  numOfTradeVehicles: Scalars['Int']['output'];
  numOfVehicleTypeUnits: Scalars['Int']['output'];
  originCode: Scalars['String']['output'];
  pricingCurrencyCode: Maybe<Scalars['String']['output']>;
  qualifiedGoods: Scalars['Boolean']['output'];
  regDateTime: Scalars['String']['output'];
  sailingArchive: SailingArchive;
  standby: Scalars['Boolean']['output'];
  statusCode: Scalars['String']['output'];
  stdAgrRouteId: Maybe<Scalars['String']['output']>;
  timeOfAuthorization: Maybe<Scalars['String']['output']>;
  tirCarnetNo: Maybe<Scalars['String']['output']>;
  toBeAuthorized: Scalars['Boolean']['output'];
  trailerRegNo: Maybe<Scalars['String']['output']>;
  transToMis: Scalars['Boolean']['output'];
  transit: Scalars['Boolean']['output'];
  transmitToFinanceDate: Maybe<Scalars['String']['output']>;
  updatedByCss: Scalars['Boolean']['output'];
  vatCountryCode: Scalars['String']['output'];
  vatInternationalNo: Scalars['String']['output'];
  vatRegistered: Maybe<Scalars['String']['output']>;
  vehicleClassificationCode: Scalars['String']['output'];
  vehicleNationalityCode: Maybe<Scalars['String']['output']>;
  vehicleRegNo: Scalars['String']['output'];
  vehicleType: VehicleType;
  version: Scalars['Int']['output'];
  weight: Scalars['Float']['output'];
  width: Scalars['Float']['output'];
  xbookingOriginCode: Maybe<Scalars['String']['output']>;
};

export type ConsignmentAddress = {
  __typename?: 'ConsignmentAddress';
  address1: Maybe<Scalars['String']['output']>;
  address2: Maybe<Scalars['String']['output']>;
  addressTypeCode: Scalars['String']['output'];
  bookingNo: Scalars['Int']['output'];
  city: Maybe<Scalars['String']['output']>;
  countryCode: Maybe<Scalars['String']['output']>;
  county: Maybe<Scalars['String']['output']>;
  custNo: Scalars['Int']['output'];
  emailAddress: Maybe<Scalars['String']['output']>;
  futureBusinessPossible: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  idGuid: Scalars['String']['output'];
  multiple: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  postCode: Maybe<Scalars['String']['output']>;
  telNo: Maybe<Scalars['String']['output']>;
  vatCountryCode: Maybe<Scalars['String']['output']>;
  vatInternationalNo: Maybe<Scalars['String']['output']>;
  vatRegistered: Maybe<Scalars['String']['output']>;
  version: Scalars['Int']['output'];
};

export type ConsignmentArticle = {
  __typename?: 'ConsignmentArticle';
  account: Maybe<Scalars['String']['output']>;
  amount: Maybe<Scalars['Int']['output']>;
  articleCode: Scalars['String']['output'];
  articleType: ArticleType;
  bookingNo: Scalars['Int']['output'];
  department: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  idGuid: Scalars['String']['output'];
  product: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Int']['output'];
  route: Maybe<Route>;
  ship: Maybe<Scalars['String']['output']>;
  text: Maybe<Scalars['String']['output']>;
  version: Scalars['Int']['output'];
};

export type ConsignmentGoods = {
  __typename?: 'ConsignmentGoods';
  description: Scalars['String']['output'];
  goodsCode: Scalars['String']['output'];
  goodsUnitTypeCode: Maybe<Scalars['String']['output']>;
  hsGoodsCode: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  noOfUnits: Scalars['Int']['output'];
  weight: Scalars['Int']['output'];
};

export type ConsignmentHazardousGoods = {
  __typename?: 'ConsignmentHazardousGoods';
  ems: Maybe<Scalars['String']['output']>;
  flashPoint: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imdg: Scalars['String']['output'];
  imoClass: Scalars['String']['output'];
  limitedQuantity: Maybe<Scalars['String']['output']>;
  marinePollutant: Scalars['String']['output'];
  netExplosiveWeight: Maybe<Scalars['Float']['output']>;
  packGroup: Maybe<Scalars['String']['output']>;
  quantity: Maybe<Scalars['Int']['output']>;
  shippingName: Scalars['String']['output'];
  technicalName: Maybe<Scalars['String']['output']>;
  unCode: Scalars['String']['output'];
  unSuffix: Scalars['Int']['output'];
  waste: Maybe<Scalars['String']['output']>;
  weight: Maybe<Scalars['Int']['output']>;
};

export type ConsignmentLegInvoice = {
  __typename?: 'ConsignmentLegInvoice';
  bookingNo: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  invoiceNo: Scalars['Int']['output'];
  invoiceNoSuffix: Maybe<Scalars['Int']['output']>;
  legNo: Scalars['Int']['output'];
  vatRateCode: Scalars['String']['output'];
  version: Scalars['Int']['output'];
};

export type ConsignmentLoadingPreference = {
  __typename?: 'ConsignmentLoadingPreference';
  bookingNo: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  loadingPreferenceCode: Scalars['String']['output'];
  loadingPreferenceStatusCode: Scalars['String']['output'];
  version: Scalars['Int']['output'];
};

export type ConsignmentTradeVehicle = {
  __typename?: 'ConsignmentTradeVehicle';
  bookingNo: Scalars['Int']['output'];
  chassiNo: Scalars['String']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  idGuid: Scalars['String']['output'];
  version: Scalars['Int']['output'];
  weight: Maybe<Scalars['Int']['output']>;
};

export type ConsignmentVersion = {
  __typename?: 'ConsignmentVersion';
  versions: Array<Scalars['Int']['output']>;
};

export type ConsignmentVersionsSearchRoot = {
  __typename?: 'ConsignmentVersionsSearchRoot';
  byId: Maybe<ConsignmentVersion>;
};


export type ConsignmentVersionsSearchRootByIdArgs = {
  id: Scalars['ID']['input'];
};

export type ConsignmentsSearchRoot = {
  __typename?: 'ConsignmentsSearchRoot';
  byId: Array<Consignment>;
  byMultiLegId: Array<Consignment>;
};


export type ConsignmentsSearchRootByIdArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['Int']['input'];
};


export type ConsignmentsSearchRootByMultiLegIdArgs = {
  id: Scalars['ID']['input'];
};

export type CopyHeadAgreementInput = {
  condition?: InputMaybe<RequiredStringInput>;
  headAgreementId: Scalars['ID']['input'];
  includedMultiLegAgreements?: InputMaybe<Array<MultiLegAgreementWithValidity>>;
  includedRouteAgreements?: InputMaybe<Array<RouteAgreementWithValidity>>;
  internalNotes?: InputMaybe<RequiredStringInput>;
  lastPage?: InputMaybe<RequiredStringInput>;
  name?: InputMaybe<RequiredStringInput>;
  specifications?: InputMaybe<RequiredStringInput>;
  toCustNo?: InputMaybe<Scalars['Int']['input']>;
  toExistingHeaderAgreementId?: InputMaybe<Scalars['String']['input']>;
  valid: ValidDatesInput;
};

export type CopyMultiLegAgreementInput = {
  breakDate?: InputMaybe<DateInput>;
  headAgreementId: Scalars['ID']['input'];
  multiLegAgreementId: Scalars['ID']['input'];
  rowVersion: Scalars['String']['input'];
};

export type CopyMultiLegRouteAgreementErrorResult = {
  __typename?: 'CopyMultiLegRouteAgreementErrorResult';
  errors: Array<ErrorDetail>;
};

export type CopyMultiLegRouteAgreementResult = CopyMultiLegRouteAgreementSuccessResult | ErrorResult;

export type CopyMultiLegRouteAgreementSuccessResult = {
  __typename?: 'CopyMultiLegRouteAgreementSuccessResult';
  multiLegAgreement: MultiLegRouteAgreement;
};

export type CopyRouteAgreementInput = {
  breakDate?: InputMaybe<DateInput>;
  headAgreementId: Scalars['ID']['input'];
  routeAgreementId: Scalars['ID']['input'];
  rowVersion: Scalars['String']['input'];
};

export type CopyRouteAgreementResult = CopyRouteAgreementSuccessResult | ErrorResult;

export type CopyRouteAgreementSuccessResult = {
  __typename?: 'CopyRouteAgreementSuccessResult';
  routeAgreement: RouteAgreement;
};

export type Country = {
  __typename?: 'Country';
  code: Scalars['String']['output'];
  currency: Currency;
  id: Scalars['ID']['output'];
  isEuMember: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  salesRegion: SalesRegion;
};

export type CountrySearchRoot = {
  __typename?: 'CountrySearchRoot';
  all: Array<Country>;
  allActive: Array<Country>;
  byId: Maybe<Country>;
};


export type CountrySearchRootByIdArgs = {
  id: Scalars['ID']['input'];
};

export type CreateAgreementArticlePriceItemInput = {
  agrRouteArticleId?: InputMaybe<Scalars['ID']['input']>;
  agrRouteArticlePriceId?: InputMaybe<Scalars['ID']['input']>;
  agrRouteId: Scalars['ID']['input'];
  changes: AgreementArticlePriceChangesInput;
};

export type CreateAgreementReportInput = {
  additionalSurchargeIds: Array<Scalars['String']['input']>;
  agrRouteIds: Array<Scalars['String']['input']>;
  agreementId: Scalars['ID']['input'];
  includeArticle: Scalars['Boolean']['input'];
  includeCredLim: Scalars['Boolean']['input'];
  includeInternalNotes: Scalars['Boolean']['input'];
  includeMatrix: Scalars['Boolean']['input'];
  includeThreshold: Scalars['Boolean']['input'];
  multiLegAgrRouteIds: Array<Scalars['String']['input']>;
  pageBreakBeforeSeaAreaHeader: Scalars['Boolean']['input'];
  reportType: Scalars['String']['input'];
  reportsForCustomers: Array<ReportsForCustomers>;
  showAccUnacc: Scalars['Boolean']['input'];
  showAllFilterRouteAgrs: Scalars['Boolean']['input'];
  showEmptyLoaded: Scalars['Boolean']['input'];
  showSeaAreaHeader: Scalars['Boolean']['input'];
  status: Scalars['Int']['input'];
  statusTypeOfAgreement: Scalars['String']['input'];
};

export type CreateAgreementReportResponse = {
  __typename?: 'CreateAgreementReportResponse';
  reportCreated: Maybe<Scalars['Boolean']['output']>;
};

export type CreateHeadAgreementErrorResult = {
  __typename?: 'CreateHeadAgreementErrorResult';
  errors: Array<ErrorDetail>;
};

export type CreateHeadAgreementInput = {
  condition?: InputMaybe<Scalars['String']['input']>;
  customerId: Scalars['ID']['input'];
  internalNotes?: InputMaybe<Scalars['String']['input']>;
  lastPage?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  specifications?: InputMaybe<Scalars['String']['input']>;
  status: Scalars['String']['input'];
  validFrom: Scalars['String']['input'];
  validTo: Scalars['String']['input'];
};

export type CreateHeadAgreementResult = CreateHeadAgreementSuccessResult | ErrorResult;

export type CreateHeadAgreementSuccessResult = {
  __typename?: 'CreateHeadAgreementSuccessResult';
  customer: Customer;
  headAgreement: HeadAgreement;
};

export type CreateInvoiceData = {
  bookingNo: Scalars['Int']['input'];
  custNo: Scalars['Int']['input'];
};

export type CreateInvoicesErrorResult = {
  __typename?: 'CreateInvoicesErrorResult';
  errors: Array<ErrorDetail>;
};

export type CreateInvoicesInput = {
  bookings: Array<CreateInvoiceData>;
  month: Scalars['Int']['input'];
  noShowLateHandlingNote?: InputMaybe<Scalars['String']['input']>;
  year: Scalars['Int']['input'];
};

export type CreateInvoicesResult = CreateInvoicesErrorResult | CreateInvoicesSuccessResult;

export type CreateInvoicesSuccessResult = {
  __typename?: 'CreateInvoicesSuccessResult';
  success: Scalars['Boolean']['output'];
};

export type CreateMatrixItemInput = {
  changes: MatrixItemChangesInput;
};

export type CreateMultiLegRouteAgreementErrorResult = {
  __typename?: 'CreateMultiLegRouteAgreementErrorResult';
  errors: Array<ErrorDetail>;
};

export type CreateMultiLegRouteAgreementInput = {
  currencyCode: Scalars['String']['input'];
  headAgreementId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  routeCode: Scalars['String']['input'];
  validFrom: Scalars['String']['input'];
  validTo: Scalars['String']['input'];
};

export type CreateMultiLegRouteAgreementResult = CreateMultiLegRouteAgreementSuccessResult | ErrorResult;

export type CreateMultiLegRouteAgreementRouteErrorResult = {
  __typename?: 'CreateMultiLegRouteAgreementRouteErrorResult';
  errors: Array<ErrorDetail>;
};

export type CreateMultiLegRouteAgreementRouteInput = {
  currencyCode: Scalars['String']['input'];
  externalDescription?: InputMaybe<Scalars['String']['input']>;
  headAgreementId: Scalars['ID']['input'];
  multiLegAgrRouteId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  offPeak: Scalars['Boolean']['input'];
  peak: Scalars['Boolean']['input'];
  routeCode: Scalars['String']['input'];
  routeIds: Array<Scalars['ID']['input']>;
  shoulder: Scalars['Boolean']['input'];
  special: Scalars['Boolean']['input'];
  type: RouteAgreementTypeCode;
  validFrom: Scalars['String']['input'];
  validTo: Scalars['String']['input'];
};

export type CreateMultiLegRouteAgreementRouteResult = CreateMultiLegRouteAgreementRouteSuccessResult | ErrorResult;

export type CreateMultiLegRouteAgreementRouteSuccessResult = {
  __typename?: 'CreateMultiLegRouteAgreementRouteSuccessResult';
  headAgreement: HeadAgreement;
  routeAgreement: RouteAgreement;
};

export type CreateMultiLegRouteAgreementSuccessResult = {
  __typename?: 'CreateMultiLegRouteAgreementSuccessResult';
  multiLegRouteAgreement: MultiLegRouteAgreement;
};

export type CreateRateSheetsPriceItemInput = {
  changes: RateSheetPriceChangesInput;
};

export type CreateRouteAgreementInput = {
  currencyId: Scalars['ID']['input'];
  externalDescription?: InputMaybe<Scalars['String']['input']>;
  headAgreementId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  offPeak: Scalars['Boolean']['input'];
  peak: Scalars['Boolean']['input'];
  routeIds: Array<Scalars['ID']['input']>;
  shoulder: Scalars['Boolean']['input'];
  special: Scalars['Boolean']['input'];
  type: RouteAgreementTypeCode;
  validFrom: Scalars['String']['input'];
  validTo: Scalars['String']['input'];
};

export type CreateRouteAgreementResult = CreateRouteAgreementSuccessResult | ErrorResult;

export type CreateRouteAgreementSuccessResult = {
  __typename?: 'CreateRouteAgreementSuccessResult';
  headAgreement: HeadAgreement;
  routeAgreement: RouteAgreement;
};

export type Criteria = {
  __typename?: 'Criteria';
  comment: Maybe<Scalars['String']['output']>;
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Maybe<Scalars['String']['output']>;
  rebateAgreementId: Scalars['ID']['output'];
  rebateModelCode: Maybe<Scalars['String']['output']>;
  sailingCategoryCode: Maybe<Scalars['String']['output']>;
};

export type Currency = {
  __typename?: 'Currency';
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  longDescription: Scalars['String']['output'];
  name: Scalars['String']['output'];
  shortDescription: Scalars['String']['output'];
};

export type CurrencySearchRoot = {
  __typename?: 'CurrencySearchRoot';
  all: Array<Currency>;
  byId: Maybe<Currency>;
};


export type CurrencySearchRootByIdArgs = {
  id: Scalars['ID']['input'];
};

export type Customer = {
  __typename?: 'Customer';
  activeHeadAgreementByYear: Maybe<HeadAgreement>;
  agreedVolumeSummary: AgreedVolumeSummaryResult;
  agreementDocuments: Array<AgreementDocuments>;
  allHeadAgreements: Array<HeadAgreement>;
  breadCrumbName: Scalars['String']['output'];
  canChangeRouteAgreementType: Scalars['Boolean']['output'];
  childCustomers: Array<Customer>;
  childCustomersByStatus: Array<Customer>;
  countryCode: Maybe<Scalars['String']['output']>;
  creditLimit: Maybe<Scalars['Int']['output']>;
  crmLink: Scalars['String']['output'];
  custIndex: Scalars['String']['output'];
  custNo: Scalars['Int']['output'];
  custStatus: Maybe<CustomerStatus>;
  customerThresholds: Array<CustomerThreshold>;
  defaultRouteAgreementType: RouteAgreementTypeCode;
  expectedStatGroupVolume: ExpectedStatGroupVolumeResult;
  expectedVolumeByFilter: ExpectedVolumeResult;
  hasDocumentByInput: Maybe<Scalars['Boolean']['output']>;
  hasRebateAgreements: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  invoiceCurrency: Currency;
  isParent: Scalars['Boolean']['output'];
  isStandardCustomer: Scalars['Boolean']['output'];
  modeOfPay: Scalars['String']['output'];
  name: Scalars['String']['output'];
  negotiationStatusByYear: Maybe<NegotiationStatus>;
  noOfChildren: Scalars['Int']['output'];
  parent: Maybe<Customer>;
  parentHistory: Maybe<Array<CustomerParentHistoryEntry>>;
  preselectedHeadAgreement: Maybe<HeadAgreement>;
  rebateAgreementDocuments: Array<RebateAgreementDocuments>;
  relatedCustomers: Array<Customer>;
  salesRegion: SalesRegion;
  seller: User;
  sortPortCountry: Maybe<Country>;
  statisticalGrouping: Maybe<Customer>;
  statisticalGroupingId: Maybe<Scalars['Int']['output']>;
  statisticsByFilter: CustomerStatisticsResult;
  statisticsByRoutePairCodes: CustomerStatisticsResult;
  subscriberContactsForReport: Array<SubscriberContact>;
  subscribers: Array<Subscriber>;
  termsOfPaymentDays: Maybe<Scalars['Int']['output']>;
  termsOfPaymentMonths: Maybe<Scalars['Int']['output']>;
  topAgreementDocuments: Array<AgreementDocuments>;
  topHeadAgreements: Array<HeadAgreement>;
  topRebateAgreementDocuments: Array<RebateAgreementDocuments>;
  writeHistory: WriteHistory;
};


export type CustomerActiveHeadAgreementByYearArgs = {
  year: Scalars['Int']['input'];
};


export type CustomerAgreedVolumeSummaryArgs = {
  headAgreementId: Scalars['ID']['input'];
};


export type CustomerChildCustomersByStatusArgs = {
  customerStatusCodes: Array<Scalars['String']['input']>;
};


export type CustomerCustomerThresholdsArgs = {
  month: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};


export type CustomerExpectedStatGroupVolumeArgs = {
  negotiationYear: Scalars['Int']['input'];
  routePairCodes: Array<Scalars['ID']['input']>;
};


export type CustomerExpectedVolumeByFilterArgs = {
  negotiationYear: Scalars['Int']['input'];
};


export type CustomerHasDocumentByInputArgs = {
  agreementDocumentType: Scalars['String']['input'];
  agreementId: Scalars['String']['input'];
};


export type CustomerNegotiationStatusByYearArgs = {
  year: Scalars['Int']['input'];
};


export type CustomerStatisticsByFilterArgs = {
  routePairId: InputMaybe<Scalars['ID']['input']>;
  year: Scalars['Int']['input'];
};


export type CustomerStatisticsByRoutePairCodesArgs = {
  routePairCodes: InputMaybe<Array<Scalars['String']['input']>>;
  year: Scalars['Int']['input'];
};


export type CustomerTopAgreementDocumentsArgs = {
  numberOfDocuments: Scalars['Int']['input'];
};


export type CustomerTopHeadAgreementsArgs = {
  numberOfAgreements: Scalars['Int']['input'];
};


export type CustomerTopRebateAgreementDocumentsArgs = {
  numberOfDocuments: Scalars['Int']['input'];
};

export type CustomerCategory = {
  __typename?: 'CustomerCategory';
  code: Scalars['String']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  presentationOrder: Scalars['Int']['output'];
};

export type CustomerCategorySearchRoot = {
  __typename?: 'CustomerCategorySearchRoot';
  all: Array<CustomerCategory>;
  byId: Maybe<CustomerCategory>;
};


export type CustomerCategorySearchRootByIdArgs = {
  id: Scalars['ID']['input'];
};

export type CustomerDataPoints = {
  __typename?: 'CustomerDataPoints';
  avgGrossMeterPrice: Maybe<Scalars['Float']['output']>;
  avgNetMeterPrice: Maybe<Scalars['Float']['output']>;
  custNo: Scalars['Int']['output'];
};

export type CustomerGetByCustNoAndStatus = {
  allowedStatuses: Array<CustomerStatusCode>;
  query: Scalars['String']['input'];
};

export type CustomerGetByFilterOptions = {
  includeCustomersWith?: InputMaybe<Array<Scalars['String']['input']>>;
  negotiationStatusIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  negotiationYear: Scalars['Int']['input'];
  routePairIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  salesRegionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  seaAreaIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  sellerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  types?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CustomerMutationRoot = {
  __typename?: 'CustomerMutationRoot';
  addParent: Scalars['Boolean']['output'];
  deleteParent: Scalars['Boolean']['output'];
  setNegotiationStatus: Array<Maybe<SetNegotiationStatusResult>>;
  setNegotiationStatusForChildren: SetNegotiationStatusResult;
  setParentValidTo: Scalars['Boolean']['output'];
};


export type CustomerMutationRootAddParentArgs = {
  input: AddCustomerParentInput;
};


export type CustomerMutationRootDeleteParentArgs = {
  input: CustomerParentKeyInput;
};


export type CustomerMutationRootSetNegotiationStatusArgs = {
  input: SetNegotiationStatusInputWithCustomerList;
};


export type CustomerMutationRootSetNegotiationStatusForChildrenArgs = {
  input: SetNegotiationStatusInput;
};


export type CustomerMutationRootSetParentValidToArgs = {
  input: SetCustomerParentValidToInput;
};

/**
 * One stretch of time an account has spent under a parent.
 *
 * Nullable as a list, because it comes from a different API to the rest of
 * the customer. A non-null list would take the whole customer down with it
 * when that API is unreachable, and the account is worth showing even when
 * its parents cannot be fetched.
 *
 * Only stretches with a parent exist. An account with no parent is the gap
 * between two of these rather than an entry of its own.
 */
export type CustomerParentHistoryEntry = {
  __typename?: 'CustomerParentHistoryEntry';
  /**
   * The parent itself, resolved from the number above.
   *
   * Nullable, because a number the accounts API knows about is not
   * guaranteed to resolve to a customer. A non-null field would take the
   * whole history down with it when one does not.
   */
  parentCustomer: Maybe<Customer>;
  parentCustomerNo: Scalars['Int']['output'];
  /** yyyy-MM-dd. */
  validFrom: Scalars['String']['output'];
  /** yyyy-MM-dd. Null while the stretch has not been given an end. */
  validTo: Maybe<Scalars['String']['output']>;
};

/**
 * A stretch is addressed by the parent it is under and the day it starts,
 * which is how the accounts API identifies one.
 */
export type CustomerParentKeyInput = {
  customerNo: Scalars['Int']['input'];
  parentCustomerNo: Scalars['Int']['input'];
  /** yyyy-MM-dd. */
  validFrom: Scalars['String']['input'];
};

export type CustomerRoutePairStatistics = {
  __typename?: 'CustomerRoutePairStatistics';
  averageNegotiationRate: Scalars['Float']['output'];
  averageTargetRate: Maybe<Scalars['Float']['output']>;
  customer: Customer;
  expectedVolume: Maybe<Scalars['Float']['output']>;
  routePair: RoutePair;
  volumeChange: Maybe<Scalars['Float']['output']>;
  volumeLast12Months: Scalars['Float']['output'];
  year: Scalars['Int']['output'];
};

export type CustomerRouteStatisticsMutationRoot = {
  __typename?: 'CustomerRouteStatisticsMutationRoot';
  updateCustomerRouteStatisticsActualOutcome: UpdateCustomerRouteStatisticsResult;
};


export type CustomerRouteStatisticsMutationRootUpdateCustomerRouteStatisticsActualOutcomeArgs = {
  input: Array<UpdateCustomerRouteStatisticsActualOutcomeInput>;
};

export type CustomerRouteStatisticsSearchRoot = {
  __typename?: 'CustomerRouteStatisticsSearchRoot';
  calculateActualPriceChangeForAllBulkEditRates: Array<CustomerStatisticsEntry>;
  calculateActualPriceChangeForAllRates: Array<CustomerStatisticsEntry>;
};


export type CustomerRouteStatisticsSearchRootCalculateActualPriceChangeForAllBulkEditRatesArgs = {
  input: CalculateActualPriceChangeForAllBulkEditRatesInput;
};


export type CustomerRouteStatisticsSearchRootCalculateActualPriceChangeForAllRatesArgs = {
  input: CalculateActualPriceChangeForAllRatesInput;
};

export type CustomerSearchByFilterResult = {
  __typename?: 'CustomerSearchByFilterResult';
  items: Array<Customer>;
};

export type CustomerSearchRoot = {
  __typename?: 'CustomerSearchRoot';
  all: Array<Customer>;
  byCustomerNumberAndStatus: Array<Customer>;
  byCustomerNumberOrIndex: Array<Customer>;
  byFilter: CustomerSearchByFilterResult;
  byId: Maybe<Customer>;
  byNslhCustomerNumberOrIndex: Array<Customer>;
  byStatCustomerNumberOrIndex: Array<Customer>;
  byUser: Array<Customer>;
};


export type CustomerSearchRootByCustomerNumberAndStatusArgs = {
  custNoAndStatus: CustomerGetByCustNoAndStatus;
};


export type CustomerSearchRootByCustomerNumberOrIndexArgs = {
  query: Scalars['String']['input'];
};


export type CustomerSearchRootByFilterArgs = {
  filter: CustomerGetByFilterOptions;
};


export type CustomerSearchRootByIdArgs = {
  id: Scalars['ID']['input'];
};


export type CustomerSearchRootByNslhCustomerNumberOrIndexArgs = {
  query: Scalars['String']['input'];
};


export type CustomerSearchRootByStatCustomerNumberOrIndexArgs = {
  query: Scalars['String']['input'];
};

export type CustomerStatisticsEntry = {
  __typename?: 'CustomerStatisticsEntry';
  actualOutcomeInPercent: Maybe<Scalars['Float']['output']>;
  expectedStatVolume: Maybe<Scalars['Int']['output']>;
  expectedVolume: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  routePairCode: Maybe<Scalars['String']['output']>;
  sailingCategoryCode: SailingTypeCode;
  statVolume12Months: Maybe<Scalars['Int']['output']>;
  targetInPercent: Maybe<Scalars['Float']['output']>;
  unitCategoryCode: UnitCategoryCode;
  volume12Months: Scalars['Int']['output'];
};

export type CustomerStatisticsResult = {
  __typename?: 'CustomerStatisticsResult';
  items: Array<CustomerStatisticsEntry>;
  itemsByRoutePairCodes: Array<CustomerStatisticsEntry>;
};

export type CustomerStatisticsSearchRoot = {
  __typename?: 'CustomerStatisticsSearchRoot';
  agreedVolumePerformance: AgreedVolumePerformanceResult;
  customerThreeYearsStatistics: Array<CustomerThreeYearsStatistics>;
};


export type CustomerStatisticsSearchRootAgreedVolumePerformanceArgs = {
  customerNumber: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};


export type CustomerStatisticsSearchRootCustomerThreeYearsStatisticsArgs = {
  input: CustomerThreeYearsStatisticsInput;
};

export type CustomerStatus = {
  __typename?: 'CustomerStatus';
  code: CustomerStatusCode;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export enum CustomerStatusCode {
  Blocked = 'BLOCKED',
  Closed = 'CLOSED',
  Open = 'OPEN',
  Possible = 'POSSIBLE'
}

export type CustomerThreeYearsStatistics = {
  __typename?: 'CustomerThreeYearsStatistics';
  actualRate: Scalars['Float']['output'];
  customerNumber: Scalars['Int']['output'];
  diffPreviousYear: Maybe<Scalars['Float']['output']>;
  expectedVolume: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  last12MonthsVolume: Scalars['Int']['output'];
  negotiationStatus: Maybe<Scalars['String']['output']>;
  pricePerMeter: Scalars['Float']['output'];
  targetRate: Scalars['Float']['output'];
  year: Scalars['Int']['output'];
};

export type CustomerThreeYearsStatisticsInput = {
  currencyCode: Scalars['String']['input'];
  customerNumber: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};

export type CustomerThreshold = {
  __typename?: 'CustomerThreshold';
  customer: Maybe<Customer>;
  id: Scalars['ID']['output'];
  percentage: Scalars['Float']['output'];
  thresholdTypeCode: Scalars['String']['output'];
  validFrom: Scalars['String']['output'];
};

export type CustomerThresholdByFilterInput = {
  custNos: Array<Scalars['Int']['input']>;
  month: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};

export type CustomerThresholdSearchRoot = {
  __typename?: 'CustomerThresholdSearchRoot';
  byFilter: Array<CustomerThreshold>;
};


export type CustomerThresholdSearchRootByFilterArgs = {
  input: CustomerThresholdByFilterInput;
};

export type CustomsClassification = {
  __typename?: 'CustomsClassification';
  code: Maybe<Scalars['String']['output']>;
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type CustomsClassificationSearchRoot = {
  __typename?: 'CustomsClassificationSearchRoot';
  all: Array<CustomsClassification>;
};

export type Date = {
  __typename?: 'Date';
  isoString: Scalars['String']['output'];
};

export type DateInput = {
  isoString: Scalars['String']['input'];
};

export type DateRange = {
  __typename?: 'DateRange';
  end: Maybe<Date>;
  start: Maybe<Date>;
};

export type DateRangeInput = {
  end: Scalars['String']['input'];
  start: Scalars['String']['input'];
};

export type DateTime = {
  __typename?: 'DateTime';
  isoString: Scalars['String']['output'];
};

export type DeleteAdditionalChargesErrorResult = {
  __typename?: 'DeleteAdditionalChargesErrorResult';
  errors: Array<ErrorDetail>;
};

export type DeleteAdditionalChargesResult = DeleteAdditionalChargesSuccessResult | ErrorResult;

export type DeleteAdditionalChargesSuccessResult = {
  __typename?: 'DeleteAdditionalChargesSuccessResult';
  success: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteAgreementDocumentErrorResult = {
  __typename?: 'DeleteAgreementDocumentErrorResult';
  errors: Array<ErrorDetail>;
};

export type DeleteAgreementDocumentResult = DeleteAgreementDocumentErrorResult | DeleteAgreementDocumentSuccessResult;

export type DeleteAgreementDocumentSuccessResult = {
  __typename?: 'DeleteAgreementDocumentSuccessResult';
  success: Scalars['Boolean']['output'];
};

export type DeleteArticleItemInput = {
  articleId: Scalars['ID']['input'];
};

export type DeleteArticlePriceInput = {
  articlePriceId: Scalars['ID']['input'];
};

export type DeleteHeadAgreementErrorResult = {
  __typename?: 'DeleteHeadAgreementErrorResult';
  errors: Array<ErrorDetail>;
};

export type DeleteHeadAgreementResult = DeleteHeadAgreementSuccessResult | ErrorResult;

export type DeleteHeadAgreementSuccessResult = {
  __typename?: 'DeleteHeadAgreementSuccessResult';
  customer: Customer;
};

export type DeleteMatrixItemInput = {
  id: Scalars['ID']['input'];
};

export type DeleteMultiLegRouteAgreementErrorResult = {
  __typename?: 'DeleteMultiLegRouteAgreementErrorResult';
  errors: Array<ErrorDetail>;
};

export type DeleteMultiLegRouteAgreementResult = DeleteMultiLegRouteAgreementSuccessResult | ErrorResult;

export type DeleteMultiLegRouteAgreementSuccessResult = {
  __typename?: 'DeleteMultiLegRouteAgreementSuccessResult';
  success: Scalars['Boolean']['output'];
};

export type DeleteRateSheetsPriceItemInput = {
  routeAgreementPriceId: Scalars['ID']['input'];
};

export type DeleteRouteAgreementResult = DeleteRouteAgreementSuccessResult | ErrorResult;

export type DeleteRouteAgreementSuccessResult = {
  __typename?: 'DeleteRouteAgreementSuccessResult';
  success: Scalars['Boolean']['output'];
};

export type DeleteValidFromDateErrorResult = {
  __typename?: 'DeleteValidFromDateErrorResult';
  errors: Array<ErrorDetail>;
};

export type DeleteValidFromDateInput = {
  routePairCode: Scalars['String']['input'];
  validFrom: Scalars['String']['input'];
};

export type DeleteValidFromDateResult = DeleteValidFromDateErrorResult | DeleteValidFromDateSuccessResult;

export type DeleteValidFromDateSuccessResult = {
  __typename?: 'DeleteValidFromDateSuccessResult';
  success: Scalars['Boolean']['output'];
};

export type DetailedCategoryData = {
  __typename?: 'DetailedCategoryData';
  customerDataPoints: Maybe<Array<CustomerDataPoints>>;
  customerTarget: Maybe<Scalars['Float']['output']>;
  gmTarget: Maybe<Scalars['Float']['output']>;
  noOfAccounts: Scalars['Int']['output'];
  sailingTypeCode: Scalars['String']['output'];
  unitCategoryCode: Scalars['String']['output'];
};

export type DistanceType = {
  __typename?: 'DistanceType';
  code: Scalars['Int']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type DistanceTypeSearchRoot = {
  __typename?: 'DistanceTypeSearchRoot';
  all: Array<DistanceType>;
};

export enum ErrorCode {
  NoNegotiationStatusSelected = 'NO_NEGOTIATION_STATUS_SELECTED'
}

export type ErrorDetail = {
  __typename?: 'ErrorDetail';
  message: Scalars['String']['output'];
  path: Maybe<Scalars['String']['output']>;
};

export type ErrorResult = {
  __typename?: 'ErrorResult';
  description: Maybe<Scalars['String']['output']>;
  errors: Array<ErrorDetail>;
  message: Maybe<Scalars['String']['output']>;
  statusCode: Scalars['Int']['output'];
};

export type ExpectedStatGroupVolume = {
  __typename?: 'ExpectedStatGroupVolume';
  expectedStatGroupVolume: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  routePairCode: Maybe<Scalars['String']['output']>;
  sailingCategoryCode: Maybe<SailingTypeCode>;
  unitCategoryCode: Maybe<Scalars['String']['output']>;
};

export type ExpectedStatGroupVolumeResult = {
  __typename?: 'ExpectedStatGroupVolumeResult';
  volumes: Array<ExpectedStatGroupVolume>;
};

export type ExpectedVolume = {
  __typename?: 'ExpectedVolume';
  customer: Customer;
  expectedVolume: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  routePair: RoutePair;
  sailingCategoryCode: SailingTypeCode;
  unitCategoryCode: Scalars['String']['output'];
  volume12Months: Scalars['Int']['output'];
  volumeAgreed: Scalars['Boolean']['output'];
  year: Scalars['Int']['output'];
};

export type ExpectedVolumeMutationRoot = {
  __typename?: 'ExpectedVolumeMutationRoot';
  bulkUpdateExpectedVolumes: BulkUpdateExpectedVolumesResult;
  updateExpectedVolumes: UpdateExpectedVolumesResult;
};


export type ExpectedVolumeMutationRootBulkUpdateExpectedVolumesArgs = {
  input: BulkUpdateExpectedVolumesInput;
};


export type ExpectedVolumeMutationRootUpdateExpectedVolumesArgs = {
  input: UpdateExpectedVolumesInput;
};

export type ExpectedVolumeResult = {
  __typename?: 'ExpectedVolumeResult';
  volumes: Array<ExpectedVolume>;
};

export type FeatureFlag = {
  __typename?: 'FeatureFlag';
  agreement: AgreementFlags;
};

export type FormulaData = {
  __typename?: 'FormulaData';
  drivers: Maybe<Scalars['Float']['output']>;
  interval1PercentValue: Maybe<Scalars['Float']['output']>;
  interval2PercentValue: Maybe<Scalars['Float']['output']>;
  interval3PercentValue: Maybe<Scalars['Float']['output']>;
  interval4PercentValue: Maybe<Scalars['Float']['output']>;
  intervalAPercentValue: Maybe<Scalars['Float']['output']>;
  intervalBPercentValue: Maybe<Scalars['Float']['output']>;
  intervalCPercentValue: Maybe<Scalars['Float']['output']>;
  intervalDPercentValue: Maybe<Scalars['Float']['output']>;
  intervalLength: Maybe<Scalars['Float']['output']>;
  maxPercent: Maybe<Scalars['Float']['output']>;
  percent: Maybe<Scalars['Float']['output']>;
  weight: Maybe<Scalars['Float']['output']>;
  width: Maybe<Scalars['Float']['output']>;
};

export type FormulaDataFormInput = {
  drivers?: InputMaybe<Scalars['Float']['input']>;
  interval1PercentValue?: InputMaybe<Scalars['Float']['input']>;
  interval2PercentValue?: InputMaybe<Scalars['Float']['input']>;
  interval3PercentValue?: InputMaybe<Scalars['Float']['input']>;
  interval4PercentValue?: InputMaybe<Scalars['Float']['input']>;
  intervalAPercentValue?: InputMaybe<Scalars['Float']['input']>;
  intervalBPercentValue?: InputMaybe<Scalars['Float']['input']>;
  intervalCPercentValue?: InputMaybe<Scalars['Float']['input']>;
  intervalDPercentValue?: InputMaybe<Scalars['Float']['input']>;
  intervalLength?: InputMaybe<Scalars['Float']['input']>;
  maxPercent?: InputMaybe<Scalars['Float']['input']>;
  percent?: InputMaybe<Scalars['Float']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type FormulaSearchRoot = {
  __typename?: 'FormulaSearchRoot';
  all: Array<FormulaType>;
  byId: Maybe<FormulaType>;
};


export type FormulaSearchRootByIdArgs = {
  id: Scalars['ID']['input'];
};

export type FormulaType = {
  __typename?: 'FormulaType';
  code: Scalars['String']['output'];
  description: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  includes: FormulaTypeIncludes;
  name: Scalars['String']['output'];
};

export type FormulaTypeIncludes = {
  __typename?: 'FormulaTypeIncludes';
  drivers: Maybe<Scalars['Boolean']['output']>;
  interval1PercentValue: Maybe<Scalars['Boolean']['output']>;
  interval2PercentValue: Maybe<Scalars['Boolean']['output']>;
  interval3PercentValue: Maybe<Scalars['Boolean']['output']>;
  interval4PercentValue: Maybe<Scalars['Boolean']['output']>;
  intervalAPercentValue: Maybe<Scalars['Boolean']['output']>;
  intervalBPercentValue: Maybe<Scalars['Boolean']['output']>;
  intervalCPercentValue: Maybe<Scalars['Boolean']['output']>;
  intervalDPercentValue: Maybe<Scalars['Boolean']['output']>;
  intervalLength: Maybe<Scalars['Boolean']['output']>;
  maxPercent: Maybe<Scalars['Boolean']['output']>;
  percent: Maybe<Scalars['Boolean']['output']>;
  weight: Maybe<Scalars['Boolean']['output']>;
  width: Maybe<Scalars['Boolean']['output']>;
};

export type FrontendVersion = {
  __typename?: 'FrontendVersion';
  version: Scalars['String']['output'];
};

export type GetTargetSummaryInput = {
  currency: Scalars['String']['input'];
  routePairCode: Scalars['String']['input'];
  year: Scalars['Int']['input'];
};

export type Goal = {
  __typename?: 'Goal';
  amountPaid: Maybe<Scalars['Float']['output']>;
  amountReversed: Maybe<Scalars['Float']['output']>;
  authorizedBy: Maybe<Scalars['String']['output']>;
  criteriaId: Scalars['ID']['output'];
  datePaid: Maybe<Scalars['String']['output']>;
  expectedOutcome: Scalars['Float']['output'];
  expectedVolume: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  period: Scalars['Int']['output'];
  rebateRate: Scalars['Float']['output'];
  rebateTermCode: Scalars['String']['output'];
  statusCode: Scalars['String']['output'];
  targetValue: Scalars['Float']['output'];
  validFrom: Scalars['String']['output'];
  validTo: Scalars['String']['output'];
  volumeFrom: Scalars['Float']['output'];
  volumeTo: Scalars['Float']['output'];
  year: Scalars['Int']['output'];
};

export type Goods = {
  __typename?: 'Goods';
  code: Scalars['String']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  presentationOrder: Scalars['Int']['output'];
};

export type GoodsRecordV2 = {
  goodsCode: Scalars['String']['input'];
  weight: Scalars['Float']['input'];
};

export type GoodsSearchRoot = {
  __typename?: 'GoodsSearchRoot';
  all: Array<Goods>;
  byId: Maybe<Goods>;
};


export type GoodsSearchRootByIdArgs = {
  id: Scalars['ID']['input'];
};

export type HandleBookingBookingData = {
  __typename?: 'HandleBookingBookingData';
  articlePrice: Maybe<Scalars['Float']['output']>;
  bookingNo: Scalars['Int']['output'];
  bookingVersion: Scalars['Int']['output'];
  codeNoShowLateHandlingType: CodeNoShowLateHandlingType;
  codeNoShowLateType: CodeNoShowLateType;
  consignment: Maybe<Consignment>;
  consignmentNo: Maybe<Scalars['Int']['output']>;
  customerReference: Maybe<Scalars['String']['output']>;
  dateModified: Maybe<Scalars['String']['output']>;
  departureDate: Scalars['String']['output'];
  departureTime: Scalars['String']['output'];
  excludeReason: Maybe<NoShowLateHandlingExcludeReason>;
  handlingStatus: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lateHandlingDate: Scalars['String']['output'];
  lateHandlingUser: Scalars['String']['output'];
  loadingListMessage: Maybe<Scalars['String']['output']>;
  modifiedBy: Maybe<Scalars['String']['output']>;
  month: Scalars['String']['output'];
  note: Maybe<Scalars['String']['output']>;
  revisedDate: Maybe<Scalars['String']['output']>;
  revisedTime: Maybe<Scalars['String']['output']>;
  route: Route;
  trailerReg: Maybe<Scalars['String']['output']>;
  vehicleReg: Maybe<Scalars['String']['output']>;
  vehicleType: Maybe<VehicleType>;
};

export type HandleRebateInput = {
  creditSum: Scalars['Float']['input'];
  criteriaId: Scalars['ID']['input'];
  customerReference?: InputMaybe<Scalars['String']['input']>;
  goalId: Scalars['ID']['input'];
  goalValidFrom: Scalars['String']['input'];
  goalValidTo: Scalars['String']['input'];
  manualPricing: Scalars['Boolean']['input'];
  period: Scalars['Int']['input'];
  rebateAgreementId: Scalars['ID']['input'];
  releaseSum: Scalars['Float']['input'];
  statusCodeForPayout: RebatePayoutStatusCode;
};

export type HeadAgreement = {
  __typename?: 'HeadAgreement';
  breadCrumbName: Scalars['String']['output'];
  condition: Maybe<Scalars['String']['output']>;
  customer: Customer;
  hasSomeRouteAgreementsWithMultiLeg: Scalars['Boolean']['output'];
  headAgreementNumber: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  internalComments: Maybe<Scalars['String']['output']>;
  lastPage: Maybe<Scalars['String']['output']>;
  multiLegAgrRoutes: Array<MultiLegRouteAgreement>;
  name: Scalars['String']['output'];
  routeAgreements: Array<RouteAgreement>;
  routePairs: Array<RoutePair>;
  rowVersion: Scalars['String']['output'];
  specifications: Maybe<Scalars['String']['output']>;
  statusCode: HeadAgreementStatusCode;
  valid: DateRange;
  writeHistory: WriteHistory;
};

export type HeadAgreementMutationRoot = {
  __typename?: 'HeadAgreementMutationRoot';
  activateHeadAgreement: ActivateHeadAgreementResult;
  changeHeadAgreementStatus: UpdateHeadAgreementResult;
  copyHeadAgreement: UpdateHeadAgreementResult;
  createHeadAgreement: CreateHeadAgreementResult;
  deleteHeadAgreement: DeleteHeadAgreementResult;
  updateHeadAgreement: UpdateHeadAgreementResult;
};


export type HeadAgreementMutationRootActivateHeadAgreementArgs = {
  headAgreementId: Scalars['ID']['input'];
  multiLegAgreements: InputMaybe<Array<ActivateMultiLegAgreementInput>>;
  routeAgreements: InputMaybe<Array<ActivateRouteAgreementInput>>;
  rowVersion: Scalars['String']['input'];
};


export type HeadAgreementMutationRootChangeHeadAgreementStatusArgs = {
  headAgreementId: Scalars['ID']['input'];
  rowVersion: Scalars['String']['input'];
  status: HeadAgreementStatusCode;
};


export type HeadAgreementMutationRootCopyHeadAgreementArgs = {
  input: CopyHeadAgreementInput;
};


export type HeadAgreementMutationRootCreateHeadAgreementArgs = {
  input: CreateHeadAgreementInput;
};


export type HeadAgreementMutationRootDeleteHeadAgreementArgs = {
  headAgreementId: Scalars['ID']['input'];
  rowVersion: Scalars['String']['input'];
};


export type HeadAgreementMutationRootUpdateHeadAgreementArgs = {
  input: UpdateHeadAgreementInput;
};

export type HeadAgreementSearchRoot = {
  __typename?: 'HeadAgreementSearchRoot';
  byId: Maybe<HeadAgreement>;
};


export type HeadAgreementSearchRootByIdArgs = {
  headAgreementId: Scalars['ID']['input'];
};

export enum HeadAgreementStatusCode {
  Active = 'ACTIVE',
  Offered = 'OFFERED',
  Pending = 'PENDING',
  Void = 'VOID'
}

export type LiveStock = {
  __typename?: 'LiveStock';
  code: Scalars['String']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  presentationOrder: Scalars['Int']['output'];
};

export type LiveStockSearchRoot = {
  __typename?: 'LiveStockSearchRoot';
  all: Array<LiveStock>;
  byId: Maybe<LiveStock>;
};


export type LiveStockSearchRootByIdArgs = {
  id: Scalars['ID']['input'];
};

export type LoadingPreference = {
  __typename?: 'LoadingPreference';
  code: Scalars['String']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  presentationOrder: Scalars['Int']['output'];
};

export type LoadingPreferenceSearchRoot = {
  __typename?: 'LoadingPreferenceSearchRoot';
  all: Array<LoadingPreference>;
  byId: Maybe<LoadingPreference>;
};


export type LoadingPreferenceSearchRootByIdArgs = {
  id: Scalars['ID']['input'];
};

export type Matrix = {
  __typename?: 'Matrix';
  id: Scalars['ID']['output'];
  keywords: Array<Scalars['String']['output']>;
  timeslots: Array<MatrixTimeslot>;
  validityKey: Scalars['String']['output'];
};

export type MatrixFormInput = {
  created: Array<MatrixItemChangesInput>;
  deleted: Array<DeleteMatrixItemInput>;
  updated: Array<UpdateMatrixItemInput>;
};

export type MatrixItemChangesInput = {
  matrixTypeId?: InputMaybe<RequiredIdInput>;
  valid?: InputMaybe<RequiredValidDatesInput>;
};

export type MatrixSearchRoot = {
  __typename?: 'MatrixSearchRoot';
  byId: Maybe<Matrix>;
  byKeyword: Array<Matrix>;
};


export type MatrixSearchRootByIdArgs = {
  id: Scalars['ID']['input'];
};


export type MatrixSearchRootByKeywordArgs = {
  query: Scalars['String']['input'];
};

export type MatrixTimeslot = {
  __typename?: 'MatrixTimeslot';
  timeFrom: Scalars['String']['output'];
  timeTo: Scalars['String']['output'];
  weekDay: Scalars['String']['output'];
};

export type MovementType = {
  __typename?: 'MovementType';
  code: Scalars['String']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  presentationOrder: Scalars['Int']['output'];
};

export type MovementTypeSearchRoot = {
  __typename?: 'MovementTypeSearchRoot';
  all: Array<MovementType>;
  byId: Maybe<MovementType>;
};


export type MovementTypeSearchRootByIdArgs = {
  id: Scalars['ID']['input'];
};

export type MultiLegAgreementWithValidity = {
  multiLegAgreementId: Scalars['ID']['input'];
  valid: ValidDatesInput;
};

export type MultiLegRouteAgreement = {
  __typename?: 'MultiLegRouteAgreement';
  createdBy: Scalars['String']['output'];
  currency: Currency;
  dateCreated: Scalars['String']['output'];
  dateModified: Maybe<Scalars['String']['output']>;
  headAgreement: HeadAgreement;
  id: Scalars['ID']['output'];
  idNumber: Maybe<Scalars['Int']['output']>;
  modifiedBy: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  route: Route;
  routeAgreements: Array<RouteAgreement>;
  routeLegs: Array<RouteLeg>;
  rowVersion: Scalars['String']['output'];
  statusCode: HeadAgreementStatusCode;
  valid: DateRange;
  workFlowStatusCode: Maybe<WorkFlowStatusCode>;
};

export type MultiLegRouteAgreementFormInput = {
  currencyCode: RequiredStringInput;
  name: OptionalStringInput;
  validity: RequiredValidDatesInput;
};

export type MultiLegRouteAgreementMutationRoot = {
  __typename?: 'MultiLegRouteAgreementMutationRoot';
  activateMultiLegAgreement: UpdateMultiLegRouteAgreementResult;
  changeMultiLegRouteAgreementSalesReadyStatus: UpdateMultiLegRouteAgreementResult;
  changeMultiLegRouteAgreementStatus: UpdateMultiLegRouteAgreementResult;
  copyMultiLegRouteAgreement: CopyMultiLegRouteAgreementResult;
  createMultiLegRouteAgreement: CreateMultiLegRouteAgreementResult;
  createMultiLegRouteAgreementRoute: CreateMultiLegRouteAgreementRouteResult;
  deleteMultiLegRouteAgreement: DeleteMultiLegRouteAgreementResult;
  updateMultiLegRouteAgreement: UpdateMultiLegRouteAgreementResult;
};


export type MultiLegRouteAgreementMutationRootActivateMultiLegAgreementArgs = {
  input: ActivateMultiLegAgreementInput;
};


export type MultiLegRouteAgreementMutationRootChangeMultiLegRouteAgreementSalesReadyStatusArgs = {
  input: ChangeMultiLegRouteAgreementWorkFlowStatusInput;
};


export type MultiLegRouteAgreementMutationRootChangeMultiLegRouteAgreementStatusArgs = {
  input: ChangeMultiLegRouteAgreementStatusInput;
};


export type MultiLegRouteAgreementMutationRootCopyMultiLegRouteAgreementArgs = {
  input: CopyMultiLegAgreementInput;
};


export type MultiLegRouteAgreementMutationRootCreateMultiLegRouteAgreementArgs = {
  input: CreateMultiLegRouteAgreementInput;
};


export type MultiLegRouteAgreementMutationRootCreateMultiLegRouteAgreementRouteArgs = {
  input: CreateMultiLegRouteAgreementRouteInput;
};


export type MultiLegRouteAgreementMutationRootDeleteMultiLegRouteAgreementArgs = {
  multiLegRouteAgreementId: Scalars['ID']['input'];
  rowVersion: Scalars['String']['input'];
};


export type MultiLegRouteAgreementMutationRootUpdateMultiLegRouteAgreementArgs = {
  input: UpdateMultiLegRouteAgreementInput;
};

export type MultiLegRouteAgreementSearchRoot = {
  __typename?: 'MultiLegRouteAgreementSearchRoot';
  byId: Maybe<MultiLegRouteAgreement>;
};


export type MultiLegRouteAgreementSearchRootByIdArgs = {
  id: Scalars['ID']['input'];
};

export type Mutation = {
  __typename?: 'Mutation';
  createAgreementReport: Maybe<CreateAgreementReportResponse>;
  productPrice: ProductPriceMutationRoot;
};


export type MutationCreateAgreementReportArgs = {
  input: CreateAgreementReportInput;
};

export type NegotiationStatus = {
  __typename?: 'NegotiationStatus';
  code: NegotiationStatusCode;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  presentationOrder: Maybe<Scalars['Int']['output']>;
};

export enum NegotiationStatusCode {
  D = 'D',
  I = 'I',
  P = 'P',
  R = 'R',
  Ra = 'RA',
  Ro = 'RO',
  T = 'T'
}

export type NegotiationStatusSearchRoot = {
  __typename?: 'NegotiationStatusSearchRoot';
  all: Array<NegotiationStatus>;
  byId: Maybe<NegotiationStatus>;
};


export type NegotiationStatusSearchRootByIdArgs = {
  id: Scalars['ID']['input'];
};

export type NegotiationStatusStatisticsItem = {
  __typename?: 'NegotiationStatusStatisticsItem';
  accounts: Scalars['Int']['output'];
  statistics: Array<StatisticsForNegotiationStatus>;
};

export type NegotiationYear = {
  __typename?: 'NegotiationYear';
  id: Scalars['ID']['output'];
  year: Scalars['Int']['output'];
};

export type NegotiationYearSearchRoot = {
  __typename?: 'NegotiationYearSearchRoot';
  availableYears: Array<NegotiationYear>;
};

export type NoShowLateHandlingBookingVolumesByCustNosAndDateInput = {
  custNos: Array<Scalars['Int']['input']>;
  month: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};

export type NoShowLateHandlingBookingsByFilterOptions = {
  bcComments?: InputMaybe<Scalars['String']['input']>;
  bookingNo?: InputMaybe<Scalars['String']['input']>;
  custNos?: InputMaybe<Array<Scalars['Int']['input']>>;
  fromDepartureDate?: InputMaybe<DateInput>;
  fromDepartureTime?: InputMaybe<Scalars['String']['input']>;
  handlingStatuses?: InputMaybe<Array<Scalars['String']['input']>>;
  handlingTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  month: Scalars['Int']['input'];
  routePairCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  salesRegions?: InputMaybe<Array<Scalars['Int']['input']>>;
  sellers?: InputMaybe<Array<Scalars['String']['input']>>;
  toDepartureDate?: InputMaybe<DateInput>;
  toDepartureTime?: InputMaybe<Scalars['String']['input']>;
  year: Scalars['Int']['input'];
};

export type NoShowLateHandlingBookingsByFilterResult = {
  __typename?: 'NoShowLateHandlingBookingsByFilterResult';
  bookingsData: Array<NoShowLateHandlingHandleBookingsData>;
};

export type NoShowLateHandlingBookingsMutationRoot = {
  __typename?: 'NoShowLateHandlingBookingsMutationRoot';
  calculateThreshold: CalculateThresholdResult;
  updateBookingHandlingStatus: UpdateBookingHandlingStatusResult;
};


export type NoShowLateHandlingBookingsMutationRootCalculateThresholdArgs = {
  input: CalculateThresholdInput;
};


export type NoShowLateHandlingBookingsMutationRootUpdateBookingHandlingStatusArgs = {
  input: Array<UpdateBookingHandlingStatusInput>;
};

export type NoShowLateHandlingBookingsSearchRoot = {
  __typename?: 'NoShowLateHandlingBookingsSearchRoot';
  byFilter: NoShowLateHandlingBookingsByFilterResult;
};


export type NoShowLateHandlingBookingsSearchRootByFilterArgs = {
  filterOptions: NoShowLateHandlingBookingsByFilterOptions;
};

export type NoShowLateHandlingByIdPricesInput = {
  routePairCode: Scalars['String']['input'];
  validFrom: Scalars['String']['input'];
};

export type NoShowLateHandlingExcludeReason = {
  __typename?: 'NoShowLateHandlingExcludeReason';
  code: Scalars['String']['output'];
  dateCreated: Scalars['String']['output'];
  dateModified: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  modifiedBy: Maybe<Scalars['String']['output']>;
  notValidDate: Maybe<Scalars['String']['output']>;
  presentationOrder: Scalars['Int']['output'];
};

export type NoShowLateHandlingExcludeReasonSearchRoot = {
  __typename?: 'NoShowLateHandlingExcludeReasonSearchRoot';
  all: Array<NoShowLateHandlingExcludeReason>;
  byId: Maybe<NoShowLateHandlingExcludeReason>;
};


export type NoShowLateHandlingExcludeReasonSearchRootByIdArgs = {
  id: Scalars['ID']['input'];
};

export type NoShowLateHandlingHandleBookingsData = {
  __typename?: 'NoShowLateHandlingHandleBookingsData';
  customer: Customer;
  customerBookings: Array<HandleBookingBookingData>;
  id: Scalars['ID']['output'];
  noOfDoNotInvoice: Scalars['Int']['output'];
  noOfInvoiced: Scalars['Int']['output'];
  noOfNotChargeable: Scalars['Int']['output'];
  noOfThreshold: Scalars['Int']['output'];
  noOfToBeInvoiced: Scalars['Int']['output'];
  noOfToDo: Scalars['Int']['output'];
  region: Scalars['String']['output'];
  seller: Scalars['String']['output'];
};

export type NoShowLateHandlingInvoicesMutationRoot = {
  __typename?: 'NoShowLateHandlingInvoicesMutationRoot';
  createInvoices: CreateInvoicesResult;
};


export type NoShowLateHandlingInvoicesMutationRootCreateInvoicesArgs = {
  input: CreateInvoicesInput;
};

export type NoShowLateHandlingMutationRoot = {
  __typename?: 'NoShowLateHandlingMutationRoot';
  deleteValidFromDate: DeleteValidFromDateResult;
  updateRoutePrices: UpdateRoutePricesResult;
};


export type NoShowLateHandlingMutationRootDeleteValidFromDateArgs = {
  input: DeleteValidFromDateInput;
};


export type NoShowLateHandlingMutationRootUpdateRoutePricesArgs = {
  input: Array<UpdateRoutePricesInput>;
};

export type NoShowLateHandlingPrices = {
  __typename?: 'NoShowLateHandlingPrices';
  createdBy: Scalars['String']['output'];
  dateCreated: Scalars['String']['output'];
  dateModified: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lateHandlingDkk: Scalars['Float']['output'];
  lateHandlingEur: Scalars['Float']['output'];
  lateHandlingGbp: Scalars['Float']['output'];
  lateHandlingNok: Scalars['Float']['output'];
  lateHandlingPln: Scalars['Float']['output'];
  lateHandlingSek: Scalars['Float']['output'];
  modifiedBy: Maybe<Scalars['String']['output']>;
  noShowDkk: Scalars['Float']['output'];
  noShowEur: Scalars['Float']['output'];
  noShowGbp: Scalars['Float']['output'];
  noShowNok: Scalars['Float']['output'];
  noShowPln: Scalars['Float']['output'];
  noShowSek: Scalars['Float']['output'];
  routePair: RoutePair;
  routePairCode: Scalars['String']['output'];
  validFrom: Scalars['String']['output'];
};

export type NoShowLateHandlingPricesSearchRoot = {
  __typename?: 'NoShowLateHandlingPricesSearchRoot';
  all: Array<NoShowLateHandlingPrices>;
  byId: NoShowLateHandlingPrices;
};


export type NoShowLateHandlingPricesSearchRootByIdArgs = {
  input: NoShowLateHandlingByIdPricesInput;
};

export type NoShowLateHandlingSearchRoot = {
  __typename?: 'NoShowLateHandlingSearchRoot';
  breakDate: Maybe<Scalars['String']['output']>;
  nslhBooking: NslhBookingSearchRoot;
  nslhBookingRouteVolume: NslhBookingRouteVolumeSearchRoot;
  nslhBookingVolume: NslhBookingVolumeSearchRoot;
  nslhFollowUp: NslhFollowUpSearchRoot;
  nslhInvoice: NslhInvoiceSearchRoot;
};

export type NoShowLateHandlingStatus = {
  __typename?: 'NoShowLateHandlingStatus';
  code: Scalars['String']['output'];
  dateCreated: Scalars['String']['output'];
  dateModified: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  modifiedBy: Maybe<Scalars['String']['output']>;
  notValidDate: Maybe<Scalars['String']['output']>;
  presentationOrder: Scalars['Int']['output'];
};

export type NoShowLateHandlingStatusSearchRoot = {
  __typename?: 'NoShowLateHandlingStatusSearchRoot';
  all: Array<NoShowLateHandlingStatus>;
  byId: Maybe<NoShowLateHandlingStatus>;
};


export type NoShowLateHandlingStatusSearchRootByIdArgs = {
  id: Scalars['ID']['input'];
};

export type NoShowLateTypeSearchRoot = {
  __typename?: 'NoShowLateTypeSearchRoot';
  allCodeNoShowLateHandlingType: Array<CodeNoShowLateHandlingType>;
  allCodeNoShowLateType: Array<CodeNoShowLateType>;
  codeNoShowLateHandlingTypeById: Maybe<CodeNoShowLateHandlingType>;
  codeNoShowLateTypeById: Maybe<CodeNoShowLateType>;
};


export type NoShowLateTypeSearchRootCodeNoShowLateHandlingTypeByIdArgs = {
  id: Scalars['ID']['input'];
};


export type NoShowLateTypeSearchRootCodeNoShowLateTypeByIdArgs = {
  id: Scalars['ID']['input'];
};

export type NotesFormInput = {
  comment?: InputMaybe<RequiredStringInput>;
  externalComment?: InputMaybe<RequiredStringInput>;
  note?: InputMaybe<RequiredStringInput>;
};

export type Notification = {
  __typename?: 'Notification';
  id: Scalars['ID']['output'];
  text: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type NslhBooking = {
  __typename?: 'NslhBooking';
  articlePrice: Maybe<Scalars['Float']['output']>;
  bookingNo: Scalars['Int']['output'];
  bookingVersion: Scalars['Int']['output'];
  consignmentNo: Maybe<Scalars['Int']['output']>;
  customer: Customer;
  customerReference: Maybe<Scalars['String']['output']>;
  departureDate: Scalars['String']['output'];
  departureTime: Scalars['String']['output'];
  handlingStatus: Scalars['String']['output'];
  handlingType: Scalars['String']['output'];
  handlingTypeGrouped: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lateHandlingDate: Maybe<Scalars['String']['output']>;
  lateHandlingUser: Maybe<Scalars['String']['output']>;
  revisedDate: Maybe<Scalars['String']['output']>;
  revisedTime: Maybe<Scalars['String']['output']>;
  route: Route;
  trailerReg: Maybe<Scalars['String']['output']>;
  vehicleReg: Maybe<Scalars['String']['output']>;
  vehicleType: VehicleType;
};

export type NslhBookingRouteVolume = {
  __typename?: 'NslhBookingRouteVolume';
  customer: Customer;
  dateCalculated: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  month: Scalars['Int']['output'];
  routePair: RoutePair;
  shippedVolume: Scalars['Int']['output'];
  year: Scalars['Int']['output'];
};

export type NslhBookingRouteVolumeByFilterInput = {
  custNos: Array<Scalars['Int']['input']>;
  month: Scalars['Int']['input'];
  routePairCodes: Array<Scalars['String']['input']>;
  year: Scalars['Int']['input'];
};

export type NslhBookingRouteVolumeSearchRoot = {
  __typename?: 'NslhBookingRouteVolumeSearchRoot';
  byFilter: Array<NslhBookingRouteVolume>;
};


export type NslhBookingRouteVolumeSearchRootByFilterArgs = {
  input: NslhBookingRouteVolumeByFilterInput;
};

export type NslhBookingSearchRoot = {
  __typename?: 'NslhBookingSearchRoot';
  byId: Maybe<NslhBooking>;
};


export type NslhBookingSearchRootByIdArgs = {
  id: Scalars['ID']['input'];
};

export type NslhBookingVolume = {
  __typename?: 'NslhBookingVolume';
  consignment: Maybe<Consignment>;
  createdBy: Scalars['String']['output'];
  customer: Customer;
  dateCalculated: Maybe<Scalars['String']['output']>;
  dateCreated: Scalars['String']['output'];
  dateModified: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  modifiedBy: Maybe<Scalars['String']['output']>;
  month: Scalars['Int']['output'];
  shippedVolume: Scalars['Int']['output'];
  thresholdLateHandleBookings: Scalars['Int']['output'];
  thresholdLateHandlePercentage: Scalars['Float']['output'];
  thresholdNoShowBookings: Scalars['Int']['output'];
  thresholdNoShowPercentage: Scalars['Float']['output'];
  year: Scalars['Int']['output'];
};

export type NslhBookingVolumeSearchRoot = {
  __typename?: 'NslhBookingVolumeSearchRoot';
  byCustNosAndDate: Array<NslhBookingVolume>;
};


export type NslhBookingVolumeSearchRootByCustNosAndDateArgs = {
  input: NoShowLateHandlingBookingVolumesByCustNosAndDateInput;
};

export type NslhFollowUp = {
  __typename?: 'NslhFollowUp';
  customer: Customer;
  id: Scalars['ID']['output'];
  noOfExcludedLateHandlings: Scalars['Int']['output'];
  noOfExcludedNoShows: Scalars['Int']['output'];
  noOfLateHandlings: Scalars['Int']['output'];
  noOfNoShows: Scalars['Int']['output'];
  noOfThresholdLateHandlings: Scalars['Int']['output'];
  noOfThresholdNoShows: Scalars['Int']['output'];
  nslhBookingVolume: Maybe<NslhBookingVolume>;
  nslhBookings: Array<NslhBooking>;
  nslhRouteVolume: Maybe<NslhBookingRouteVolume>;
  routePair: RoutePair;
  shippedVolume: Scalars['Int']['output'];
};


export type NslhFollowUpNslhBookingVolumeArgs = {
  month: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};


export type NslhFollowUpNslhRouteVolumeArgs = {
  month: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};

export type NslhFollowUpByFilterInput = {
  custNo?: InputMaybe<Scalars['Int']['input']>;
  month: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};

export type NslhFollowUpSearchRoot = {
  __typename?: 'NslhFollowUpSearchRoot';
  byFilter: Array<NslhFollowUp>;
};


export type NslhFollowUpSearchRootByFilterArgs = {
  input: NslhFollowUpByFilterInput;
};

export type NslhInvoice = {
  __typename?: 'NslhInvoice';
  companyRouteOperatingCompanyId: Maybe<Scalars['Int']['output']>;
  consignmentNo: Maybe<Scalars['Int']['output']>;
  consignmentTypeCode: Maybe<Scalars['String']['output']>;
  custAddress1: Maybe<Scalars['String']['output']>;
  custAddress2: Maybe<Scalars['String']['output']>;
  custCity: Maybe<Scalars['String']['output']>;
  custCountryCode: Maybe<Scalars['String']['output']>;
  custCountryCodeDesc: Maybe<Scalars['String']['output']>;
  custCounty: Maybe<Scalars['String']['output']>;
  custLanguageCode: Maybe<Scalars['String']['output']>;
  custName: Maybe<Scalars['String']['output']>;
  custPostCode: Maybe<Scalars['String']['output']>;
  custRegion: Maybe<Scalars['Int']['output']>;
  customer: Customer;
  departureDateDd: Maybe<Scalars['String']['output']>;
  departureDateYyyymm: Maybe<Scalars['String']['output']>;
  documentTypeCode: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  invoiceCentre: Maybe<Scalars['String']['output']>;
  invoiceCompany: Maybe<Scalars['String']['output']>;
  invoiceCurrencyCode: Maybe<Scalars['String']['output']>;
  invoiceDate: Maybe<Scalars['String']['output']>;
  invoiceDueDate: Maybe<Scalars['String']['output']>;
  invoiceNo: Scalars['Int']['output'];
  invoicePrint: Maybe<Scalars['String']['output']>;
  invoiceTotalRounded: Maybe<Scalars['Int']['output']>;
  manualPrintHandling: Maybe<Scalars['Boolean']['output']>;
  microgenDocHeadInfoCode: Maybe<Scalars['String']['output']>;
  netAmount: Scalars['Int']['output'];
  nslhBookings: Array<NslhBooking>;
  nslhMonth: Scalars['Int']['output'];
  nslhYear: Scalars['Int']['output'];
  pricingInvExchangeRate: Maybe<Scalars['Int']['output']>;
  routeCodeBreak: Maybe<Scalars['String']['output']>;
  routeVolumes: Array<NslhBookingRouteVolume>;
  summaryInvoice: Maybe<Scalars['String']['output']>;
  thresholdLateHandling: Scalars['Int']['output'];
  thresholdNoShow: Scalars['Int']['output'];
  vatAmount: Maybe<Scalars['Int']['output']>;
  vatCountryCode: Maybe<Scalars['String']['output']>;
  vatCurrencyCode: Maybe<Scalars['String']['output']>;
  vatRate: Maybe<Scalars['Int']['output']>;
  vatRateCode: Maybe<Scalars['String']['output']>;
  vatTextNo: Maybe<Scalars['Int']['output']>;
};

export type NslhInvoiceByFilterInput = {
  custNos: Array<Scalars['Int']['input']>;
  fromMonth: Scalars['Int']['input'];
  fromYear: Scalars['Int']['input'];
  toMonth: Scalars['Int']['input'];
  toYear: Scalars['Int']['input'];
};

export type NslhInvoiceInfo = {
  __typename?: 'NslhInvoiceInfo';
  customer: Maybe<Customer>;
  id: Scalars['ID']['output'];
  lateHandlingDate: Scalars['String']['output'];
  noShowLateTypeCodes: Array<Scalars['String']['output']>;
  nslhInvoice: NslhInvoice;
};

export type NslhInvoiceSearchRoot = {
  __typename?: 'NslhInvoiceSearchRoot';
  byFilter: Array<NslhInvoiceInfo>;
  byId: Array<NslhInvoice>;
};


export type NslhInvoiceSearchRootByFilterArgs = {
  input: NslhInvoiceByFilterInput;
};


export type NslhInvoiceSearchRootByIdArgs = {
  id: Scalars['ID']['input'];
};

export type NumPerNegotiationStatus = {
  __typename?: 'NumPerNegotiationStatus';
  negotiationStatus: NegotiationStatus;
  num: Maybe<Scalars['Float']['output']>;
};

export type NumberVolumeStatisticsItem = {
  __typename?: 'NumberVolumeStatisticsItem';
  percentageOfAccount: Scalars['Float']['output'];
  percentageOfVolume: Scalars['Float']['output'];
};

export type OptionalBooleanInput = {
  value?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OptionalFloatInput = {
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type OptionalIdInput = {
  value?: InputMaybe<Scalars['ID']['input']>;
};

export type OptionalIntInput = {
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type OptionalPriceInput = {
  value?: InputMaybe<PriceInput>;
};

export type OptionalRouteAgreementTypeCodeInput = {
  value?: InputMaybe<RouteAgreementTypeCode>;
};

export type OptionalStringArrayInput = {
  value?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OptionalStringInput = {
  value?: InputMaybe<Scalars['String']['input']>;
};

export type OptionalValidDatesInput = {
  value?: InputMaybe<ValidDatesInput>;
};

export type PartialSeaArea = {
  __typename?: 'PartialSeaArea';
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type Price = {
  __typename?: 'Price';
  amount: Scalars['String']['output'];
};

export type PriceCalculator = {
  __typename?: 'PriceCalculator';
  ancillaryRecords: Array<AncillaryChargeV2>;
  auditLogs: Maybe<Array<Scalars['String']['output']>>;
  baseCurrencyCode: Scalars['String']['output'];
  convertedFrom: Maybe<Scalars['String']['output']>;
  errorMessage: Maybe<Scalars['String']['output']>;
  route: Route;
  seaFreightPrice: Scalars['Float']['output'];
  surchargeRecords: Array<SurChargeV2>;
  totalPrice: Scalars['Float']['output'];
  totalVat: Scalars['Float']['output'];
};

export type PriceCalculatorBooking = {
  __typename?: 'PriceCalculatorBooking';
  articles: Array<ConsignmentArticle>;
  bookingArticles: Array<BookingArticle>;
  bookingGoods: Array<BookingGoods>;
  bookingLegInvoice: Maybe<ConsignmentLegInvoice>;
  bookingLegNumber: Scalars['Int']['output'];
  bookingNumber: Scalars['Int']['output'];
  customerNumber: Scalars['Int']['output'];
  customerReference: Maybe<Scalars['String']['output']>;
  customsClassificationCode: Maybe<Scalars['String']['output']>;
  goods: Array<ConsignmentGoods>;
  hasLivestock: Scalars['Boolean']['output'];
  hazardousGoodsTotalWeight: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  importId: Maybe<Scalars['String']['output']>;
  includeImoClass1Row: Scalars['Boolean']['output'];
  length: Scalars['Float']['output'];
  livestockType: Maybe<LiveStock>;
  loadingPreferenceCode: Maybe<Scalars['String']['output']>;
  loadingPreferenceStatus: Maybe<Scalars['String']['output']>;
  movementType: MovementType;
  multiLegBookingNumber: Maybe<Scalars['Int']['output']>;
  multiLegRoute: Maybe<Route>;
  numberOfAdults: Maybe<Scalars['Int']['output']>;
  numberOfChildren: Maybe<Scalars['Int']['output']>;
  numberOfDrivers: Scalars['Int']['output'];
  numberOfFoc: Maybe<Scalars['Int']['output']>;
  numberOfHazardousGoodsRows: Scalars['Int']['output'];
  numberOfInfants: Maybe<Scalars['Int']['output']>;
  numberOfPlugins: Maybe<Scalars['Int']['output']>;
  numberOfSleepers: Maybe<Scalars['Int']['output']>;
  numberOfTradeVehicles: Maybe<Scalars['Int']['output']>;
  numberOfVehTypeUnits: Maybe<Scalars['Int']['output']>;
  priceCalculatorStatus: Maybe<Scalars['String']['output']>;
  qualifiedGoods: Scalars['Boolean']['output'];
  receiverCountryCode: Maybe<Scalars['String']['output']>;
  routeCode: Maybe<Route>;
  sailingBookingConsignment: SailingBookingConsignment;
  senderCountryCode: Maybe<Scalars['String']['output']>;
  standby: Scalars['Boolean']['output'];
  tradeVehicleWeight: Maybe<Scalars['Int']['output']>;
  trailerRegistrationNumber: Maybe<Scalars['String']['output']>;
  transit: Scalars['Boolean']['output'];
  vehicleRegistrationNumber: Maybe<Scalars['String']['output']>;
  vehicleType: VehicleType;
  version: Scalars['Int']['output'];
  weight: Maybe<Scalars['Int']['output']>;
  width: Scalars['Float']['output'];
};

export type PriceCalculatorError = {
  __typename?: 'PriceCalculatorError';
  error: Scalars['String']['output'];
  errorType: PriceCalculatorErrorType;
};

export enum PriceCalculatorErrorType {
  CouldNotPriceCalculate = 'CouldNotPriceCalculate',
  NotValidatedRequest = 'NotValidatedRequest'
}

export type PriceCalculatorInput = {
  ancillaries?: InputMaybe<Array<AncillaryRecordV2>>;
  customerNumber?: InputMaybe<Scalars['Int']['input']>;
  customsClassificationCode?: InputMaybe<Scalars['String']['input']>;
  departureDate?: InputMaybe<Scalars['String']['input']>;
  departureTime?: InputMaybe<Scalars['String']['input']>;
  goodsRecords?: InputMaybe<Array<GoodsRecordV2>>;
  hazardousGoodsTotalWeight?: InputMaybe<Scalars['Int']['input']>;
  importId?: InputMaybe<Scalars['String']['input']>;
  includeImoClass1Row?: InputMaybe<Scalars['Boolean']['input']>;
  length?: InputMaybe<Scalars['Float']['input']>;
  livestock?: InputMaybe<Scalars['Boolean']['input']>;
  livestockType?: InputMaybe<Scalars['String']['input']>;
  loadingPreferenceCode?: InputMaybe<Scalars['String']['input']>;
  loadingPreferenceStatus?: InputMaybe<Scalars['String']['input']>;
  movementType?: InputMaybe<Scalars['String']['input']>;
  multiLegRouteCode?: InputMaybe<Scalars['String']['input']>;
  noOfAdults?: InputMaybe<Scalars['Int']['input']>;
  noOfChildren?: InputMaybe<Scalars['Int']['input']>;
  noOfDrivers?: InputMaybe<Scalars['Int']['input']>;
  noOfFoc?: InputMaybe<Scalars['Int']['input']>;
  noOfHazardousGoodsRows?: InputMaybe<Scalars['Int']['input']>;
  noOfInfants?: InputMaybe<Scalars['Int']['input']>;
  noOfPlugins: Scalars['Int']['input'];
  noOfSleepers?: InputMaybe<Scalars['Int']['input']>;
  noOfTradeVehicles?: InputMaybe<Scalars['Int']['input']>;
  noOfVehTypeUnits?: InputMaybe<Scalars['Int']['input']>;
  offeredAgreementsAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  pendingAgreementsAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  qualifiedGoods: Scalars['Boolean']['input'];
  receiverCountryCode?: InputMaybe<Scalars['String']['input']>;
  routeCode: Scalars['String']['input'];
  routeLegs?: InputMaybe<Array<PriceCalculatorRouteLeg>>;
  sailingTypeCode?: InputMaybe<Scalars['String']['input']>;
  senderCountryCode?: InputMaybe<Scalars['String']['input']>;
  standBy: Scalars['Boolean']['input'];
  tradeVehicleWeight?: InputMaybe<Scalars['Int']['input']>;
  transit: Scalars['Boolean']['input'];
  useCustomerInvoiceCurrency?: InputMaybe<Scalars['Boolean']['input']>;
  vehicleTypeCode?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type PriceCalculatorMultiLeg = {
  __typename?: 'PriceCalculatorMultiLeg';
  list: Array<PriceCalculator>;
};

export type PriceCalculatorMultiLegResultV2 = PriceCalculatorError | PriceCalculatorMultiLeg;

export type PriceCalculatorResultV2 = PriceCalculator | PriceCalculatorError;

export type PriceCalculatorRouteLeg = {
  departureDate?: InputMaybe<Scalars['String']['input']>;
  departureTime?: InputMaybe<Scalars['String']['input']>;
  routeCode?: InputMaybe<Scalars['String']['input']>;
  sailingTypeCode?: InputMaybe<Scalars['String']['input']>;
};

export type PriceCalculatorSearchRoot = {
  __typename?: 'PriceCalculatorSearchRoot';
  bookingVersions: BookingVersionsSearchRoot;
  bookings: BookingsSearchRoot;
  byInput: PriceCalculatorResultV2;
  byMultiLegInput: PriceCalculatorMultiLegResultV2;
};


export type PriceCalculatorSearchRootByInputArgs = {
  variables: PriceCalculatorInput;
};


export type PriceCalculatorSearchRootByMultiLegInputArgs = {
  variables: PriceCalculatorInput;
};

export type PriceInput = {
  amount: Scalars['String']['input'];
};

export type PriceListFilterInput = {
  currency: Scalars['String']['input'];
  customerNumbers?: InputMaybe<Array<Scalars['Int']['input']>>;
  date: Scalars['String']['input'];
  lengthFrom: Scalars['Int']['input'];
  lengthTo: Scalars['Int']['input'];
  movementTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  routeAgreementCurrencies?: InputMaybe<Array<Scalars['String']['input']>>;
  routes: Array<Scalars['String']['input']>;
  sailingCategories?: InputMaybe<Array<Scalars['String']['input']>>;
  vehicleTypes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type PriceListResult = {
  __typename?: 'PriceListResult';
  priceListRows: Array<PriceListRow>;
};

export type PriceListRow = {
  __typename?: 'PriceListRow';
  customerIndex: Scalars['String']['output'];
  customerNumber: Scalars['Int']['output'];
  length: Scalars['Int']['output'];
  movementType: Scalars['String']['output'];
  price: Scalars['Float']['output'];
  route: Scalars['String']['output'];
  routeAgreementCurrency: Scalars['String']['output'];
  routeAgreementName: Scalars['String']['output'];
  routeAgreementNumber: Scalars['Int']['output'];
  routeAgreementVehicleType: Maybe<Scalars['String']['output']>;
  sailingCategory: Scalars['String']['output'];
  unaccompanied: Maybe<Scalars['String']['output']>;
  validFrom: Scalars['String']['output'];
  validTo: Scalars['String']['output'];
  vehicleType: Scalars['String']['output'];
  weightFrom: Maybe<Scalars['Float']['output']>;
  weightTo: Maybe<Scalars['Float']['output']>;
};

export type PriceListSearchRoot = {
  __typename?: 'PriceListSearchRoot';
  byFilter: PriceListResult;
};


export type PriceListSearchRootByFilterArgs = {
  filter: PriceListFilterInput;
};

export type ProductPriceMutationRoot = {
  __typename?: 'ProductPriceMutationRoot';
  additionalCharges: AdditionalChargesMutationRoot;
  adminTarget: AdminTargetMutationRoot;
  agreementDocuments: AgreementDocumentMutationRoot;
  customer: CustomerMutationRoot;
  customerRouteStatistics: CustomerRouteStatisticsMutationRoot;
  expectedVolume: ExpectedVolumeMutationRoot;
  headAgreement: HeadAgreementMutationRoot;
  multiLegRouteAgreement: MultiLegRouteAgreementMutationRoot;
  noShowLateHandlingBookings: NoShowLateHandlingBookingsMutationRoot;
  noShowLateHandlingInvoices: NoShowLateHandlingInvoicesMutationRoot;
  noShowLateHandlingPrices: NoShowLateHandlingMutationRoot;
  rebate: RebateMutationRoot;
  routeAgreement: RouteAgreementMutationRoot;
  routeAgreementPrice: RouteAgreementPriceMutationRoot;
  routePairCustomerTarget: RoutePairCustomerTargetMutationRoot;
  targetOverview: TargetOverviewMutationRoot;
};

export type ProductPriceSearchRoot = {
  __typename?: 'ProductPriceSearchRoot';
  actualPriceChange: ActualPriceChangeSearchRoot;
  additionalCharges: AdditionalChargesSearchRoot;
  agrRouteSailingTypes: AgrRouteSailingTypesSearchRoot;
  agreementDocuments: Maybe<AgreementDocumentsSearchRoot>;
  agreementTexts: AgreementTextsSearchRoot;
  articleType: ArticleTypeSearchRoot;
  buildVersions: BuildVersion;
  consignmentVersions: ConsignmentVersionsSearchRoot;
  consignments: ConsignmentsSearchRoot;
  country: CountrySearchRoot;
  currency: CurrencySearchRoot;
  customerCategory: CustomerCategorySearchRoot;
  customerRouteStatistics: CustomerRouteStatisticsSearchRoot;
  customerStatistics: CustomerStatisticsSearchRoot;
  customerThreshold: CustomerThresholdSearchRoot;
  customers: CustomerSearchRoot;
  customsClassification: CustomsClassificationSearchRoot;
  distanceType: DistanceTypeSearchRoot;
  features: FeatureFlag;
  formula: FormulaSearchRoot;
  goods: GoodsSearchRoot;
  headAgreement: HeadAgreementSearchRoot;
  liveStock: LiveStockSearchRoot;
  loadingPreference: LoadingPreferenceSearchRoot;
  matrices: MatrixSearchRoot;
  movementType: MovementTypeSearchRoot;
  multiLegRouteAgreement: MultiLegRouteAgreementSearchRoot;
  negotiationStatus: NegotiationStatusSearchRoot;
  negotiationYear: NegotiationYearSearchRoot;
  noShowLateHandling: NoShowLateHandlingSearchRoot;
  noShowLateHandlingBookings: Maybe<NoShowLateHandlingBookingsSearchRoot>;
  noShowLateHandlingExcludeReason: NoShowLateHandlingExcludeReasonSearchRoot;
  noShowLateHandlingPrices: Maybe<NoShowLateHandlingPricesSearchRoot>;
  noShowLateHandlingStatus: NoShowLateHandlingStatusSearchRoot;
  noShowLateTypes: NoShowLateTypeSearchRoot;
  publicOverview: PublicOverviewSearchRoot;
  route: RouteSearchRoot;
  routeAgreement: RouteAgreementSearchRoot;
  routeAgreementPrice: RouteAgreementPriceSearchRoot;
  routePair: RoutePairSearchRoot;
  routePairNegotiationYear: RoutePairNegotiationYearSearchRoot;
  sailingArchives: Maybe<SailingArchivesSearchRoot>;
  sailingCategory: SailingCategorySearchRoot;
  sailings: Maybe<SailingsSearchRoot>;
  salesRegion: SalesRegionSearchRoot;
  seaArea: SeaAreaSearchRoot;
  targetAdmin: TargetAdminSearchRoot;
  targetNegotiationStatus: TargetNegotiationStatusSearchRoot;
  targetOverviews: TargetOverviewSearchRoot;
  targetRoutePair: TargetRoutePairSearchRoot;
  targetSummary: TargetSummarySearchRoot;
  unitType: UnitTypeSearchRoot;
  user: UserSearchRoot;
  userProfile: UserProfileSearchRoot;
  vehicleType: VehicleTypeSearchRoot;
};

export type PublicOverviewBookings = {
  __typename?: 'PublicOverviewBookings';
  customer: Customer;
  customerThresholdLateHandlingPercentage: Maybe<Scalars['Float']['output']>;
  customerThresholdNoShowPercentage: Maybe<Scalars['Float']['output']>;
  excludedLateHandlings: Scalars['Int']['output'];
  excludedNoShows: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  lateHandlingPercentage: Scalars['Float']['output'];
  noOfLateHandlings: Scalars['Int']['output'];
  noOfNoShows: Scalars['Int']['output'];
  noShowPercentage: Scalars['Float']['output'];
  routePairCode: Maybe<Scalars['String']['output']>;
  routePairDescription: Maybe<Scalars['String']['output']>;
  shippedVolume: Scalars['Int']['output'];
};

export type PublicOverviewSearchRoot = {
  __typename?: 'PublicOverviewSearchRoot';
  byPeriod: Array<PublicOverviewBookings>;
};


export type PublicOverviewSearchRootByPeriodArgs = {
  input: ByPublicOverviewPeriodInput;
};

export type Query = {
  __typename?: 'Query';
  hello: Maybe<Scalars['String']['output']>;
  priceCalculator: PriceCalculatorSearchRoot;
  priceList: PriceListSearchRoot;
  productPrice: ProductPriceSearchRoot;
  rebates: RebateSearchRoot;
  statistics: StatisticsSearchRoot;
  validateRoutesForAgreement: Maybe<ValidationResponse>;
};


export type QueryValidateRoutesForAgreementArgs = {
  custNo: Scalars['Int']['input'];
  headAgreementId: Scalars['ID']['input'];
  multiLegAgreements: InputMaybe<Array<Scalars['String']['input']>>;
  routeAgreements: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum RaiseByType {
  Absolute = 'ABSOLUTE',
  Percent = 'PERCENT'
}

export enum RaiseType {
  FixedPrice = 'FIXED_PRICE',
  MeterPrice = 'METER_PRICE'
}

export type RateChangeAllChartsData = {
  __typename?: 'RateChangeAllChartsData';
  offPeak: RateChangeChartData;
  peak: RateChangeChartData;
  shoulder: RateChangeChartData;
  total: RateChangeChartData;
};

export type RateChangeAllTablesData = {
  __typename?: 'RateChangeAllTablesData';
  offPeak: RateChangeTableData;
  peak: RateChangeTableData;
  shoulder: RateChangeTableData;
  total: RateChangeTableData;
};

export type RateChangeChartData = {
  __typename?: 'RateChangeChartData';
  averageRateChange: Maybe<Scalars['Float']['output']>;
  averageTarget: Maybe<Scalars['Float']['output']>;
};

export type RateChangeData = {
  __typename?: 'RateChangeData';
  charts: RateChangeAllChartsData;
  tables: RateChangeAllTablesData;
};

export type RateChangeTableData = {
  __typename?: 'RateChangeTableData';
  acc: RateChangeTableRowData;
  total: RateChangeTableRowData;
  unacc: RateChangeTableRowData;
};

export type RateChangeTableRowData = {
  __typename?: 'RateChangeTableRowData';
  rate: Maybe<Scalars['Float']['output']>;
  target: Maybe<Scalars['Float']['output']>;
};

export type RateSheetChanges = {
  created: Array<CreateRateSheetsPriceItemInput>;
  deleted: Array<DeleteRateSheetsPriceItemInput>;
  updated: Array<UpdateRateSheetsPriceItemInput>;
};

export type RateSheetPriceChangesInput = {
  acc?: InputMaybe<RequiredBooleanInput>;
  actual?: InputMaybe<OptionalFloatInput>;
  additionalFrom?: InputMaybe<OptionalFloatInput>;
  avgGrossPrice?: InputMaybe<OptionalPriceInput>;
  avgLength?: InputMaybe<OptionalFloatInput>;
  avgRebate?: InputMaybe<OptionalPriceInput>;
  empty?: InputMaybe<RequiredBooleanInput>;
  lastChargedFrom?: InputMaybe<OptionalFloatInput>;
  lastMeterPrice?: InputMaybe<OptionalPriceInput>;
  lastPrice?: InputMaybe<OptionalPriceInput>;
  lengthFrom?: InputMaybe<OptionalFloatInput>;
  lengthTo?: InputMaybe<OptionalFloatInput>;
  loaded?: InputMaybe<RequiredBooleanInput>;
  meterPrice?: InputMaybe<OptionalPriceInput>;
  newPrice?: InputMaybe<RequiredPriceInput>;
  unacc?: InputMaybe<RequiredBooleanInput>;
  vehicleTypeId?: InputMaybe<OptionalIdInput>;
  volume?: InputMaybe<OptionalFloatInput>;
  weightFrom?: InputMaybe<OptionalIntInput>;
  weightTo?: InputMaybe<OptionalIntInput>;
};

export type RebateAgreement = {
  __typename?: 'RebateAgreement';
  createdBy: Maybe<Scalars['String']['output']>;
  currencyCode: Maybe<Scalars['String']['output']>;
  dateCreated: Scalars['String']['output'];
  dateModified: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  modifiedBy: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  paymentAsCode: Maybe<Scalars['String']['output']>;
  paymentReceiverCode: Maybe<Scalars['String']['output']>;
  paymentReceiverCustomer: Maybe<Scalars['Int']['output']>;
  rebateAgreementNumber: Maybe<Scalars['Int']['output']>;
  rebateStatusCode: Maybe<Scalars['String']['output']>;
  topLevelRebateModelCode: Maybe<Scalars['String']['output']>;
  topLevelRebateTermCode: Maybe<Scalars['String']['output']>;
  topLevelTarget: Maybe<Scalars['Int']['output']>;
  validFrom: Scalars['String']['output'];
  validTo: Scalars['String']['output'];
};

export type RebateAgreementDocuments = {
  __typename?: 'RebateAgreementDocuments';
  customerNumber: Scalars['Int']['output'];
  fileName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  negotiationYear: Scalars['Int']['output'];
  rebateAgreementId: Scalars['String']['output'];
  rebateAgreementValidFromDate: Scalars['String']['output'];
  rebateAgreementValidToDate: Scalars['String']['output'];
  writeHistory: WriteHistory;
};

export enum RebateAgreementStatusCode {
  Active = 'ACTIVE',
  Finalized = 'FINALIZED',
  Pending = 'PENDING',
  Void = 'VOID'
}

export type RebateMutationRoot = {
  __typename?: 'RebateMutationRoot';
  authorizePayment: Scalars['Boolean']['output'];
  handleRebate: Scalars['Boolean']['output'];
  setExpectedVolume: Scalars['Boolean']['output'];
};


export type RebateMutationRootAuthorizePaymentArgs = {
  goalId: Scalars['ID']['input'];
};


export type RebateMutationRootHandleRebateArgs = {
  input: HandleRebateInput;
};


export type RebateMutationRootSetExpectedVolumeArgs = {
  input: SetExpectedVolumeInput;
};

export type RebateOverview = {
  __typename?: 'RebateOverview';
  achieved: Scalars['Int']['output'];
  creditNoteBookingNumbers: Array<Scalars['Int']['output']>;
  criteriaIds: Array<Scalars['ID']['output']>;
  criterias: Array<Criteria>;
  customers: Array<Customer>;
  displayedTarget: Scalars['String']['output'];
  goalIds: Array<Scalars['String']['output']>;
  goals: Array<Goal>;
  period: Scalars['Int']['output'];
  rebateAgreement: Maybe<RebateAgreement>;
  rebateAgreementId: Scalars['String']['output'];
  rebateAgreementNumber: Scalars['Int']['output'];
  rebateTermCode: Scalars['String']['output'];
  reservedAmount: Scalars['Float']['output'];
  sellerIds: Array<Scalars['String']['output']>;
};

export type RebateOverviewFilter = {
  customerNumber?: InputMaybe<Scalars['Int']['input']>;
  goalStatusCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  rebateAgreementNumber?: InputMaybe<Scalars['Int']['input']>;
  rebateTermCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  salesRegionCodes?: InputMaybe<Array<Scalars['Int']['input']>>;
  sellerId?: InputMaybe<Scalars['String']['input']>;
  validFrom?: InputMaybe<Scalars['String']['input']>;
  validTo?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

export enum RebatePayoutStatusCode {
  Failed = 'FAILED',
  Negotiated = 'NEGOTIATED',
  Paid = 'PAID'
}

export type RebateProgress = {
  __typename?: 'RebateProgress';
  achieved: Scalars['Float']['output'];
  completionPercent: Scalars['Float']['output'];
  criteria: Maybe<Criteria>;
  criteriaId: Scalars['ID']['output'];
  displayedTarget: Scalars['String']['output'];
  expectedVolume: Maybe<Scalars['Float']['output']>;
  goal: Maybe<Goal>;
  goalId: Scalars['ID']['output'];
  neededVolume: Scalars['Float']['output'];
  period: Scalars['Int']['output'];
  rebateAgreement: Maybe<RebateAgreement>;
  rebateAgreementId: Scalars['ID']['output'];
  suggestedExpectedVolume: Scalars['Float']['output'];
  usedTarget: Scalars['Float']['output'];
};

export type RebateProgressFilter = {
  customerNumber?: InputMaybe<Scalars['Int']['input']>;
  rebateAgreementNumber?: InputMaybe<Scalars['Int']['input']>;
  rebateTermCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  salesRegionCodes?: InputMaybe<Array<Scalars['Int']['input']>>;
  sellerId?: InputMaybe<Scalars['String']['input']>;
  validFrom?: InputMaybe<Scalars['String']['input']>;
  validTo?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type RebateSearchRoot = {
  __typename?: 'RebateSearchRoot';
  rebateAgreement: RebateAgreement;
  rebateOverview: Array<RebateOverview>;
  rebateProgress: Array<RebateProgress>;
};


export type RebateSearchRootRebateAgreementArgs = {
  id: Scalars['ID']['input'];
};


export type RebateSearchRootRebateOverviewArgs = {
  filter: RebateOverviewFilter;
};


export type RebateSearchRootRebateProgressArgs = {
  filter: RebateProgressFilter;
};

export type ReportsForCustomers = {
  customerCountry: Scalars['String']['input'];
  customerNumber: Scalars['Int']['input'];
  subscriberContactId?: InputMaybe<Scalars['String']['input']>;
};

export type RequiredBooleanInput = {
  value: Scalars['Boolean']['input'];
};

export type RequiredFloatInput = {
  value: Scalars['Float']['input'];
};

export type RequiredFormulaDataFormInput = {
  value: FormulaDataFormInput;
};

export type RequiredIdInput = {
  value: Scalars['ID']['input'];
};

export type RequiredIntInput = {
  value: Scalars['Int']['input'];
};

export type RequiredPriceInput = {
  value: PriceInput;
};

export type RequiredRouteAgreementTypeCodeInput = {
  value: RouteAgreementTypeCode;
};

export type RequiredStringArrayInput = {
  value: Array<Scalars['String']['input']>;
};

export type RequiredStringInput = {
  value: Scalars['String']['input'];
};

export type RequiredValidDatesInput = {
  value: ValidDatesInput;
};

export type Route = {
  __typename?: 'Route';
  code: Scalars['String']['output'];
  distanceType: Maybe<DistanceType>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  pairedRoute: Route;
  routeLegs: Array<RouteLeg>;
  routePair: RoutePair;
  routeType: Scalars['String']['output'];
};

export type RouteAgreement = {
  __typename?: 'RouteAgreement';
  agreementNumber: Scalars['Int']['output'];
  articles: Array<RouteAgreementArticle>;
  breadCrumbName: Scalars['String']['output'];
  comment: Maybe<Scalars['String']['output']>;
  currency: Currency;
  externalComment: Maybe<Scalars['String']['output']>;
  externalDescription: Maybe<Scalars['String']['output']>;
  goods: Array<Goods>;
  hasArticles: Scalars['Boolean']['output'];
  hasConditions: Scalars['Boolean']['output'];
  hasMatrix: Scalars['Boolean']['output'];
  headAgreement: HeadAgreement;
  id: Scalars['ID']['output'];
  isSalesReady: Scalars['Boolean']['output'];
  matrices: Array<RouteAgreementMatrix>;
  multiLegAgrRouteId: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  note: Maybe<Scalars['String']['output']>;
  prices: Array<RouteAgreementPrice>;
  receiverCountries: Array<Country>;
  routeDescription: Scalars['String']['output'];
  routes: Array<Route>;
  rowVersion: Scalars['String']['output'];
  sailingTypeCodes: Array<SailingTypeCode>;
  senderCountries: Array<Country>;
  standby: Scalars['Boolean']['output'];
  statusCode: HeadAgreementStatusCode;
  transit: Scalars['Boolean']['output'];
  typeCode: RouteAgreementTypeCode;
  valid: DateRange;
  writeHistory: WriteHistory;
};

export type RouteAgreementArticle = {
  __typename?: 'RouteAgreementArticle';
  articleType: ArticleType;
  formulaData: Maybe<FormulaData>;
  formulaType: Maybe<FormulaType>;
  id: Scalars['ID']['output'];
  includedInPrice: Scalars['Boolean']['output'];
  maxNumberOf: Maybe<Scalars['Int']['output']>;
  maxPrice: Maybe<Scalars['Float']['output']>;
  prices: Array<ArticlePrice>;
  validities: Array<ArticlePriceValidity>;
};

export type RouteAgreementFormInput = {
  articles: ArticlesFormInput;
  conditions: ConditionsFormInput;
  matrix: MatrixFormInput;
  notes: NotesFormInput;
  routes: RoutesFormInput;
};

export type RouteAgreementMatrix = {
  __typename?: 'RouteAgreementMatrix';
  id: Scalars['ID']['output'];
  matrix: Matrix;
  routeAgreement: RouteAgreement;
  valid: DateRange;
  version: Scalars['String']['output'];
  writeHistory: WriteHistory;
};

export type RouteAgreementMutationRoot = {
  __typename?: 'RouteAgreementMutationRoot';
  activateRouteAgreement: UpdateRouteAgreementResult;
  changeRouteAgreementStatus: UpdateRouteAgreementResult;
  copyRouteAgreement: CopyRouteAgreementResult;
  createRouteAgreement: CreateRouteAgreementResult;
  deleteRouteAgreement: DeleteRouteAgreementResult;
  updateAgreementArticles: Array<UpdateAgreementArticlesResult>;
  updateRouteAgreement: UpdateRouteAgreementResult;
  updateRouteAgreementConnectedToMultiLeg: UpdateRouteAgreementConnectedToMultiLegResult;
};


export type RouteAgreementMutationRootActivateRouteAgreementArgs = {
  routeAgreement: ActivateRouteAgreementInput;
};


export type RouteAgreementMutationRootChangeRouteAgreementStatusArgs = {
  routeAgreementId: Scalars['ID']['input'];
  rowVersion: Scalars['String']['input'];
  status: HeadAgreementStatusCode;
};


export type RouteAgreementMutationRootCopyRouteAgreementArgs = {
  input: CopyRouteAgreementInput;
};


export type RouteAgreementMutationRootCreateRouteAgreementArgs = {
  input: CreateRouteAgreementInput;
};


export type RouteAgreementMutationRootDeleteRouteAgreementArgs = {
  routeAgreementId: Scalars['ID']['input'];
  rowVersion: Scalars['String']['input'];
};


export type RouteAgreementMutationRootUpdateAgreementArticlesArgs = {
  input: UpdateAgreementArticlesInput;
};


export type RouteAgreementMutationRootUpdateRouteAgreementArgs = {
  input: UpdateRouteAgreementInput;
};


export type RouteAgreementMutationRootUpdateRouteAgreementConnectedToMultiLegArgs = {
  input: UpdateRouteAgreementInput;
};

export type RouteAgreementPrice = {
  __typename?: 'RouteAgreementPrice';
  actual: Maybe<Scalars['Float']['output']>;
  additionalFrom: Maybe<Scalars['Float']['output']>;
  avgGrossPrice: Maybe<Price>;
  avgLength: Maybe<Scalars['Float']['output']>;
  avgNetPrice: Maybe<Price>;
  avgRebate: Maybe<Price>;
  calculateActualPriceChange: Maybe<Scalars['Float']['output']>;
  cargoStatusCode: CargoStatusCode;
  id: Scalars['ID']['output'];
  internalComments: Maybe<Scalars['String']['output']>;
  lastChargedFrom: Maybe<Scalars['Float']['output']>;
  lastMeterPrice: Maybe<Price>;
  lastPrice: Maybe<Price>;
  lengthFrom: Maybe<Scalars['Float']['output']>;
  lengthTo: Maybe<Scalars['Float']['output']>;
  meterPrice: Price;
  newPrice: Price;
  routeAgreement: RouteAgreement;
  unaccompanied: Maybe<Scalars['Boolean']['output']>;
  vehicleType: Maybe<VehicleType>;
  volume: Maybe<Scalars['Int']['output']>;
  weightFrom: Maybe<Scalars['Float']['output']>;
  weightTo: Maybe<Scalars['Float']['output']>;
  writeHistory: WriteHistory;
};


export type RouteAgreementPriceCalculateActualPriceChangeArgs = {
  additionalFrom: Scalars['Float']['input'];
  avgGrossPrice: InputMaybe<Scalars['Float']['input']>;
  avgLength: InputMaybe<Scalars['Float']['input']>;
  meterPrice: Scalars['Float']['input'];
  newPrice: Scalars['Float']['input'];
  oldAdditionalFrom: InputMaybe<Scalars['Float']['input']>;
  oldFixPrice: InputMaybe<Scalars['Float']['input']>;
  oldVarPrice: InputMaybe<Scalars['Float']['input']>;
};

export type RouteAgreementPriceByFilterResult = {
  __typename?: 'RouteAgreementPriceByFilterResult';
  agrRoutePrices: Maybe<Array<RouteAgreementPrice>>;
  numberOfAgrRouteRates: Scalars['Int']['output'];
};

export type RouteAgreementPriceCalculateStatisticsInput = {
  cargoStatusCode?: InputMaybe<CargoStatusCode>;
  currencyCode: Scalars['String']['input'];
  customerId: Scalars['ID']['input'];
  lengthFrom?: InputMaybe<Scalars['Float']['input']>;
  lengthTo?: InputMaybe<Scalars['Float']['input']>;
  offPeak: Scalars['Boolean']['input'];
  peak: Scalars['Boolean']['input'];
  routeAgreementId: Scalars['ID']['input'];
  routeAgreementPriceId: Scalars['ID']['input'];
  routeCodes: Array<Scalars['String']['input']>;
  shoulder: Scalars['Boolean']['input'];
  special: Scalars['Boolean']['input'];
  unaccompanied?: InputMaybe<Scalars['Boolean']['input']>;
  validFrom: DateInput;
  vehicleTypeId?: InputMaybe<Scalars['String']['input']>;
};

export type RouteAgreementPriceCalculateStatisticsResult = {
  __typename?: 'RouteAgreementPriceCalculateStatisticsResult';
  avgGrossPrice: Price;
  avgLength: Scalars['Float']['output'];
  avgRebate: Price;
  routeAgreementPriceId: Scalars['ID']['output'];
  volume: Scalars['Float']['output'];
};

export type RouteAgreementPriceMutationRoot = {
  __typename?: 'RouteAgreementPriceMutationRoot';
  updateMultiLegRateSheets: Array<UpdateRateSheetsResult>;
  updateRateSheets: Array<UpdateRateSheetsResult>;
};


export type RouteAgreementPriceMutationRootUpdateMultiLegRateSheetsArgs = {
  input: UpdateRateSheetsInput;
};


export type RouteAgreementPriceMutationRootUpdateRateSheetsArgs = {
  input: UpdateRateSheetsInput;
};

export type RouteAgreementPriceSearchRoot = {
  __typename?: 'RouteAgreementPriceSearchRoot';
  byFilter: RouteAgreementPriceByFilterResult;
  calculateStatistics: RouteAgreementPriceCalculateStatisticsResult;
};


export type RouteAgreementPriceSearchRootByFilterArgs = {
  input: RouteAgreementPricesByFilterInput;
};


export type RouteAgreementPriceSearchRootCalculateStatisticsArgs = {
  input: RouteAgreementPriceCalculateStatisticsInput;
};

export type RouteAgreementPricesByFilterInput = {
  agreementId: Scalars['String']['input'];
  emptyLoaded?: InputMaybe<Array<Scalars['String']['input']>>;
  lengthFrom?: InputMaybe<Scalars['Float']['input']>;
  lengthTo?: InputMaybe<Scalars['Float']['input']>;
  routePairCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  sailingTypeCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  unaccompanied?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vehicleTypeCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  weightFrom?: InputMaybe<Scalars['Float']['input']>;
  weightTo?: InputMaybe<Scalars['Float']['input']>;
};

export type RouteAgreementSearchRoot = {
  __typename?: 'RouteAgreementSearchRoot';
  byHeadAgreementAndRoutePair: Array<RouteAgreement>;
  byId: Maybe<RouteAgreement>;
};


export type RouteAgreementSearchRootByHeadAgreementAndRoutePairArgs = {
  headAgreementId: Scalars['ID']['input'];
  routePairId: Scalars['ID']['input'];
};


export type RouteAgreementSearchRootByIdArgs = {
  id: Scalars['ID']['input'];
};

export enum RouteAgreementTypeCode {
  Base = 'BASE',
  Cond = 'COND'
}

export type RouteAgreementWithValidity = {
  routeAgreementId: Scalars['ID']['input'];
  valid: ValidDatesInput;
};

export type RouteAgreementsByRoutePairCode = {
  routeAgreements: Array<CalculatePriceRouteAgreementInput>;
  routePairCode: Scalars['String']['input'];
};

export type RouteLeg = {
  __typename?: 'RouteLeg';
  id: Scalars['ID']['output'];
  legNo: Scalars['Int']['output'];
  legRoute: Route;
  route: Route;
};

export type RoutePair = {
  __typename?: 'RoutePair';
  code: Scalars['String']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  routes: Array<Route>;
  seaArea: SeaArea;
  statisticsForCustomerIdAndYear: Maybe<CustomerRoutePairStatistics>;
};


export type RoutePairStatisticsForCustomerIdAndYearArgs = {
  customerId: Scalars['ID']['input'];
  year: Scalars['Int']['input'];
};

export type RoutePairCustomerTargetMutationRoot = {
  __typename?: 'RoutePairCustomerTargetMutationRoot';
  updateRoutePairCustomerTargets: RoutePairCustomerTargetResult;
};


export type RoutePairCustomerTargetMutationRootUpdateRoutePairCustomerTargetsArgs = {
  filter: TargetRoutePairInput;
  input: UpdateRoutePairCustomerTargetInput;
};

export type RoutePairCustomerTargetResult = ErrorResult | RoutePairCustomerTargetSuccessResult;

export type RoutePairCustomerTargetSuccessResult = {
  __typename?: 'RoutePairCustomerTargetSuccessResult';
  targetRoutePairs: Array<TargetRoutePair>;
};

export type RoutePairNegotiationYear = {
  __typename?: 'RoutePairNegotiationYear';
  id: Scalars['ID']['output'];
  routePair: RoutePair;
  status: Scalars['String']['output'];
  volumeTarget: Maybe<Scalars['Float']['output']>;
  year: Scalars['Int']['output'];
};

export type RoutePairNegotiationYearSearchRoot = {
  __typename?: 'RoutePairNegotiationYearSearchRoot';
  byRoutePairAndYear: Maybe<RoutePairNegotiationYear>;
};


export type RoutePairNegotiationYearSearchRootByRoutePairAndYearArgs = {
  routePairCode: Scalars['String']['input'];
  year: Scalars['Int']['input'];
};

export type RoutePairSearchRoot = {
  __typename?: 'RoutePairSearchRoot';
  allWithStatusOwn: Array<RoutePair>;
  byId: Maybe<RoutePair>;
  byRouteTypeCodes: Array<RoutePair>;
};


export type RoutePairSearchRootAllWithStatusOwnArgs = {
  includeNotValidRoutes: InputMaybe<Scalars['Boolean']['input']>;
};


export type RoutePairSearchRootByIdArgs = {
  id: Scalars['ID']['input'];
};


export type RoutePairSearchRootByRouteTypeCodesArgs = {
  includeNotValidRoutes: InputMaybe<Scalars['Boolean']['input']>;
  typeCodes: Array<Scalars['String']['input']>;
};

export type RouteSearchRoot = {
  __typename?: 'RouteSearchRoot';
  all: Array<Route>;
  allMultiLeg: Array<Route>;
  byId: Maybe<Route>;
  byRouteTypes: Array<Route>;
};


export type RouteSearchRootByIdArgs = {
  id: Scalars['ID']['input'];
};


export type RouteSearchRootByRouteTypesArgs = {
  excludeOnlyAsPartOfMultiLegRoutes: Scalars['Boolean']['input'];
  includeNotValid: Scalars['Boolean']['input'];
  routeTypes: Array<Scalars['String']['input']>;
};

export type RoutesFormInput = {
  currencyId?: InputMaybe<RequiredStringInput>;
  externalDescription?: InputMaybe<RequiredStringInput>;
  isSalesReady?: InputMaybe<RequiredBooleanInput>;
  name?: InputMaybe<RequiredStringInput>;
  offPeak?: InputMaybe<RequiredBooleanInput>;
  peak?: InputMaybe<RequiredBooleanInput>;
  routeIds?: InputMaybe<RequiredStringArrayInput>;
  shoulder?: InputMaybe<RequiredBooleanInput>;
  special?: InputMaybe<RequiredBooleanInput>;
  type?: InputMaybe<RequiredRouteAgreementTypeCodeInput>;
  valid?: InputMaybe<RequiredValidDatesInput>;
};

export type Sailing = {
  __typename?: 'Sailing';
  arrivalDate: Scalars['String']['output'];
  arrivalLocation: Maybe<Scalars['String']['output']>;
  arrivalTime: Scalars['String']['output'];
  blocked: Scalars['String']['output'];
  departureDate: Scalars['String']['output'];
  departureLocation: Maybe<Scalars['String']['output']>;
  departureTime: Scalars['String']['output'];
  estimArrivalDate: Scalars['String']['output'];
  estimArrivalTime: Scalars['String']['output'];
  extranetExcluded: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  realArrivalDate: Maybe<Scalars['String']['output']>;
  realArrivalTime: Maybe<Scalars['String']['output']>;
  realDepartureDate: Scalars['String']['output'];
  realDepartureTime: Scalars['String']['output'];
  route: Route;
  sailingTypeCode: Scalars['String']['output'];
  statusCode: Scalars['String']['output'];
  statusDescription: Maybe<Scalars['String']['output']>;
};

export type SailingArchive = {
  __typename?: 'SailingArchive';
  departureDate: Scalars['String']['output'];
  departureTime: Scalars['String']['output'];
  dummy: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  route: Route;
  sailingType: Maybe<SailingTypeCode>;
  shipCode: Scalars['String']['output'];
};

export type SailingArchivesSearchRoot = {
  __typename?: 'SailingArchivesSearchRoot';
  byId: Maybe<SailingArchive>;
  byRouteCodeDeparture: Array<SailingArchive>;
};


export type SailingArchivesSearchRootByIdArgs = {
  id: Scalars['ID']['input'];
};


export type SailingArchivesSearchRootByRouteCodeDepartureArgs = {
  departureDate: Scalars['String']['input'];
  routeCode: Scalars['String']['input'];
};

export type SailingBookingConsignment = {
  __typename?: 'SailingBookingConsignment';
  departureDate: Scalars['String']['output'];
  departureTime: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  route: Route;
  sailingType: Maybe<SailingTypeCode>;
};

export type SailingCategory = {
  __typename?: 'SailingCategory';
  code: Scalars['String']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  presentationOrder: Scalars['Int']['output'];
};

export type SailingCategorySearchRoot = {
  __typename?: 'SailingCategorySearchRoot';
  all: Array<SailingCategory>;
  byId: Maybe<SailingCategory>;
};


export type SailingCategorySearchRootByIdArgs = {
  id: Scalars['ID']['input'];
};

export enum SailingTypeCode {
  M = 'M',
  O = 'O',
  P = 'P',
  S = 'S'
}

export type SailingsSearchRoot = {
  __typename?: 'SailingsSearchRoot';
  byId: Maybe<Sailing>;
  byRouteCodeDeparture: Array<Sailing>;
};


export type SailingsSearchRootByIdArgs = {
  id: Scalars['ID']['input'];
};


export type SailingsSearchRootByRouteCodeDepartureArgs = {
  departureDate: Scalars['String']['input'];
  routeCode: Scalars['String']['input'];
};

export type SalesRegion = {
  __typename?: 'SalesRegion';
  code: Scalars['String']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  shortName: Scalars['String']['output'];
};

export type SalesRegionSearchRoot = {
  __typename?: 'SalesRegionSearchRoot';
  all: Array<SalesRegion>;
  byId: Maybe<SalesRegion>;
};


export type SalesRegionSearchRootByIdArgs = {
  id: Scalars['ID']['input'];
};

export type SeaArea = {
  __typename?: 'SeaArea';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  routePairs: Array<RoutePair>;
};

export type SeaAreaSearchRoot = {
  __typename?: 'SeaAreaSearchRoot';
  all: Array<SeaArea>;
  byId: Maybe<SeaArea>;
};


export type SeaAreaSearchRootByIdArgs = {
  id: Scalars['ID']['input'];
};

/**
 * Moves the day a stretch stops applying.
 *
 * There is no operation for taking an end date away - the API requires one
 * on this call - so a stretch cannot be reopened once it has been closed.
 */
export type SetCustomerParentValidToInput = {
  key: CustomerParentKeyInput;
  /** yyyy-MM-dd. */
  validTo: Scalars['String']['input'];
};

export type SetExpectedVolumeInput = {
  expectedVolume: Scalars['Int']['input'];
  goalId: Scalars['ID']['input'];
};

export type SetNegotiationStatusInput = {
  customerId: Scalars['ID']['input'];
  negotiationStatusId: Scalars['ID']['input'];
  year: Scalars['Int']['input'];
};

export type SetNegotiationStatusInputWithCustomerList = {
  customerNumbers: Array<Scalars['ID']['input']>;
  negotiationStatusId: Scalars['ID']['input'];
  year: Scalars['Int']['input'];
};

export type SetNegotiationStatusResult = {
  __typename?: 'SetNegotiationStatusResult';
  customer: Customer;
};

export type SetTargetNegotiationStatusInput = {
  negotiationStatusId: Scalars['ID']['input'];
  routePairCode: Scalars['ID']['input'];
  year: Scalars['Int']['input'];
};

export type SetTargetNegotiationStatusResult = {
  __typename?: 'SetTargetNegotiationStatusResult';
  targetOverview: TargetOverview;
};

export type StatisticsAdvancedListSearchRoot = {
  __typename?: 'StatisticsAdvancedListSearchRoot';
  byFilter: StatisticsSearchAdvancedListByFilterResult;
};


export type StatisticsAdvancedListSearchRootByFilterArgs = {
  filterOptions: StatisticsSearchAdvancedListByFilterOptions;
};

export type StatisticsAgreedVolumeListSearchRoot = {
  __typename?: 'StatisticsAgreedVolumeListSearchRoot';
  byFilter: Maybe<StatisticsSearchAgreedVolumeByFilterResult>;
};


export type StatisticsAgreedVolumeListSearchRootByFilterArgs = {
  filterOptions: StatisticsSearchAgreedVolumeByFilterOptions;
};

export type StatisticsByAdvancedListItem = {
  __typename?: 'StatisticsByAdvancedListItem';
  actualOutcomeInPercent: Maybe<Scalars['Float']['output']>;
  avgGrossMeterPrice: Maybe<Scalars['Float']['output']>;
  avgNetMeterPrice: Maybe<Scalars['Float']['output']>;
  custIndex: Maybe<Scalars['String']['output']>;
  custNo: Scalars['Int']['output'];
  customerName: Scalars['String']['output'];
  expectedVol: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  last12MonthStatVol: Maybe<Scalars['Float']['output']>;
  last12MonthVol: Scalars['Float']['output'];
  negotiationStatus: Maybe<Scalars['String']['output']>;
  parentNo: Maybe<Scalars['Int']['output']>;
  routePairCode: Maybe<Scalars['String']['output']>;
  sailingCategoryCode: Maybe<Scalars['String']['output']>;
  seller: Maybe<Scalars['String']['output']>;
  statNo: Maybe<Scalars['Int']['output']>;
  targetInPercent: Maybe<Scalars['Float']['output']>;
  unitCategoryCode: Maybe<Scalars['String']['output']>;
};

export type StatisticsByAgreedVolumeListItem = {
  __typename?: 'StatisticsByAgreedVolumeListItem';
  agreedVolume: Scalars['Int']['output'];
  performanceInPercent: Scalars['Int']['output'];
  routePairCode: Scalars['String']['output'];
  shippedVolume: Scalars['Int']['output'];
  statCustomerIndex: Scalars['String']['output'];
  statNumber: Scalars['Int']['output'];
};

export type StatisticsByCustomerListItem = {
  __typename?: 'StatisticsByCustomerListItem';
  customerName: Maybe<Scalars['String']['output']>;
  customerNumber: Scalars['Int']['output'];
  negotiationStatus: Maybe<Scalars['String']['output']>;
  parentNumber: Maybe<Scalars['Int']['output']>;
  sellerId: Maybe<Scalars['String']['output']>;
  statNumber: Maybe<Scalars['Int']['output']>;
  volumeAndTargetForSelected: VolumeAndTargetForSelected;
};

export type StatisticsByRoutePairListItem = {
  __typename?: 'StatisticsByRoutePairListItem';
  negotiationStatusStatistics: NegotiationStatusStatisticsItem;
  routePair: RoutePair;
};

export type StatisticsByRoutePairListVolumeAndTargetItem = {
  __typename?: 'StatisticsByRoutePairListVolumeAndTargetItem';
  routePair: RoutePair;
  volumeAndTargetForSelected: VolumeAndTargetForSelected;
};

export type StatisticsBySalesRegionListItem = {
  __typename?: 'StatisticsBySalesRegionListItem';
  negotiationStatusStatistics: NegotiationStatusStatisticsItem;
  salesRegion: SalesRegion;
};

export type StatisticsBySalesRegionListVolumeAndTargetItem = {
  __typename?: 'StatisticsBySalesRegionListVolumeAndTargetItem';
  salesRegion: SalesRegion;
  volumeAndTargetForSelected: VolumeAndTargetForSelected;
};

export type StatisticsBySellerListItem = {
  __typename?: 'StatisticsBySellerListItem';
  negotiationStatusStatistics: NegotiationStatusStatisticsItem;
  seller: User;
};

export type StatisticsBySellerListVolumeAndTargetItem = {
  __typename?: 'StatisticsBySellerListVolumeAndTargetItem';
  seller: User;
  volumeAndTargetForSelected: VolumeAndTargetForSelected;
};

export type StatisticsCustomerDetailsSearchRoot = {
  __typename?: 'StatisticsCustomerDetailsSearchRoot';
  threeYearsPricePerMeterByCustNoYearAndCurrency: Array<ThreeYearsPricePerMeter>;
  threeYearsTargetAndActualByCustNoAndYear: Array<ThreeYearsTargetAndActual>;
  threeYearsVolumeAndExpectedByCustNoAndYear: Array<ThreeYearsVolumeAndExpected>;
};


export type StatisticsCustomerDetailsSearchRootThreeYearsPricePerMeterByCustNoYearAndCurrencyArgs = {
  currencyCode: Scalars['String']['input'];
  customerNumber: Scalars['ID']['input'];
  year: Scalars['Int']['input'];
};


export type StatisticsCustomerDetailsSearchRootThreeYearsTargetAndActualByCustNoAndYearArgs = {
  customerNumber: Scalars['ID']['input'];
  year: Scalars['Int']['input'];
};


export type StatisticsCustomerDetailsSearchRootThreeYearsVolumeAndExpectedByCustNoAndYearArgs = {
  customerNumber: Scalars['ID']['input'];
  year: Scalars['Int']['input'];
};

export type StatisticsCustomerListSearchRoot = {
  __typename?: 'StatisticsCustomerListSearchRoot';
  byFilter: StatisticsSearchCustomerListByFilterResult;
};


export type StatisticsCustomerListSearchRootByFilterArgs = {
  filterOptions: StatisticsSearchCustomerListByFilterOptions;
};

export type StatisticsDetailsSummaryResult = {
  __typename?: 'StatisticsDetailsSummaryResult';
  byNumber: StatisticsSummaryPieChart;
  byVolume: StatisticsSummaryPieChart;
};

export type StatisticsDetailsVolumeAndRatesResult = {
  __typename?: 'StatisticsDetailsVolumeAndRatesResult';
  rateChange: RateChangeData;
  volumeChange: VolumeChangeData;
};

export type StatisticsForNegotiationStatus = {
  __typename?: 'StatisticsForNegotiationStatus';
  negotiationStatus: NegotiationStatus;
  numberVolumeStatistics: NumberVolumeStatisticsItem;
};

export type StatisticsRoutePairDetailsSearchRoot = {
  __typename?: 'StatisticsRoutePairDetailsSearchRoot';
  summary: StatisticsDetailsSummaryResult;
  threeYearsAverageMeterPrices: AverageMeterPricesData;
  volumeAndRates: StatisticsDetailsVolumeAndRatesResult;
};


export type StatisticsRoutePairDetailsSearchRootSummaryArgs = {
  routePairId: Scalars['ID']['input'];
  year: Scalars['Int']['input'];
};


export type StatisticsRoutePairDetailsSearchRootThreeYearsAverageMeterPricesArgs = {
  currencyCode: Scalars['String']['input'];
  negotiationStatusCodes: Array<NegotiationStatusCode>;
  routePairId: Scalars['ID']['input'];
  year: Scalars['Int']['input'];
};


export type StatisticsRoutePairDetailsSearchRootVolumeAndRatesArgs = {
  negotiationStatusCodes: Array<NegotiationStatusCode>;
  routePairId: Scalars['ID']['input'];
  year: Scalars['Int']['input'];
};

export type StatisticsRoutePairListSearchRoot = {
  __typename?: 'StatisticsRoutePairListSearchRoot';
  byFilter: StatisticsSearchRoutePairListByFilterResult;
  volumeAndTarget: StatisticsSearchRoutePairListVolumeAndTargetByFilterResult;
};


export type StatisticsRoutePairListSearchRootByFilterArgs = {
  filterOptions: StatisticsSearchRoutePairListByFilterOptions;
};


export type StatisticsRoutePairListSearchRootVolumeAndTargetArgs = {
  filterOptions: StatisticsSearchRoutePairListVolumeAndTargetByFilterOptions;
};

export type StatisticsSalesRegionDetailsSearchRoot = {
  __typename?: 'StatisticsSalesRegionDetailsSearchRoot';
  summary: StatisticsDetailsSummaryResult;
  threeYearsAverageMeterPrices: AverageMeterPricesData;
  volumeAndRates: StatisticsDetailsVolumeAndRatesResult;
};


export type StatisticsSalesRegionDetailsSearchRootSummaryArgs = {
  salesRegionId: Scalars['ID']['input'];
  year: Scalars['Int']['input'];
};


export type StatisticsSalesRegionDetailsSearchRootThreeYearsAverageMeterPricesArgs = {
  currencyCode: Scalars['String']['input'];
  negotiationStatusCodes: Array<NegotiationStatusCode>;
  salesRegionId: Scalars['ID']['input'];
  year: Scalars['Int']['input'];
};


export type StatisticsSalesRegionDetailsSearchRootVolumeAndRatesArgs = {
  currencyCode: Scalars['String']['input'];
  negotiationStatusCodes: Array<NegotiationStatusCode>;
  salesRegionId: Scalars['ID']['input'];
  year: Scalars['Int']['input'];
};

export type StatisticsSalesRegionListSearchRoot = {
  __typename?: 'StatisticsSalesRegionListSearchRoot';
  byFilter: StatisticsSearchSalesRegionListByFilterResult;
  volumeAndTarget: StatisticsSearchSalesRegionListVolumeAndTargetByFilterResult;
};


export type StatisticsSalesRegionListSearchRootByFilterArgs = {
  filterOptions: StatisticsSearchSalesRegionListByFilterOptions;
};


export type StatisticsSalesRegionListSearchRootVolumeAndTargetArgs = {
  filterOptions: StatisticsSearchSalesRegionListVolumeAndTargetByFilterOptions;
};

export type StatisticsSearchAdvancedListByFilterOptions = {
  avgGrossMeterPriceFrom?: InputMaybe<Scalars['Float']['input']>;
  avgGrossMeterPriceTo?: InputMaybe<Scalars['Float']['input']>;
  avgNetMeterPriceFrom?: InputMaybe<Scalars['Float']['input']>;
  avgNetMeterPriceTo?: InputMaybe<Scalars['Float']['input']>;
  currency: Scalars['String']['input'];
  custNos?: InputMaybe<Array<Scalars['Int']['input']>>;
  negotiationStatuses?: InputMaybe<Array<Scalars['String']['input']>>;
  negotiationYear: Scalars['Int']['input'];
  rateFrom?: InputMaybe<Scalars['Float']['input']>;
  rateTo?: InputMaybe<Scalars['Float']['input']>;
  routePairCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  sailingCategories?: InputMaybe<Array<Scalars['String']['input']>>;
  salesRegions?: InputMaybe<Array<Scalars['Int']['input']>>;
  sellers?: InputMaybe<Array<Scalars['String']['input']>>;
  targetFrom?: InputMaybe<Scalars['Float']['input']>;
  targetTo?: InputMaybe<Scalars['Float']['input']>;
  twelveMonthVolumeFrom?: InputMaybe<Scalars['Float']['input']>;
  twelveMonthVolumeTo?: InputMaybe<Scalars['Float']['input']>;
  unitTypes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type StatisticsSearchAdvancedListByFilterResult = {
  __typename?: 'StatisticsSearchAdvancedListByFilterResult';
  items: Array<StatisticsByAdvancedListItem>;
};

export type StatisticsSearchAgreedVolumeByFilterOptions = {
  routePairCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  salesRegions?: InputMaybe<Array<Scalars['Int']['input']>>;
  sellers?: InputMaybe<Array<Scalars['String']['input']>>;
  statNumbers?: InputMaybe<Array<Scalars['Int']['input']>>;
  year: Scalars['Int']['input'];
};

export type StatisticsSearchAgreedVolumeByFilterResult = {
  __typename?: 'StatisticsSearchAgreedVolumeByFilterResult';
  items: Array<StatisticsByAgreedVolumeListItem>;
};

export type StatisticsSearchCustomerListByFilterOptions = {
  currencyCode: Scalars['String']['input'];
  negotiationStatuses?: InputMaybe<Array<Scalars['String']['input']>>;
  negotiationYear: Scalars['Int']['input'];
  routePairCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  salesRegionCodes?: InputMaybe<Array<Scalars['Int']['input']>>;
  sellerIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type StatisticsSearchCustomerListByFilterResult = {
  __typename?: 'StatisticsSearchCustomerListByFilterResult';
  items: Array<StatisticsByCustomerListItem>;
};

export type StatisticsSearchRoot = {
  __typename?: 'StatisticsSearchRoot';
  advancedList: StatisticsAdvancedListSearchRoot;
  agreedVolumeList: StatisticsAgreedVolumeListSearchRoot;
  customerDetails: StatisticsCustomerDetailsSearchRoot;
  customerList: StatisticsCustomerListSearchRoot;
  routePairDetails: StatisticsRoutePairDetailsSearchRoot;
  routePairList: StatisticsRoutePairListSearchRoot;
  salesRegionDetails: StatisticsSalesRegionDetailsSearchRoot;
  salesRegionList: StatisticsSalesRegionListSearchRoot;
  sellerDetails: StatisticsSellerDetailsSearchRoot;
  sellerList: StatisticsSellerListSearchRoot;
  totalDetails: StatisticsTotalDetailsSearchRoot;
};

export type StatisticsSearchRoutePairListByFilterOptions = {
  routePairIds: Array<Scalars['ID']['input']>;
  year: Scalars['Int']['input'];
};

export type StatisticsSearchRoutePairListByFilterResult = {
  __typename?: 'StatisticsSearchRoutePairListByFilterResult';
  items: Array<StatisticsByRoutePairListItem>;
};

export type StatisticsSearchRoutePairListVolumeAndTargetByFilterOptions = {
  currencyCode: Scalars['String']['input'];
  negotiationStatusCodes: Array<NegotiationStatusCode>;
  routePairIds: Array<Scalars['ID']['input']>;
  year: Scalars['Int']['input'];
};

export type StatisticsSearchRoutePairListVolumeAndTargetByFilterResult = {
  __typename?: 'StatisticsSearchRoutePairListVolumeAndTargetByFilterResult';
  items: Array<StatisticsByRoutePairListVolumeAndTargetItem>;
};

export type StatisticsSearchSalesRegionListByFilterOptions = {
  salesRegionCodes: Array<Scalars['ID']['input']>;
  year: Scalars['Int']['input'];
};

export type StatisticsSearchSalesRegionListByFilterResult = {
  __typename?: 'StatisticsSearchSalesRegionListByFilterResult';
  items: Array<StatisticsBySalesRegionListItem>;
};

export type StatisticsSearchSalesRegionListVolumeAndTargetByFilterOptions = {
  currencyCode: Scalars['String']['input'];
  negotiationStatusCodes: Array<NegotiationStatusCode>;
  salesRegionCodes: Array<Scalars['ID']['input']>;
  year: Scalars['Int']['input'];
};

export type StatisticsSearchSalesRegionListVolumeAndTargetByFilterResult = {
  __typename?: 'StatisticsSearchSalesRegionListVolumeAndTargetByFilterResult';
  items: Array<StatisticsBySalesRegionListVolumeAndTargetItem>;
};

export type StatisticsSearchSellerListByFilterOptions = {
  sellerIds: Array<Scalars['ID']['input']>;
  year: Scalars['Int']['input'];
};

export type StatisticsSearchSellerListByFilterResult = {
  __typename?: 'StatisticsSearchSellerListByFilterResult';
  items: Array<StatisticsBySellerListItem>;
};

export type StatisticsSearchSellerListVolumeAndTargetByFilterOptions = {
  currencyCode: Scalars['String']['input'];
  negotiationStatusCodes: Array<NegotiationStatusCode>;
  sellerIds: Array<Scalars['ID']['input']>;
  year: Scalars['Int']['input'];
};

export type StatisticsSearchSellerListVolumeAndTargetByFilterResult = {
  __typename?: 'StatisticsSearchSellerListVolumeAndTargetByFilterResult';
  items: Array<StatisticsBySellerListVolumeAndTargetItem>;
};

export type StatisticsSellerDetailsSearchRoot = {
  __typename?: 'StatisticsSellerDetailsSearchRoot';
  summary: StatisticsDetailsSummaryResult;
  threeYearsAverageMeterPrices: AverageMeterPricesData;
  volumeAndRates: StatisticsDetailsVolumeAndRatesResult;
};


export type StatisticsSellerDetailsSearchRootSummaryArgs = {
  sellerId: Scalars['ID']['input'];
  year: Scalars['Int']['input'];
};


export type StatisticsSellerDetailsSearchRootThreeYearsAverageMeterPricesArgs = {
  currencyCode: Scalars['String']['input'];
  negotiationStatusCodes: Array<NegotiationStatusCode>;
  sellerId: Scalars['ID']['input'];
  year: Scalars['Int']['input'];
};


export type StatisticsSellerDetailsSearchRootVolumeAndRatesArgs = {
  negotiationStatusCodes: Array<NegotiationStatusCode>;
  sellerId: Scalars['ID']['input'];
  year: Scalars['Int']['input'];
};

export type StatisticsSellerListSearchRoot = {
  __typename?: 'StatisticsSellerListSearchRoot';
  byFilter: StatisticsSearchSellerListByFilterResult;
  volumeAndTarget: StatisticsSearchSellerListVolumeAndTargetByFilterResult;
};


export type StatisticsSellerListSearchRootByFilterArgs = {
  filterOptions: StatisticsSearchSellerListByFilterOptions;
};


export type StatisticsSellerListSearchRootVolumeAndTargetArgs = {
  filterOptions: StatisticsSearchSellerListVolumeAndTargetByFilterOptions;
};

export type StatisticsSummaryPieChart = {
  __typename?: 'StatisticsSummaryPieChart';
  items: Array<NumPerNegotiationStatus>;
  total: Scalars['Int']['output'];
};

export enum StatisticsTableRowType {
  Acc = 'ACC',
  Total = 'TOTAL',
  Unacc = 'UNACC'
}

export type StatisticsTotalDetailsSearchRoot = {
  __typename?: 'StatisticsTotalDetailsSearchRoot';
  summary: StatisticsDetailsSummaryResult;
  threeYearsAverageMeterPrices: AverageMeterPricesData;
  volumeAndRates: StatisticsDetailsVolumeAndRatesResult;
};


export type StatisticsTotalDetailsSearchRootSummaryArgs = {
  year: Scalars['Int']['input'];
};


export type StatisticsTotalDetailsSearchRootThreeYearsAverageMeterPricesArgs = {
  currencyCode: Scalars['String']['input'];
  negotiationStatusCodes: Array<NegotiationStatusCode>;
  year: Scalars['Int']['input'];
};


export type StatisticsTotalDetailsSearchRootVolumeAndRatesArgs = {
  negotiationStatusCodes: Array<NegotiationStatusCode>;
  year: Scalars['Int']['input'];
};

export type Subscriber = {
  __typename?: 'Subscriber';
  customer: Customer;
  firstName: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  prospectNo: Maybe<Scalars['Int']['output']>;
  salesRegion: SalesRegion;
  shipCode: Maybe<Scalars['String']['output']>;
  subscriberTypeCode: Scalars['String']['output'];
  surName: Maybe<Scalars['String']['output']>;
  telNo: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
  user: Maybe<User>;
};

export type SubscriberContact = {
  __typename?: 'SubscriberContact';
  email: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  mobile: Maybe<Scalars['String']['output']>;
  subscriber: Subscriber;
  subscriberContactId: Maybe<Scalars['String']['output']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  agreementReportCreationFailed: Notification;
  agreementReportCreationSuccessful: Notification;
  upsertedExpectedVolumeSuccessful: Notification;
};


export type SubscriptionAgreementReportCreationFailedArgs = {
  userName: Scalars['String']['input'];
};


export type SubscriptionAgreementReportCreationSuccessfulArgs = {
  userName: Scalars['String']['input'];
};


export type SubscriptionUpsertedExpectedVolumeSuccessfulArgs = {
  userName: Scalars['String']['input'];
};

export type SurChargeV2 = {
  __typename?: 'SurChargeV2';
  articleType: ArticleType;
  quantity: Scalars['Int']['output'];
  surchargePrice: Scalars['Float']['output'];
  surchargeVatAmount: Maybe<Scalars['Float']['output']>;
  surchargeVatRate: Maybe<Scalars['Float']['output']>;
};

export type TargetAdminSearchRoot = {
  __typename?: 'TargetAdminSearchRoot';
  byYear: Array<AdminTarget>;
};


export type TargetAdminSearchRootByYearArgs = {
  year: Scalars['Int']['input'];
};

export type TargetNegotiationStatus = {
  __typename?: 'TargetNegotiationStatus';
  code: Scalars['String']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  presentationOrder: Scalars['Int']['output'];
};

export type TargetNegotiationStatusSearchRoot = {
  __typename?: 'TargetNegotiationStatusSearchRoot';
  all: Array<TargetNegotiationStatus>;
  byId: Maybe<TargetNegotiationStatus>;
};


export type TargetNegotiationStatusSearchRootByIdArgs = {
  id: Scalars['ID']['input'];
};

export type TargetOverview = {
  __typename?: 'TargetOverview';
  completionRate: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  last12MonthVol: Scalars['Int']['output'];
  negotiationStatus: Maybe<TargetNegotiationStatus>;
  noOfAccounts: Scalars['Int']['output'];
  routePair: RoutePair;
  routePairCode: Scalars['String']['output'];
  volumeTargetGm: Maybe<Scalars['Float']['output']>;
  weightedTargetCustomer: Maybe<Scalars['Float']['output']>;
  weightedTargetGm: Maybe<Scalars['Float']['output']>;
};

export type TargetOverviewMutationRoot = {
  __typename?: 'TargetOverviewMutationRoot';
  setTargetNegotiationStatus: SetTargetNegotiationStatusResult;
};


export type TargetOverviewMutationRootSetTargetNegotiationStatusArgs = {
  input: SetTargetNegotiationStatusInput;
};

export type TargetOverviewSearchRoot = {
  __typename?: 'TargetOverviewSearchRoot';
  byId: Maybe<TargetOverview>;
  byYear: Array<TargetOverview>;
};


export type TargetOverviewSearchRootByIdArgs = {
  id: Scalars['ID']['input'];
};


export type TargetOverviewSearchRootByYearArgs = {
  year: Scalars['Int']['input'];
};

export type TargetRoutePair = {
  __typename?: 'TargetRoutePair';
  avgGrossMeterPrice: Maybe<Scalars['Float']['output']>;
  avgNetMeterPrice: Maybe<Scalars['Float']['output']>;
  custNetworkVolume: Maybe<Scalars['Int']['output']>;
  custNo: Scalars['Int']['output'];
  custRouteRowVolume: Maybe<Scalars['Int']['output']>;
  custRouteVolume: Maybe<Scalars['Int']['output']>;
  customerCategory: CustomerCategory;
  customerCountry: Country;
  customerName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  routePairCode: Scalars['String']['output'];
  sailingCategory: SailingCategory;
  salesRegion: SalesRegion;
  seller: Scalars['String']['output'];
  statNetworkVolume: Maybe<Scalars['Int']['output']>;
  statNo: Maybe<Scalars['Int']['output']>;
  statRouteRowVolume: Maybe<Scalars['Int']['output']>;
  statRouteVolume: Maybe<Scalars['Int']['output']>;
  targetInPercent: Maybe<Scalars['Float']['output']>;
  unitCategoryCode: UnitCategoryCode;
  year: Scalars['Int']['output'];
};

export type TargetRoutePairInput = {
  avgGrossMeterPriceFrom?: InputMaybe<Scalars['Float']['input']>;
  avgGrossMeterPriceTo?: InputMaybe<Scalars['Float']['input']>;
  avgNetMeterPriceFrom?: InputMaybe<Scalars['Float']['input']>;
  avgNetMeterPriceTo?: InputMaybe<Scalars['Float']['input']>;
  currency: Scalars['String']['input'];
  custAccountsNetworkVolumeFrom?: InputMaybe<Scalars['Int']['input']>;
  custAccountsNetworkVolumeTo?: InputMaybe<Scalars['Int']['input']>;
  custAccountsRouteVolumeFrom?: InputMaybe<Scalars['Int']['input']>;
  custAccountsRouteVolumeTo?: InputMaybe<Scalars['Int']['input']>;
  custCategoryCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  custCountryCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  custNos?: InputMaybe<Array<Scalars['Int']['input']>>;
  parentCustomerNumber?: InputMaybe<Scalars['Int']['input']>;
  routePairCode: Scalars['String']['input'];
  sailingCategories?: InputMaybe<Array<Scalars['String']['input']>>;
  salesRegions?: InputMaybe<Array<Scalars['Int']['input']>>;
  sellers?: InputMaybe<Array<Scalars['String']['input']>>;
  showWithTargets?: InputMaybe<Scalars['Boolean']['input']>;
  showWithoutTargets?: InputMaybe<Scalars['Boolean']['input']>;
  statAccountsNetworkVolumeFrom?: InputMaybe<Scalars['Int']['input']>;
  statAccountsNetworkVolumeTo?: InputMaybe<Scalars['Int']['input']>;
  statAccountsRouteVolumeFrom?: InputMaybe<Scalars['Int']['input']>;
  statAccountsRouteVolumeTo?: InputMaybe<Scalars['Int']['input']>;
  statNos?: InputMaybe<Array<Scalars['Int']['input']>>;
  targetFrom?: InputMaybe<Scalars['Float']['input']>;
  targetTo?: InputMaybe<Scalars['Float']['input']>;
  unitTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  year: Scalars['Int']['input'];
};

export type TargetRoutePairSearchByFilterResult = {
  __typename?: 'TargetRoutePairSearchByFilterResult';
  items: Array<TargetRoutePair>;
};

export type TargetRoutePairSearchRoot = {
  __typename?: 'TargetRoutePairSearchRoot';
  byFilter: TargetRoutePairSearchByFilterResult;
};


export type TargetRoutePairSearchRootByFilterArgs = {
  filter: TargetRoutePairInput;
};

export type TargetSummary = {
  __typename?: 'TargetSummary';
  categoryData: Array<DetailedCategoryData>;
  completionRate: Scalars['Float']['output'];
  noOfAccounts: Scalars['Int']['output'];
  totalCustomerTarget: Maybe<Scalars['Float']['output']>;
  totalGmTarget: Maybe<Scalars['Float']['output']>;
  volume: Maybe<Scalars['Float']['output']>;
};

export type TargetSummarySearchRoot = {
  __typename?: 'TargetSummarySearchRoot';
  byId: Maybe<TargetSummary>;
};


export type TargetSummarySearchRootByIdArgs = {
  input: InputMaybe<GetTargetSummaryInput>;
};

export type ThreeYearsPricePerMeter = {
  __typename?: 'ThreeYearsPricePerMeter';
  pricePerMeter: Maybe<Scalars['Float']['output']>;
  routePairCode: Maybe<Scalars['String']['output']>;
  twelveMonthsVolume: Scalars['Int']['output'];
  year: Scalars['Int']['output'];
};

export type ThreeYearsTargetAndActual = {
  __typename?: 'ThreeYearsTargetAndActual';
  actualOutcomeInPercent: Maybe<Scalars['Float']['output']>;
  routePairCode: Maybe<Scalars['String']['output']>;
  targetInPercent: Maybe<Scalars['Float']['output']>;
  twelveMonthsVolume: Scalars['Int']['output'];
  year: Scalars['Int']['output'];
};

export type ThreeYearsVolumeAndExpected = {
  __typename?: 'ThreeYearsVolumeAndExpected';
  expectedVolume: Maybe<Scalars['Float']['output']>;
  routePairCode: Maybe<Scalars['String']['output']>;
  volume: Maybe<Scalars['Int']['output']>;
  year: Scalars['Int']['output'];
};

export enum UnitCategoryCode {
  Acc = 'ACC',
  Unacc = 'UNACC'
}

export type UnitType = {
  __typename?: 'UnitType';
  code: Scalars['String']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  presentationOrder: Scalars['Int']['output'];
};

export type UnitTypeSearchRoot = {
  __typename?: 'UnitTypeSearchRoot';
  all: Array<UnitType>;
  byId: Maybe<UnitType>;
};


export type UnitTypeSearchRootByIdArgs = {
  id: Scalars['ID']['input'];
};

export type UpdateAgreementArticlesInput = {
  routeAgreements: Array<UpdateAgreementArticlesItemInput>;
};

export type UpdateAgreementArticlesItemInput = {
  agrRouteId: Scalars['ID']['input'];
  changes: AgreementArticlesChanges;
  rowVersion: Scalars['String']['input'];
};

export type UpdateAgreementArticlesResult = ErrorResult | UpdateAgreementArticlesSuccessResult;

export type UpdateAgreementArticlesSuccessResult = {
  __typename?: 'UpdateAgreementArticlesSuccessResult';
  routeAgreement: RouteAgreement;
};

export type UpdateArticleItemInput = {
  articleId: Scalars['ID']['input'];
  changes: ArticleItemChangesInput;
};

export type UpdateArticlePriceInput = {
  articlePriceId: Scalars['ID']['input'];
  changes: ArticlePriceChangesInput;
};

export type UpdateBookingHandlingStatusErrorResult = {
  __typename?: 'UpdateBookingHandlingStatusErrorResult';
  errors: Array<ErrorDetail>;
};

export type UpdateBookingHandlingStatusInput = {
  bookingNo: Scalars['Int']['input'];
  excludeReasonCode?: InputMaybe<Scalars['String']['input']>;
  handlingStatus: Scalars['String']['input'];
};

export type UpdateBookingHandlingStatusResult = UpdateBookingHandlingStatusErrorResult | UpdateBookingHandlingStatusSuccessResult;

export type UpdateBookingHandlingStatusSuccessResult = {
  __typename?: 'UpdateBookingHandlingStatusSuccessResult';
  handleBookingBookingData: Array<HandleBookingBookingData>;
};

export type UpdateCustomerRouteStatisticsActualOutcomeInput = {
  actualOutcomeInPercent?: InputMaybe<Scalars['Float']['input']>;
  custNo: Scalars['Int']['input'];
  routePairCode: Scalars['String']['input'];
  sailingCategoryCode: Scalars['String']['input'];
  unitCategoryCode: Scalars['String']['input'];
  year: Scalars['Int']['input'];
};

export type UpdateCustomerRouteStatisticsActualOutcomeItemResult = {
  __typename?: 'UpdateCustomerRouteStatisticsActualOutcomeItemResult';
  actualOutcomeInPercent: Maybe<Scalars['Float']['output']>;
  custNo: Scalars['Int']['output'];
  routePairCode: Scalars['String']['output'];
  sailingCategoryCode: Scalars['String']['output'];
  unitCategoryCode: Scalars['String']['output'];
  year: Scalars['Int']['output'];
};

export type UpdateCustomerRouteStatisticsResult = {
  __typename?: 'UpdateCustomerRouteStatisticsResult';
  customerRouteStatistics: Array<UpdateCustomerRouteStatisticsActualOutcomeItemResult>;
};

export type UpdateExpectedVolumesInput = {
  changesPerRoute: Array<UpdateExpectedVolumesItemInput>;
  customerStatisticalGrouping: Scalars['Int']['input'];
  negotiationYear: Scalars['Int']['input'];
};

export type UpdateExpectedVolumesItemChangesInput = {
  accompaniedExpectedVolOffPeak?: InputMaybe<OptionalFloatInput>;
  accompaniedExpectedVolPeak?: InputMaybe<OptionalFloatInput>;
  accompaniedExpectedVolShoulder?: InputMaybe<OptionalFloatInput>;
  customerId: Scalars['ID']['input'];
  unaccompaniedExpectedVolOffPeak?: InputMaybe<OptionalFloatInput>;
  unaccompaniedExpectedVolPeak?: InputMaybe<OptionalFloatInput>;
  unaccompaniedExpectedVolShoulder?: InputMaybe<OptionalFloatInput>;
  volumeAgreed: Scalars['Boolean']['input'];
};

export type UpdateExpectedVolumesItemInput = {
  changesForCustomer: Array<UpdateExpectedVolumesItemChangesInput>;
  routePairId: Scalars['ID']['input'];
};

export type UpdateExpectedVolumesResult = ErrorResult | UpdateExpectedVolumesSuccessResult;

export type UpdateExpectedVolumesSuccessResult = {
  __typename?: 'UpdateExpectedVolumesSuccessResult';
  volumes: Array<ExpectedVolume>;
};

export type UpdateGroupFreightTargetInput = {
  offPeakAcc?: InputMaybe<Scalars['Float']['input']>;
  offPeakUnAcc?: InputMaybe<Scalars['Float']['input']>;
  peakAcc?: InputMaybe<Scalars['Float']['input']>;
  peakUnAcc?: InputMaybe<Scalars['Float']['input']>;
  routePairCode: Scalars['String']['input'];
  shoulderAcc?: InputMaybe<Scalars['Float']['input']>;
  shoulderUnAcc?: InputMaybe<Scalars['Float']['input']>;
  volume?: InputMaybe<Scalars['Float']['input']>;
  year: Scalars['Int']['input'];
};

export type UpdateGroupFreightTargetResult = {
  __typename?: 'UpdateGroupFreightTargetResult';
  id: Scalars['String']['output'];
  routePairCode: Scalars['String']['output'];
  year: Scalars['Int']['output'];
};

export type UpdateGroupFreightTargetSuccessResult = {
  __typename?: 'UpdateGroupFreightTargetSuccessResult';
  updateTargets: Array<UpdateGroupFreightTargetResult>;
};

export type UpdateHeadAgreementErrorResult = {
  __typename?: 'UpdateHeadAgreementErrorResult';
  errors: Array<ErrorDetail>;
};

export type UpdateHeadAgreementInput = {
  condition?: InputMaybe<RequiredStringInput>;
  headAgreementId: Scalars['ID']['input'];
  internalNotes?: InputMaybe<RequiredStringInput>;
  lastPage?: InputMaybe<RequiredStringInput>;
  name?: InputMaybe<RequiredStringInput>;
  rowVersion: Scalars['String']['input'];
  specifications?: InputMaybe<RequiredStringInput>;
  valid?: InputMaybe<ValidDatesInput>;
};

export type UpdateHeadAgreementResult = ErrorResult | UpdateHeadAgreementSuccessResult;

export type UpdateHeadAgreementSuccessResult = {
  __typename?: 'UpdateHeadAgreementSuccessResult';
  headAgreement: HeadAgreement;
};

export type UpdateMatrixItemInput = {
  changes: MatrixItemChangesInput;
  id: Scalars['ID']['input'];
};

export type UpdateMultiLegRouteAgreementErrorResult = {
  __typename?: 'UpdateMultiLegRouteAgreementErrorResult';
  errors: Array<ErrorDetail>;
};

export type UpdateMultiLegRouteAgreementInput = {
  formModel: MultiLegRouteAgreementFormInput;
  multiLegRouteAgreementId: Scalars['ID']['input'];
  rowVersion: Scalars['String']['input'];
};

export type UpdateMultiLegRouteAgreementResult = ErrorResult | UpdateMultiLegRouteAgreementSuccessResult;

export type UpdateMultiLegRouteAgreementSuccessResult = {
  __typename?: 'UpdateMultiLegRouteAgreementSuccessResult';
  multiLegAgreement: MultiLegRouteAgreement;
};

export type UpdateRateSheetsInput = {
  routeAgreements: Array<UpdateRateSheetsRouteAgreementItemInput>;
};

export type UpdateRateSheetsPriceItemInput = {
  changes: RateSheetPriceChangesInput;
  routeAgreementPriceId: Scalars['ID']['input'];
};

export type UpdateRateSheetsResult = ErrorResult | UpdateRateSheetsSuccessResult;

export type UpdateRateSheetsRouteAgreementItemInput = {
  changes: RateSheetChanges;
  isSalesReady?: InputMaybe<RequiredBooleanInput>;
  routeAgreementId: Scalars['ID']['input'];
  rowVersion: Scalars['String']['input'];
};

export type UpdateRateSheetsSuccessResult = {
  __typename?: 'UpdateRateSheetsSuccessResult';
  routeAgreement: RouteAgreement;
};

export type UpdateRouteAgreementConnectedToMultiLegResult = ErrorResult | UpdateRouteAgreementSuccessResult;

export type UpdateRouteAgreementInput = {
  formModel: RouteAgreementFormInput;
  rateSheetChanges: RateSheetChanges;
  routeAgreementId: Scalars['ID']['input'];
  rowVersion: Scalars['String']['input'];
};

export type UpdateRouteAgreementResult = ErrorResult | UpdateRouteAgreementSuccessResult;

export type UpdateRouteAgreementSuccessResult = {
  __typename?: 'UpdateRouteAgreementSuccessResult';
  routeAgreement: RouteAgreement;
};

export type UpdateRoutePairCustomerTargetInput = {
  routePairCustomerTargetUpdates: Array<UpdateRoutePairCustomerTargetItemInput>;
};

export type UpdateRoutePairCustomerTargetItemInput = {
  custNo: Scalars['ID']['input'];
  routePairCode: Scalars['String']['input'];
  sailingCategoryCode: Scalars['String']['input'];
  targetInPercent?: InputMaybe<Scalars['Float']['input']>;
  unitCategoryCode: Scalars['String']['input'];
  year: Scalars['Int']['input'];
};

export type UpdateRoutePricesErrorResult = {
  __typename?: 'UpdateRoutePricesErrorResult';
  errors: Array<ErrorDetail>;
};

export type UpdateRoutePricesInput = {
  id: Scalars['ID']['input'];
  lateHandlingDkk: Scalars['Float']['input'];
  lateHandlingEur: Scalars['Float']['input'];
  lateHandlingGbp: Scalars['Float']['input'];
  lateHandlingNok: Scalars['Float']['input'];
  lateHandlingPln: Scalars['Float']['input'];
  lateHandlingSek: Scalars['Float']['input'];
  noShowDkk: Scalars['Float']['input'];
  noShowEur: Scalars['Float']['input'];
  noShowGbp: Scalars['Float']['input'];
  noShowNok: Scalars['Float']['input'];
  noShowPln: Scalars['Float']['input'];
  noShowSek: Scalars['Float']['input'];
  routePairCode: Scalars['String']['input'];
  validFrom: Scalars['String']['input'];
};

export type UpdateRoutePricesResult = UpdateRoutePricesErrorResult | UpdateRoutePricesSuccessResult;

export type UpdateRoutePricesSuccessResult = {
  __typename?: 'UpdateRoutePricesSuccessResult';
  updatePrices: Array<UpdateRoutePricesSuccessResultData>;
};

export type UpdateRoutePricesSuccessResultData = {
  __typename?: 'UpdateRoutePricesSuccessResultData';
  id: Scalars['ID']['output'];
  routePairCode: Scalars['String']['output'];
  validFrom: Scalars['String']['output'];
};

export type User = {
  __typename?: 'User';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  sellerEmailAddress: Maybe<Scalars['String']['output']>;
  sellerFirstName: Scalars['String']['output'];
  sellerLastName: Scalars['String']['output'];
  sellerPhoneNumber: Maybe<Scalars['String']['output']>;
};

export type UserProfile = {
  __typename?: 'UserProfile';
  claims: Array<Scalars['String']['output']>;
  fullName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  userName: Scalars['String']['output'];
};

export type UserProfileSearchRoot = {
  __typename?: 'UserProfileSearchRoot';
  me: UserProfile;
};

export type UserSearchRoot = {
  __typename?: 'UserSearchRoot';
  all: Array<User>;
  byId: Maybe<User>;
  me: User;
};


export type UserSearchRootByIdArgs = {
  id: Scalars['ID']['input'];
};

export type ValidDatesInput = {
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};

export type ValidationErrors = {
  __typename?: 'ValidationErrors';
  errorMessage: Maybe<Scalars['String']['output']>;
  path: Maybe<Scalars['String']['output']>;
  severityLevel: Maybe<Scalars['Int']['output']>;
  statusCode: Maybe<Scalars['Int']['output']>;
};

export type ValidationResponse = {
  __typename?: 'ValidationResponse';
  validationResult: Maybe<ValidationResult>;
};

export type ValidationResult = {
  __typename?: 'ValidationResult';
  resourceId: Maybe<Scalars['String']['output']>;
  statusCode: Maybe<Scalars['Int']['output']>;
  validationErrors: Maybe<Array<Maybe<ValidationErrors>>>;
};

export type VehicleType = {
  __typename?: 'VehicleType';
  accompanied: Scalars['Boolean']['output'];
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isMultilegBookable: Scalars['Boolean']['output'];
  length: Maybe<Scalars['Float']['output']>;
  longDescription: Scalars['String']['output'];
  name: Scalars['String']['output'];
  noOfDrivers: Maybe<Scalars['Int']['output']>;
  shortDescription: Scalars['String']['output'];
  weight: Maybe<Scalars['Int']['output']>;
  width: Maybe<Scalars['Float']['output']>;
};

export type VehicleTypeSearchRoot = {
  __typename?: 'VehicleTypeSearchRoot';
  all: Array<VehicleType>;
  byId: Maybe<VehicleType>;
};


export type VehicleTypeSearchRootByIdArgs = {
  id: Scalars['ID']['input'];
};

export type VolumeAndTargetForSelected = {
  __typename?: 'VolumeAndTargetForSelected';
  averageNegotiationRate: Maybe<Scalars['Float']['output']>;
  averageTarget: Maybe<Scalars['Float']['output']>;
  avgMeterPrice: Maybe<Scalars['Float']['output']>;
  avgMeterPriceDiffInPercent: Maybe<Scalars['Float']['output']>;
  expectedVolume: Maybe<Scalars['Int']['output']>;
  lastYearVolume: Scalars['Int']['output'];
  volume: Scalars['Float']['output'];
};

export type VolumeChangeAllChartsData = {
  __typename?: 'VolumeChangeAllChartsData';
  offPeak: VolumeChangeChartData;
  peak: VolumeChangeChartData;
  shoulder: VolumeChangeChartData;
  total: VolumeChangeChartData;
};

export type VolumeChangeAllTablesData = {
  __typename?: 'VolumeChangeAllTablesData';
  offPeak: VolumeChangeTableData;
  peak: VolumeChangeTableData;
  shoulder: VolumeChangeTableData;
  total: VolumeChangeTableData;
};

export type VolumeChangeChartData = {
  __typename?: 'VolumeChangeChartData';
  expectedVolume: VolumeChangeChartRowData;
  lastYearVolume: VolumeChangeChartRowData;
};

export type VolumeChangeChartRowData = {
  __typename?: 'VolumeChangeChartRowData';
  acc: Maybe<Scalars['Float']['output']>;
  unacc: Maybe<Scalars['Float']['output']>;
};

export type VolumeChangeData = {
  __typename?: 'VolumeChangeData';
  charts: VolumeChangeAllChartsData;
  tables: VolumeChangeAllTablesData;
};

export type VolumeChangeTableData = {
  __typename?: 'VolumeChangeTableData';
  acc: VolumeChangeTableRowData;
  total: VolumeChangeTableRowData;
  unacc: VolumeChangeTableRowData;
};

export type VolumeChangeTableRowData = {
  __typename?: 'VolumeChangeTableRowData';
  diff: Maybe<Scalars['Float']['output']>;
  expected: Maybe<Scalars['Int']['output']>;
  lastYear: Maybe<Scalars['Int']['output']>;
};

export enum WorkFlowStatusCode {
  Pndsupport = 'PNDSUPPORT',
  Rdytooffer = 'RDYTOOFFER',
  Sready = 'SREADY',
  Swork = 'SWORK'
}

export type WriteHistory = {
  __typename?: 'WriteHistory';
  createdAt: DateTime;
  createdBy: User;
  modifiedAt: Maybe<DateTime>;
  modifiedBy: Maybe<User>;
};

export type ReportCreatedResponse = {
  __typename?: 'reportCreatedResponse';
  userId: Scalars['ID']['output'];
};

export type NslhInvoiceByFilterFragment = { __typename?: 'NslhInvoiceInfo', id: string, noShowLateTypeCodes: Array<string>, lateHandlingDate: string, customer: { __typename?: 'Customer', id: string, custNo: number, custIndex: string } | null, nslhInvoice: { __typename?: 'NslhInvoice', id: string, invoiceNo: number, invoiceCurrencyCode: string | null, netAmount: number } };

export type SearchByFilterPublicInvoicesQueryVariables = Exact<{
  input: NslhInvoiceByFilterInput;
}>;


export type SearchByFilterPublicInvoicesQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', noShowLateHandling: { __typename?: 'NoShowLateHandlingSearchRoot', nslhInvoice: { __typename?: 'NslhInvoiceSearchRoot', byFilter: Array<{ __typename?: 'NslhInvoiceInfo', id: string, noShowLateTypeCodes: Array<string>, lateHandlingDate: string, customer: { __typename?: 'Customer', id: string, custNo: number, custIndex: string } | null, nslhInvoice: { __typename?: 'NslhInvoice', id: string, invoiceNo: number, invoiceCurrencyCode: string | null, netAmount: number } }> } } } };

export type SearchByInvoiceNoPublicInvoicesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SearchByInvoiceNoPublicInvoicesQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', noShowLateHandling: { __typename?: 'NoShowLateHandlingSearchRoot', nslhInvoice: { __typename?: 'NslhInvoiceSearchRoot', byId: Array<{ __typename?: 'NslhInvoice', id: string, consignmentNo: number | null }> } } } };

export type PublicInvoiceCustomerFragment = { __typename?: 'Customer', id: string, custNo: number, custIndex: string, name: string };

export type PublicInvoiceInitialFilterQueryVariables = Exact<{ [key: string]: never; }>;


export type PublicInvoiceInitialFilterQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', noShowLateHandling: { __typename?: 'NoShowLateHandlingSearchRoot', breakDate: string | null }, customers: { __typename?: 'CustomerSearchRoot', byUser: Array<{ __typename?: 'Customer', id: string, custNo: number, custIndex: string, name: string }> } } };

export type QueryPublicOneMonthBookingsQueryVariables = Exact<{
  custNo: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
  month: Scalars['Int']['input'];
}>;


export type QueryPublicOneMonthBookingsQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', noShowLateHandling: { __typename?: 'NoShowLateHandlingSearchRoot', nslhFollowUp: { __typename?: 'NslhFollowUpSearchRoot', byFilter: Array<{ __typename?: 'NslhFollowUp', id: string, shippedVolume: number, noOfNoShows: number, noOfExcludedNoShows: number, noOfLateHandlings: number, noOfExcludedLateHandlings: number, customer: { __typename?: 'Customer', id: string, custNo: number, custIndex: string, name: string, customerThresholds: Array<{ __typename?: 'CustomerThreshold', thresholdTypeCode: string, percentage: number }> }, routePair: { __typename?: 'RoutePair', id: string, code: string, description: string }, nslhRouteVolume: { __typename?: 'NslhBookingRouteVolume', id: string, shippedVolume: number, routePair: { __typename?: 'RoutePair', id: string, code: string } } | null, nslhBookingVolume: { __typename?: 'NslhBookingVolume', id: string, thresholdNoShowPercentage: number, thresholdLateHandleBookings: number, thresholdLateHandlePercentage: number, thresholdNoShowBookings: number } | null, nslhBookings: Array<{ __typename?: 'NslhBooking', id: string, consignmentNo: number | null, articlePrice: number | null, bookingNo: number, bookingVersion: number, customerReference: string | null, departureDate: string, departureTime: string, handlingStatus: string, handlingType: string, handlingTypeGrouped: string, revisedDate: string | null, revisedTime: string | null, trailerReg: string | null, vehicleReg: string | null, lateHandlingDate: string | null, lateHandlingUser: string | null, customer: { __typename?: 'Customer', id: string, custNo: number }, vehicleType: { __typename?: 'VehicleType', id: string, shortDescription: string }, route: { __typename?: 'Route', id: string, routePair: { __typename?: 'RoutePair', id: string, code: string, description: string } } }> }> } } } };

export type NslhFollowUpForPublicOverviewFragment = { __typename?: 'NslhFollowUp', id: string, shippedVolume: number, noOfNoShows: number, noOfExcludedNoShows: number, noOfLateHandlings: number, noOfExcludedLateHandlings: number, customer: { __typename?: 'Customer', id: string, custNo: number, custIndex: string, customerThresholds: Array<{ __typename?: 'CustomerThreshold', thresholdTypeCode: string, percentage: number }> }, routePair: { __typename?: 'RoutePair', id: string, code: string, description: string }, nslhBookingVolume: { __typename?: 'NslhBookingVolume', id: string, thresholdNoShowPercentage: number, thresholdLateHandleBookings: number, thresholdLateHandlePercentage: number, thresholdNoShowBookings: number } | null };

export type PublicOverviewQueryVariables = Exact<{
  year: Scalars['Int']['input'];
  month: Scalars['Int']['input'];
}>;


export type PublicOverviewQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', noShowLateHandling: { __typename?: 'NoShowLateHandlingSearchRoot', nslhFollowUp: { __typename?: 'NslhFollowUpSearchRoot', byFilter: Array<{ __typename?: 'NslhFollowUp', id: string, shippedVolume: number, noOfNoShows: number, noOfExcludedNoShows: number, noOfLateHandlings: number, noOfExcludedLateHandlings: number, customer: { __typename?: 'Customer', id: string, custNo: number, custIndex: string, customerThresholds: Array<{ __typename?: 'CustomerThreshold', thresholdTypeCode: string, percentage: number }> }, routePair: { __typename?: 'RoutePair', id: string, code: string, description: string }, nslhBookingVolume: { __typename?: 'NslhBookingVolume', id: string, thresholdNoShowPercentage: number, thresholdLateHandleBookings: number, thresholdLateHandlePercentage: number, thresholdNoShowBookings: number } | null }> } } } };

export type PublicNshlInvoiceSpecificationFragment = { __typename?: 'NslhInvoice', id: string, invoiceNo: number, consignmentNo: number | null, invoiceDate: string | null, invoiceCurrencyCode: string | null, netAmount: number, nslhMonth: number, nslhYear: number, routeCodeBreak: string | null, thresholdNoShow: number, thresholdLateHandling: number, customer: { __typename?: 'Customer', id: string, custNo: number, custIndex: string, name: string, invoiceCurrency: { __typename?: 'Currency', id: string, code: string } }, routeVolumes: Array<{ __typename?: 'NslhBookingRouteVolume', id: string, shippedVolume: number, routePair: { __typename?: 'RoutePair', code: string, id: string } }>, nslhBookings: Array<{ __typename?: 'NslhBooking', id: string, consignmentNo: number | null, articlePrice: number | null, bookingNo: number, bookingVersion: number, customerReference: string | null, departureDate: string, departureTime: string, handlingStatus: string, handlingType: string, handlingTypeGrouped: string, revisedTime: string | null, revisedDate: string | null, trailerReg: string | null, vehicleReg: string | null, lateHandlingUser: string | null, lateHandlingDate: string | null, customer: { __typename?: 'Customer', id: string, custNo: number }, vehicleType: { __typename?: 'VehicleType', id: string, shortDescription: string }, route: { __typename?: 'Route', id: string, code: string, routePair: { __typename?: 'RoutePair', code: string, description: string } } }> };

export type PublicInvoiceSpecificationsQueryVariables = Exact<{
  invoiceNo: Scalars['ID']['input'];
}>;


export type PublicInvoiceSpecificationsQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', noShowLateHandling: { __typename?: 'NoShowLateHandlingSearchRoot', nslhInvoice: { __typename?: 'NslhInvoiceSearchRoot', byId: Array<{ __typename?: 'NslhInvoice', id: string, invoiceNo: number, consignmentNo: number | null, invoiceDate: string | null, invoiceCurrencyCode: string | null, netAmount: number, nslhMonth: number, nslhYear: number, routeCodeBreak: string | null, thresholdNoShow: number, thresholdLateHandling: number, customer: { __typename?: 'Customer', id: string, custNo: number, custIndex: string, name: string, invoiceCurrency: { __typename?: 'Currency', id: string, code: string } }, routeVolumes: Array<{ __typename?: 'NslhBookingRouteVolume', id: string, shippedVolume: number, routePair: { __typename?: 'RoutePair', code: string, id: string } }>, nslhBookings: Array<{ __typename?: 'NslhBooking', id: string, consignmentNo: number | null, articlePrice: number | null, bookingNo: number, bookingVersion: number, customerReference: string | null, departureDate: string, departureTime: string, handlingStatus: string, handlingType: string, handlingTypeGrouped: string, revisedTime: string | null, revisedDate: string | null, trailerReg: string | null, vehicleReg: string | null, lateHandlingUser: string | null, lateHandlingDate: string | null, customer: { __typename?: 'Customer', id: string, custNo: number }, vehicleType: { __typename?: 'VehicleType', id: string, shortDescription: string }, route: { __typename?: 'Route', id: string, code: string, routePair: { __typename?: 'RoutePair', code: string, description: string } } }> }> } } } };

export type BuildVersionsQueryVariables = Exact<{ [key: string]: never; }>;


export type BuildVersionsQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', buildVersions: { __typename?: 'BuildVersion', frontend: { __typename?: 'FrontendVersion', version: string }, backend: { __typename?: 'BackendVersion', version: string } } } };

export type CurrencyRadioButtonRowQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrencyRadioButtonRowQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', currency: { __typename?: 'CurrencySearchRoot', all: Array<{ __typename?: 'Currency', id: string, name: string }> } } };

export type MatricesByKeyWordFragment = { __typename?: 'Matrix', id: string, keywords: Array<string>, validityKey: string, timeslots: Array<{ __typename?: 'MatrixTimeslot', timeFrom: string, timeTo: string, weekDay: string }> };

export type MatricesTypeSearchListQueryVariables = Exact<{
  query: Scalars['String']['input'];
}>;


export type MatricesTypeSearchListQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', matrices: { __typename?: 'MatrixSearchRoot', byKeyword: Array<{ __typename?: 'Matrix', id: string, keywords: Array<string>, validityKey: string, timeslots: Array<{ __typename?: 'MatrixTimeslot', timeFrom: string, timeTo: string, weekDay: string }> }> } } };

export type AllRoutePairsSelectQueryVariables = Exact<{
  typeCodes: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type AllRoutePairsSelectQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', routePair: { __typename?: 'RoutePairSearchRoot', byRouteTypeCodes: Array<{ __typename?: 'RoutePair', id: string, code: string, seaArea: { __typename?: 'SeaArea', id: string, name: string } }> } } };

export type RoutePairFragment = { __typename?: 'RoutePair', id: string, seaArea: { __typename?: 'SeaArea', id: string, name: string } };

export type RouteAgreementsByRoutePairFragment = { __typename?: 'RouteAgreement', id: string, isSalesReady: boolean, routes: Array<{ __typename?: 'Route', id: string, routePair: { __typename?: 'RoutePair', id: string } }> };

export type RoutePairInSeaAreaSelectQueryVariables = Exact<{
  headAgreementId: Scalars['ID']['input'];
}>;


export type RoutePairInSeaAreaSelectQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', headAgreement: { __typename?: 'HeadAgreementSearchRoot', byId: { __typename?: 'HeadAgreement', id: string, routeAgreements: Array<{ __typename?: 'RouteAgreement', id: string, isSalesReady: boolean, routes: Array<{ __typename?: 'Route', id: string, routePair: { __typename?: 'RoutePair', id: string } }> }>, routePairs: Array<{ __typename?: 'RoutePair', id: string, seaArea: { __typename?: 'SeaArea', id: string, name: string } }> } | null } } };

export type AncillariesFragment = { __typename?: 'ArticleType', id: string, code: string, name: string };

export type AncillaryTypeQueryVariables = Exact<{ [key: string]: never; }>;


export type AncillaryTypeQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', articleType: { __typename?: 'ArticleTypeSearchRoot', ancillaries: Array<{ __typename?: 'ArticleType', id: string, code: string, name: string }> } } };

export type CountryMultiChipSelectAllQueryVariables = Exact<{ [key: string]: never; }>;


export type CountryMultiChipSelectAllQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', country: { __typename?: 'CountrySearchRoot', all: Array<{ __typename?: 'Country', id: string, code: string, name: string }> } } };

export type CountryMultiChipSelectAllActiveQueryVariables = Exact<{ [key: string]: never; }>;


export type CountryMultiChipSelectAllActiveQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', country: { __typename?: 'CountrySearchRoot', allActive: Array<{ __typename?: 'Country', id: string, code: string, name: string }> } } };

export type CountryMultiSelectAllQueryVariables = Exact<{ [key: string]: never; }>;


export type CountryMultiSelectAllQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', country: { __typename?: 'CountrySearchRoot', all: Array<{ __typename?: 'Country', id: string, code: string, name: string }> } } };

export type CountryMultiSelectAllActiveQueryVariables = Exact<{ [key: string]: never; }>;


export type CountryMultiSelectAllActiveQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', country: { __typename?: 'CountrySearchRoot', allActive: Array<{ __typename?: 'Country', id: string, code: string, name: string }> } } };

export type CurrencySelectQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrencySelectQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', currency: { __typename?: 'CurrencySearchRoot', all: Array<{ __typename?: 'Currency', id: string, name: string }> } } };

export type ByCustomerNumberOrIndexFragment = { __typename?: 'Customer', id: string, name: string, custNo: number, custIndex: string };

export type CustomersSelectQueryVariables = Exact<{
  query: Scalars['String']['input'];
}>;


export type CustomersSelectQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', customers: { __typename?: 'CustomerSearchRoot', byCustomerNumberOrIndex: Array<{ __typename?: 'Customer', id: string, name: string, custNo: number, custIndex: string }> } } };

export type CustomsClassificationSelectQueryVariables = Exact<{ [key: string]: never; }>;


export type CustomsClassificationSelectQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', customsClassification: { __typename?: 'CustomsClassificationSearchRoot', all: Array<{ __typename?: 'CustomsClassification', id: string, code: string | null, description: string | null }> } } };

export type FormulaTypeSelectQueryVariables = Exact<{ [key: string]: never; }>;


export type FormulaTypeSelectQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', formula: { __typename?: 'FormulaSearchRoot', all: Array<{ __typename?: 'FormulaType', code: string, description: Array<string>, id: string, name: string, includes: { __typename?: 'FormulaTypeIncludes', drivers: boolean | null, interval1PercentValue: boolean | null, interval2PercentValue: boolean | null, interval3PercentValue: boolean | null, interval4PercentValue: boolean | null, intervalAPercentValue: boolean | null, intervalBPercentValue: boolean | null, intervalCPercentValue: boolean | null, intervalDPercentValue: boolean | null, intervalLength: boolean | null, maxPercent: boolean | null, percent: boolean | null, weight: boolean | null, width: boolean | null } }> } } };

export type GoodsMultiSelectQueryVariables = Exact<{ [key: string]: never; }>;


export type GoodsMultiSelectQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', goods: { __typename?: 'GoodsSearchRoot', all: Array<{ __typename?: 'Goods', id: string, code: string, name: string }> } } };

export type HandleBookingExcludeReasonsQueryVariables = Exact<{ [key: string]: never; }>;


export type HandleBookingExcludeReasonsQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', noShowLateHandlingExcludeReason: { __typename?: 'NoShowLateHandlingExcludeReasonSearchRoot', all: Array<{ __typename?: 'NoShowLateHandlingExcludeReason', id: string, code: string, description: string, presentationOrder: number }> } } };

export type AllHeadAgreementsFragment = { __typename?: 'HeadAgreement', id: string, headAgreementNumber: number, statusCode: HeadAgreementStatusCode, name: string, valid: { __typename?: 'DateRange', start: { __typename?: 'Date', isoString: string } | null, end: { __typename?: 'Date', isoString: string } | null } };

export type HeadAgreementByCustomerIdSelectQueryVariables = Exact<{
  customerId: Scalars['ID']['input'];
}>;


export type HeadAgreementByCustomerIdSelectQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', customers: { __typename?: 'CustomerSearchRoot', byId: { __typename?: 'Customer', id: string, allHeadAgreements: Array<{ __typename?: 'HeadAgreement', id: string, headAgreementNumber: number, statusCode: HeadAgreementStatusCode, name: string, valid: { __typename?: 'DateRange', start: { __typename?: 'Date', isoString: string } | null, end: { __typename?: 'Date', isoString: string } | null } }> } | null } } };

export type AllLiveStockFragment = { __typename?: 'LiveStock', id: string, code: string, description: string, presentationOrder: number };

export type LiveStockQueryVariables = Exact<{ [key: string]: never; }>;


export type LiveStockQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', liveStock: { __typename?: 'LiveStockSearchRoot', all: Array<{ __typename?: 'LiveStock', id: string, code: string, description: string, presentationOrder: number }> } } };

export type MultilegRoutePairSelectQueryVariables = Exact<{
  headAgreementId: Scalars['ID']['input'];
}>;


export type MultilegRoutePairSelectQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', headAgreement: { __typename?: 'HeadAgreementSearchRoot', byId: { __typename?: 'HeadAgreement', id: string, multiLegAgrRoutes: Array<{ __typename?: 'MultiLegRouteAgreement', id: string, statusCode: HeadAgreementStatusCode, name: string, route: { __typename?: 'Route', id: string } }> } | null } } };

export type NegotiationStatusSelectQueryVariables = Exact<{ [key: string]: never; }>;


export type NegotiationStatusSelectQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', negotiationStatus: { __typename?: 'NegotiationStatusSearchRoot', all: Array<{ __typename?: 'NegotiationStatus', id: string, code: NegotiationStatusCode, name: string, presentationOrder: number | null }> } } };

export type NegotiationYearSelectQueryVariables = Exact<{ [key: string]: never; }>;


export type NegotiationYearSelectQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', negotiationYear: { __typename?: 'NegotiationYearSearchRoot', availableYears: Array<{ __typename?: 'NegotiationYear', id: string, year: number }> } } };

export type RouteInRoutePairSelectQueryVariables = Exact<{
  routeTypes: Array<Scalars['String']['input']> | Scalars['String']['input'];
  excludeOnlyAsPartOfMultiLegRoutes: Scalars['Boolean']['input'];
  includeNotValid: Scalars['Boolean']['input'];
}>;


export type RouteInRoutePairSelectQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', route: { __typename?: 'RouteSearchRoot', byRouteTypes: Array<{ __typename?: 'Route', id: string, code: string, name: string, routeType: string, routePair: { __typename?: 'RoutePair', id: string, code: string, seaArea: { __typename?: 'SeaArea', id: string, name: string } } }> } } };

export type ByRouteTypesFragment = { __typename?: 'Route', id: string, code: string, name: string, routeType: string, routePair: { __typename?: 'RoutePair', id: string, code: string, seaArea: { __typename?: 'SeaArea', id: string, name: string } } };

export type RouteSelectQueryVariables = Exact<{
  routeTypes: Array<Scalars['String']['input']> | Scalars['String']['input'];
  excludeOnlyAsPartOfMultiLegRoutes: Scalars['Boolean']['input'];
  includeNotValid: Scalars['Boolean']['input'];
}>;


export type RouteSelectQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', route: { __typename?: 'RouteSearchRoot', byRouteTypes: Array<{ __typename?: 'Route', id: string, code: string, name: string, routeType: string, routePair: { __typename?: 'RoutePair', id: string, code: string, seaArea: { __typename?: 'SeaArea', id: string, name: string } } }> } } };

export type AllTargetNegotiationStatusFragment = { __typename?: 'TargetNegotiationStatus', id: string, code: string, description: string, presentationOrder: number };

export type TargetStatusSelectQueryVariables = Exact<{ [key: string]: never; }>;


export type TargetStatusSelectQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', targetNegotiationStatus: { __typename?: 'TargetNegotiationStatusSearchRoot', all: Array<{ __typename?: 'TargetNegotiationStatus', id: string, code: string, description: string, presentationOrder: number }> } } };

export type UserMultiChipSelectQueryVariables = Exact<{ [key: string]: never; }>;


export type UserMultiChipSelectQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', user: { __typename?: 'UserSearchRoot', all: Array<{ __typename?: 'User', id: string, name: string }>, me: { __typename?: 'User', id: string, name: string } } } };

export type AllUsersFragment = { __typename?: 'User', id: string, name: string };

export type UserMultiSelectQueryVariables = Exact<{ [key: string]: never; }>;


export type UserMultiSelectQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', user: { __typename?: 'UserSearchRoot', all: Array<{ __typename?: 'User', id: string, name: string }>, me: { __typename?: 'User', id: string, name: string } } } };

export type VehicleTypeSelectQueryVariables = Exact<{ [key: string]: never; }>;


export type VehicleTypeSelectQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', vehicleType: { __typename?: 'VehicleTypeSearchRoot', all: Array<{ __typename?: 'VehicleType', id: string, shortDescription: string, code: string, accompanied: boolean }> } } };

export type VehicleTypeWithAllSelectQueryVariables = Exact<{ [key: string]: never; }>;


export type VehicleTypeWithAllSelectQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', vehicleType: { __typename?: 'VehicleTypeSearchRoot', all: Array<{ __typename?: 'VehicleType', id: string, shortDescription: string, code: string }> } } };

export type UserProfileGateQueryVariables = Exact<{ [key: string]: never; }>;


export type UserProfileGateQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', userProfile: { __typename?: 'UserProfileSearchRoot', me: { __typename?: 'UserProfile', id: string, userName: string, fullName: string, claims: Array<string> } } } };

export type FeatureFlagsQueryVariables = Exact<{ [key: string]: never; }>;


export type FeatureFlagsQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', features: { __typename?: 'FeatureFlag', agreement: { __typename?: 'AgreementFlags', useReportMessageSubscription: boolean } } } };

export type NegotiationYearsQueryVariables = Exact<{ [key: string]: never; }>;


export type NegotiationYearsQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', negotiationYear: { __typename?: 'NegotiationYearSearchRoot', availableYears: Array<{ __typename?: 'NegotiationYear', id: string, year: number }> } } };

export type SurchargeDocumentsQueryVariables = Exact<{ [key: string]: never; }>;


export type SurchargeDocumentsQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', additionalCharges: { __typename?: 'AdditionalChargesSearchRoot', all: Array<{ __typename?: 'AdditionalCharges', id: string, currency: string | null, fileName: string | null, validFrom: string | null, createdBy: string | null, createdDate: string | null, seaArea: { __typename?: 'PartialSeaArea', name: string, code: string } | null }> } } };

export type DeleteAdditionalChargesMutationVariables = Exact<{
  additionalCharges: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type DeleteAdditionalChargesMutation = { __typename?: 'Mutation', productPrice: { __typename?: 'ProductPriceMutationRoot', additionalCharges: { __typename?: 'AdditionalChargesMutationRoot', deleteAdditionalCharges: { __typename?: 'DeleteAdditionalChargesSuccessResult', success: boolean | null } | { __typename?: 'ErrorResult' } } } };

export type SurchargeDocumentsSeaAreaQueryVariables = Exact<{ [key: string]: never; }>;


export type SurchargeDocumentsSeaAreaQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', seaArea: { __typename?: 'SeaAreaSearchRoot', all: Array<{ __typename?: 'SeaArea', id: string, name: string }> } } };

export type SpecificationInformationQueryVariables = Exact<{
  byIdId: Scalars['ID']['input'];
  year: Scalars['Int']['input'];
  month: Scalars['Int']['input'];
}>;


export type SpecificationInformationQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', customers: { __typename?: 'CustomerSearchRoot', byId: { __typename?: 'Customer', id: string, creditLimit: number | null, termsOfPaymentDays: number | null, termsOfPaymentMonths: number | null, customerThresholds: Array<{ __typename?: 'CustomerThreshold', id: string, percentage: number, thresholdTypeCode: string, validFrom: string }> } | null } } };

export type ChildCustomersByStatusFragment = { __typename?: 'Customer', id: string, countryCode: string | null, custNo: number, name: string, custIndex: string, hasDocumentByInput: boolean | null, subscriberContactsForReport: Array<{ __typename?: 'SubscriberContact', id: string, email: string | null, subscriberContactId: string | null }>, activeHeadAgreementByYear: { __typename?: 'HeadAgreement', id: string } | null };

export type ChildSelectorQueryVariables = Exact<{
  customerId: Scalars['ID']['input'];
  year: Scalars['Int']['input'];
  agreementId: Scalars['String']['input'];
  agreementDocumentType: Scalars['String']['input'];
}>;


export type ChildSelectorQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', customers: { __typename?: 'CustomerSearchRoot', byId: { __typename?: 'Customer', id: string, childCustomersByStatus: Array<{ __typename?: 'Customer', id: string, countryCode: string | null, custNo: number, name: string, custIndex: string, hasDocumentByInput: boolean | null, subscriberContactsForReport: Array<{ __typename?: 'SubscriberContact', id: string, email: string | null, subscriberContactId: string | null }>, activeHeadAgreementByYear: { __typename?: 'HeadAgreement', id: string } | null }> } | null } } };

export type CreateAgreementReportMutationVariables = Exact<{
  input: CreateAgreementReportInput;
}>;


export type CreateAgreementReportMutation = { __typename?: 'Mutation', createAgreementReport: { __typename?: 'CreateAgreementReportResponse', reportCreated: boolean | null } | null };

export type SubscriberContactSubscriberFragment = { __typename?: 'Subscriber', id: string, firstName: string | null, surName: string | null, telNo: string | null };

export type SubscriberContactsForReportFragment = { __typename?: 'SubscriberContact', id: string, email: string | null, mobile: string | null, subscriberContactId: string | null, subscriber: { __typename?: 'Subscriber', id: string, firstName: string | null, surName: string | null, telNo: string | null } };

export type CustomerSubscriberSelectorFragment = { __typename?: 'Customer', id: string, subscriberContactsForReport: Array<{ __typename?: 'SubscriberContact', id: string, email: string | null, mobile: string | null, subscriberContactId: string | null, subscriber: { __typename?: 'Subscriber', id: string, firstName: string | null, surName: string | null, telNo: string | null } }> };

export type RouteAgreementsFragment = { __typename?: 'RouteAgreement', routeDescription: string, id: string, statusCode: HeadAgreementStatusCode, agreementNumber: number, name: string, externalDescription: string | null, externalComment: string | null, multiLegAgrRouteId: string | null, hasArticles: boolean, sailingTypeCodes: Array<SailingTypeCode>, hasMatrix: boolean, routes: Array<{ __typename?: 'Route', id: string, code: string, routePair: { __typename?: 'RoutePair', code: string, seaArea: { __typename?: 'SeaArea', name: string } } }>, valid: { __typename?: 'DateRange', start: { __typename?: 'Date', isoString: string } | null, end: { __typename?: 'Date', isoString: string } | null }, currency: { __typename?: 'Currency', id: string, code: string } };

export type CreateReportHeaderFragment = { __typename?: 'HeadAgreement', id: string, breadCrumbName: string };

export type CreateReportHeaderCustomerFragment = { __typename?: 'Customer', id: string, name: string, custNo: number, custIndex: string, breadCrumbName: string };

export type MultiLegRouteAgreementsFragment = { __typename?: 'HeadAgreement', id: string, multiLegAgrRoutes: Array<{ __typename?: 'MultiLegRouteAgreement', id: string, statusCode: HeadAgreementStatusCode, name: string, idNumber: number | null, workFlowStatusCode: WorkFlowStatusCode | null, routeAgreements: Array<{ __typename?: 'RouteAgreement', isSalesReady: boolean }>, currency: { __typename?: 'Currency', id: string, code: string }, route: { __typename?: 'Route', id: string, code: string, routePair: { __typename?: 'RoutePair', seaArea: { __typename?: 'SeaArea', id: string, name: string } } }, valid: { __typename?: 'DateRange', start: { __typename?: 'Date', isoString: string } | null, end: { __typename?: 'Date', isoString: string } | null } }> };

export type ReportScreenCustomerFragment = { __typename?: 'Customer', id: string, name: string, breadCrumbName: string, statisticalGroupingId: number | null, custIndex: string, termsOfPaymentMonths: number | null, termsOfPaymentDays: number | null, creditLimit: number | null, custNo: number, countryCode: string | null, modeOfPay: string, noOfChildren: number, sortPortCountry: { __typename?: 'Country', id: string, code: string } | null, preselectedHeadAgreement: { __typename?: 'HeadAgreement', id: string } | null, invoiceCurrency: { __typename?: 'Currency', code: string }, seller: { __typename?: 'User', id: string, sellerFirstName: string, sellerLastName: string, sellerPhoneNumber: string | null, sellerEmailAddress: string | null }, subscriberContactsForReport: Array<{ __typename?: 'SubscriberContact', id: string, email: string | null, mobile: string | null, subscriberContactId: string | null, subscriber: { __typename?: 'Subscriber', id: string, firstName: string | null, surName: string | null, telNo: string | null } }> };

export type ReportScreenHeadagreementFragment = { __typename?: 'HeadAgreement', name: string, id: string, lastPage: string | null, internalComments: string | null, condition: string | null, specifications: string | null, headAgreementNumber: number, rowVersion: string, breadCrumbName: string, valid: { __typename?: 'DateRange', end: { __typename?: 'Date', isoString: string } | null, start: { __typename?: 'Date', isoString: string } | null }, routeAgreements: Array<{ __typename?: 'RouteAgreement', routeDescription: string, id: string, statusCode: HeadAgreementStatusCode, agreementNumber: number, name: string, externalDescription: string | null, externalComment: string | null, multiLegAgrRouteId: string | null, hasArticles: boolean, sailingTypeCodes: Array<SailingTypeCode>, hasMatrix: boolean, routes: Array<{ __typename?: 'Route', id: string, code: string, routePair: { __typename?: 'RoutePair', code: string, seaArea: { __typename?: 'SeaArea', name: string } } }>, valid: { __typename?: 'DateRange', start: { __typename?: 'Date', isoString: string } | null, end: { __typename?: 'Date', isoString: string } | null }, currency: { __typename?: 'Currency', id: string, code: string } }>, multiLegAgrRoutes: Array<{ __typename?: 'MultiLegRouteAgreement', id: string, statusCode: HeadAgreementStatusCode, name: string, idNumber: number | null, workFlowStatusCode: WorkFlowStatusCode | null, routeAgreements: Array<{ __typename?: 'RouteAgreement', isSalesReady: boolean }>, currency: { __typename?: 'Currency', id: string, code: string }, route: { __typename?: 'Route', id: string, code: string, routePair: { __typename?: 'RoutePair', seaArea: { __typename?: 'SeaArea', id: string, name: string } } }, valid: { __typename?: 'DateRange', start: { __typename?: 'Date', isoString: string } | null, end: { __typename?: 'Date', isoString: string } | null } }> };

export type ReportScreenQueryVariables = Exact<{
  customerId: Scalars['ID']['input'];
  headAgreementId: Scalars['ID']['input'];
  codes: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type ReportScreenQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', customers: { __typename?: 'CustomerSearchRoot', byId: { __typename?: 'Customer', id: string, name: string, breadCrumbName: string, statisticalGroupingId: number | null, custIndex: string, termsOfPaymentMonths: number | null, termsOfPaymentDays: number | null, creditLimit: number | null, custNo: number, countryCode: string | null, modeOfPay: string, noOfChildren: number, agreedVolumeSummary: { __typename?: 'AgreedVolumeSummaryResult', volumes: Array<{ __typename?: 'AgreedVolumeSummary', id: string, routePairCode: string, routePairDescription: string, agreedVolume: number }> }, sortPortCountry: { __typename?: 'Country', id: string, code: string } | null, preselectedHeadAgreement: { __typename?: 'HeadAgreement', id: string } | null, invoiceCurrency: { __typename?: 'Currency', code: string }, seller: { __typename?: 'User', id: string, sellerFirstName: string, sellerLastName: string, sellerPhoneNumber: string | null, sellerEmailAddress: string | null }, subscriberContactsForReport: Array<{ __typename?: 'SubscriberContact', id: string, email: string | null, mobile: string | null, subscriberContactId: string | null, subscriber: { __typename?: 'Subscriber', id: string, firstName: string | null, surName: string | null, telNo: string | null } }> } | null }, headAgreement: { __typename?: 'HeadAgreementSearchRoot', byId: { __typename?: 'HeadAgreement', name: string, id: string, lastPage: string | null, internalComments: string | null, condition: string | null, specifications: string | null, headAgreementNumber: number, rowVersion: string, breadCrumbName: string, valid: { __typename?: 'DateRange', end: { __typename?: 'Date', isoString: string } | null, start: { __typename?: 'Date', isoString: string } | null }, routeAgreements: Array<{ __typename?: 'RouteAgreement', routeDescription: string, id: string, statusCode: HeadAgreementStatusCode, agreementNumber: number, name: string, externalDescription: string | null, externalComment: string | null, multiLegAgrRouteId: string | null, hasArticles: boolean, sailingTypeCodes: Array<SailingTypeCode>, hasMatrix: boolean, routes: Array<{ __typename?: 'Route', id: string, code: string, routePair: { __typename?: 'RoutePair', code: string, seaArea: { __typename?: 'SeaArea', name: string } } }>, valid: { __typename?: 'DateRange', start: { __typename?: 'Date', isoString: string } | null, end: { __typename?: 'Date', isoString: string } | null }, currency: { __typename?: 'Currency', id: string, code: string } }>, multiLegAgrRoutes: Array<{ __typename?: 'MultiLegRouteAgreement', id: string, statusCode: HeadAgreementStatusCode, name: string, idNumber: number | null, workFlowStatusCode: WorkFlowStatusCode | null, routeAgreements: Array<{ __typename?: 'RouteAgreement', isSalesReady: boolean }>, currency: { __typename?: 'Currency', id: string, code: string }, route: { __typename?: 'Route', id: string, code: string, routePair: { __typename?: 'RoutePair', seaArea: { __typename?: 'SeaArea', id: string, name: string } } }, valid: { __typename?: 'DateRange', start: { __typename?: 'Date', isoString: string } | null, end: { __typename?: 'Date', isoString: string } | null } }> } | null }, agreementTexts: { __typename?: 'AgreementTextsSearchRoot', byAgreementTextCodes: Array<{ __typename?: 'AgreementTexts', id: string, code: string, value: string }> } } };

export type UpdateHeadAgreementTextsMutationVariables = Exact<{
  input: UpdateHeadAgreementInput;
}>;


export type UpdateHeadAgreementTextsMutation = { __typename?: 'Mutation', productPrice: { __typename?: 'ProductPriceMutationRoot', headAgreement: { __typename?: 'HeadAgreementMutationRoot', updateHeadAgreement: { __typename?: 'ErrorResult', errors: Array<{ __typename?: 'ErrorDetail', message: string, path: string | null }> } | { __typename?: 'UpdateHeadAgreementSuccessResult', headAgreement: { __typename?: 'HeadAgreement', id: string, condition: string | null, lastPage: string | null, rowVersion: string, specifications: string | null } } } } };

export type RoutesValidationQueryVariables = Exact<{
  headAgreementId: Scalars['ID']['input'];
  custNo: Scalars['Int']['input'];
  multiLegAgreements: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  routeAgreements: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type RoutesValidationQuery = { __typename?: 'Query', validateRoutesForAgreement: { __typename?: 'ValidationResponse', validationResult: { __typename?: 'ValidationResult', resourceId: string | null, statusCode: number | null, validationErrors: Array<{ __typename?: 'ValidationErrors', path: string | null, errorMessage: string | null, severityLevel: number | null, statusCode: number | null } | null> | null } | null } | null };

export type CustomerStatisticsByFilterItemsFragment = { __typename?: 'CustomerStatisticsEntry', id: string, expectedVolume: number | null, statVolume12Months: number | null, unitCategoryCode: UnitCategoryCode, expectedStatVolume: number | null, sailingCategoryCode: SailingTypeCode, volume12Months: number, actualOutcomeInPercent: number | null, targetInPercent: number | null };

export type ExpectedStatGroupVolumeItemsFragment = { __typename?: 'ExpectedStatGroupVolume', sailingCategoryCode: SailingTypeCode | null, unitCategoryCode: string | null, expectedStatGroupVolume: number };

export type FetchStatBoxesQueryVariables = Exact<{
  customerId: Scalars['ID']['input'];
  routePairId: Scalars['ID']['input'];
  year: Scalars['Int']['input'];
}>;


export type FetchStatBoxesQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', customers: { __typename?: 'CustomerSearchRoot', byId: { __typename?: 'Customer', id: string, expectedStatGroupVolume: { __typename?: 'ExpectedStatGroupVolumeResult', volumes: Array<{ __typename?: 'ExpectedStatGroupVolume', sailingCategoryCode: SailingTypeCode | null, unitCategoryCode: string | null, expectedStatGroupVolume: number }> }, statisticsByFilter: { __typename?: 'CustomerStatisticsResult', items: Array<{ __typename?: 'CustomerStatisticsEntry', id: string, expectedVolume: number | null, statVolume12Months: number | null, unitCategoryCode: UnitCategoryCode, expectedStatVolume: number | null, sailingCategoryCode: SailingTypeCode, volume12Months: number, actualOutcomeInPercent: number | null, targetInPercent: number | null }> } } | null } } };

export type RefetchDataForStatBoxesForRoutePairQueryVariables = Exact<{
  input: CalculateActualPriceChangeForAllRatesInput;
}>;


export type RefetchDataForStatBoxesForRoutePairQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', customerRouteStatistics: { __typename?: 'CustomerRouteStatisticsSearchRoot', calculateActualPriceChangeForAllRates: Array<{ __typename?: 'CustomerStatisticsEntry', actualOutcomeInPercent: number | null, expectedVolume: number | null, id: string, sailingCategoryCode: SailingTypeCode, statVolume12Months: number | null, expectedStatVolume: number | null, targetInPercent: number | null, unitCategoryCode: UnitCategoryCode, volume12Months: number }> } } };

export type UpdateCustomerRouteStatisticsActualOutcomeMutationVariables = Exact<{
  input: Array<UpdateCustomerRouteStatisticsActualOutcomeInput> | UpdateCustomerRouteStatisticsActualOutcomeInput;
}>;


export type UpdateCustomerRouteStatisticsActualOutcomeMutation = { __typename?: 'Mutation', productPrice: { __typename?: 'ProductPriceMutationRoot', customerRouteStatistics: { __typename?: 'CustomerRouteStatisticsMutationRoot', updateCustomerRouteStatisticsActualOutcome: { __typename?: 'UpdateCustomerRouteStatisticsResult', customerRouteStatistics: Array<{ __typename?: 'UpdateCustomerRouteStatisticsActualOutcomeItemResult', custNo: number, routePairCode: string, year: number, sailingCategoryCode: string, unitCategoryCode: string, actualOutcomeInPercent: number | null }> } } } };

export type RelatedCustomersFragment = { __typename?: 'Customer', id: string, custIndex: string, custNo: number, name: string, isParent: boolean };

export type ExpectedVolumeFragment = { __typename?: 'ExpectedVolumeResult', volumes: Array<{ __typename?: 'ExpectedVolume', id: string, expectedVolume: number | null, sailingCategoryCode: SailingTypeCode, unitCategoryCode: string, volume12Months: number, year: number, volumeAgreed: boolean, customer: { __typename?: 'Customer', id: string }, routePair: { __typename?: 'RoutePair', id: string } }> };

export type ExpectedVolumeFetcherQueryVariables = Exact<{
  customerId: Scalars['ID']['input'];
  negotiationYear: Scalars['Int']['input'];
}>;


export type ExpectedVolumeFetcherQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', routePair: { __typename?: 'RoutePairSearchRoot', allWithStatusOwn: Array<{ __typename?: 'RoutePair', id: string, code: string }> }, customers: { __typename?: 'CustomerSearchRoot', byId: { __typename?: 'Customer', id: string, name: string, breadCrumbName: string, custIndex: string, custNo: number, isParent: boolean, isStandardCustomer: boolean, hasRebateAgreements: boolean | null, relatedCustomers: Array<{ __typename?: 'Customer', id: string, custIndex: string, custNo: number, name: string, isParent: boolean }>, expectedVolumeByFilter: { __typename?: 'ExpectedVolumeResult', volumes: Array<{ __typename?: 'ExpectedVolume', id: string, expectedVolume: number | null, sailingCategoryCode: SailingTypeCode, unitCategoryCode: string, volume12Months: number, year: number, volumeAgreed: boolean, customer: { __typename?: 'Customer', id: string }, routePair: { __typename?: 'RoutePair', id: string } }> }, custStatus: { __typename?: 'CustomerStatus', id: string, name: string } | null, parent: { __typename?: 'Customer', id: string, preselectedHeadAgreement: { __typename?: 'HeadAgreement', id: string } | null } | null, childCustomers: Array<{ __typename?: 'Customer', id: string }>, statisticalGrouping: { __typename?: 'Customer', id: string } | null, invoiceCurrency: { __typename?: 'Currency', id: string, code: string }, seller: { __typename?: 'User', id: string, name: string }, salesRegion: { __typename?: 'SalesRegion', id: string, code: string, name: string }, writeHistory: { __typename?: 'WriteHistory', createdAt: { __typename?: 'DateTime', isoString: string }, createdBy: { __typename?: 'User', id: string, name: string }, modifiedAt: { __typename?: 'DateTime', isoString: string } | null, modifiedBy: { __typename?: 'User', id: string, name: string } | null } } | null } } };

export type UpdateExpectedVolumesMutationVariables = Exact<{
  input: UpdateExpectedVolumesInput;
}>;


export type UpdateExpectedVolumesMutation = { __typename?: 'Mutation', productPrice: { __typename?: 'ProductPriceMutationRoot', expectedVolume: { __typename?: 'ExpectedVolumeMutationRoot', updateExpectedVolumes: { __typename?: 'ErrorResult', errors: Array<{ __typename?: 'ErrorDetail', message: string, path: string | null }> } | { __typename?: 'UpdateExpectedVolumesSuccessResult', volumes: Array<{ __typename?: 'ExpectedVolume', id: string, expectedVolume: number | null, volume12Months: number }> } } } };

export type CustomerSearchNumberAndStatusFragment = { __typename?: 'Customer', id: string, custIndex: string, custNo: number, name: string, custStatus: { __typename?: 'CustomerStatus', id: string, name: string, code: CustomerStatusCode } | null, parent: { __typename?: 'Customer', id: string } | null, preselectedHeadAgreement: { __typename?: 'HeadAgreement', id: string } | null };

export type CustomersSearchQueryVariables = Exact<{
  custNoAndStatus: CustomerGetByCustNoAndStatus;
}>;


export type CustomersSearchQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', customers: { __typename?: 'CustomerSearchRoot', byCustomerNumberAndStatus: Array<{ __typename?: 'Customer', id: string, custIndex: string, custNo: number, name: string, custStatus: { __typename?: 'CustomerStatus', id: string, name: string, code: CustomerStatusCode } | null, parent: { __typename?: 'Customer', id: string } | null, preselectedHeadAgreement: { __typename?: 'HeadAgreement', id: string } | null }> } } };

export type NslhCustomerSelectFragment = { __typename?: 'Customer', id: string, custNo: number, custIndex: string, name: string };

export type NslhCustomersSelectQueryVariables = Exact<{
  query: Scalars['String']['input'];
}>;


export type NslhCustomersSelectQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', customers: { __typename?: 'CustomerSearchRoot', byCustomerNumberOrIndex: Array<{ __typename?: 'Customer', id: string, custNo: number, custIndex: string, name: string }> } } };

export type UpdateHandleBookingStatusMutationVariables = Exact<{
  input: Array<UpdateBookingHandlingStatusInput> | UpdateBookingHandlingStatusInput;
}>;


export type UpdateHandleBookingStatusMutation = { __typename?: 'Mutation', productPrice: { __typename?: 'ProductPriceMutationRoot', noShowLateHandlingBookings: { __typename?: 'NoShowLateHandlingBookingsMutationRoot', updateBookingHandlingStatus: { __typename?: 'UpdateBookingHandlingStatusErrorResult', errors: Array<{ __typename?: 'ErrorDetail', message: string, path: string | null }> } | { __typename?: 'UpdateBookingHandlingStatusSuccessResult', handleBookingBookingData: Array<{ __typename?: 'HandleBookingBookingData', id: string, consignmentNo: number | null, handlingStatus: string, month: string, bookingNo: number, bookingVersion: number, departureDate: string, departureTime: string, vehicleReg: string | null, trailerReg: string | null, customerReference: string | null, revisedDate: string | null, revisedTime: string | null, loadingListMessage: string | null, note: string | null, lateHandlingDate: string, lateHandlingUser: string, dateModified: string | null, modifiedBy: string | null, codeNoShowLateType: { __typename?: 'CodeNoShowLateType', id: string, code: string, description: string }, consignment: { __typename?: 'Consignment', id: string, sailingArchive: { __typename?: 'SailingArchive', departureDate: string, departureTime: string, route: { __typename?: 'Route', code: string } } } | null, route: { __typename?: 'Route', id: string, code: string, routePair: { __typename?: 'RoutePair', id: string, code: string } }, vehicleType: { __typename?: 'VehicleType', id: string, code: string, shortDescription: string } | null, excludeReason: { __typename?: 'NoShowLateHandlingExcludeReason', id: string, code: string, description: string } | null }> } } } };

export type CalculateThresholdMutationVariables = Exact<{
  input: CalculateThresholdInput;
}>;


export type CalculateThresholdMutation = { __typename?: 'Mutation', productPrice: { __typename?: 'ProductPriceMutationRoot', noShowLateHandlingBookings: { __typename?: 'NoShowLateHandlingBookingsMutationRoot', calculateThreshold: { __typename?: 'CalculateThresholdErrorResult', errors: Array<{ __typename?: 'ErrorDetail', message: string, path: string | null }> } | { __typename?: 'CalculateThresholdSuccessResult', success: boolean } } } };

export type CreateInvoicesMutationVariables = Exact<{
  input: CreateInvoicesInput;
}>;


export type CreateInvoicesMutation = { __typename?: 'Mutation', productPrice: { __typename?: 'ProductPriceMutationRoot', noShowLateHandlingInvoices: { __typename?: 'NoShowLateHandlingInvoicesMutationRoot', createInvoices: { __typename?: 'CreateInvoicesErrorResult', errors: Array<{ __typename?: 'ErrorDetail', message: string, path: string | null }> } | { __typename?: 'CreateInvoicesSuccessResult', success: boolean } } } };

export type HandleBookingDataFragment = { __typename?: 'HandleBookingBookingData', id: string, consignmentNo: number | null, handlingStatus: string, month: string, bookingNo: number, bookingVersion: number, departureDate: string, departureTime: string, vehicleReg: string | null, trailerReg: string | null, customerReference: string | null, revisedDate: string | null, revisedTime: string | null, loadingListMessage: string | null, note: string | null, lateHandlingDate: string, lateHandlingUser: string, dateModified: string | null, modifiedBy: string | null, codeNoShowLateType: { __typename?: 'CodeNoShowLateType', id: string, code: string, description: string }, consignment: { __typename?: 'Consignment', id: string, sailingArchive: { __typename?: 'SailingArchive', departureDate: string, departureTime: string, route: { __typename?: 'Route', code: string } } } | null, route: { __typename?: 'Route', id: string, code: string, routePair: { __typename?: 'RoutePair', id: string, code: string } }, vehicleType: { __typename?: 'VehicleType', id: string, code: string, shortDescription: string } | null, excludeReason: { __typename?: 'NoShowLateHandlingExcludeReason', id: string, code: string, description: string } | null };

export type NslhBookingDataFragment = { __typename?: 'NoShowLateHandlingHandleBookingsData', id: string, region: string, seller: string, noOfToDo: number, noOfToBeInvoiced: number, noOfInvoiced: number, noOfDoNotInvoice: number, noOfThreshold: number, noOfNotChargeable: number, customer: { __typename?: 'Customer', id: string, custIndex: string, custNo: number, name: string, modeOfPay: string }, customerBookings: Array<{ __typename?: 'HandleBookingBookingData', id: string, consignmentNo: number | null, handlingStatus: string, month: string, bookingNo: number, bookingVersion: number, departureDate: string, departureTime: string, vehicleReg: string | null, trailerReg: string | null, customerReference: string | null, revisedDate: string | null, revisedTime: string | null, loadingListMessage: string | null, note: string | null, lateHandlingDate: string, lateHandlingUser: string, dateModified: string | null, modifiedBy: string | null, codeNoShowLateType: { __typename?: 'CodeNoShowLateType', id: string, code: string, description: string }, consignment: { __typename?: 'Consignment', id: string, sailingArchive: { __typename?: 'SailingArchive', departureDate: string, departureTime: string, route: { __typename?: 'Route', code: string } } } | null, route: { __typename?: 'Route', id: string, code: string, routePair: { __typename?: 'RoutePair', id: string, code: string } }, vehicleType: { __typename?: 'VehicleType', id: string, code: string, shortDescription: string } | null, excludeReason: { __typename?: 'NoShowLateHandlingExcludeReason', id: string, code: string, description: string } | null }> };

export type NoShowLateHandlingBookingListQueryVariables = Exact<{
  filterOptions: NoShowLateHandlingBookingsByFilterOptions;
}>;


export type NoShowLateHandlingBookingListQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', noShowLateHandlingBookings: { __typename?: 'NoShowLateHandlingBookingsSearchRoot', byFilter: { __typename?: 'NoShowLateHandlingBookingsByFilterResult', bookingsData: Array<{ __typename?: 'NoShowLateHandlingHandleBookingsData', id: string, region: string, seller: string, noOfToDo: number, noOfToBeInvoiced: number, noOfInvoiced: number, noOfDoNotInvoice: number, noOfThreshold: number, noOfNotChargeable: number, customer: { __typename?: 'Customer', id: string, custIndex: string, custNo: number, name: string, modeOfPay: string }, customerBookings: Array<{ __typename?: 'HandleBookingBookingData', id: string, consignmentNo: number | null, handlingStatus: string, month: string, bookingNo: number, bookingVersion: number, departureDate: string, departureTime: string, vehicleReg: string | null, trailerReg: string | null, customerReference: string | null, revisedDate: string | null, revisedTime: string | null, loadingListMessage: string | null, note: string | null, lateHandlingDate: string, lateHandlingUser: string, dateModified: string | null, modifiedBy: string | null, codeNoShowLateType: { __typename?: 'CodeNoShowLateType', id: string, code: string, description: string }, consignment: { __typename?: 'Consignment', id: string, sailingArchive: { __typename?: 'SailingArchive', departureDate: string, departureTime: string, route: { __typename?: 'Route', code: string } } } | null, route: { __typename?: 'Route', id: string, code: string, routePair: { __typename?: 'RoutePair', id: string, code: string } }, vehicleType: { __typename?: 'VehicleType', id: string, code: string, shortDescription: string } | null, excludeReason: { __typename?: 'NoShowLateHandlingExcludeReason', id: string, code: string, description: string } | null }> }> } } | null } };

export type NshlInvoiceSpecificationFragment = { __typename?: 'NslhInvoice', id: string, invoiceNo: number, consignmentNo: number | null, invoiceDate: string | null, netAmount: number, nslhMonth: number, invoiceCurrencyCode: string | null, nslhYear: number, routeCodeBreak: string | null, thresholdNoShow: number, thresholdLateHandling: number, customer: { __typename?: 'Customer', id: string, custNo: number, name: string, custIndex: string, invoiceCurrency: { __typename?: 'Currency', id: string, code: string } }, routeVolumes: Array<{ __typename?: 'NslhBookingRouteVolume', id: string, shippedVolume: number, routePair: { __typename?: 'RoutePair', code: string, id: string } }>, nslhBookings: Array<{ __typename?: 'NslhBooking', id: string, consignmentNo: number | null, articlePrice: number | null, bookingNo: number, bookingVersion: number, customerReference: string | null, departureDate: string, departureTime: string, handlingStatus: string, handlingType: string, handlingTypeGrouped: string, revisedTime: string | null, revisedDate: string | null, trailerReg: string | null, vehicleReg: string | null, lateHandlingUser: string | null, lateHandlingDate: string | null, customer: { __typename?: 'Customer', id: string, custNo: number }, vehicleType: { __typename?: 'VehicleType', id: string, shortDescription: string }, route: { __typename?: 'Route', id: string, code: string, routePair: { __typename?: 'RoutePair', id: string, code: string, description: string } } }> };

export type InternalInvoiceSpecificationQueryVariables = Exact<{
  invoiceNo: Scalars['ID']['input'];
}>;


export type InternalInvoiceSpecificationQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', noShowLateHandling: { __typename?: 'NoShowLateHandlingSearchRoot', nslhInvoice: { __typename?: 'NslhInvoiceSearchRoot', byId: Array<{ __typename?: 'NslhInvoice', id: string, invoiceNo: number, consignmentNo: number | null, invoiceDate: string | null, netAmount: number, nslhMonth: number, invoiceCurrencyCode: string | null, nslhYear: number, routeCodeBreak: string | null, thresholdNoShow: number, thresholdLateHandling: number, customer: { __typename?: 'Customer', id: string, custNo: number, name: string, custIndex: string, invoiceCurrency: { __typename?: 'Currency', id: string, code: string } }, routeVolumes: Array<{ __typename?: 'NslhBookingRouteVolume', id: string, shippedVolume: number, routePair: { __typename?: 'RoutePair', code: string, id: string } }>, nslhBookings: Array<{ __typename?: 'NslhBooking', id: string, consignmentNo: number | null, articlePrice: number | null, bookingNo: number, bookingVersion: number, customerReference: string | null, departureDate: string, departureTime: string, handlingStatus: string, handlingType: string, handlingTypeGrouped: string, revisedTime: string | null, revisedDate: string | null, trailerReg: string | null, vehicleReg: string | null, lateHandlingUser: string | null, lateHandlingDate: string | null, customer: { __typename?: 'Customer', id: string, custNo: number }, vehicleType: { __typename?: 'VehicleType', id: string, shortDescription: string }, route: { __typename?: 'Route', id: string, code: string, routePair: { __typename?: 'RoutePair', id: string, code: string, description: string } } }> }> } } } };

export type InternalOneMonthBookingsQueryVariables = Exact<{
  custNo: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
  month: Scalars['Int']['input'];
}>;


export type InternalOneMonthBookingsQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', noShowLateHandling: { __typename?: 'NoShowLateHandlingSearchRoot', nslhFollowUp: { __typename?: 'NslhFollowUpSearchRoot', byFilter: Array<{ __typename?: 'NslhFollowUp', id: string, shippedVolume: number, noOfNoShows: number, noOfExcludedNoShows: number, noOfLateHandlings: number, noOfExcludedLateHandlings: number, customer: { __typename?: 'Customer', id: string, custNo: number, custIndex: string, name: string, customerThresholds: Array<{ __typename?: 'CustomerThreshold', thresholdTypeCode: string, percentage: number }> }, routePair: { __typename?: 'RoutePair', id: string, code: string, description: string }, nslhRouteVolume: { __typename?: 'NslhBookingRouteVolume', id: string, shippedVolume: number, routePair: { __typename?: 'RoutePair', id: string, code: string } } | null, nslhBookingVolume: { __typename?: 'NslhBookingVolume', id: string, thresholdNoShowPercentage: number, thresholdLateHandleBookings: number, thresholdLateHandlePercentage: number, thresholdNoShowBookings: number } | null, nslhBookings: Array<{ __typename?: 'NslhBooking', id: string, consignmentNo: number | null, articlePrice: number | null, bookingNo: number, bookingVersion: number, customerReference: string | null, departureDate: string, departureTime: string, handlingStatus: string, handlingType: string, handlingTypeGrouped: string, revisedDate: string | null, revisedTime: string | null, trailerReg: string | null, vehicleReg: string | null, lateHandlingDate: string | null, lateHandlingUser: string | null, customer: { __typename?: 'Customer', id: string, custNo: number }, vehicleType: { __typename?: 'VehicleType', id: string, shortDescription: string }, route: { __typename?: 'Route', id: string, routePair: { __typename?: 'RoutePair', id: string, code: string, description: string } } }> }> } } } };

export type InternalOverviewQueryVariables = Exact<{
  custNo: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
  month: Scalars['Int']['input'];
}>;


export type InternalOverviewQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', noShowLateHandling: { __typename?: 'NoShowLateHandlingSearchRoot', nslhFollowUp: { __typename?: 'NslhFollowUpSearchRoot', byFilter: Array<{ __typename?: 'NslhFollowUp', id: string, shippedVolume: number, noOfNoShows: number, noOfExcludedNoShows: number, noOfLateHandlings: number, noOfExcludedLateHandlings: number, customer: { __typename?: 'Customer', id: string, custNo: number, custIndex: string, customerThresholds: Array<{ __typename?: 'CustomerThreshold', thresholdTypeCode: string, percentage: number }> }, routePair: { __typename?: 'RoutePair', id: string, code: string, description: string }, nslhBookingVolume: { __typename?: 'NslhBookingVolume', id: string, thresholdNoShowPercentage: number, thresholdLateHandleBookings: number, thresholdLateHandlePercentage: number, thresholdNoShowBookings: number } | null }> } } } };

export type DeleteValidFromDateMutationVariables = Exact<{
  input: DeleteValidFromDateInput;
}>;


export type DeleteValidFromDateMutation = { __typename?: 'Mutation', productPrice: { __typename?: 'ProductPriceMutationRoot', noShowLateHandlingPrices: { __typename?: 'NoShowLateHandlingMutationRoot', deleteValidFromDate: { __typename: 'DeleteValidFromDateErrorResult', errors: Array<{ __typename?: 'ErrorDetail', message: string, path: string | null }> } | { __typename: 'DeleteValidFromDateSuccessResult', success: boolean } } } };

export type AllNoShowLateHandlingPricesFragment = { __typename?: 'NoShowLateHandlingPrices', id: string, routePairCode: string, validFrom: string, noShowDkk: number, noShowEur: number, noShowSek: number, noShowNok: number, noShowPln: number, noShowGbp: number, lateHandlingDkk: number, lateHandlingEur: number, lateHandlingSek: number, lateHandlingNok: number, lateHandlingPln: number, lateHandlingGbp: number, createdBy: string, dateCreated: string, routePair: { __typename?: 'RoutePair', description: string } };

export type NoShowLateHandlingRoutePricesQueryVariables = Exact<{ [key: string]: never; }>;


export type NoShowLateHandlingRoutePricesQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', routePair: { __typename?: 'RoutePairSearchRoot', allWithStatusOwn: Array<{ __typename?: 'RoutePair', id: string, code: string, description: string }> }, noShowLateHandlingPrices: { __typename?: 'NoShowLateHandlingPricesSearchRoot', all: Array<{ __typename?: 'NoShowLateHandlingPrices', id: string, routePairCode: string, validFrom: string, noShowDkk: number, noShowEur: number, noShowSek: number, noShowNok: number, noShowPln: number, noShowGbp: number, lateHandlingDkk: number, lateHandlingEur: number, lateHandlingSek: number, lateHandlingNok: number, lateHandlingPln: number, lateHandlingGbp: number, createdBy: string, dateCreated: string, routePair: { __typename?: 'RoutePair', description: string } }> } | null } };

export type NoShowLateHandlingAllRoutePricesMutationVariables = Exact<{
  updateRoutePricesInput: Array<UpdateRoutePricesInput> | UpdateRoutePricesInput;
}>;


export type NoShowLateHandlingAllRoutePricesMutation = { __typename?: 'Mutation', productPrice: { __typename?: 'ProductPriceMutationRoot', noShowLateHandlingPrices: { __typename?: 'NoShowLateHandlingMutationRoot', updateRoutePrices: { __typename?: 'UpdateRoutePricesErrorResult', errors: Array<{ __typename?: 'ErrorDetail', message: string, path: string | null }> } | { __typename?: 'UpdateRoutePricesSuccessResult', updatePrices: Array<{ __typename?: 'UpdateRoutePricesSuccessResultData', id: string, routePairCode: string, validFrom: string }> } } } };

export type SearchNslhInvoiceByFilterFragment = { __typename?: 'NslhInvoiceInfo', id: string, noShowLateTypeCodes: Array<string>, lateHandlingDate: string, customer: { __typename?: 'Customer', id: string, custNo: number, custIndex: string } | null, nslhInvoice: { __typename?: 'NslhInvoice', id: string, invoiceNo: number, invoiceCurrencyCode: string | null, netAmount: number } };

export type SearchNslhInvoiceByCustomerDateRangeFragment = { __typename?: 'NslhInvoice', id: string, invoiceNo: number, invoiceCurrencyCode: string | null, netAmount: number };

export type SearchNslhInvoiceByCustomerDateRangeQueryVariables = Exact<{
  input: NslhInvoiceByFilterInput;
}>;


export type SearchNslhInvoiceByCustomerDateRangeQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', noShowLateHandling: { __typename?: 'NoShowLateHandlingSearchRoot', nslhInvoice: { __typename?: 'NslhInvoiceSearchRoot', byFilter: Array<{ __typename?: 'NslhInvoiceInfo', id: string, noShowLateTypeCodes: Array<string>, lateHandlingDate: string, customer: { __typename?: 'Customer', id: string, custNo: number, custIndex: string } | null, nslhInvoice: { __typename?: 'NslhInvoice', id: string, invoiceNo: number, invoiceCurrencyCode: string | null, netAmount: number } }> } } } };

export type QueryByInvoiceNoNslhInvoiceFragment = { __typename?: 'NslhInvoice', id: string, invoiceNo: number, consignmentNo: number | null };

export type SearchByInvoiceNoInvoicesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SearchByInvoiceNoInvoicesQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', noShowLateHandling: { __typename?: 'NoShowLateHandlingSearchRoot', nslhInvoice: { __typename?: 'NslhInvoiceSearchRoot', byId: Array<{ __typename?: 'NslhInvoice', id: string, invoiceNo: number, consignmentNo: number | null }> } } } };

export type UpsertedExpectedVolumeSuccessSubscriptionVariables = Exact<{
  userName: Scalars['String']['input'];
}>;


export type UpsertedExpectedVolumeSuccessSubscription = { __typename?: 'Subscription', upsertedExpectedVolumeSuccessful: { __typename?: 'Notification', id: string, text: string | null, title: string } };

export type SuccessSubscriptionVariables = Exact<{
  userName: Scalars['String']['input'];
}>;


export type SuccessSubscription = { __typename?: 'Subscription', agreementReportCreationSuccessful: { __typename?: 'Notification', id: string, text: string | null, title: string } };

export type FailSubscriptionVariables = Exact<{
  userName: Scalars['String']['input'];
}>;


export type FailSubscription = { __typename?: 'Subscription', agreementReportCreationFailed: { __typename?: 'Notification', id: string, text: string | null, title: string } };

export type GetConsignmentVersionsV2QueryVariables = Exact<{
  bookingNum: Scalars['ID']['input'];
}>;


export type GetConsignmentVersionsV2Query = { __typename?: 'Query', priceCalculator: { __typename?: 'PriceCalculatorSearchRoot', bookingVersions: { __typename?: 'BookingVersionsSearchRoot', byId: { __typename?: 'BookingVersion', versions: Array<number> } | null } } };

export type PriceCalculatorCustomerDetailsQueryVariables = Exact<{
  customerId: Scalars['ID']['input'];
}>;


export type PriceCalculatorCustomerDetailsQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', customers: { __typename?: 'CustomerSearchRoot', byId: { __typename?: 'Customer', id: string, name: string, custIndex: string, custNo: number, statisticalGrouping: { __typename?: 'Customer', id: string, custNo: number } | null, parent: { __typename?: 'Customer', id: string, custNo: number } | null, invoiceCurrency: { __typename?: 'Currency', code: string } } | null } } };

export type PriceCalculatorVehicleTypeSelectQueryVariables = Exact<{ [key: string]: never; }>;


export type PriceCalculatorVehicleTypeSelectQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', vehicleType: { __typename?: 'VehicleTypeSearchRoot', all: Array<{ __typename?: 'VehicleType', id: string, shortDescription: string, code: string, length: number | null, noOfDrivers: number | null, weight: number | null, width: number | null, isMultilegBookable: boolean }> } } };

export type PriceCalculatorAllMultiLegRoutesQueryVariables = Exact<{ [key: string]: never; }>;


export type PriceCalculatorAllMultiLegRoutesQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', route: { __typename?: 'RouteSearchRoot', allMultiLeg: Array<{ __typename?: 'Route', id: string, name: string, code: string, routeLegs: Array<{ __typename?: 'RouteLeg', id: string, legNo: number, legRoute: { __typename?: 'Route', code: string, id: string, name: string } }> }> } } };

export type PriceCalcLoadingPreferencesRadioQueryVariables = Exact<{ [key: string]: never; }>;


export type PriceCalcLoadingPreferencesRadioQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', loadingPreference: { __typename?: 'LoadingPreferenceSearchRoot', all: Array<{ __typename?: 'LoadingPreference', id: string, code: string, description: string, presentationOrder: number }> } } };

export type FetchPriceCalculatorFragment = { __typename?: 'PriceCalculator', auditLogs: Array<string> | null, errorMessage: string | null, baseCurrencyCode: string, seaFreightPrice: number, totalPrice: number, totalVat: number, convertedFrom: string | null, surchargeRecords: Array<{ __typename?: 'SurChargeV2', quantity: number, surchargePrice: number, surchargeVatAmount: number | null, surchargeVatRate: number | null, articleType: { __typename?: 'ArticleType', id: string, code: string, name: string } }>, ancillaryRecords: Array<{ __typename?: 'AncillaryChargeV2', ancillaryCode: string, quantity: number, ancillaryPrice: number, ancillaryVatAmount: number | null, ancillaryVatRate: number | null }>, route: { __typename?: 'Route', id: string, code: string, name: string } };

export type FetchBookingFragment = { __typename?: 'PriceCalculatorBooking', id: string, version: number, bookingNumber: number, priceCalculatorStatus: string | null, transit: boolean, vehicleRegistrationNumber: string | null, trailerRegistrationNumber: string | null, hasLivestock: boolean, loadingPreferenceCode: string | null, loadingPreferenceStatus: string | null, multiLegBookingNumber: number | null, bookingLegNumber: number, numberOfDrivers: number, numberOfAdults: number | null, numberOfChildren: number | null, numberOfInfants: number | null, numberOfFoc: number | null, numberOfPlugins: number | null, numberOfSleepers: number | null, numberOfTradeVehicles: number | null, numberOfVehTypeUnits: number | null, numberOfHazardousGoodsRows: number, standby: boolean, qualifiedGoods: boolean, receiverCountryCode: string | null, senderCountryCode: string | null, tradeVehicleWeight: number | null, hazardousGoodsTotalWeight: number | null, includeImoClass1Row: boolean, customsClassificationCode: string | null, importId: string | null, customerNumber: number, customerReference: string | null, length: number, weight: number | null, width: number, vehicleType: { __typename?: 'VehicleType', id: string, code: string, length: number | null, shortDescription: string }, sailingBookingConsignment: { __typename?: 'SailingBookingConsignment', id: string, sailingType: SailingTypeCode | null, departureDate: string, departureTime: string, route: { __typename?: 'Route', id: string, code: string, name: string } }, articles: Array<{ __typename?: 'ConsignmentArticle', id: string, articleCode: string, quantity: number, articleType: { __typename?: 'ArticleType', id: string, type: string, name: string } }>, livestockType: { __typename?: 'LiveStock', id: string, code: string, description: string } | null, movementType: { __typename?: 'MovementType', id: string, code: string, description: string }, multiLegRoute: { __typename?: 'Route', id: string, name: string, code: string } | null, goods: Array<{ __typename?: 'ConsignmentGoods', id: string, goodsCode: string, weight: number, description: string }>, bookingGoods: Array<{ __typename?: 'BookingGoods', id: string, goodsCode: string, weight: number, description: string }>, bookingArticles: Array<{ __typename?: 'BookingArticle', id: string, articleCode: string, quantity: number, articleType: { __typename?: 'ArticleType', id: string, type: string, name: string } }>, routeCode: { __typename?: 'Route', id: string, code: string, name: string } | null, bookingLegInvoice: { __typename?: 'ConsignmentLegInvoice', id: string, invoiceNo: number } | null };

export type PriceCalculatorBookingQueryVariables = Exact<{
  bookingNum: Scalars['ID']['input'];
  consignmentVersion: Scalars['Int']['input'];
}>;


export type PriceCalculatorBookingQuery = { __typename?: 'Query', priceCalculator: { __typename?: 'PriceCalculatorSearchRoot', bookings: { __typename?: 'BookingsSearchRoot', byId: Array<{ __typename?: 'PriceCalculatorBooking', id: string, version: number, bookingNumber: number, priceCalculatorStatus: string | null, transit: boolean, vehicleRegistrationNumber: string | null, trailerRegistrationNumber: string | null, hasLivestock: boolean, loadingPreferenceCode: string | null, loadingPreferenceStatus: string | null, multiLegBookingNumber: number | null, bookingLegNumber: number, numberOfDrivers: number, numberOfAdults: number | null, numberOfChildren: number | null, numberOfInfants: number | null, numberOfFoc: number | null, numberOfPlugins: number | null, numberOfSleepers: number | null, numberOfTradeVehicles: number | null, numberOfVehTypeUnits: number | null, numberOfHazardousGoodsRows: number, standby: boolean, qualifiedGoods: boolean, receiverCountryCode: string | null, senderCountryCode: string | null, tradeVehicleWeight: number | null, hazardousGoodsTotalWeight: number | null, includeImoClass1Row: boolean, customsClassificationCode: string | null, importId: string | null, customerNumber: number, customerReference: string | null, length: number, weight: number | null, width: number, vehicleType: { __typename?: 'VehicleType', id: string, code: string, length: number | null, shortDescription: string }, sailingBookingConsignment: { __typename?: 'SailingBookingConsignment', id: string, sailingType: SailingTypeCode | null, departureDate: string, departureTime: string, route: { __typename?: 'Route', id: string, code: string, name: string } }, articles: Array<{ __typename?: 'ConsignmentArticle', id: string, articleCode: string, quantity: number, articleType: { __typename?: 'ArticleType', id: string, type: string, name: string } }>, livestockType: { __typename?: 'LiveStock', id: string, code: string, description: string } | null, movementType: { __typename?: 'MovementType', id: string, code: string, description: string }, multiLegRoute: { __typename?: 'Route', id: string, name: string, code: string } | null, goods: Array<{ __typename?: 'ConsignmentGoods', id: string, goodsCode: string, weight: number, description: string }>, bookingGoods: Array<{ __typename?: 'BookingGoods', id: string, goodsCode: string, weight: number, description: string }>, bookingArticles: Array<{ __typename?: 'BookingArticle', id: string, articleCode: string, quantity: number, articleType: { __typename?: 'ArticleType', id: string, type: string, name: string } }>, routeCode: { __typename?: 'Route', id: string, code: string, name: string } | null, bookingLegInvoice: { __typename?: 'ConsignmentLegInvoice', id: string, invoiceNo: number } | null }> } } };

export type PriceCalculationMultiLegResultQueryVariables = Exact<{
  input: PriceCalculatorInput;
}>;


export type PriceCalculationMultiLegResultQuery = { __typename?: 'Query', priceCalculator: { __typename?: 'PriceCalculatorSearchRoot', byMultiLegInput: { __typename: 'PriceCalculatorError', error: string, errorType: PriceCalculatorErrorType } | { __typename: 'PriceCalculatorMultiLeg', list: Array<{ __typename?: 'PriceCalculator', auditLogs: Array<string> | null, errorMessage: string | null, baseCurrencyCode: string, seaFreightPrice: number, totalPrice: number, totalVat: number, convertedFrom: string | null, surchargeRecords: Array<{ __typename?: 'SurChargeV2', quantity: number, surchargePrice: number, surchargeVatAmount: number | null, surchargeVatRate: number | null, articleType: { __typename?: 'ArticleType', id: string, code: string, name: string } }>, ancillaryRecords: Array<{ __typename?: 'AncillaryChargeV2', ancillaryCode: string, quantity: number, ancillaryPrice: number, ancillaryVatAmount: number | null, ancillaryVatRate: number | null }>, route: { __typename?: 'Route', id: string, code: string, name: string } }> } } };

export type PriceCalcSailingsFragment = { __typename?: 'Sailing', id: string, departureTime: string, sailingTypeCode: string, statusCode: string };

export type MultilegPriceCalculatorSailingsV2QueryVariables = Exact<{
  routeCode: Scalars['String']['input'];
  departureDate: Scalars['String']['input'];
}>;


export type MultilegPriceCalculatorSailingsV2Query = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', sailings: { __typename?: 'SailingsSearchRoot', byRouteCodeDeparture: Array<{ __typename?: 'Sailing', id: string, departureTime: string, sailingTypeCode: string, statusCode: string }> } | null } };

export type PriceCalculatorResultV2QueryVariables = Exact<{
  input: PriceCalculatorInput;
}>;


export type PriceCalculatorResultV2Query = { __typename?: 'Query', priceCalculator: { __typename?: 'PriceCalculatorSearchRoot', byInput: { __typename: 'PriceCalculator', auditLogs: Array<string> | null, errorMessage: string | null, baseCurrencyCode: string, seaFreightPrice: number, totalPrice: number, totalVat: number, convertedFrom: string | null, surchargeRecords: Array<{ __typename?: 'SurChargeV2', quantity: number, surchargePrice: number, surchargeVatAmount: number | null, surchargeVatRate: number | null, articleType: { __typename?: 'ArticleType', id: string, code: string, name: string } }>, ancillaryRecords: Array<{ __typename?: 'AncillaryChargeV2', ancillaryCode: string, quantity: number, ancillaryPrice: number, ancillaryVatAmount: number | null, ancillaryVatRate: number | null }>, route: { __typename?: 'Route', id: string, code: string, name: string } } | { __typename: 'PriceCalculatorError', error: string, errorType: PriceCalculatorErrorType } } };

export type PriceDetailsRouteQueryVariables = Exact<{
  input: Scalars['ID']['input'];
}>;


export type PriceDetailsRouteQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', route: { __typename?: 'RouteSearchRoot', byId: { __typename?: 'Route', id: string, name: string } | null } } };

export type PriceCalculatorSailingsV2QueryVariables = Exact<{
  routeCode: Scalars['String']['input'];
  departureDate: Scalars['String']['input'];
}>;


export type PriceCalculatorSailingsV2Query = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', sailings: { __typename?: 'SailingsSearchRoot', byRouteCodeDeparture: Array<{ __typename?: 'Sailing', id: string, departureTime: string, sailingTypeCode: string, statusCode: string }> } | null } };

export type PriceListQueryVariables = Exact<{
  filter: PriceListFilterInput;
}>;


export type PriceListQuery = { __typename?: 'Query', priceList: { __typename?: 'PriceListSearchRoot', byFilter: { __typename?: 'PriceListResult', priceListRows: Array<{ __typename?: 'PriceListRow', routeAgreementNumber: number, routeAgreementName: string, routeAgreementVehicleType: string | null, routeAgreementCurrency: string, customerNumber: number, customerIndex: string, validFrom: string, validTo: string, route: string, sailingCategory: string, vehicleType: string, movementType: string, length: number, price: number, weightFrom: number | null, weightTo: number | null, unaccompanied: string | null }> } } };

export type PriceListRouteFilterQueryVariables = Exact<{
  routeTypes: Array<Scalars['String']['input']> | Scalars['String']['input'];
  excludeOnlyAsPartOfMultiLegRoutes: Scalars['Boolean']['input'];
  includeNotValid: Scalars['Boolean']['input'];
}>;


export type PriceListRouteFilterQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', route: { __typename?: 'RouteSearchRoot', byRouteTypes: Array<{ __typename?: 'Route', id: string, code: string, name: string, routeType: string, routePair: { __typename?: 'RoutePair', id: string, code: string, seaArea: { __typename?: 'SeaArea', id: string, name: string } } }> } } };

export type RouteAgreementsForMultilegRouteFragment = { __typename?: 'MultiLegRouteAgreement', id: string, idNumber: number | null, workFlowStatusCode: WorkFlowStatusCode | null, statusCode: HeadAgreementStatusCode, rowVersion: string, name: string, headAgreement: { __typename?: 'HeadAgreement', id: string, name: string, breadCrumbName: string, statusCode: HeadAgreementStatusCode, hasSomeRouteAgreementsWithMultiLeg: boolean, customer: { __typename?: 'Customer', id: string, name: string, custNo: number }, valid: { __typename?: 'DateRange', end: { __typename?: 'Date', isoString: string } | null, start: { __typename?: 'Date', isoString: string } | null } }, routeLegs: Array<{ __typename?: 'RouteLeg', id: string, legNo: number, legRoute: { __typename?: 'Route', id: string, code: string, name: string } }>, routeAgreements: Array<{ __typename?: 'RouteAgreement', id: string, rowVersion: string, name: string, agreementNumber: number, routeDescription: string, sailingTypeCodes: Array<SailingTypeCode>, statusCode: HeadAgreementStatusCode, hasConditions: boolean, currency: { __typename?: 'Currency', id: string, code: string }, valid: { __typename?: 'DateRange', start: { __typename?: 'Date', isoString: string } | null, end: { __typename?: 'Date', isoString: string } | null }, routes: Array<{ __typename?: 'Route', id: string, routePair: { __typename?: 'RoutePair', id: string, code: string } }> }>, route: { __typename?: 'Route', id: string, name: string } };

export type HeadAgreementForMultilegFragment = { __typename?: 'HeadAgreement', id: string, name: string, statusCode: HeadAgreementStatusCode, breadCrumbName: string, headAgreementNumber: number, hasSomeRouteAgreementsWithMultiLeg: boolean, rowVersion: string, valid: { __typename?: 'DateRange', start: { __typename?: 'Date', isoString: string } | null, end: { __typename?: 'Date', isoString: string } | null }, routeAgreements: Array<{ __typename?: 'RouteAgreement', id: string, agreementNumber: number, name: string, statusCode: HeadAgreementStatusCode, isSalesReady: boolean, sailingTypeCodes: Array<SailingTypeCode>, rowVersion: string, hasArticles: boolean, hasConditions: boolean, hasMatrix: boolean, multiLegAgrRouteId: string | null, routeDescription: string, headAgreement: { __typename?: 'HeadAgreement', id: string, headAgreementNumber: number, statusCode: HeadAgreementStatusCode, customer: { __typename?: 'Customer', id: string, name: string } }, currency: { __typename?: 'Currency', id: string, code: string }, valid: { __typename?: 'DateRange', start: { __typename?: 'Date', isoString: string } | null, end: { __typename?: 'Date', isoString: string } | null }, writeHistory: { __typename?: 'WriteHistory', createdAt: { __typename?: 'DateTime', isoString: string }, modifiedAt: { __typename?: 'DateTime', isoString: string } | null }, routes: Array<{ __typename?: 'Route', id: string, routePair: { __typename?: 'RoutePair', id: string, statisticsForCustomerIdAndYear: { __typename?: 'CustomerRoutePairStatistics', averageNegotiationRate: number, averageTargetRate: number | null, expectedVolume: number | null, volumeLast12Months: number, volumeChange: number | null } | null, seaArea: { __typename?: 'SeaArea', id: string, name: string } } }> }>, multiLegAgrRoutes: Array<{ __typename?: 'MultiLegRouteAgreement', id: string, name: string, statusCode: HeadAgreementStatusCode, dateCreated: string, createdBy: string, dateModified: string | null, modifiedBy: string | null, idNumber: number | null, rowVersion: string, workFlowStatusCode: WorkFlowStatusCode | null, headAgreement: { __typename?: 'HeadAgreement', id: string, headAgreementNumber: number, statusCode: HeadAgreementStatusCode, customer: { __typename?: 'Customer', id: string, name: string } }, route: { __typename?: 'Route', id: string, code: string, name: string }, currency: { __typename?: 'Currency', id: string, code: string, name: string, shortDescription: string, longDescription: string }, valid: { __typename?: 'DateRange', start: { __typename?: 'Date', isoString: string } | null, end: { __typename?: 'Date', isoString: string } | null }, routeAgreements: Array<{ __typename?: 'RouteAgreement', id: string, agreementNumber: number, name: string, statusCode: HeadAgreementStatusCode, isSalesReady: boolean, sailingTypeCodes: Array<SailingTypeCode>, rowVersion: string, hasArticles: boolean, hasConditions: boolean, hasMatrix: boolean, multiLegAgrRouteId: string | null, routeDescription: string, headAgreement: { __typename?: 'HeadAgreement', id: string, headAgreementNumber: number, statusCode: HeadAgreementStatusCode, customer: { __typename?: 'Customer', id: string, name: string } }, currency: { __typename?: 'Currency', id: string, code: string }, valid: { __typename?: 'DateRange', start: { __typename?: 'Date', isoString: string } | null, end: { __typename?: 'Date', isoString: string } | null }, writeHistory: { __typename?: 'WriteHistory', createdAt: { __typename?: 'DateTime', isoString: string }, modifiedAt: { __typename?: 'DateTime', isoString: string } | null }, routes: Array<{ __typename?: 'Route', id: string, routePair: { __typename?: 'RoutePair', id: string, statisticsForCustomerIdAndYear: { __typename?: 'CustomerRoutePairStatistics', averageNegotiationRate: number, averageTargetRate: number | null, expectedVolume: number | null, volumeLast12Months: number, volumeChange: number | null } | null, seaArea: { __typename?: 'SeaArea', id: string, name: string } } }> }>, routeLegs: Array<{ __typename?: 'RouteLeg', id: string, legRoute: { __typename?: 'Route', id: string, code: string, name: string }, route: { __typename?: 'Route', id: string, code: string, name: string } }> }> };

export type CustomerMultilegRouteFetcherQueryVariables = Exact<{
  multiLegAgreementId: Scalars['ID']['input'];
  headAgreementId: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
  year: Scalars['Int']['input'];
}>;


export type CustomerMultilegRouteFetcherQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', headAgreement: { __typename?: 'HeadAgreementSearchRoot', byId: { __typename?: 'HeadAgreement', id: string, name: string, statusCode: HeadAgreementStatusCode, breadCrumbName: string, headAgreementNumber: number, hasSomeRouteAgreementsWithMultiLeg: boolean, rowVersion: string, valid: { __typename?: 'DateRange', start: { __typename?: 'Date', isoString: string } | null, end: { __typename?: 'Date', isoString: string } | null }, routeAgreements: Array<{ __typename?: 'RouteAgreement', id: string, agreementNumber: number, name: string, statusCode: HeadAgreementStatusCode, isSalesReady: boolean, sailingTypeCodes: Array<SailingTypeCode>, rowVersion: string, hasArticles: boolean, hasConditions: boolean, hasMatrix: boolean, multiLegAgrRouteId: string | null, routeDescription: string, headAgreement: { __typename?: 'HeadAgreement', id: string, headAgreementNumber: number, statusCode: HeadAgreementStatusCode, customer: { __typename?: 'Customer', id: string, name: string } }, currency: { __typename?: 'Currency', id: string, code: string }, valid: { __typename?: 'DateRange', start: { __typename?: 'Date', isoString: string } | null, end: { __typename?: 'Date', isoString: string } | null }, writeHistory: { __typename?: 'WriteHistory', createdAt: { __typename?: 'DateTime', isoString: string }, modifiedAt: { __typename?: 'DateTime', isoString: string } | null }, routes: Array<{ __typename?: 'Route', id: string, routePair: { __typename?: 'RoutePair', id: string, statisticsForCustomerIdAndYear: { __typename?: 'CustomerRoutePairStatistics', averageNegotiationRate: number, averageTargetRate: number | null, expectedVolume: number | null, volumeLast12Months: number, volumeChange: number | null } | null, seaArea: { __typename?: 'SeaArea', id: string, name: string } } }> }>, multiLegAgrRoutes: Array<{ __typename?: 'MultiLegRouteAgreement', id: string, name: string, statusCode: HeadAgreementStatusCode, dateCreated: string, createdBy: string, dateModified: string | null, modifiedBy: string | null, idNumber: number | null, rowVersion: string, workFlowStatusCode: WorkFlowStatusCode | null, headAgreement: { __typename?: 'HeadAgreement', id: string, headAgreementNumber: number, statusCode: HeadAgreementStatusCode, customer: { __typename?: 'Customer', id: string, name: string } }, route: { __typename?: 'Route', id: string, code: string, name: string }, currency: { __typename?: 'Currency', id: string, code: string, name: string, shortDescription: string, longDescription: string }, valid: { __typename?: 'DateRange', start: { __typename?: 'Date', isoString: string } | null, end: { __typename?: 'Date', isoString: string } | null }, routeAgreements: Array<{ __typename?: 'RouteAgreement', id: string, agreementNumber: number, name: string, statusCode: HeadAgreementStatusCode, isSalesReady: boolean, sailingTypeCodes: Array<SailingTypeCode>, rowVersion: string, hasArticles: boolean, hasConditions: boolean, hasMatrix: boolean, multiLegAgrRouteId: string | null, routeDescription: string, headAgreement: { __typename?: 'HeadAgreement', id: string, headAgreementNumber: number, statusCode: HeadAgreementStatusCode, customer: { __typename?: 'Customer', id: string, name: string } }, currency: { __typename?: 'Currency', id: string, code: string }, valid: { __typename?: 'DateRange', start: { __typename?: 'Date', isoString: string } | null, end: { __typename?: 'Date', isoString: string } | null }, writeHistory: { __typename?: 'WriteHistory', createdAt: { __typename?: 'DateTime', isoString: string }, modifiedAt: { __typename?: 'DateTime', isoString: string } | null }, routes: Array<{ __typename?: 'Route', id: string, routePair: { __typename?: 'RoutePair', id: string, statisticsForCustomerIdAndYear: { __typename?: 'CustomerRoutePairStatistics', averageNegotiationRate: number, averageTargetRate: number | null, expectedVolume: number | null, volumeLast12Months: number, volumeChange: number | null } | null, seaArea: { __typename?: 'SeaArea', id: string, name: string } } }> }>, routeLegs: Array<{ __typename?: 'RouteLeg', id: string, legRoute: { __typename?: 'Route', id: string, code: string, name: string }, route: { __typename?: 'Route', id: string, code: string, name: string } }> }> } | null }, multiLegRouteAgreement: { __typename?: 'MultiLegRouteAgreementSearchRoot', byId: { __typename?: 'MultiLegRouteAgreement', id: string, idNumber: number | null, workFlowStatusCode: WorkFlowStatusCode | null, statusCode: HeadAgreementStatusCode, rowVersion: string, name: string, headAgreement: { __typename?: 'HeadAgreement', id: string, name: string, breadCrumbName: string, statusCode: HeadAgreementStatusCode, hasSomeRouteAgreementsWithMultiLeg: boolean, customer: { __typename?: 'Customer', id: string, name: string, custNo: number }, valid: { __typename?: 'DateRange', end: { __typename?: 'Date', isoString: string } | null, start: { __typename?: 'Date', isoString: string } | null } }, routeLegs: Array<{ __typename?: 'RouteLeg', id: string, legNo: number, legRoute: { __typename?: 'Route', id: string, code: string, name: string } }>, routeAgreements: Array<{ __typename?: 'RouteAgreement', id: string, rowVersion: string, name: string, agreementNumber: number, routeDescription: string, sailingTypeCodes: Array<SailingTypeCode>, statusCode: HeadAgreementStatusCode, hasConditions: boolean, currency: { __typename?: 'Currency', id: string, code: string }, valid: { __typename?: 'DateRange', start: { __typename?: 'Date', isoString: string } | null, end: { __typename?: 'Date', isoString: string } | null }, routes: Array<{ __typename?: 'Route', id: string, routePair: { __typename?: 'RoutePair', id: string, code: string } }> }>, route: { __typename?: 'Route', id: string, name: string } } | null } } };

export type ChangeMultiLegAgreementWorkFlowStatusMutationVariables = Exact<{
  changeMultiLegRouteAgreementWorkFlowStatusInput: ChangeMultiLegRouteAgreementWorkFlowStatusInput;
}>;


export type ChangeMultiLegAgreementWorkFlowStatusMutation = { __typename?: 'Mutation', productPrice: { __typename?: 'ProductPriceMutationRoot', multiLegRouteAgreement: { __typename?: 'MultiLegRouteAgreementMutationRoot', changeMultiLegRouteAgreementSalesReadyStatus: { __typename?: 'ErrorResult', errors: Array<{ __typename?: 'ErrorDetail', message: string, path: string | null }> } | { __typename?: 'UpdateMultiLegRouteAgreementSuccessResult', multiLegAgreement: { __typename?: 'MultiLegRouteAgreement', id: string, workFlowStatusCode: WorkFlowStatusCode | null, rowVersion: string } } } } };

export type UpdateRateSheetsForMultiLegRouteAgreementMutationVariables = Exact<{
  input: UpdateRateSheetsInput;
}>;


export type UpdateRateSheetsForMultiLegRouteAgreementMutation = { __typename?: 'Mutation', productPrice: { __typename?: 'ProductPriceMutationRoot', routeAgreementPrice: { __typename?: 'RouteAgreementPriceMutationRoot', updateMultiLegRateSheets: Array<{ __typename: 'ErrorResult', errors: Array<{ __typename?: 'ErrorDetail', message: string, path: string | null }> } | { __typename: 'UpdateRateSheetsSuccessResult', routeAgreement: { __typename?: 'RouteAgreement', id: string, name: string, agreementNumber: number, routeDescription: string, sailingTypeCodes: Array<SailingTypeCode>, externalDescription: string | null, multiLegAgrRouteId: string | null, isSalesReady: boolean, typeCode: RouteAgreementTypeCode, statusCode: HeadAgreementStatusCode, rowVersion: string, hasConditions: boolean, prices: Array<{ __typename?: 'RouteAgreementPrice', id: string, volume: number | null, lengthFrom: number | null, lengthTo: number | null, weightFrom: number | null, weightTo: number | null, unaccompanied: boolean | null, lastChargedFrom: number | null, cargoStatusCode: CargoStatusCode, avgLength: number | null, additionalFrom: number | null, actual: number | null, avgGrossPrice: { __typename?: 'Price', amount: string } | null, avgNetPrice: { __typename?: 'Price', amount: string } | null, avgRebate: { __typename?: 'Price', amount: string } | null, vehicleType: { __typename?: 'VehicleType', id: string, name: string, shortDescription: string, accompanied: boolean, code: string } | null, lastPrice: { __typename?: 'Price', amount: string } | null, lastMeterPrice: { __typename?: 'Price', amount: string } | null, newPrice: { __typename?: 'Price', amount: string }, meterPrice: { __typename?: 'Price', amount: string } }>, currency: { __typename?: 'Currency', id: string, code: string }, valid: { __typename?: 'DateRange', start: { __typename?: 'Date', isoString: string } | null, end: { __typename?: 'Date', isoString: string } | null }, routes: Array<{ __typename?: 'Route', id: string, code: string, routeType: string, routePair: { __typename?: 'RoutePair', id: string, code: string, description: string } }> } }> } } };

export type CustomerRouteFetcherRouteAgreementFragment = { __typename?: 'RouteAgreement', id: string, rowVersion: string, name: string, agreementNumber: number, routeDescription: string, sailingTypeCodes: Array<SailingTypeCode>, statusCode: HeadAgreementStatusCode, hasConditions: boolean, hasArticles: boolean, multiLegAgrRouteId: string | null, currency: { __typename?: 'Currency', id: string, code: string }, valid: { __typename?: 'DateRange', start: { __typename?: 'Date', isoString: string } | null, end: { __typename?: 'Date', isoString: string } | null }, routes: Array<{ __typename?: 'Route', id: string, routePair: { __typename?: 'RoutePair', id: string } }> };

export type CustomerRouteFetcherHeadAgreementFragment = { __typename?: 'HeadAgreement', id: string, statusCode: HeadAgreementStatusCode, name: string, headAgreementNumber: number, breadCrumbName: string, hasSomeRouteAgreementsWithMultiLeg: boolean, rowVersion: string, valid: { __typename?: 'DateRange', start: { __typename?: 'Date', isoString: string } | null, end: { __typename?: 'Date', isoString: string } | null }, writeHistory: { __typename?: 'WriteHistory', createdAt: { __typename?: 'DateTime', isoString: string }, createdBy: { __typename?: 'User', id: string, name: string }, modifiedAt: { __typename?: 'DateTime', isoString: string } | null, modifiedBy: { __typename?: 'User', id: string, name: string } | null } };

export type CustomerRouteFetcherQueryVariables = Exact<{
  headAgreementId: Scalars['ID']['input'];
  routePairId: Scalars['ID']['input'];
}>;


export type CustomerRouteFetcherQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', routeAgreement: { __typename?: 'RouteAgreementSearchRoot', byHeadAgreementAndRoutePair: Array<{ __typename?: 'RouteAgreement', id: string, rowVersion: string, name: string, agreementNumber: number, routeDescription: string, sailingTypeCodes: Array<SailingTypeCode>, statusCode: HeadAgreementStatusCode, hasConditions: boolean, hasArticles: boolean, multiLegAgrRouteId: string | null, currency: { __typename?: 'Currency', id: string, code: string }, valid: { __typename?: 'DateRange', start: { __typename?: 'Date', isoString: string } | null, end: { __typename?: 'Date', isoString: string } | null }, routes: Array<{ __typename?: 'Route', id: string, routePair: { __typename?: 'RoutePair', id: string } }> }> }, headAgreement: { __typename?: 'HeadAgreementSearchRoot', byId: { __typename?: 'HeadAgreement', id: string, statusCode: HeadAgreementStatusCode, name: string, headAgreementNumber: number, breadCrumbName: string, hasSomeRouteAgreementsWithMultiLeg: boolean, rowVersion: string, valid: { __typename?: 'DateRange', start: { __typename?: 'Date', isoString: string } | null, end: { __typename?: 'Date', isoString: string } | null }, writeHistory: { __typename?: 'WriteHistory', createdAt: { __typename?: 'DateTime', isoString: string }, createdBy: { __typename?: 'User', id: string, name: string }, modifiedAt: { __typename?: 'DateTime', isoString: string } | null, modifiedBy: { __typename?: 'User', id: string, name: string } | null } } | null } } };

export type UpdateRateSheetsForRouteAgreementMutationVariables = Exact<{
  input: UpdateRateSheetsInput;
}>;


export type UpdateRateSheetsForRouteAgreementMutation = { __typename?: 'Mutation', productPrice: { __typename?: 'ProductPriceMutationRoot', routeAgreementPrice: { __typename?: 'RouteAgreementPriceMutationRoot', updateRateSheets: Array<{ __typename: 'ErrorResult', errors: Array<{ __typename?: 'ErrorDetail', message: string, path: string | null }> } | { __typename: 'UpdateRateSheetsSuccessResult', routeAgreement: { __typename?: 'RouteAgreement', id: string, name: string, agreementNumber: number, routeDescription: string, sailingTypeCodes: Array<SailingTypeCode>, externalDescription: string | null, multiLegAgrRouteId: string | null, isSalesReady: boolean, typeCode: RouteAgreementTypeCode, statusCode: HeadAgreementStatusCode, rowVersion: string, hasConditions: boolean, prices: Array<{ __typename?: 'RouteAgreementPrice', id: string, volume: number | null, lengthFrom: number | null, lengthTo: number | null, weightFrom: number | null, weightTo: number | null, unaccompanied: boolean | null, lastChargedFrom: number | null, cargoStatusCode: CargoStatusCode, avgLength: number | null, additionalFrom: number | null, actual: number | null, avgGrossPrice: { __typename?: 'Price', amount: string } | null, avgNetPrice: { __typename?: 'Price', amount: string } | null, avgRebate: { __typename?: 'Price', amount: string } | null, vehicleType: { __typename?: 'VehicleType', id: string, name: string, shortDescription: string, accompanied: boolean, code: string } | null, lastPrice: { __typename?: 'Price', amount: string } | null, lastMeterPrice: { __typename?: 'Price', amount: string } | null, newPrice: { __typename?: 'Price', amount: string }, meterPrice: { __typename?: 'Price', amount: string } }>, currency: { __typename?: 'Currency', id: string, code: string }, valid: { __typename?: 'DateRange', start: { __typename?: 'Date', isoString: string } | null, end: { __typename?: 'Date', isoString: string } | null }, routes: Array<{ __typename?: 'Route', id: string, code: string, routeType: string, routePair: { __typename?: 'RoutePair', id: string, code: string, description: string } }> } }> } } };

export type UpdateRouteAgreementsInRoutePairPageMutationVariables = Exact<{
  input: UpdateRouteAgreementInput;
}>;


export type UpdateRouteAgreementsInRoutePairPageMutation = { __typename?: 'Mutation', productPrice: { __typename?: 'ProductPriceMutationRoot', routeAgreement: { __typename?: 'RouteAgreementMutationRoot', updateRouteAgreement: { __typename: 'ErrorResult', errors: Array<{ __typename?: 'ErrorDetail', message: string, path: string | null }> } | { __typename: 'UpdateRouteAgreementSuccessResult', routeAgreement: { __typename?: 'RouteAgreement', rowVersion: string, isSalesReady: boolean, id: string, statusCode: HeadAgreementStatusCode, agreementNumber: number, hasArticles: boolean, hasConditions: boolean, externalComment: string | null, note: string | null, comment: string | null, hasMatrix: boolean, name: string, routeDescription: string, sailingTypeCodes: Array<SailingTypeCode>, valid: { __typename?: 'DateRange', start: { __typename?: 'Date', isoString: string } | null, end: { __typename?: 'Date', isoString: string } | null }, prices: Array<{ __typename?: 'RouteAgreementPrice', id: string, volume: number | null, lengthFrom: number | null, lengthTo: number | null, weightFrom: number | null, weightTo: number | null, unaccompanied: boolean | null, lastChargedFrom: number | null, cargoStatusCode: CargoStatusCode, avgLength: number | null, additionalFrom: number | null, actual: number | null, avgGrossPrice: { __typename?: 'Price', amount: string } | null, avgNetPrice: { __typename?: 'Price', amount: string } | null, avgRebate: { __typename?: 'Price', amount: string } | null, vehicleType: { __typename?: 'VehicleType', id: string, name: string, shortDescription: string, accompanied: boolean, code: string } | null, lastPrice: { __typename?: 'Price', amount: string } | null, lastMeterPrice: { __typename?: 'Price', amount: string } | null, newPrice: { __typename?: 'Price', amount: string }, meterPrice: { __typename?: 'Price', amount: string } }>, writeHistory: { __typename?: 'WriteHistory', createdAt: { __typename?: 'DateTime', isoString: string }, createdBy: { __typename?: 'User', id: string, name: string }, modifiedAt: { __typename?: 'DateTime', isoString: string } | null, modifiedBy: { __typename?: 'User', id: string, name: string } | null }, currency: { __typename?: 'Currency', id: string, code: string }, headAgreement: { __typename?: 'HeadAgreement', headAgreementNumber: number, id: string, name: string, breadCrumbName: string } } } } } };

export type RoutePairRatesPopulatorQueryVariables = Exact<{
  headAgreementId: Scalars['ID']['input'];
  routePairId: Scalars['ID']['input'];
}>;


export type RoutePairRatesPopulatorQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', routeAgreement: { __typename?: 'RouteAgreementSearchRoot', byHeadAgreementAndRoutePair: Array<{ __typename?: 'RouteAgreement', id: string, name: string, agreementNumber: number, routeDescription: string, sailingTypeCodes: Array<SailingTypeCode>, externalDescription: string | null, multiLegAgrRouteId: string | null, isSalesReady: boolean, typeCode: RouteAgreementTypeCode, statusCode: HeadAgreementStatusCode, rowVersion: string, hasConditions: boolean, currency: { __typename?: 'Currency', id: string, code: string }, valid: { __typename?: 'DateRange', start: { __typename?: 'Date', isoString: string } | null, end: { __typename?: 'Date', isoString: string } | null }, prices: Array<{ __typename?: 'RouteAgreementPrice', id: string, volume: number | null, lengthFrom: number | null, lengthTo: number | null, weightFrom: number | null, weightTo: number | null, unaccompanied: boolean | null, lastChargedFrom: number | null, cargoStatusCode: CargoStatusCode, avgLength: number | null, additionalFrom: number | null, actual: number | null, avgGrossPrice: { __typename?: 'Price', amount: string } | null, avgNetPrice: { __typename?: 'Price', amount: string } | null, avgRebate: { __typename?: 'Price', amount: string } | null, vehicleType: { __typename?: 'VehicleType', id: string, name: string, shortDescription: string, accompanied: boolean, code: string } | null, lastPrice: { __typename?: 'Price', amount: string } | null, lastMeterPrice: { __typename?: 'Price', amount: string } | null, newPrice: { __typename?: 'Price', amount: string }, meterPrice: { __typename?: 'Price', amount: string } }>, routes: Array<{ __typename?: 'Route', id: string, code: string, routeType: string, routePair: { __typename?: 'RoutePair', id: string, code: string, description: string } }> }> } } };

export type CustomerStatisticsFragment = { __typename?: 'CustomerStatisticsEntry', id: string, expectedVolume: number | null, statVolume12Months: number | null, unitCategoryCode: UnitCategoryCode, expectedStatVolume: number | null, sailingCategoryCode: SailingTypeCode, volume12Months: number, actualOutcomeInPercent: number | null };

export type ChildCustomersQueryVariables = Exact<{
  customerId: Scalars['ID']['input'];
}>;


export type ChildCustomersQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', customers: { __typename?: 'CustomerSearchRoot', byId: { __typename?: 'Customer', id: string, name: string, breadCrumbName: string, custIndex: string, custNo: number, hasRebateAgreements: boolean | null, isParent: boolean, preselectedHeadAgreement: { __typename?: 'HeadAgreement', id: string } | null, statisticalGrouping: { __typename?: 'Customer', id: string } | null, invoiceCurrency: { __typename?: 'Currency', id: string, code: string }, salesRegion: { __typename?: 'SalesRegion', id: string, name: string }, seller: { __typename?: 'User', id: string, name: string }, custStatus: { __typename?: 'CustomerStatus', id: string, name: string } | null, writeHistory: { __typename?: 'WriteHistory', createdAt: { __typename?: 'DateTime', isoString: string }, createdBy: { __typename?: 'User', name: string }, modifiedBy: { __typename?: 'User', name: string } | null, modifiedAt: { __typename?: 'DateTime', isoString: string } | null }, parent: { __typename?: 'Customer', id: string, preselectedHeadAgreement: { __typename?: 'HeadAgreement', id: string } | null } | null, childCustomers: Array<{ __typename?: 'Customer', id: string, name: string, custIndex: string, custNo: number, preselectedHeadAgreement: { __typename?: 'HeadAgreement', id: string } | null }> } | null } } };

export type ChildCustomersFragment = { __typename?: 'Customer', id: string, name: string, breadCrumbName: string, custIndex: string, custNo: number, hasRebateAgreements: boolean | null, isParent: boolean, preselectedHeadAgreement: { __typename?: 'HeadAgreement', id: string } | null, statisticalGrouping: { __typename?: 'Customer', id: string } | null, invoiceCurrency: { __typename?: 'Currency', id: string, code: string }, salesRegion: { __typename?: 'SalesRegion', id: string, name: string }, seller: { __typename?: 'User', id: string, name: string }, custStatus: { __typename?: 'CustomerStatus', id: string, name: string } | null, writeHistory: { __typename?: 'WriteHistory', createdAt: { __typename?: 'DateTime', isoString: string }, createdBy: { __typename?: 'User', name: string }, modifiedBy: { __typename?: 'User', name: string } | null, modifiedAt: { __typename?: 'DateTime', isoString: string } | null }, parent: { __typename?: 'Customer', id: string, preselectedHeadAgreement: { __typename?: 'HeadAgreement', id: string } | null } | null, childCustomers: Array<{ __typename?: 'Customer', id: string, name: string, custIndex: string, custNo: number, preselectedHeadAgreement: { __typename?: 'HeadAgreement', id: string } | null }> };

export type HeadAgreementInfoRowSectionFragment = { __typename?: 'HeadAgreement', id: string, statusCode: HeadAgreementStatusCode, name: string, headAgreementNumber: number, breadCrumbName: string, hasSomeRouteAgreementsWithMultiLeg: boolean, rowVersion: string, valid: { __typename?: 'DateRange', start: { __typename?: 'Date', isoString: string } | null, end: { __typename?: 'Date', isoString: string } | null }, writeHistory: { __typename?: 'WriteHistory', createdAt: { __typename?: 'DateTime', isoString: string }, createdBy: { __typename?: 'User', id: string, name: string }, modifiedAt: { __typename?: 'DateTime', isoString: string } | null, modifiedBy: { __typename?: 'User', id: string, name: string } | null } };

export type HeadAgreementInfoRowSectionQueryVariables = Exact<{
  headAgreementId: Scalars['ID']['input'];
}>;


export type HeadAgreementInfoRowSectionQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', headAgreement: { __typename?: 'HeadAgreementSearchRoot', byId: { __typename?: 'HeadAgreement', id: string, statusCode: HeadAgreementStatusCode, name: string, headAgreementNumber: number, breadCrumbName: string, hasSomeRouteAgreementsWithMultiLeg: boolean, rowVersion: string, valid: { __typename?: 'DateRange', start: { __typename?: 'Date', isoString: string } | null, end: { __typename?: 'Date', isoString: string } | null }, writeHistory: { __typename?: 'WriteHistory', createdAt: { __typename?: 'DateTime', isoString: string }, createdBy: { __typename?: 'User', id: string, name: string }, modifiedAt: { __typename?: 'DateTime', isoString: string } | null, modifiedBy: { __typename?: 'User', id: string, name: string } | null } } | null } } };

export type CustomerNoExistingHaFragment = { __typename?: 'Customer', id: string, name: string, breadCrumbName: string, custIndex: string, custNo: number, isParent: boolean, isStandardCustomer: boolean, hasRebateAgreements: boolean | null, custStatus: { __typename?: 'CustomerStatus', id: string, name: string } | null, parent: { __typename?: 'Customer', id: string, preselectedHeadAgreement: { __typename?: 'HeadAgreement', id: string } | null } | null, childCustomers: Array<{ __typename?: 'Customer', id: string }>, statisticalGrouping: { __typename?: 'Customer', id: string } | null, invoiceCurrency: { __typename?: 'Currency', id: string, code: string }, seller: { __typename?: 'User', id: string, name: string }, salesRegion: { __typename?: 'SalesRegion', id: string, code: string, name: string }, writeHistory: { __typename?: 'WriteHistory', createdAt: { __typename?: 'DateTime', isoString: string }, createdBy: { __typename?: 'User', id: string, name: string }, modifiedAt: { __typename?: 'DateTime', isoString: string } | null, modifiedBy: { __typename?: 'User', id: string, name: string } | null } };

export type CustomerNoExistingHaPanelQueryVariables = Exact<{
  customerId: Scalars['ID']['input'];
}>;


export type CustomerNoExistingHaPanelQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', customers: { __typename?: 'CustomerSearchRoot', byId: { __typename?: 'Customer', id: string, name: string, breadCrumbName: string, custIndex: string, custNo: number, isParent: boolean, isStandardCustomer: boolean, hasRebateAgreements: boolean | null, custStatus: { __typename?: 'CustomerStatus', id: string, name: string } | null, parent: { __typename?: 'Customer', id: string, preselectedHeadAgreement: { __typename?: 'HeadAgreement', id: string } | null } | null, childCustomers: Array<{ __typename?: 'Customer', id: string }>, statisticalGrouping: { __typename?: 'Customer', id: string } | null, invoiceCurrency: { __typename?: 'Currency', id: string, code: string }, seller: { __typename?: 'User', id: string, name: string }, salesRegion: { __typename?: 'SalesRegion', id: string, code: string, name: string }, writeHistory: { __typename?: 'WriteHistory', createdAt: { __typename?: 'DateTime', isoString: string }, createdBy: { __typename?: 'User', id: string, name: string }, modifiedAt: { __typename?: 'DateTime', isoString: string } | null, modifiedBy: { __typename?: 'User', id: string, name: string } | null } } | null } } };

export type CustomerDetailsFragment = { __typename?: 'Customer', id: string, name: string, breadCrumbName: string, custIndex: string, custNo: number, isParent: boolean, isStandardCustomer: boolean, hasRebateAgreements: boolean | null, custStatus: { __typename?: 'CustomerStatus', id: string, name: string } | null, parent: { __typename?: 'Customer', id: string, preselectedHeadAgreement: { __typename?: 'HeadAgreement', id: string } | null } | null, childCustomers: Array<{ __typename?: 'Customer', id: string }>, statisticalGrouping: { __typename?: 'Customer', id: string } | null, invoiceCurrency: { __typename?: 'Currency', id: string, code: string }, seller: { __typename?: 'User', id: string, name: string }, salesRegion: { __typename?: 'SalesRegion', id: string, code: string, name: string }, writeHistory: { __typename?: 'WriteHistory', createdAt: { __typename?: 'DateTime', isoString: string }, createdBy: { __typename?: 'User', id: string, name: string }, modifiedAt: { __typename?: 'DateTime', isoString: string } | null, modifiedBy: { __typename?: 'User', id: string, name: string } | null }, topAgreementDocuments: Array<{ __typename?: 'AgreementDocuments', id: string, agreementId: string, customerNumber: number, fileName: string, agreementValidFromDate: string, agreementValidToDate: string, agreementDocumentType: string, negotiationYear: number, writeHistory: { __typename?: 'WriteHistory', createdAt: { __typename?: 'DateTime', isoString: string }, createdBy: { __typename?: 'User', id: string, name: string } } }>, topRebateAgreementDocuments: Array<{ __typename?: 'RebateAgreementDocuments', id: string, rebateAgreementId: string, customerNumber: number, fileName: string, rebateAgreementValidFromDate: string, rebateAgreementValidToDate: string, negotiationYear: number, writeHistory: { __typename?: 'WriteHistory', createdAt: { __typename?: 'DateTime', isoString: string }, createdBy: { __typename?: 'User', id: string, name: string } } }>, topHeadAgreements: Array<{ __typename?: 'HeadAgreement', statusCode: HeadAgreementStatusCode, headAgreementNumber: number, name: string, id: string, customer: { __typename?: 'Customer', id: string, preselectedHeadAgreement: { __typename?: 'HeadAgreement', id: string } | null }, valid: { __typename?: 'DateRange', start: { __typename?: 'Date', isoString: string } | null, end: { __typename?: 'Date', isoString: string } | null } }> };

export type CustomerDetailsViewQueryVariables = Exact<{
  customerId: Scalars['ID']['input'];
  numberOfAgreements: Scalars['Int']['input'];
  numberOfDocuments: Scalars['Int']['input'];
}>;


export type CustomerDetailsViewQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', customers: { __typename?: 'CustomerSearchRoot', byId: { __typename?: 'Customer', id: string, name: string, breadCrumbName: string, custIndex: string, custNo: number, isParent: boolean, isStandardCustomer: boolean, hasRebateAgreements: boolean | null, custStatus: { __typename?: 'CustomerStatus', id: string, name: string } | null, parent: { __typename?: 'Customer', id: string, preselectedHeadAgreement: { __typename?: 'HeadAgreement', id: string } | null } | null, childCustomers: Array<{ __typename?: 'Customer', id: string }>, statisticalGrouping: { __typename?: 'Customer', id: string } | null, invoiceCurrency: { __typename?: 'Currency', id: string, code: string }, seller: { __typename?: 'User', id: string, name: string }, salesRegion: { __typename?: 'SalesRegion', id: string, code: string, name: string }, writeHistory: { __typename?: 'WriteHistory', createdAt: { __typename?: 'DateTime', isoString: string }, createdBy: { __typename?: 'User', id: string, name: string }, modifiedAt: { __typename?: 'DateTime', isoString: string } | null, modifiedBy: { __typename?: 'User', id: string, name: string } | null }, topAgreementDocuments: Array<{ __typename?: 'AgreementDocuments', id: string, agreementId: string, customerNumber: number, fileName: string, agreementValidFromDate: string, agreementValidToDate: string, agreementDocumentType: string, negotiationYear: number, writeHistory: { __typename?: 'WriteHistory', createdAt: { __typename?: 'DateTime', isoString: string }, createdBy: { __typename?: 'User', id: string, name: string } } }>, topRebateAgreementDocuments: Array<{ __typename?: 'RebateAgreementDocuments', id: string, rebateAgreementId: string, customerNumber: number, fileName: string, rebateAgreementValidFromDate: string, rebateAgreementValidToDate: string, negotiationYear: number, writeHistory: { __typename?: 'WriteHistory', createdAt: { __typename?: 'DateTime', isoString: string }, createdBy: { __typename?: 'User', id: string, name: string } } }>, topHeadAgreements: Array<{ __typename?: 'HeadAgreement', statusCode: HeadAgreementStatusCode, headAgreementNumber: number, name: string, id: string, customer: { __typename?: 'Customer', id: string, preselectedHeadAgreement: { __typename?: 'HeadAgreement', id: string } | null }, valid: { __typename?: 'DateRange', start: { __typename?: 'Date', isoString: string } | null, end: { __typename?: 'Date', isoString: string } | null } }> } | null } } };

export type BulkUpdateExpectedVolumesMutationVariables = Exact<{
  input: BulkUpdateExpectedVolumesInput;
}>;


export type BulkUpdateExpectedVolumesMutation = { __typename?: 'Mutation', productPrice: { __typename?: 'ProductPriceMutationRoot', expectedVolume: { __typename?: 'ExpectedVolumeMutationRoot', bulkUpdateExpectedVolumes: { __typename: 'BulkUpdateExpectedVolumesSuccessResult', success: boolean } | { __typename: 'ErrorResult', errors: Array<{ __typename?: 'ErrorDetail', message: string, path: string | null }> } } } };

export type CustomerListNegotationStatusByYearFragment = { __typename?: 'NegotiationStatus', id: string, name: string, presentationOrder: number | null };

export type CustomersForCustomerListFragment = { __typename?: 'Customer', id: string, custIndex: string, custNo: number, name: string, noOfChildren: number, isParent: boolean, custStatus: { __typename?: 'CustomerStatus', id: string, name: string, code: CustomerStatusCode } | null, seller: { __typename?: 'User', id: string, name: string }, parent: { __typename?: 'Customer', id: string, custNo: number } | null, preselectedHeadAgreement: { __typename?: 'HeadAgreement', id: string } | null, negotiationStatusByYear: { __typename?: 'NegotiationStatus', id: string, name: string, presentationOrder: number | null } | null, statisticalGrouping: { __typename?: 'Customer', id: string } | null, activeHeadAgreementByYear: { __typename?: 'HeadAgreement', id: string } | null, statisticsByFilter: { __typename?: 'CustomerStatisticsResult', items: Array<{ __typename?: 'CustomerStatisticsEntry', id: string, expectedVolume: number | null, statVolume12Months: number | null, unitCategoryCode: UnitCategoryCode, expectedStatVolume: number | null, sailingCategoryCode: SailingTypeCode, volume12Months: number, actualOutcomeInPercent: number | null }> } };

export type CustomerListQueryVariables = Exact<{
  filter: CustomerGetByFilterOptions;
  negotiationYear: Scalars['Int']['input'];
  lastNegotiationYear: Scalars['Int']['input'];
}>;


export type CustomerListQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', customers: { __typename?: 'CustomerSearchRoot', byFilter: { __typename?: 'CustomerSearchByFilterResult', items: Array<{ __typename?: 'Customer', id: string, custIndex: string, custNo: number, name: string, noOfChildren: number, isParent: boolean, custStatus: { __typename?: 'CustomerStatus', id: string, name: string, code: CustomerStatusCode } | null, seller: { __typename?: 'User', id: string, name: string }, parent: { __typename?: 'Customer', id: string, custNo: number } | null, preselectedHeadAgreement: { __typename?: 'HeadAgreement', id: string } | null, negotiationStatusByYear: { __typename?: 'NegotiationStatus', id: string, name: string, presentationOrder: number | null } | null, statisticalGrouping: { __typename?: 'Customer', id: string } | null, activeHeadAgreementByYear: { __typename?: 'HeadAgreement', id: string } | null, statisticsByFilter: { __typename?: 'CustomerStatisticsResult', items: Array<{ __typename?: 'CustomerStatisticsEntry', id: string, expectedVolume: number | null, statVolume12Months: number | null, unitCategoryCode: UnitCategoryCode, expectedStatVolume: number | null, sailingCategoryCode: SailingTypeCode, volume12Months: number, actualOutcomeInPercent: number | null }> } }> } } } };

export type NegotiationStatusFetcherCustomerFragment = { __typename?: 'Customer', id: string, isParent: boolean, name: string, custNo: number, custIndex: string, noOfChildren: number, negotiationStatusByYear: { __typename?: 'NegotiationStatus', id: string, name: string, presentationOrder: number | null } | null };

export type CustomerNegotiationStatusEditorFetcherQueryVariables = Exact<{
  customerId: Scalars['ID']['input'];
  year: Scalars['Int']['input'];
}>;


export type CustomerNegotiationStatusEditorFetcherQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', customers: { __typename?: 'CustomerSearchRoot', byId: { __typename?: 'Customer', id: string, isParent: boolean, name: string, custNo: number, custIndex: string, noOfChildren: number, negotiationStatusByYear: { __typename?: 'NegotiationStatus', id: string, name: string, presentationOrder: number | null } | null } | null } } };

export type SetNegotiationStatusForChildrenMutationVariables = Exact<{
  input: SetNegotiationStatusInput;
  year: Scalars['Int']['input'];
}>;


export type SetNegotiationStatusForChildrenMutation = { __typename?: 'Mutation', productPrice: { __typename?: 'ProductPriceMutationRoot', customer: { __typename?: 'CustomerMutationRoot', setNegotiationStatusForChildren: { __typename?: 'SetNegotiationStatusResult', customer: { __typename?: 'Customer', id: string, childCustomers: Array<{ __typename?: 'Customer', id: string, negotiationStatusByYear: { __typename?: 'NegotiationStatus', id: string, code: NegotiationStatusCode } | null }> } } } } };

export type SetNegotiationStatusMutationVariables = Exact<{
  input: SetNegotiationStatusInputWithCustomerList;
  year: Scalars['Int']['input'];
}>;


export type SetNegotiationStatusMutation = { __typename?: 'Mutation', productPrice: { __typename: 'ProductPriceMutationRoot', customer: { __typename: 'CustomerMutationRoot', setNegotiationStatus: Array<{ __typename: 'SetNegotiationStatusResult', customer: { __typename: 'Customer', id: string, negotiationStatusByYear: { __typename: 'NegotiationStatus', id: string, name: string } | null } } | null> } } };

export type CustomerPriceParentQueryVariables = Exact<{
  customerId: Scalars['ID']['input'];
}>;


export type CustomerPriceParentQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', customers: { __typename?: 'CustomerSearchRoot', byId: { __typename?: 'Customer', id: string, name: string, breadCrumbName: string, custIndex: string, custNo: number, hasRebateAgreements: boolean | null, isParent: boolean, statisticalGrouping: { __typename?: 'Customer', id: string } | null, invoiceCurrency: { __typename?: 'Currency', id: string, code: string }, salesRegion: { __typename?: 'SalesRegion', id: string, name: string }, seller: { __typename?: 'User', id: string, name: string }, custStatus: { __typename?: 'CustomerStatus', id: string, name: string } | null, writeHistory: { __typename?: 'WriteHistory', createdAt: { __typename?: 'DateTime', isoString: string }, createdBy: { __typename?: 'User', name: string }, modifiedBy: { __typename?: 'User', name: string } | null, modifiedAt: { __typename?: 'DateTime', isoString: string } | null }, parent: { __typename?: 'Customer', id: string, preselectedHeadAgreement: { __typename?: 'HeadAgreement', id: string } | null } | null, childCustomers: Array<{ __typename?: 'Customer', id: string }>, parentHistory: Array<{ __typename?: 'CustomerParentHistoryEntry', parentCustomerNo: number, validFrom: string, validTo: string | null, parentCustomer: { __typename?: 'Customer', id: string, custIndex: string } | null }> | null } | null } } };

export type CustomerPriceParentFragment = { __typename?: 'Customer', id: string, name: string, breadCrumbName: string, custIndex: string, custNo: number, hasRebateAgreements: boolean | null, isParent: boolean, statisticalGrouping: { __typename?: 'Customer', id: string } | null, invoiceCurrency: { __typename?: 'Currency', id: string, code: string }, salesRegion: { __typename?: 'SalesRegion', id: string, name: string }, seller: { __typename?: 'User', id: string, name: string }, custStatus: { __typename?: 'CustomerStatus', id: string, name: string } | null, writeHistory: { __typename?: 'WriteHistory', createdAt: { __typename?: 'DateTime', isoString: string }, createdBy: { __typename?: 'User', name: string }, modifiedBy: { __typename?: 'User', name: string } | null, modifiedAt: { __typename?: 'DateTime', isoString: string } | null }, parent: { __typename?: 'Customer', id: string, preselectedHeadAgreement: { __typename?: 'HeadAgreement', id: string } | null } | null, childCustomers: Array<{ __typename?: 'Customer', id: string }>, parentHistory: Array<{ __typename?: 'CustomerParentHistoryEntry', parentCustomerNo: number, validFrom: string, validTo: string | null, parentCustomer: { __typename?: 'Customer', id: string, custIndex: string } | null }> | null };

export type AddCustomerParentMutationVariables = Exact<{
  input: AddCustomerParentInput;
}>;


export type AddCustomerParentMutation = { __typename?: 'Mutation', productPrice: { __typename?: 'ProductPriceMutationRoot', customer: { __typename?: 'CustomerMutationRoot', addParent: boolean } } };

export type SetCustomerParentValidToMutationVariables = Exact<{
  input: SetCustomerParentValidToInput;
}>;


export type SetCustomerParentValidToMutation = { __typename?: 'Mutation', productPrice: { __typename?: 'ProductPriceMutationRoot', customer: { __typename?: 'CustomerMutationRoot', setParentValidTo: boolean } } };

export type DeleteCustomerParentMutationVariables = Exact<{
  input: CustomerParentKeyInput;
}>;


export type DeleteCustomerParentMutation = { __typename?: 'Mutation', productPrice: { __typename?: 'ProductPriceMutationRoot', customer: { __typename?: 'CustomerMutationRoot', deleteParent: boolean } } };

export type ActivateHeadAgreementSuccessHeadAgreementFragment = { __typename?: 'HeadAgreement', id: string, statusCode: HeadAgreementStatusCode, rowVersion: string, routeAgreements: Array<{ __typename?: 'RouteAgreement', id: string, statusCode: HeadAgreementStatusCode, rowVersion: string }> };

export type ActivateHeadAgreementMutationVariables = Exact<{
  headAgreementId: Scalars['ID']['input'];
  routeAgreements: InputMaybe<Array<ActivateRouteAgreementInput> | ActivateRouteAgreementInput>;
  multiLegAgreements: InputMaybe<Array<ActivateMultiLegAgreementInput> | ActivateMultiLegAgreementInput>;
  rowVersion: Scalars['String']['input'];
}>;


export type ActivateHeadAgreementMutation = { __typename?: 'Mutation', productPrice: { __typename?: 'ProductPriceMutationRoot', headAgreement: { __typename?: 'HeadAgreementMutationRoot', activateHeadAgreement: { __typename?: 'ActivateHeadAgreementSuccessResult', headAgreement: { __typename?: 'HeadAgreement', id: string, statusCode: HeadAgreementStatusCode, rowVersion: string, routeAgreements: Array<{ __typename?: 'RouteAgreement', id: string, statusCode: HeadAgreementStatusCode, rowVersion: string }> } } | { __typename?: 'ErrorResult', message: string | null, statusCode: number, description: string | null, errors: Array<{ __typename?: 'ErrorDetail', message: string, path: string | null }> } } } };

export type ActivateHeadAgreementRouteAgreementsFragment = { __typename?: 'RouteAgreement', id: string, name: string, statusCode: HeadAgreementStatusCode, routeDescription: string, agreementNumber: number, hasMatrix: boolean, sailingTypeCodes: Array<SailingTypeCode>, rowVersion: string, externalDescription: string | null, multiLegAgrRouteId: string | null, routes: Array<{ __typename?: 'Route', id: string, code: string, routePair: { __typename?: 'RoutePair', code: string } }>, currency: { __typename?: 'Currency', id: string, code: string }, valid: { __typename?: 'DateRange', start: { __typename?: 'Date', isoString: string } | null, end: { __typename?: 'Date', isoString: string } | null } };

export type ActivateHeadAgrHeadAgrFragment = { __typename?: 'HeadAgreement', id: string, name: string, breadCrumbName: string, headAgreementNumber: number, internalComments: string | null, specifications: string | null, condition: string | null, lastPage: string | null, statusCode: HeadAgreementStatusCode, rowVersion: string, customer: { __typename?: 'Customer', id: string, custIndex: string, custNo: number, name: string, breadCrumbName: string }, valid: { __typename?: 'DateRange', start: { __typename?: 'Date', isoString: string } | null, end: { __typename?: 'Date', isoString: string } | null }, routeAgreements: Array<{ __typename?: 'RouteAgreement', id: string, name: string, statusCode: HeadAgreementStatusCode, routeDescription: string, agreementNumber: number, hasMatrix: boolean, sailingTypeCodes: Array<SailingTypeCode>, rowVersion: string, externalDescription: string | null, multiLegAgrRouteId: string | null, routes: Array<{ __typename?: 'Route', id: string, code: string, routePair: { __typename?: 'RoutePair', code: string } }>, currency: { __typename?: 'Currency', id: string, code: string }, valid: { __typename?: 'DateRange', start: { __typename?: 'Date', isoString: string } | null, end: { __typename?: 'Date', isoString: string } | null } }>, multiLegAgrRoutes: Array<{ __typename?: 'MultiLegRouteAgreement', id: string, name: string, statusCode: HeadAgreementStatusCode, dateCreated: string, createdBy: string, dateModified: string | null, modifiedBy: string | null, idNumber: number | null, rowVersion: string, workFlowStatusCode: WorkFlowStatusCode | null, currency: { __typename?: 'Currency', id: string, code: string, name: string, shortDescription: string, longDescription: string }, valid: { __typename?: 'DateRange', start: { __typename?: 'Date', isoString: string } | null, end: { __typename?: 'Date', isoString: string } | null }, route: { __typename?: 'Route', id: string, code: string, name: string } }> };

export type ActivateCustomerFragment = { __typename?: 'Customer', id: string, name: string, breadCrumbName: string, custIndex: string, custNo: number, isParent: boolean, isStandardCustomer: boolean, hasRebateAgreements: boolean | null, custStatus: { __typename?: 'CustomerStatus', id: string, name: string } | null, parent: { __typename?: 'Customer', id: string, preselectedHeadAgreement: { __typename?: 'HeadAgreement', id: string } | null } | null, childCustomers: Array<{ __typename?: 'Customer', id: string }>, statisticalGrouping: { __typename?: 'Customer', id: string } | null, invoiceCurrency: { __typename?: 'Currency', id: string, code: string }, seller: { __typename?: 'User', id: string, name: string }, salesRegion: { __typename?: 'SalesRegion', id: string, code: string, name: string }, writeHistory: { __typename?: 'WriteHistory', createdAt: { __typename?: 'DateTime', isoString: string }, createdBy: { __typename?: 'User', id: string, name: string }, modifiedAt: { __typename?: 'DateTime', isoString: string } | null, modifiedBy: { __typename?: 'User', id: string, name: string } | null } };

export type ActivateHeadAgreementFetcherQueryVariables = Exact<{
  headAgreementId: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
}>;


export type ActivateHeadAgreementFetcherQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', customers: { __typename?: 'CustomerSearchRoot', byId: { __typename?: 'Customer', id: string, name: string, breadCrumbName: string, custIndex: string, custNo: number, isParent: boolean, isStandardCustomer: boolean, hasRebateAgreements: boolean | null, custStatus: { __typename?: 'CustomerStatus', id: string, name: string } | null, parent: { __typename?: 'Customer', id: string, preselectedHeadAgreement: { __typename?: 'HeadAgreement', id: string } | null } | null, childCustomers: Array<{ __typename?: 'Customer', id: string }>, statisticalGrouping: { __typename?: 'Customer', id: string } | null, invoiceCurrency: { __typename?: 'Currency', id: string, code: string }, seller: { __typename?: 'User', id: string, name: string }, salesRegion: { __typename?: 'SalesRegion', id: string, code: string, name: string }, writeHistory: { __typename?: 'WriteHistory', createdAt: { __typename?: 'DateTime', isoString: string }, createdBy: { __typename?: 'User', id: string, name: string }, modifiedAt: { __typename?: 'DateTime', isoString: string } | null, modifiedBy: { __typename?: 'User', id: string, name: string } | null } } | null }, headAgreement: { __typename?: 'HeadAgreementSearchRoot', byId: { __typename?: 'HeadAgreement', id: string, name: string, breadCrumbName: string, headAgreementNumber: number, internalComments: string | null, specifications: string | null, condition: string | null, lastPage: string | null, statusCode: HeadAgreementStatusCode, rowVersion: string, customer: { __typename?: 'Customer', id: string, custIndex: string, custNo: number, name: string, breadCrumbName: string }, valid: { __typename?: 'DateRange', start: { __typename?: 'Date', isoString: string } | null, end: { __typename?: 'Date', isoString: string } | null }, routeAgreements: Array<{ __typename?: 'RouteAgreement', id: string, name: string, statusCode: HeadAgreementStatusCode, routeDescription: string, agreementNumber: number, hasMatrix: boolean, sailingTypeCodes: Array<SailingTypeCode>, rowVersion: string, externalDescription: string | null, multiLegAgrRouteId: string | null, routes: Array<{ __typename?: 'Route', id: string, code: string, routePair: { __typename?: 'RoutePair', code: string } }>, currency: { __typename?: 'Currency', id: string, code: string }, valid: { __typename?: 'DateRange', start: { __typename?: 'Date', isoString: string } | null, end: { __typename?: 'Date', isoString: string } | null } }>, multiLegAgrRoutes: Array<{ __typename?: 'MultiLegRouteAgreement', id: string, name: string, statusCode: HeadAgreementStatusCode, dateCreated: string, createdBy: string, dateModified: string | null, modifiedBy: string | null, idNumber: number | null, rowVersion: string, workFlowStatusCode: WorkFlowStatusCode | null, currency: { __typename?: 'Currency', id: string, code: string, name: string, shortDescription: string, longDescription: string }, valid: { __typename?: 'DateRange', start: { __typename?: 'Date', isoString: string } | null, end: { __typename?: 'Date', isoString: string } | null }, route: { __typename?: 'Route', id: string, code: string, name: string } }> } | null } } };

export type AgreementArticlesFetcherQueryVariables = Exact<{
  headAgreementId: Scalars['ID']['input'];
}>;


export type AgreementArticlesFetcherQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', headAgreement: { __typename?: 'HeadAgreementSearchRoot', byId: { __typename?: 'HeadAgreement', id: string, statusCode: HeadAgreementStatusCode, name: string, headAgreementNumber: number, hasSomeRouteAgreementsWithMultiLeg: boolean, customer: { __typename?: 'Customer', id: string, name: string, custIndex: string, custNo: number, hasRebateAgreements: boolean | null, isParent: boolean, breadCrumbName: string, statisticalGrouping: { __typename?: 'Customer', id: string } | null, salesRegion: { __typename?: 'SalesRegion', id: string, name: string }, seller: { __typename?: 'User', id: string, name: string }, custStatus: { __typename?: 'CustomerStatus', id: string, name: string } | null, writeHistory: { __typename?: 'WriteHistory', createdAt: { __typename?: 'DateTime', isoString: string }, createdBy: { __typename?: 'User', name: string }, modifiedAt: { __typename?: 'DateTime', isoString: string } | null, modifiedBy: { __typename?: 'User', name: string } | null }, parent: { __typename?: 'Customer', id: string, preselectedHeadAgreement: { __typename?: 'HeadAgreement', id: string } | null } | null, childCustomers: Array<{ __typename?: 'Customer', id: string }>, invoiceCurrency: { __typename?: 'Currency', id: string, code: string } }, routeAgreements: Array<{ __typename?: 'RouteAgreement', name: string, id: string, rowVersion: string, statusCode: HeadAgreementStatusCode, sailingTypeCodes: Array<SailingTypeCode>, routes: Array<{ __typename?: 'Route', id: string, code: string, routePair: { __typename?: 'RoutePair', id: string, description: string, code: string }, distanceType: { __typename?: 'DistanceType', id: string, description: string, code: number } | null }>, valid: { __typename?: 'DateRange', start: { __typename?: 'Date', isoString: string } | null, end: { __typename?: 'Date', isoString: string } | null }, articles: Array<{ __typename?: 'RouteAgreementArticle', id: string, articleType: { __typename?: 'ArticleType', code: string, updatable: boolean | null }, prices: Array<{ __typename?: 'ArticlePrice', id: string, lengthFrom: number | null, lengthTo: number | null, weightFrom: number | null, weightTo: number | null, vehicleType: { __typename?: 'VehicleType', code: string, shortDescription: string } | null, price: { __typename?: 'Price', amount: string } }>, validities: Array<{ __typename?: 'ArticlePriceValidity', id: string, price: number | null, validFrom: string | null, agrRouteArticlePriceId: string }> }> }>, valid: { __typename?: 'DateRange', start: { __typename?: 'Date', isoString: string } | null, end: { __typename?: 'Date', isoString: string } | null }, writeHistory: { __typename?: 'WriteHistory', createdAt: { __typename?: 'DateTime', isoString: string }, createdBy: { __typename?: 'User', id: string, name: string }, modifiedAt: { __typename?: 'DateTime', isoString: string } | null, modifiedBy: { __typename?: 'User', id: string, name: string } | null } } | null } } };

export type AgrArticleDistanceTypeSelectQueryVariables = Exact<{ [key: string]: never; }>;


export type AgrArticleDistanceTypeSelectQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', distanceType: { __typename?: 'DistanceTypeSearchRoot', all: Array<{ __typename?: 'DistanceType', id: string, code: number, description: string }> } } };

export type AgrArticleSelectQueryVariables = Exact<{ [key: string]: never; }>;


export type AgrArticleSelectQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', articleType: { __typename?: 'ArticleTypeSearchRoot', all: Array<{ __typename?: 'ArticleType', id: string, updatable: boolean | null, code: string }> } } };

export type UpdateAgreementRouteArticlePriceMutationVariables = Exact<{
  input: UpdateAgreementArticlesInput;
}>;


export type UpdateAgreementRouteArticlePriceMutation = { __typename?: 'Mutation', productPrice: { __typename?: 'ProductPriceMutationRoot', routeAgreement: { __typename?: 'RouteAgreementMutationRoot', updateAgreementArticles: Array<{ __typename: 'ErrorResult', errors: Array<{ __typename?: 'ErrorDetail', message: string, path: string | null }> } | { __typename: 'UpdateAgreementArticlesSuccessResult', routeAgreement: { __typename?: 'RouteAgreement', name: string, id: string, rowVersion: string, statusCode: HeadAgreementStatusCode, sailingTypeCodes: Array<SailingTypeCode>, routes: Array<{ __typename?: 'Route', id: string, code: string, routePair: { __typename?: 'RoutePair', id: string, description: string, code: string }, distanceType: { __typename?: 'DistanceType', id: string, description: string, code: number } | null }>, valid: { __typename?: 'DateRange', start: { __typename?: 'Date', isoString: string } | null, end: { __typename?: 'Date', isoString: string } | null }, articles: Array<{ __typename?: 'RouteAgreementArticle', id: string, articleType: { __typename?: 'ArticleType', code: string, updatable: boolean | null }, prices: Array<{ __typename?: 'ArticlePrice', id: string, lengthFrom: number | null, lengthTo: number | null, weightFrom: number | null, weightTo: number | null, vehicleType: { __typename?: 'VehicleType', code: string, shortDescription: string } | null, price: { __typename?: 'Price', amount: string } }>, validities: Array<{ __typename?: 'ArticlePriceValidity', id: string, price: number | null, validFrom: string | null, agrRouteArticlePriceId: string }> }> } }> } } };

export type AgreementArticlesHeadAgreementFragment = { __typename?: 'HeadAgreement', id: string, statusCode: HeadAgreementStatusCode, name: string, headAgreementNumber: number, hasSomeRouteAgreementsWithMultiLeg: boolean, valid: { __typename?: 'DateRange', start: { __typename?: 'Date', isoString: string } | null, end: { __typename?: 'Date', isoString: string } | null }, writeHistory: { __typename?: 'WriteHistory', createdAt: { __typename?: 'DateTime', isoString: string }, createdBy: { __typename?: 'User', id: string, name: string }, modifiedAt: { __typename?: 'DateTime', isoString: string } | null, modifiedBy: { __typename?: 'User', id: string, name: string } | null } };

export type AgreementArticlesCustomerFragment = { __typename?: 'Customer', id: string, name: string, custIndex: string, custNo: number, hasRebateAgreements: boolean | null, isParent: boolean, breadCrumbName: string, statisticalGrouping: { __typename?: 'Customer', id: string } | null, salesRegion: { __typename?: 'SalesRegion', id: string, name: string }, seller: { __typename?: 'User', id: string, name: string }, custStatus: { __typename?: 'CustomerStatus', id: string, name: string } | null, writeHistory: { __typename?: 'WriteHistory', createdAt: { __typename?: 'DateTime', isoString: string }, createdBy: { __typename?: 'User', name: string }, modifiedAt: { __typename?: 'DateTime', isoString: string } | null, modifiedBy: { __typename?: 'User', name: string } | null }, parent: { __typename?: 'Customer', id: string, preselectedHeadAgreement: { __typename?: 'HeadAgreement', id: string } | null } | null, childCustomers: Array<{ __typename?: 'Customer', id: string }>, invoiceCurrency: { __typename?: 'Currency', id: string, code: string } };

export type AgreementArticlesRouteAgreementFragment = { __typename?: 'RouteAgreement', name: string, id: string, rowVersion: string, statusCode: HeadAgreementStatusCode, sailingTypeCodes: Array<SailingTypeCode>, routes: Array<{ __typename?: 'Route', id: string, code: string, routePair: { __typename?: 'RoutePair', id: string, description: string, code: string }, distanceType: { __typename?: 'DistanceType', id: string, description: string, code: number } | null }>, valid: { __typename?: 'DateRange', start: { __typename?: 'Date', isoString: string } | null, end: { __typename?: 'Date', isoString: string } | null }, articles: Array<{ __typename?: 'RouteAgreementArticle', id: string, articleType: { __typename?: 'ArticleType', code: string, updatable: boolean | null }, prices: Array<{ __typename?: 'ArticlePrice', id: string, lengthFrom: number | null, lengthTo: number | null, weightFrom: number | null, weightTo: number | null, vehicleType: { __typename?: 'VehicleType', code: string, shortDescription: string } | null, price: { __typename?: 'Price', amount: string } }>, validities: Array<{ __typename?: 'ArticlePriceValidity', id: string, price: number | null, validFrom: string | null, agrRouteArticlePriceId: string }> }> };

export type DeleteAgreementDocumenteMutationVariables = Exact<{
  documentId: Scalars['ID']['input'];
  customerNumber: Scalars['Int']['input'];
}>;


export type DeleteAgreementDocumenteMutation = { __typename?: 'Mutation', productPrice: { __typename?: 'ProductPriceMutationRoot', agreementDocuments: { __typename?: 'AgreementDocumentMutationRoot', deleteAgreementDocument: { __typename: 'DeleteAgreementDocumentErrorResult', errors: Array<{ __typename?: 'ErrorDetail', message: string, path: string | null }> } | { __typename: 'DeleteAgreementDocumentSuccessResult', success: boolean } } } };

export type DocumentsScreenQueryVariables = Exact<{
  customerNo: Scalars['ID']['input'];
}>;


export type DocumentsScreenQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', customers: { __typename?: 'CustomerSearchRoot', byId: { __typename?: 'Customer', id: string, name: string, breadCrumbName: string, custIndex: string, custNo: number, isParent: boolean, hasRebateAgreements: boolean | null, preselectedHeadAgreement: { __typename?: 'HeadAgreement', id: string } | null, custStatus: { __typename?: 'CustomerStatus', id: string, name: string } | null, parent: { __typename?: 'Customer', id: string, preselectedHeadAgreement: { __typename?: 'HeadAgreement', id: string } | null } | null, childCustomers: Array<{ __typename?: 'Customer', id: string }>, statisticalGrouping: { __typename?: 'Customer', id: string } | null, invoiceCurrency: { __typename?: 'Currency', id: string, code: string }, seller: { __typename?: 'User', id: string, name: string }, salesRegion: { __typename?: 'SalesRegion', id: string, name: string }, writeHistory: { __typename?: 'WriteHistory', createdAt: { __typename?: 'DateTime', isoString: string }, createdBy: { __typename?: 'User', name: string }, modifiedAt: { __typename?: 'DateTime', isoString: string } | null, modifiedBy: { __typename?: 'User', name: string } | null }, agreementDocuments: Array<{ __typename?: 'AgreementDocuments', id: string, agreementId: string, customerNumber: number, fileName: string, agreementValidFromDate: string, agreementValidToDate: string, agreementDocumentType: string, negotiationYear: number, writeHistory: { __typename?: 'WriteHistory', createdAt: { __typename?: 'DateTime', isoString: string }, createdBy: { __typename?: 'User', id: string, name: string } } }>, rebateAgreementDocuments: Array<{ __typename?: 'RebateAgreementDocuments', id: string, rebateAgreementId: string, customerNumber: number, fileName: string, rebateAgreementValidFromDate: string, rebateAgreementValidToDate: string, negotiationYear: number, writeHistory: { __typename?: 'WriteHistory', createdAt: { __typename?: 'DateTime', isoString: string }, createdBy: { __typename?: 'User', id: string, name: string } } }> } | null } } };

export type CopyAgreementMultiLegRouteAgreementsFragment = { __typename?: 'MultiLegRouteAgreement', id: string, name: string, statusCode: HeadAgreementStatusCode, dateCreated: string, createdBy: string, dateModified: string | null, modifiedBy: string | null, idNumber: number | null, rowVersion: string, workFlowStatusCode: WorkFlowStatusCode | null, currency: { __typename?: 'Currency', id: string, code: string, name: string, shortDescription: string, longDescription: string }, valid: { __typename?: 'DateRange', start: { __typename?: 'Date', isoString: string } | null, end: { __typename?: 'Date', isoString: string } | null }, route: { __typename?: 'Route', id: string, code: string, name: string } };

export type CopyAgreementRouteAgreementsFragment = { __typename?: 'RouteAgreement', id: string, name: string, statusCode: HeadAgreementStatusCode, routeDescription: string, agreementNumber: number, hasMatrix: boolean, sailingTypeCodes: Array<SailingTypeCode>, externalDescription: string | null, multiLegAgrRouteId: string | null, currency: { __typename?: 'Currency', id: string, code: string }, valid: { __typename?: 'DateRange', start: { __typename?: 'Date', isoString: string } | null, end: { __typename?: 'Date', isoString: string } | null } };

export type CopyAgreementCustomerFragment = { __typename?: 'Customer', id: string, custIndex: string, custNo: number, name: string, breadCrumbName: string };

export type CopyHeadAgreementDataHeadAgreementFragment = { __typename?: 'HeadAgreement', id: string, name: string, breadCrumbName: string, headAgreementNumber: number, internalComments: string | null, specifications: string | null, condition: string | null, lastPage: string | null, statusCode: HeadAgreementStatusCode, customer: { __typename?: 'Customer', id: string, custIndex: string, custNo: number, name: string, breadCrumbName: string }, valid: { __typename?: 'DateRange', start: { __typename?: 'Date', isoString: string } | null, end: { __typename?: 'Date', isoString: string } | null }, routeAgreements: Array<{ __typename?: 'RouteAgreement', id: string, name: string, statusCode: HeadAgreementStatusCode, routeDescription: string, agreementNumber: number, hasMatrix: boolean, sailingTypeCodes: Array<SailingTypeCode>, externalDescription: string | null, multiLegAgrRouteId: string | null, currency: { __typename?: 'Currency', id: string, code: string }, valid: { __typename?: 'DateRange', start: { __typename?: 'Date', isoString: string } | null, end: { __typename?: 'Date', isoString: string } | null } }>, multiLegAgrRoutes: Array<{ __typename?: 'MultiLegRouteAgreement', id: string, name: string, statusCode: HeadAgreementStatusCode, dateCreated: string, createdBy: string, dateModified: string | null, modifiedBy: string | null, idNumber: number | null, rowVersion: string, workFlowStatusCode: WorkFlowStatusCode | null, currency: { __typename?: 'Currency', id: string, code: string, name: string, shortDescription: string, longDescription: string }, valid: { __typename?: 'DateRange', start: { __typename?: 'Date', isoString: string } | null, end: { __typename?: 'Date', isoString: string } | null }, route: { __typename?: 'Route', id: string, code: string, name: string } }> };

export type CopyHeadAgreementDataQueryVariables = Exact<{
  headAgreementId: Scalars['ID']['input'];
}>;


export type CopyHeadAgreementDataQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', headAgreement: { __typename?: 'HeadAgreementSearchRoot', byId: { __typename?: 'HeadAgreement', id: string, name: string, breadCrumbName: string, headAgreementNumber: number, internalComments: string | null, specifications: string | null, condition: string | null, lastPage: string | null, statusCode: HeadAgreementStatusCode, customer: { __typename?: 'Customer', id: string, custIndex: string, custNo: number, name: string, breadCrumbName: string }, valid: { __typename?: 'DateRange', start: { __typename?: 'Date', isoString: string } | null, end: { __typename?: 'Date', isoString: string } | null }, routeAgreements: Array<{ __typename?: 'RouteAgreement', id: string, name: string, statusCode: HeadAgreementStatusCode, routeDescription: string, agreementNumber: number, hasMatrix: boolean, sailingTypeCodes: Array<SailingTypeCode>, externalDescription: string | null, multiLegAgrRouteId: string | null, currency: { __typename?: 'Currency', id: string, code: string }, valid: { __typename?: 'DateRange', start: { __typename?: 'Date', isoString: string } | null, end: { __typename?: 'Date', isoString: string } | null } }>, multiLegAgrRoutes: Array<{ __typename?: 'MultiLegRouteAgreement', id: string, name: string, statusCode: HeadAgreementStatusCode, dateCreated: string, createdBy: string, dateModified: string | null, modifiedBy: string | null, idNumber: number | null, rowVersion: string, workFlowStatusCode: WorkFlowStatusCode | null, currency: { __typename?: 'Currency', id: string, code: string, name: string, shortDescription: string, longDescription: string }, valid: { __typename?: 'DateRange', start: { __typename?: 'Date', isoString: string } | null, end: { __typename?: 'Date', isoString: string } | null }, route: { __typename?: 'Route', id: string, code: string, name: string } }> } | null } } };

export type CopyHeadAgreementTargetCustomerQueryVariables = Exact<{
  headAgreementId: Scalars['ID']['input'];
}>;


export type CopyHeadAgreementTargetCustomerQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', headAgreement: { __typename?: 'HeadAgreementSearchRoot', byId: { __typename?: 'HeadAgreement', id: string, name: string, internalComments: string | null, specifications: string | null, condition: string | null, lastPage: string | null, statusCode: HeadAgreementStatusCode, valid: { __typename?: 'DateRange', start: { __typename?: 'Date', isoString: string } | null, end: { __typename?: 'Date', isoString: string } | null } } | null } } };

export type GetCopyFromOtherCustomerBreadCrumbNameQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetCopyFromOtherCustomerBreadCrumbNameQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', customers: { __typename?: 'CustomerSearchRoot', byId: { __typename?: 'Customer', breadCrumbName: string } | null } } };

export type GetCopyToCustomerQueryVariables = Exact<{
  customerId: Scalars['ID']['input'];
}>;


export type GetCopyToCustomerQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', customers: { __typename?: 'CustomerSearchRoot', byId: { __typename?: 'Customer', id: string, name: string, custIndex: string, custNo: number } | null } } };

export type HeadAgreementScreenParamsQueryVariables = Exact<{
  headAgreementId: Scalars['ID']['input'];
}>;


export type HeadAgreementScreenParamsQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', headAgreement: { __typename?: 'HeadAgreementSearchRoot', byId: { __typename?: 'HeadAgreement', headAgreementNumber: number } | null } } };

export type GetCopyToOtherCustomerBreadCrumbNameQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetCopyToOtherCustomerBreadCrumbNameQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', customers: { __typename?: 'CustomerSearchRoot', byId: { __typename?: 'Customer', breadCrumbName: string } | null } } };

export type CopyHeadAgreementMutationVariables = Exact<{
  input: CopyHeadAgreementInput;
}>;


export type CopyHeadAgreementMutation = { __typename?: 'Mutation', productPrice: { __typename?: 'ProductPriceMutationRoot', headAgreement: { __typename?: 'HeadAgreementMutationRoot', copyHeadAgreement: { __typename?: 'ErrorResult', errors: Array<{ __typename?: 'ErrorDetail', message: string, path: string | null }> } | { __typename?: 'UpdateHeadAgreementSuccessResult', headAgreement: { __typename?: 'HeadAgreement', id: string, rowVersion: string, customer: { __typename?: 'Customer', id: string } } } } } };

export type CreateHeadAgreementFetcherQueryVariables = Exact<{
  customerId: Scalars['ID']['input'];
}>;


export type CreateHeadAgreementFetcherQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', customers: { __typename?: 'CustomerSearchRoot', byId: { __typename?: 'Customer', id: string, name: string, breadCrumbName: string, custIndex: string, custNo: number, isParent: boolean, isStandardCustomer: boolean, hasRebateAgreements: boolean | null, preselectedHeadAgreement: { __typename?: 'HeadAgreement', id: string } | null, custStatus: { __typename?: 'CustomerStatus', id: string, name: string } | null, parent: { __typename?: 'Customer', id: string, preselectedHeadAgreement: { __typename?: 'HeadAgreement', id: string } | null } | null, childCustomers: Array<{ __typename?: 'Customer', id: string }>, statisticalGrouping: { __typename?: 'Customer', id: string } | null, invoiceCurrency: { __typename?: 'Currency', id: string, code: string }, seller: { __typename?: 'User', id: string, name: string }, salesRegion: { __typename?: 'SalesRegion', id: string, code: string, name: string }, writeHistory: { __typename?: 'WriteHistory', createdAt: { __typename?: 'DateTime', isoString: string }, createdBy: { __typename?: 'User', id: string, name: string }, modifiedAt: { __typename?: 'DateTime', isoString: string } | null, modifiedBy: { __typename?: 'User', id: string, name: string } | null } } | null } } };

export type CreateHeadAgreementMutationVariables = Exact<{
  input: CreateHeadAgreementInput;
}>;


export type CreateHeadAgreementMutation = { __typename?: 'Mutation', productPrice: { __typename?: 'ProductPriceMutationRoot', headAgreement: { __typename?: 'HeadAgreementMutationRoot', createHeadAgreement: { __typename?: 'CreateHeadAgreementSuccessResult', customer: { __typename?: 'Customer', id: string }, headAgreement: { __typename?: 'HeadAgreement', id: string } } | { __typename?: 'ErrorResult', errors: Array<{ __typename?: 'ErrorDetail', message: string, path: string | null }> } } } };

export type HeadAgreementPanelCustomersFragment = { __typename?: 'Customer', id: string, custIndex: string, custNo: number, name: string, isParent: boolean, childCustomers: Array<{ __typename?: 'Customer', id: string }>, statisticsByFilter: { __typename?: 'CustomerStatisticsResult', items: Array<{ __typename?: 'CustomerStatisticsEntry', id: string, expectedVolume: number | null, statVolume12Months: number | null, unitCategoryCode: UnitCategoryCode, expectedStatVolume: number | null, sailingCategoryCode: SailingTypeCode, volume12Months: number, actualOutcomeInPercent: number | null }> } };

export type HeadAgreementPanelQueryVariables = Exact<{
  customerId: Scalars['ID']['input'];
  headAgreementId: Scalars['ID']['input'];
  year: Scalars['Int']['input'];
}>;


export type HeadAgreementPanelQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', customers: { __typename?: 'CustomerSearchRoot', byId: { __typename?: 'Customer', id: string, custIndex: string, custNo: number, name: string, isParent: boolean, childCustomers: Array<{ __typename?: 'Customer', id: string }>, statisticsByFilter: { __typename?: 'CustomerStatisticsResult', items: Array<{ __typename?: 'CustomerStatisticsEntry', id: string, expectedVolume: number | null, statVolume12Months: number | null, unitCategoryCode: UnitCategoryCode, expectedStatVolume: number | null, sailingCategoryCode: SailingTypeCode, volume12Months: number, actualOutcomeInPercent: number | null }> } } | null }, headAgreement: { __typename?: 'HeadAgreementSearchRoot', byId: { __typename?: 'HeadAgreement', id: string, statusCode: HeadAgreementStatusCode, name: string, headAgreementNumber: number, breadCrumbName: string, hasSomeRouteAgreementsWithMultiLeg: boolean, rowVersion: string, customer: { __typename?: 'Customer', custNo: number }, valid: { __typename?: 'DateRange', start: { __typename?: 'Date', isoString: string } | null, end: { __typename?: 'Date', isoString: string } | null }, writeHistory: { __typename?: 'WriteHistory', createdAt: { __typename?: 'DateTime', isoString: string }, createdBy: { __typename?: 'User', id: string, name: string }, modifiedAt: { __typename?: 'DateTime', isoString: string } | null, modifiedBy: { __typename?: 'User', id: string, name: string } | null } } | null } } };

export type CustomerHeaderStatsQueryVariables = Exact<{
  customerId: Scalars['ID']['input'];
  year: Scalars['Int']['input'];
}>;


export type CustomerHeaderStatsQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', customers: { __typename?: 'CustomerSearchRoot', byId: { __typename?: 'Customer', id: string, statisticsByFilter: { __typename?: 'CustomerStatisticsResult', items: Array<{ __typename?: 'CustomerStatisticsEntry', id: string, expectedVolume: number | null, statVolume12Months: number | null, unitCategoryCode: UnitCategoryCode, expectedStatVolume: number | null, sailingCategoryCode: SailingTypeCode, volume12Months: number, actualOutcomeInPercent: number | null }> } } | null } } };

export type ActivateRouteAgreementMutationVariables = Exact<{
  routeAgreement: ActivateRouteAgreementInput;
}>;


export type ActivateRouteAgreementMutation = { __typename?: 'Mutation', productPrice: { __typename?: 'ProductPriceMutationRoot', routeAgreement: { __typename?: 'RouteAgreementMutationRoot', activateRouteAgreement: { __typename?: 'ErrorResult', errors: Array<{ __typename?: 'ErrorDetail', message: string, path: string | null }> } | { __typename?: 'UpdateRouteAgreementSuccessResult', routeAgreement: { __typename?: 'RouteAgreement', id: string, statusCode: HeadAgreementStatusCode, rowVersion: string } } } } };

export type ChangeRouteAgreementStatusMutationVariables = Exact<{
  routeAgreementId: Scalars['ID']['input'];
  status: HeadAgreementStatusCode;
  rowVersion: Scalars['String']['input'];
}>;


export type ChangeRouteAgreementStatusMutation = { __typename?: 'Mutation', productPrice: { __typename?: 'ProductPriceMutationRoot', routeAgreement: { __typename?: 'RouteAgreementMutationRoot', changeRouteAgreementStatus: { __typename?: 'ErrorResult', errors: Array<{ __typename?: 'ErrorDetail', message: string, path: string | null }> } | { __typename?: 'UpdateRouteAgreementSuccessResult', routeAgreement: { __typename?: 'RouteAgreement', id: string, statusCode: HeadAgreementStatusCode, rowVersion: string } } } } };

export type CopyRouteAgreementMutationVariables = Exact<{
  input: CopyRouteAgreementInput;
}>;


export type CopyRouteAgreementMutation = { __typename?: 'Mutation', productPrice: { __typename?: 'ProductPriceMutationRoot', routeAgreement: { __typename?: 'RouteAgreementMutationRoot', copyRouteAgreement: { __typename?: 'CopyRouteAgreementSuccessResult', routeAgreement: { __typename?: 'RouteAgreement', id: string } } | { __typename?: 'ErrorResult', errors: Array<{ __typename?: 'ErrorDetail', message: string, path: string | null }> } } } };

export type DeleteRouteAgreementMutationVariables = Exact<{
  routeAgreementId: Scalars['ID']['input'];
  rowVersion: Scalars['String']['input'];
}>;


export type DeleteRouteAgreementMutation = { __typename?: 'Mutation', productPrice: { __typename?: 'ProductPriceMutationRoot', routeAgreement: { __typename?: 'RouteAgreementMutationRoot', deleteRouteAgreement: { __typename?: 'DeleteRouteAgreementSuccessResult', success: boolean } | { __typename?: 'ErrorResult', errors: Array<{ __typename?: 'ErrorDetail', message: string, path: string | null }> } } } };

export type ActivateMultiLegAgreementMutationVariables = Exact<{
  activateMultiLegAgreementInput: ActivateMultiLegAgreementInput;
}>;


export type ActivateMultiLegAgreementMutation = { __typename?: 'Mutation', productPrice: { __typename?: 'ProductPriceMutationRoot', multiLegRouteAgreement: { __typename?: 'MultiLegRouteAgreementMutationRoot', activateMultiLegAgreement: { __typename?: 'ErrorResult', errors: Array<{ __typename?: 'ErrorDetail', message: string, path: string | null }> } | { __typename?: 'UpdateMultiLegRouteAgreementSuccessResult', multiLegAgreement: { __typename?: 'MultiLegRouteAgreement', id: string, statusCode: HeadAgreementStatusCode, rowVersion: string } } } } };

export type ChangeMultiLegAgreementStatusMutationVariables = Exact<{
  changeMultiLegRouteAgreementStatusInput: ChangeMultiLegRouteAgreementStatusInput;
}>;


export type ChangeMultiLegAgreementStatusMutation = { __typename?: 'Mutation', productPrice: { __typename?: 'ProductPriceMutationRoot', multiLegRouteAgreement: { __typename?: 'MultiLegRouteAgreementMutationRoot', changeMultiLegRouteAgreementStatus: { __typename?: 'ErrorResult', errors: Array<{ __typename?: 'ErrorDetail', message: string, path: string | null }> } | { __typename?: 'UpdateMultiLegRouteAgreementSuccessResult', multiLegAgreement: { __typename?: 'MultiLegRouteAgreement', id: string, statusCode: HeadAgreementStatusCode, rowVersion: string } } } } };

export type CopyMultiLegRouteAgreementMutationVariables = Exact<{
  copyMultiLegRouteAgreementInput: CopyMultiLegAgreementInput;
}>;


export type CopyMultiLegRouteAgreementMutation = { __typename?: 'Mutation', productPrice: { __typename?: 'ProductPriceMutationRoot', multiLegRouteAgreement: { __typename?: 'MultiLegRouteAgreementMutationRoot', copyMultiLegRouteAgreement: { __typename?: 'CopyMultiLegRouteAgreementSuccessResult', multiLegAgreement: { __typename?: 'MultiLegRouteAgreement', id: string } } | { __typename?: 'ErrorResult', errors: Array<{ __typename?: 'ErrorDetail', message: string, path: string | null }> } } } };

export type DeleteMultiLegRouteAgreementMutationVariables = Exact<{
  deleteMultiLegRouteAgreementMultiLegRouteAgreementId: Scalars['ID']['input'];
  deleteMultiLegRouteAgreementRowVersion: Scalars['String']['input'];
}>;


export type DeleteMultiLegRouteAgreementMutation = { __typename?: 'Mutation', productPrice: { __typename?: 'ProductPriceMutationRoot', multiLegRouteAgreement: { __typename?: 'MultiLegRouteAgreementMutationRoot', deleteMultiLegRouteAgreement: { __typename?: 'DeleteMultiLegRouteAgreementSuccessResult', success: boolean } | { __typename?: 'ErrorResult', errors: Array<{ __typename?: 'ErrorDetail', message: string, path: string | null }> } } } };

export type RouteAgreementCreatedAtFragment = { __typename?: 'DateTime', isoString: string };

export type RouteAgreementModifiedAtFragment = { __typename?: 'DateTime', isoString: string };

export type RouteAgreementFieldsFragment = { __typename?: 'RouteAgreement', id: string, agreementNumber: number, name: string, statusCode: HeadAgreementStatusCode, isSalesReady: boolean, sailingTypeCodes: Array<SailingTypeCode>, rowVersion: string, hasArticles: boolean, hasConditions: boolean, hasMatrix: boolean, multiLegAgrRouteId: string | null, routeDescription: string, headAgreement: { __typename?: 'HeadAgreement', id: string, headAgreementNumber: number, statusCode: HeadAgreementStatusCode, customer: { __typename?: 'Customer', id: string, name: string } }, currency: { __typename?: 'Currency', id: string, code: string }, valid: { __typename?: 'DateRange', start: { __typename?: 'Date', isoString: string } | null, end: { __typename?: 'Date', isoString: string } | null }, writeHistory: { __typename?: 'WriteHistory', createdAt: { __typename?: 'DateTime', isoString: string }, modifiedAt: { __typename?: 'DateTime', isoString: string } | null }, routes: Array<{ __typename?: 'Route', id: string, routePair: { __typename?: 'RoutePair', id: string, statisticsForCustomerIdAndYear: { __typename?: 'CustomerRoutePairStatistics', averageNegotiationRate: number, averageTargetRate: number | null, expectedVolume: number | null, volumeLast12Months: number, volumeChange: number | null } | null, seaArea: { __typename?: 'SeaArea', id: string, name: string } } }> };

export type ChangeHeadAgreementStatusMutationVariables = Exact<{
  headAgreementId: Scalars['ID']['input'];
  status: HeadAgreementStatusCode;
  rowVersion: Scalars['String']['input'];
}>;


export type ChangeHeadAgreementStatusMutation = { __typename?: 'Mutation', productPrice: { __typename?: 'ProductPriceMutationRoot', headAgreement: { __typename?: 'HeadAgreementMutationRoot', changeHeadAgreementStatus: { __typename?: 'ErrorResult', errors: Array<{ __typename?: 'ErrorDetail', message: string, path: string | null }> } | { __typename?: 'UpdateHeadAgreementSuccessResult', headAgreement: { __typename?: 'HeadAgreement', id: string, statusCode: HeadAgreementStatusCode, rowVersion: string } } } } };

export type DeleteHeadAgreementMutationVariables = Exact<{
  headAgreementId: Scalars['ID']['input'];
  rowVersion: Scalars['String']['input'];
}>;


export type DeleteHeadAgreementMutation = { __typename?: 'Mutation', productPrice: { __typename?: 'ProductPriceMutationRoot', headAgreement: { __typename?: 'HeadAgreementMutationRoot', deleteHeadAgreement: { __typename?: 'DeleteHeadAgreementSuccessResult', customer: { __typename?: 'Customer', id: string, preselectedHeadAgreement: { __typename?: 'HeadAgreement', id: string } | null } } | { __typename?: 'ErrorResult', errors: Array<{ __typename?: 'ErrorDetail', message: string, path: string | null }> } } } };

export type HeadAgreementByIdFragment = { __typename?: 'HeadAgreement', id: string, name: string, statusCode: HeadAgreementStatusCode, headAgreementNumber: number, hasSomeRouteAgreementsWithMultiLeg: boolean, rowVersion: string, valid: { __typename?: 'DateRange', start: { __typename?: 'Date', isoString: string } | null, end: { __typename?: 'Date', isoString: string } | null }, routeAgreements: Array<{ __typename?: 'RouteAgreement', id: string, agreementNumber: number, name: string, statusCode: HeadAgreementStatusCode, isSalesReady: boolean, sailingTypeCodes: Array<SailingTypeCode>, rowVersion: string, hasArticles: boolean, hasConditions: boolean, hasMatrix: boolean, multiLegAgrRouteId: string | null, routeDescription: string, headAgreement: { __typename?: 'HeadAgreement', id: string, headAgreementNumber: number, statusCode: HeadAgreementStatusCode, customer: { __typename?: 'Customer', id: string, name: string } }, currency: { __typename?: 'Currency', id: string, code: string }, valid: { __typename?: 'DateRange', start: { __typename?: 'Date', isoString: string } | null, end: { __typename?: 'Date', isoString: string } | null }, writeHistory: { __typename?: 'WriteHistory', createdAt: { __typename?: 'DateTime', isoString: string }, modifiedAt: { __typename?: 'DateTime', isoString: string } | null }, routes: Array<{ __typename?: 'Route', id: string, routePair: { __typename?: 'RoutePair', id: string, statisticsForCustomerIdAndYear: { __typename?: 'CustomerRoutePairStatistics', averageNegotiationRate: number, averageTargetRate: number | null, expectedVolume: number | null, volumeLast12Months: number, volumeChange: number | null } | null, seaArea: { __typename?: 'SeaArea', id: string, name: string } } }> }>, multiLegAgrRoutes: Array<{ __typename?: 'MultiLegRouteAgreement', id: string, name: string, statusCode: HeadAgreementStatusCode, dateCreated: string, createdBy: string, dateModified: string | null, modifiedBy: string | null, idNumber: number | null, rowVersion: string, workFlowStatusCode: WorkFlowStatusCode | null, headAgreement: { __typename?: 'HeadAgreement', id: string, headAgreementNumber: number, statusCode: HeadAgreementStatusCode, customer: { __typename?: 'Customer', id: string, name: string } }, route: { __typename?: 'Route', id: string, code: string, name: string }, currency: { __typename?: 'Currency', id: string, code: string, name: string, shortDescription: string, longDescription: string }, valid: { __typename?: 'DateRange', start: { __typename?: 'Date', isoString: string } | null, end: { __typename?: 'Date', isoString: string } | null }, routeAgreements: Array<{ __typename?: 'RouteAgreement', id: string, agreementNumber: number, name: string, statusCode: HeadAgreementStatusCode, isSalesReady: boolean, sailingTypeCodes: Array<SailingTypeCode>, rowVersion: string, hasArticles: boolean, hasConditions: boolean, hasMatrix: boolean, multiLegAgrRouteId: string | null, routeDescription: string, headAgreement: { __typename?: 'HeadAgreement', id: string, headAgreementNumber: number, statusCode: HeadAgreementStatusCode, customer: { __typename?: 'Customer', id: string, name: string } }, currency: { __typename?: 'Currency', id: string, code: string }, valid: { __typename?: 'DateRange', start: { __typename?: 'Date', isoString: string } | null, end: { __typename?: 'Date', isoString: string } | null }, writeHistory: { __typename?: 'WriteHistory', createdAt: { __typename?: 'DateTime', isoString: string }, modifiedAt: { __typename?: 'DateTime', isoString: string } | null }, routes: Array<{ __typename?: 'Route', id: string, routePair: { __typename?: 'RoutePair', id: string, statisticsForCustomerIdAndYear: { __typename?: 'CustomerRoutePairStatistics', averageNegotiationRate: number, averageTargetRate: number | null, expectedVolume: number | null, volumeLast12Months: number, volumeChange: number | null } | null, seaArea: { __typename?: 'SeaArea', id: string, name: string } } }> }>, routeLegs: Array<{ __typename?: 'RouteLeg', id: string, legRoute: { __typename?: 'Route', id: string, code: string, name: string }, route: { __typename?: 'Route', id: string, code: string, name: string } }> }> };

export type HeadAgreementQueryVariables = Exact<{
  headAgreementId: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
  year: Scalars['Int']['input'];
}>;


export type HeadAgreementQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', headAgreement: { __typename?: 'HeadAgreementSearchRoot', byId: { __typename?: 'HeadAgreement', id: string, name: string, statusCode: HeadAgreementStatusCode, headAgreementNumber: number, hasSomeRouteAgreementsWithMultiLeg: boolean, rowVersion: string, valid: { __typename?: 'DateRange', start: { __typename?: 'Date', isoString: string } | null, end: { __typename?: 'Date', isoString: string } | null }, routeAgreements: Array<{ __typename?: 'RouteAgreement', id: string, agreementNumber: number, name: string, statusCode: HeadAgreementStatusCode, isSalesReady: boolean, sailingTypeCodes: Array<SailingTypeCode>, rowVersion: string, hasArticles: boolean, hasConditions: boolean, hasMatrix: boolean, multiLegAgrRouteId: string | null, routeDescription: string, headAgreement: { __typename?: 'HeadAgreement', id: string, headAgreementNumber: number, statusCode: HeadAgreementStatusCode, customer: { __typename?: 'Customer', id: string, name: string } }, currency: { __typename?: 'Currency', id: string, code: string }, valid: { __typename?: 'DateRange', start: { __typename?: 'Date', isoString: string } | null, end: { __typename?: 'Date', isoString: string } | null }, writeHistory: { __typename?: 'WriteHistory', createdAt: { __typename?: 'DateTime', isoString: string }, modifiedAt: { __typename?: 'DateTime', isoString: string } | null }, routes: Array<{ __typename?: 'Route', id: string, routePair: { __typename?: 'RoutePair', id: string, statisticsForCustomerIdAndYear: { __typename?: 'CustomerRoutePairStatistics', averageNegotiationRate: number, averageTargetRate: number | null, expectedVolume: number | null, volumeLast12Months: number, volumeChange: number | null } | null, seaArea: { __typename?: 'SeaArea', id: string, name: string } } }> }>, multiLegAgrRoutes: Array<{ __typename?: 'MultiLegRouteAgreement', id: string, name: string, statusCode: HeadAgreementStatusCode, dateCreated: string, createdBy: string, dateModified: string | null, modifiedBy: string | null, idNumber: number | null, rowVersion: string, workFlowStatusCode: WorkFlowStatusCode | null, headAgreement: { __typename?: 'HeadAgreement', id: string, headAgreementNumber: number, statusCode: HeadAgreementStatusCode, customer: { __typename?: 'Customer', id: string, name: string } }, route: { __typename?: 'Route', id: string, code: string, name: string }, currency: { __typename?: 'Currency', id: string, code: string, name: string, shortDescription: string, longDescription: string }, valid: { __typename?: 'DateRange', start: { __typename?: 'Date', isoString: string } | null, end: { __typename?: 'Date', isoString: string } | null }, routeAgreements: Array<{ __typename?: 'RouteAgreement', id: string, agreementNumber: number, name: string, statusCode: HeadAgreementStatusCode, isSalesReady: boolean, sailingTypeCodes: Array<SailingTypeCode>, rowVersion: string, hasArticles: boolean, hasConditions: boolean, hasMatrix: boolean, multiLegAgrRouteId: string | null, routeDescription: string, headAgreement: { __typename?: 'HeadAgreement', id: string, headAgreementNumber: number, statusCode: HeadAgreementStatusCode, customer: { __typename?: 'Customer', id: string, name: string } }, currency: { __typename?: 'Currency', id: string, code: string }, valid: { __typename?: 'DateRange', start: { __typename?: 'Date', isoString: string } | null, end: { __typename?: 'Date', isoString: string } | null }, writeHistory: { __typename?: 'WriteHistory', createdAt: { __typename?: 'DateTime', isoString: string }, modifiedAt: { __typename?: 'DateTime', isoString: string } | null }, routes: Array<{ __typename?: 'Route', id: string, routePair: { __typename?: 'RoutePair', id: string, statisticsForCustomerIdAndYear: { __typename?: 'CustomerRoutePairStatistics', averageNegotiationRate: number, averageTargetRate: number | null, expectedVolume: number | null, volumeLast12Months: number, volumeChange: number | null } | null, seaArea: { __typename?: 'SeaArea', id: string, name: string } } }> }>, routeLegs: Array<{ __typename?: 'RouteLeg', id: string, legRoute: { __typename?: 'Route', id: string, code: string, name: string }, route: { __typename?: 'Route', id: string, code: string, name: string } }> }> } | null } } };

export type EditHeadAgreementCustomerQueryVariables = Exact<{
  customerId: Scalars['ID']['input'];
  headAgreementId: Scalars['ID']['input'];
}>;


export type EditHeadAgreementCustomerQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', customers: { __typename?: 'CustomerSearchRoot', byId: { __typename?: 'Customer', id: string, name: string, breadCrumbName: string, custIndex: string, custNo: number, isParent: boolean, isStandardCustomer: boolean, hasRebateAgreements: boolean | null, custStatus: { __typename?: 'CustomerStatus', id: string, name: string } | null, parent: { __typename?: 'Customer', id: string, preselectedHeadAgreement: { __typename?: 'HeadAgreement', id: string } | null } | null, childCustomers: Array<{ __typename?: 'Customer', id: string }>, statisticalGrouping: { __typename?: 'Customer', id: string } | null, invoiceCurrency: { __typename?: 'Currency', id: string, code: string }, seller: { __typename?: 'User', id: string, name: string }, salesRegion: { __typename?: 'SalesRegion', id: string, code: string, name: string }, writeHistory: { __typename?: 'WriteHistory', createdAt: { __typename?: 'DateTime', isoString: string }, createdBy: { __typename?: 'User', id: string, name: string }, modifiedAt: { __typename?: 'DateTime', isoString: string } | null, modifiedBy: { __typename?: 'User', id: string, name: string } | null } } | null }, headAgreement: { __typename?: 'HeadAgreementSearchRoot', byId: { __typename?: 'HeadAgreement', id: string, headAgreementNumber: number, breadCrumbName: string } | null } } };

export type HeadAgreementModelLoaderHeadAgreementsFragment = { __typename?: 'HeadAgreement', id: string, rowVersion: string, headAgreementNumber: number, statusCode: HeadAgreementStatusCode, internalComments: string | null, specifications: string | null, condition: string | null, lastPage: string | null, name: string, valid: { __typename?: 'DateRange', start: { __typename?: 'Date', isoString: string } | null, end: { __typename?: 'Date', isoString: string } | null }, routeAgreements: Array<{ __typename?: 'RouteAgreement', id: string, name: string, routeDescription: string, statusCode: HeadAgreementStatusCode, valid: { __typename?: 'DateRange', start: { __typename?: 'Date', isoString: string } | null, end: { __typename?: 'Date', isoString: string } | null }, currency: { __typename?: 'Currency', id: string, code: string } }> };

export type HeadAgreementModelLoaderQueryVariables = Exact<{
  headAgreementId: Scalars['ID']['input'];
}>;


export type HeadAgreementModelLoaderQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', headAgreement: { __typename?: 'HeadAgreementSearchRoot', byId: { __typename?: 'HeadAgreement', id: string, rowVersion: string, headAgreementNumber: number, statusCode: HeadAgreementStatusCode, internalComments: string | null, specifications: string | null, condition: string | null, lastPage: string | null, name: string, valid: { __typename?: 'DateRange', start: { __typename?: 'Date', isoString: string } | null, end: { __typename?: 'Date', isoString: string } | null }, routeAgreements: Array<{ __typename?: 'RouteAgreement', id: string, name: string, routeDescription: string, statusCode: HeadAgreementStatusCode, valid: { __typename?: 'DateRange', start: { __typename?: 'Date', isoString: string } | null, end: { __typename?: 'Date', isoString: string } | null }, currency: { __typename?: 'Currency', id: string, code: string } }> } | null } } };

export type UpdateHeadAgreementMutationVariables = Exact<{
  input: UpdateHeadAgreementInput;
}>;


export type UpdateHeadAgreementMutation = { __typename?: 'Mutation', productPrice: { __typename?: 'ProductPriceMutationRoot', headAgreement: { __typename?: 'HeadAgreementMutationRoot', updateHeadAgreement: { __typename?: 'ErrorResult', errors: Array<{ __typename?: 'ErrorDetail', message: string, path: string | null }> } | { __typename?: 'UpdateHeadAgreementSuccessResult', headAgreement: { __typename?: 'HeadAgreement', id: string, condition: string | null, lastPage: string | null, rowVersion: string, specifications: string | null, internalComments: string | null, name: string, valid: { __typename?: 'DateRange', start: { __typename?: 'Date', isoString: string } | null, end: { __typename?: 'Date', isoString: string } | null } } } } } };

export type AllHeadAgreementsByCustomerFragment = { __typename?: 'HeadAgreement', id: string, name: string, statusCode: HeadAgreementStatusCode, headAgreementNumber: number, valid: { __typename?: 'DateRange', start: { __typename?: 'Date', isoString: string } | null, end: { __typename?: 'Date', isoString: string } | null } };

export type HeadAgreementsByCustomerQueryVariables = Exact<{
  customerId: Scalars['ID']['input'];
}>;


export type HeadAgreementsByCustomerQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', customers: { __typename?: 'CustomerSearchRoot', byId: { __typename?: 'Customer', id: string, allHeadAgreements: Array<{ __typename?: 'HeadAgreement', id: string, name: string, statusCode: HeadAgreementStatusCode, headAgreementNumber: number, valid: { __typename?: 'DateRange', start: { __typename?: 'Date', isoString: string } | null, end: { __typename?: 'Date', isoString: string } | null } }> } | null } } };

export type DeleteRebateAgreementDocumenteMutationVariables = Exact<{
  documentId: Scalars['ID']['input'];
  customerNumber: Scalars['Int']['input'];
}>;


export type DeleteRebateAgreementDocumenteMutation = { __typename?: 'Mutation', productPrice: { __typename?: 'ProductPriceMutationRoot', agreementDocuments: { __typename?: 'AgreementDocumentMutationRoot', deleteRebateAgreementDocument: { __typename: 'DeleteAgreementDocumentErrorResult', errors: Array<{ __typename?: 'ErrorDetail', message: string, path: string | null }> } | { __typename: 'DeleteAgreementDocumentSuccessResult', success: boolean } } } };

export type AgreedVolumePerformanceFragment = { __typename?: 'AgreedVolumePerformance', routePairCode: string, agreedVolume: number, shippedVolume: number, performanceInPercent: number };

export type CustomerAgreedVolumePerformanceByYearQueryVariables = Exact<{
  customerNumber: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
}>;


export type CustomerAgreedVolumePerformanceByYearQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', customerStatistics: { __typename?: 'CustomerStatisticsSearchRoot', agreedVolumePerformance: { __typename?: 'AgreedVolumePerformanceResult', performanceByRouteCode: Array<{ __typename?: 'AgreedVolumePerformance', routePairCode: string, agreedVolume: number, shippedVolume: number, performanceInPercent: number }> } } } };

export type CustomerThreeYearsStatisticsQueryVariables = Exact<{
  customerNumber: Scalars['Int']['input'];
  currencyCode: Scalars['String']['input'];
  year: Scalars['Int']['input'];
}>;


export type CustomerThreeYearsStatisticsQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', customerStatistics: { __typename?: 'CustomerStatisticsSearchRoot', customerThreeYearsStatistics: Array<{ __typename?: 'CustomerThreeYearsStatistics', actualRate: number, customerNumber: number, diffPreviousYear: number | null, expectedVolume: number, id: string, last12MonthsVolume: number, negotiationStatus: string | null, pricePerMeter: number, targetRate: number, year: number }> } } };

export type AllMultiLegForMultiLegEditQueryVariables = Exact<{ [key: string]: never; }>;


export type AllMultiLegForMultiLegEditQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', route: { __typename?: 'RouteSearchRoot', allMultiLeg: Array<{ __typename?: 'Route', id: string, name: string, code: string }> } } };

export type CreateMultiLegAgreementMutationVariables = Exact<{
  createMultiLegRouteAgreementInput: CreateMultiLegRouteAgreementInput;
}>;


export type CreateMultiLegAgreementMutation = { __typename?: 'Mutation', productPrice: { __typename?: 'ProductPriceMutationRoot', multiLegRouteAgreement: { __typename?: 'MultiLegRouteAgreementMutationRoot', createMultiLegRouteAgreement: { __typename?: 'CreateMultiLegRouteAgreementSuccessResult', multiLegRouteAgreement: { __typename?: 'MultiLegRouteAgreement', id: string, headAgreement: { __typename?: 'HeadAgreement', id: string }, routeAgreements: Array<{ __typename?: 'RouteAgreement', id: string, routes: Array<{ __typename?: 'Route', routePair: { __typename?: 'RoutePair', id: string } }> }> } } | { __typename?: 'ErrorResult', errors: Array<{ __typename?: 'ErrorDetail', message: string, path: string | null }> } } } };

export type CreateMultiLegRouteAgreementRouteMutationVariables = Exact<{
  createMultiLegRouteAgreementRouteInput: CreateMultiLegRouteAgreementRouteInput;
}>;


export type CreateMultiLegRouteAgreementRouteMutation = { __typename?: 'Mutation', productPrice: { __typename?: 'ProductPriceMutationRoot', multiLegRouteAgreement: { __typename?: 'MultiLegRouteAgreementMutationRoot', createMultiLegRouteAgreementRoute: { __typename?: 'CreateMultiLegRouteAgreementRouteSuccessResult', routeAgreement: { __typename?: 'RouteAgreement', id: string, agreementNumber: number, name: string, breadCrumbName: string, typeCode: RouteAgreementTypeCode, sailingTypeCodes: Array<SailingTypeCode>, isSalesReady: boolean, routeDescription: string, hasArticles: boolean, hasConditions: boolean, hasMatrix: boolean, note: string | null, comment: string | null, multiLegAgrRouteId: string | null, externalComment: string | null, rowVersion: string, routes: Array<{ __typename?: 'Route', id: string, code: string, name: string, routePair: { __typename?: 'RoutePair', id: string } }>, currency: { __typename?: 'Currency', id: string, code: string, name: string }, valid: { __typename?: 'DateRange', start: { __typename?: 'Date', isoString: string } | null, end: { __typename?: 'Date', isoString: string } | null } }, headAgreement: { __typename?: 'HeadAgreement', id: string, name: string, statusCode: HeadAgreementStatusCode, valid: { __typename?: 'DateRange', start: { __typename?: 'Date', isoString: string } | null, end: { __typename?: 'Date', isoString: string } | null } } } | { __typename?: 'ErrorResult', errors: Array<{ __typename?: 'ErrorDetail', message: string, path: string | null }> } } } };

export type EditMultiLegRouteAgreementMutationVariables = Exact<{
  updateMultiLegRouteAgreementInput: UpdateMultiLegRouteAgreementInput;
}>;


export type EditMultiLegRouteAgreementMutation = { __typename?: 'Mutation', productPrice: { __typename?: 'ProductPriceMutationRoot', multiLegRouteAgreement: { __typename?: 'MultiLegRouteAgreementMutationRoot', updateMultiLegRouteAgreement: { __typename?: 'ErrorResult', errors: Array<{ __typename?: 'ErrorDetail', message: string, path: string | null }> } | { __typename?: 'UpdateMultiLegRouteAgreementSuccessResult', multiLegAgreement: { __typename?: 'MultiLegRouteAgreement', id: string, name: string, dateCreated: string, createdBy: string, dateModified: string | null, modifiedBy: string | null, idNumber: number | null, rowVersion: string, workFlowStatusCode: WorkFlowStatusCode | null, statusCode: HeadAgreementStatusCode, headAgreement: { __typename?: 'HeadAgreement', id: string }, route: { __typename?: 'Route', code: string, name: string, id: string, routeLegs: Array<{ __typename?: 'RouteLeg', id: string, legNo: number, route: { __typename?: 'Route', id: string, code: string, name: string } }> }, currency: { __typename?: 'Currency', id: string, code: string, name: string, shortDescription: string, longDescription: string }, valid: { __typename?: 'DateRange', start: { __typename?: 'Date', isoString: string } | null, end: { __typename?: 'Date', isoString: string } | null }, routeAgreements: Array<{ __typename?: 'RouteAgreement', id: string }> } } } } };

export type CreateMultiLegAgreementFetcherQueryVariables = Exact<{
  headAgreementId: Scalars['ID']['input'];
}>;


export type CreateMultiLegAgreementFetcherQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', headAgreement: { __typename?: 'HeadAgreementSearchRoot', byId: { __typename?: 'HeadAgreement', id: string, valid: { __typename?: 'DateRange', start: { __typename?: 'Date', isoString: string } | null, end: { __typename?: 'Date', isoString: string } | null } } | null } } };

export type CustomerIndexQueryVariables = Exact<{
  customerId: Scalars['ID']['input'];
  headAgreementId: Scalars['ID']['input'];
}>;


export type CustomerIndexQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', customers: { __typename?: 'CustomerSearchRoot', byId: { __typename?: 'Customer', id: string, custIndex: string, name: string, custNo: number, hasRebateAgreements: boolean | null, isParent: boolean, invoiceCurrency: { __typename?: 'Currency', id: string, code: string }, salesRegion: { __typename?: 'SalesRegion', id: string, name: string }, statisticalGrouping: { __typename?: 'Customer', id: string } | null, seller: { __typename?: 'User', id: string, name: string }, custStatus: { __typename?: 'CustomerStatus', id: string, name: string } | null, parent: { __typename?: 'Customer', id: string } | null, childCustomers: Array<{ __typename?: 'Customer', id: string, name: string }> } | null }, headAgreement: { __typename?: 'HeadAgreementSearchRoot', byId: { __typename?: 'HeadAgreement', id: string, statusCode: HeadAgreementStatusCode, name: string, headAgreementNumber: number, breadCrumbName: string, hasSomeRouteAgreementsWithMultiLeg: boolean, rowVersion: string, valid: { __typename?: 'DateRange', start: { __typename?: 'Date', isoString: string } | null, end: { __typename?: 'Date', isoString: string } | null }, writeHistory: { __typename?: 'WriteHistory', createdAt: { __typename?: 'DateTime', isoString: string }, createdBy: { __typename?: 'User', id: string, name: string }, modifiedAt: { __typename?: 'DateTime', isoString: string } | null, modifiedBy: { __typename?: 'User', id: string, name: string } | null } } | null } } };

export type RefetchDataForBulkEditStatBoxesQueryVariables = Exact<{
  input: CalculateActualPriceChangeForAllBulkEditRatesInput;
}>;


export type RefetchDataForBulkEditStatBoxesQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', customerRouteStatistics: { __typename?: 'CustomerRouteStatisticsSearchRoot', calculateActualPriceChangeForAllBulkEditRates: Array<{ __typename?: 'CustomerStatisticsEntry', actualOutcomeInPercent: number | null, expectedVolume: number | null, id: string, sailingCategoryCode: SailingTypeCode, statVolume12Months: number | null, expectedStatVolume: number | null, targetInPercent: number | null, unitCategoryCode: UnitCategoryCode, volume12Months: number, routePairCode: string | null }> } } };

export type RouteAgreementForRouteAgreementPriceFragment = { __typename?: 'RouteAgreement', id: string, agreementNumber: number, name: string, isSalesReady: boolean, rowVersion: string, sailingTypeCodes: Array<SailingTypeCode>, statusCode: HeadAgreementStatusCode, routeDescription: string, routes: Array<{ __typename?: 'Route', id: string, routePair: { __typename?: 'RoutePair', id: string, code: string, description: string } }>, valid: { __typename?: 'DateRange', start: { __typename?: 'Date', isoString: string } | null, end: { __typename?: 'Date', isoString: string } | null }, currency: { __typename?: 'Currency', id: string, code: string }, prices: Array<{ __typename?: 'RouteAgreementPrice', avgRebate: { __typename?: 'Price', amount: string } | null }> };

export type VehicleTypeForAgrRoutePricesFragment = { __typename?: 'VehicleType', id: string, code: string, name: string, shortDescription: string, accompanied: boolean };

export type ItemByRoutePairCodesForCustomersFragment = { __typename?: 'CustomerStatisticsEntry', id: string, expectedVolume: number | null, statVolume12Months: number | null, unitCategoryCode: UnitCategoryCode, expectedStatVolume: number | null, routePairCode: string | null, volume12Months: number, actualOutcomeInPercent: number | null, targetInPercent: number | null, sailingCategoryCode: SailingTypeCode };

export type AgreementRoutePricesFragment = { __typename?: 'RouteAgreementPrice', id: string, lengthFrom: number | null, lengthTo: number | null, weightFrom: number | null, weightTo: number | null, cargoStatusCode: CargoStatusCode, unaccompanied: boolean | null, avgLength: number | null, lastChargedFrom: number | null, volume: number | null, additionalFrom: number | null, actual: number | null, vehicleType: { __typename?: 'VehicleType', id: string, code: string, name: string, shortDescription: string, accompanied: boolean } | null, avgGrossPrice: { __typename?: 'Price', amount: string } | null, lastPrice: { __typename?: 'Price', amount: string } | null, meterPrice: { __typename?: 'Price', amount: string }, newPrice: { __typename?: 'Price', amount: string }, lastMeterPrice: { __typename?: 'Price', amount: string } | null, avgRebate: { __typename?: 'Price', amount: string } | null, routeAgreement: { __typename?: 'RouteAgreement', id: string, agreementNumber: number, name: string, isSalesReady: boolean, rowVersion: string, sailingTypeCodes: Array<SailingTypeCode>, statusCode: HeadAgreementStatusCode, routeDescription: string, routes: Array<{ __typename?: 'Route', id: string, routePair: { __typename?: 'RoutePair', id: string, code: string, description: string } }>, valid: { __typename?: 'DateRange', start: { __typename?: 'Date', isoString: string } | null, end: { __typename?: 'Date', isoString: string } | null }, currency: { __typename?: 'Currency', id: string, code: string }, prices: Array<{ __typename?: 'RouteAgreementPrice', avgRebate: { __typename?: 'Price', amount: string } | null }> } };

export type RouteAgreementsRatesByFilterQueryVariables = Exact<{
  byFilterInput: RouteAgreementPricesByFilterInput;
  routePairCodes: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  year: Scalars['Int']['input'];
  customerId: Scalars['ID']['input'];
}>;


export type RouteAgreementsRatesByFilterQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', customers: { __typename?: 'CustomerSearchRoot', byId: { __typename?: 'Customer', id: string, statisticsByRoutePairCodes: { __typename?: 'CustomerStatisticsResult', itemsByRoutePairCodes: Array<{ __typename?: 'CustomerStatisticsEntry', id: string, expectedVolume: number | null, statVolume12Months: number | null, unitCategoryCode: UnitCategoryCode, expectedStatVolume: number | null, routePairCode: string | null, volume12Months: number, actualOutcomeInPercent: number | null, targetInPercent: number | null, sailingCategoryCode: SailingTypeCode }> } } | null }, routeAgreementPrice: { __typename?: 'RouteAgreementPriceSearchRoot', byFilter: { __typename?: 'RouteAgreementPriceByFilterResult', numberOfAgrRouteRates: number, agrRoutePrices: Array<{ __typename?: 'RouteAgreementPrice', id: string, lengthFrom: number | null, lengthTo: number | null, weightFrom: number | null, weightTo: number | null, cargoStatusCode: CargoStatusCode, unaccompanied: boolean | null, avgLength: number | null, lastChargedFrom: number | null, volume: number | null, additionalFrom: number | null, actual: number | null, vehicleType: { __typename?: 'VehicleType', id: string, code: string, name: string, shortDescription: string, accompanied: boolean } | null, avgGrossPrice: { __typename?: 'Price', amount: string } | null, lastPrice: { __typename?: 'Price', amount: string } | null, meterPrice: { __typename?: 'Price', amount: string }, newPrice: { __typename?: 'Price', amount: string }, lastMeterPrice: { __typename?: 'Price', amount: string } | null, avgRebate: { __typename?: 'Price', amount: string } | null, routeAgreement: { __typename?: 'RouteAgreement', id: string, agreementNumber: number, name: string, isSalesReady: boolean, rowVersion: string, sailingTypeCodes: Array<SailingTypeCode>, statusCode: HeadAgreementStatusCode, routeDescription: string, routes: Array<{ __typename?: 'Route', id: string, routePair: { __typename?: 'RoutePair', id: string, code: string, description: string } }>, valid: { __typename?: 'DateRange', start: { __typename?: 'Date', isoString: string } | null, end: { __typename?: 'Date', isoString: string } | null }, currency: { __typename?: 'Currency', id: string, code: string }, prices: Array<{ __typename?: 'RouteAgreementPrice', avgRebate: { __typename?: 'Price', amount: string } | null }> } }> | null } } } };

export type AllVehiclesFragment = { __typename?: 'VehicleType', id: string, code: string, name: string, shortDescription: string, accompanied: boolean };

export type RateSheetTableQueryVariables = Exact<{ [key: string]: never; }>;


export type RateSheetTableQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', vehicleType: { __typename?: 'VehicleTypeSearchRoot', all: Array<{ __typename?: 'VehicleType', id: string, code: string, name: string, shortDescription: string, accompanied: boolean }> } } };

export type RateEditPanelQueryVariables = Exact<{
  routeAgreementId: Scalars['ID']['input'];
}>;


export type RateEditPanelQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', vehicleType: { __typename?: 'VehicleTypeSearchRoot', all: Array<{ __typename?: 'VehicleType', id: string, code: string, name: string, shortDescription: string, accompanied: boolean }> }, routeAgreement: { __typename?: 'RouteAgreementSearchRoot', byId: { __typename?: 'RouteAgreement', id: string, sailingTypeCodes: Array<SailingTypeCode>, valid: { __typename?: 'DateRange', start: { __typename?: 'Date', isoString: string } | null }, routes: Array<{ __typename?: 'Route', id: string, code: string }>, currency: { __typename?: 'Currency', id: string, code: string }, headAgreement: { __typename?: 'HeadAgreement', id: string, customer: { __typename?: 'Customer', id: string } } } | null } } };

export type ActualChangeForPriceRowQueryVariables = Exact<{
  meterPrice: Scalars['Float']['input'];
  newPrice: Scalars['Float']['input'];
  additionalFrom: Scalars['Float']['input'];
  avgGrossPrice: InputMaybe<Scalars['Float']['input']>;
  avgLength: InputMaybe<Scalars['Float']['input']>;
  oldAdditionalFrom: InputMaybe<Scalars['Float']['input']>;
  oldFixPrice: InputMaybe<Scalars['Float']['input']>;
  oldVarPrice: InputMaybe<Scalars['Float']['input']>;
}>;


export type ActualChangeForPriceRowQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', actualPriceChange: { __typename?: 'ActualPriceChangeSearchRoot', calculateActualPriceChange: number | null } } };

export type FetchAndPopulateRouteAgreementPriceStatisticsQueryVariables = Exact<{
  input: RouteAgreementPriceCalculateStatisticsInput;
}>;


export type FetchAndPopulateRouteAgreementPriceStatisticsQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', routeAgreementPrice: { __typename?: 'RouteAgreementPriceSearchRoot', calculateStatistics: { __typename?: 'RouteAgreementPriceCalculateStatisticsResult', routeAgreementPriceId: string, avgLength: number, volume: number, avgGrossPrice: { __typename?: 'Price', amount: string }, avgRebate: { __typename?: 'Price', amount: string } } } } };

export type RecalcPriceStatsForMultipleRouteAgreementsQueryVariables = Exact<{
  input: RouteAgreementPriceCalculateStatisticsInput;
}>;


export type RecalcPriceStatsForMultipleRouteAgreementsQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', routeAgreementPrice: { __typename?: 'RouteAgreementPriceSearchRoot', calculateStatistics: { __typename?: 'RouteAgreementPriceCalculateStatisticsResult', routeAgreementPriceId: string, avgLength: number, volume: number, avgGrossPrice: { __typename?: 'Price', amount: string }, avgRebate: { __typename?: 'Price', amount: string } } } } };

export type RouteAgreementForRecalcStatsQueryVariables = Exact<{
  routeAgreementId: Scalars['ID']['input'];
}>;


export type RouteAgreementForRecalcStatsQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', routeAgreement: { __typename?: 'RouteAgreementSearchRoot', byId: { __typename?: 'RouteAgreement', id: string, sailingTypeCodes: Array<SailingTypeCode>, valid: { __typename?: 'DateRange', start: { __typename?: 'Date', isoString: string } | null, end: { __typename?: 'Date', isoString: string } | null }, currency: { __typename?: 'Currency', id: string }, routes: Array<{ __typename?: 'Route', id: string, code: string }> } | null } } };

export type RecalcStatsForSingleRouteAgreementPriceQueryVariables = Exact<{
  input: RouteAgreementPriceCalculateStatisticsInput;
}>;


export type RecalcStatsForSingleRouteAgreementPriceQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', routeAgreementPrice: { __typename?: 'RouteAgreementPriceSearchRoot', calculateStatistics: { __typename?: 'RouteAgreementPriceCalculateStatisticsResult', routeAgreementPriceId: string, avgLength: number, volume: number, avgGrossPrice: { __typename?: 'Price', amount: string }, avgRebate: { __typename?: 'Price', amount: string } } } } };

export type AuthorizePaymentMutationVariables = Exact<{
  goalId: Scalars['ID']['input'];
}>;


export type AuthorizePaymentMutation = { __typename?: 'Mutation', productPrice: { __typename?: 'ProductPriceMutationRoot', rebate: { __typename?: 'RebateMutationRoot', authorizePayment: boolean } } };

export type HandleRebateMutationVariables = Exact<{
  input: HandleRebateInput;
}>;


export type HandleRebateMutation = { __typename?: 'Mutation', productPrice: { __typename?: 'ProductPriceMutationRoot', rebate: { __typename?: 'RebateMutationRoot', handleRebate: boolean } } };

export type RebateOverviewFetcherQueryVariables = Exact<{
  filter: RebateOverviewFilter;
}>;


export type RebateOverviewFetcherQuery = { __typename?: 'Query', rebates: { __typename?: 'RebateSearchRoot', rebateOverview: Array<{ __typename?: 'RebateOverview', rebateAgreementId: string, criteriaIds: Array<string>, goalIds: Array<string>, period: number, displayedTarget: string, achieved: number, rebateTermCode: string, reservedAmount: number, creditNoteBookingNumbers: Array<number>, sellerIds: Array<string>, rebateAgreement: { __typename?: 'RebateAgreement', name: string | null, rebateAgreementNumber: number | null, currencyCode: string | null } | null, criterias: Array<{ __typename?: 'Criteria', id: string, name: string | null, description: string | null, rebateModelCode: string | null }>, customers: Array<{ __typename?: 'Customer', custIndex: string }>, goals: Array<{ __typename?: 'Goal', id: string, criteriaId: string, validFrom: string, validTo: string, period: number, year: number, statusCode: string, amountPaid: number | null, datePaid: string | null, rebateRate: number, expectedVolume: number, targetValue: number, amountReversed: number | null, authorizedBy: string | null }> }> } };

export type RebateProgressFetcherQueryVariables = Exact<{
  filter: RebateProgressFilter;
}>;


export type RebateProgressFetcherQuery = { __typename?: 'Query', rebates: { __typename?: 'RebateSearchRoot', rebateProgress: Array<{ __typename?: 'RebateProgress', goalId: string, period: number, displayedTarget: string, usedTarget: number, expectedVolume: number | null, suggestedExpectedVolume: number, achieved: number, completionPercent: number, rebateAgreement: { __typename?: 'RebateAgreement', name: string | null, rebateAgreementNumber: number | null } | null, criteria: { __typename?: 'Criteria', name: string | null, description: string | null, rebateModelCode: string | null } | null, goal: { __typename?: 'Goal', period: number, rebateTermCode: string, validFrom: string, validTo: string } | null }> } };

export type UpdateGoalExpectedVolumeMutationVariables = Exact<{
  input: SetExpectedVolumeInput;
}>;


export type UpdateGoalExpectedVolumeMutation = { __typename?: 'Mutation', productPrice: { __typename?: 'ProductPriceMutationRoot', rebate: { __typename?: 'RebateMutationRoot', setExpectedVolume: boolean } } };

export type FormulaFormInputsIncludesFragment = { __typename?: 'FormulaTypeIncludes', drivers: boolean | null, interval1PercentValue: boolean | null, interval2PercentValue: boolean | null, interval3PercentValue: boolean | null, interval4PercentValue: boolean | null, intervalAPercentValue: boolean | null, intervalBPercentValue: boolean | null, intervalCPercentValue: boolean | null, intervalDPercentValue: boolean | null, intervalLength: boolean | null, maxPercent: boolean | null, percent: boolean | null, weight: boolean | null, width: boolean | null };

export type FormulaByIdFragment = { __typename?: 'FormulaType', code: string, id: string, description: Array<string>, includes: { __typename?: 'FormulaTypeIncludes', drivers: boolean | null, interval1PercentValue: boolean | null, interval2PercentValue: boolean | null, interval3PercentValue: boolean | null, interval4PercentValue: boolean | null, intervalAPercentValue: boolean | null, intervalBPercentValue: boolean | null, intervalCPercentValue: boolean | null, intervalDPercentValue: boolean | null, intervalLength: boolean | null, maxPercent: boolean | null, percent: boolean | null, weight: boolean | null, width: boolean | null } };

export type FormulaFormInputsQueryVariables = Exact<{
  formulaTypeId: Scalars['ID']['input'];
}>;


export type FormulaFormInputsQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', formula: { __typename?: 'FormulaSearchRoot', byId: { __typename?: 'FormulaType', code: string, id: string, description: Array<string>, includes: { __typename?: 'FormulaTypeIncludes', drivers: boolean | null, interval1PercentValue: boolean | null, interval2PercentValue: boolean | null, interval3PercentValue: boolean | null, interval4PercentValue: boolean | null, intervalAPercentValue: boolean | null, intervalBPercentValue: boolean | null, intervalCPercentValue: boolean | null, intervalDPercentValue: boolean | null, intervalLength: boolean | null, maxPercent: boolean | null, percent: boolean | null, weight: boolean | null, width: boolean | null } } | null } } };

export type AllArticleTypesFragment = { __typename?: 'ArticleType', id: string, code: string, name: string, needsPricingData: boolean, usesPercent: boolean };

export type ArticleTypesMultiSelectQueryVariables = Exact<{ [key: string]: never; }>;


export type ArticleTypesMultiSelectQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', articleType: { __typename?: 'ArticleTypeSearchRoot', all: Array<{ __typename?: 'ArticleType', id: string, code: string, name: string, needsPricingData: boolean, usesPercent: boolean }> } } };

export type CreateRouteAgreementFetcherQueryVariables = Exact<{
  headAgreementId: Scalars['ID']['input'];
}>;


export type CreateRouteAgreementFetcherQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', headAgreement: { __typename?: 'HeadAgreementSearchRoot', byId: { __typename?: 'HeadAgreement', id: string, valid: { __typename?: 'DateRange', start: { __typename?: 'Date', isoString: string } | null, end: { __typename?: 'Date', isoString: string } | null } } | null } } };

export type MatrixListItemMatricesFragment = { __typename?: 'Matrix', id: string, keywords: Array<string>, validityKey: string, timeslots: Array<{ __typename?: 'MatrixTimeslot', timeFrom: string, timeTo: string, weekDay: string }> };

export type MatrixListItemFetcherQueryVariables = Exact<{
  matrixId: Scalars['ID']['input'];
}>;


export type MatrixListItemFetcherQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', matrices: { __typename?: 'MatrixSearchRoot', byId: { __typename?: 'Matrix', id: string, keywords: Array<string>, validityKey: string, timeslots: Array<{ __typename?: 'MatrixTimeslot', timeFrom: string, timeTo: string, weekDay: string }> } | null } } };

export type RouteAgreementHeaderRouteAgreementFragment = { __typename?: 'RouteAgreement', id: string, statusCode: HeadAgreementStatusCode, agreementNumber: number, rowVersion: string, hasArticles: boolean, hasConditions: boolean, externalComment: string | null, note: string | null, comment: string | null, hasMatrix: boolean, name: string, routeDescription: string, sailingTypeCodes: Array<SailingTypeCode>, writeHistory: { __typename?: 'WriteHistory', createdAt: { __typename?: 'DateTime', isoString: string }, createdBy: { __typename?: 'User', id: string, name: string }, modifiedAt: { __typename?: 'DateTime', isoString: string } | null, modifiedBy: { __typename?: 'User', id: string, name: string } | null }, valid: { __typename?: 'DateRange', start: { __typename?: 'Date', isoString: string } | null, end: { __typename?: 'Date', isoString: string } | null }, currency: { __typename?: 'Currency', id: string, code: string }, headAgreement: { __typename?: 'HeadAgreement', headAgreementNumber: number, id: string, name: string, breadCrumbName: string } };

export type RouteAgreementHeaderQueryVariables = Exact<{
  routeAgreementId: Scalars['ID']['input'];
  headAgreementId: Scalars['ID']['input'];
}>;


export type RouteAgreementHeaderQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', routeAgreement: { __typename?: 'RouteAgreementSearchRoot', byId: { __typename?: 'RouteAgreement', id: string, statusCode: HeadAgreementStatusCode, agreementNumber: number, rowVersion: string, hasArticles: boolean, hasConditions: boolean, externalComment: string | null, note: string | null, comment: string | null, hasMatrix: boolean, name: string, routeDescription: string, sailingTypeCodes: Array<SailingTypeCode>, writeHistory: { __typename?: 'WriteHistory', createdAt: { __typename?: 'DateTime', isoString: string }, createdBy: { __typename?: 'User', id: string, name: string }, modifiedAt: { __typename?: 'DateTime', isoString: string } | null, modifiedBy: { __typename?: 'User', id: string, name: string } | null }, valid: { __typename?: 'DateRange', start: { __typename?: 'Date', isoString: string } | null, end: { __typename?: 'Date', isoString: string } | null }, currency: { __typename?: 'Currency', id: string, code: string }, headAgreement: { __typename?: 'HeadAgreement', headAgreementNumber: number, id: string, name: string, breadCrumbName: string } } | null }, headAgreement: { __typename?: 'HeadAgreementSearchRoot', byId: { __typename?: 'HeadAgreement', id: string, statusCode: HeadAgreementStatusCode, name: string, headAgreementNumber: number, breadCrumbName: string, hasSomeRouteAgreementsWithMultiLeg: boolean, rowVersion: string, valid: { __typename?: 'DateRange', start: { __typename?: 'Date', isoString: string } | null, end: { __typename?: 'Date', isoString: string } | null }, writeHistory: { __typename?: 'WriteHistory', createdAt: { __typename?: 'DateTime', isoString: string }, createdBy: { __typename?: 'User', id: string, name: string }, modifiedAt: { __typename?: 'DateTime', isoString: string } | null, modifiedBy: { __typename?: 'User', id: string, name: string } | null } } | null } } };

export type RouteAgreementDetailsHeaderQueryVariables = Exact<{
  routeAgreementId: Scalars['ID']['input'];
}>;


export type RouteAgreementDetailsHeaderQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', routeAgreement: { __typename?: 'RouteAgreementSearchRoot', byId: { __typename?: 'RouteAgreement', id: string, statusCode: HeadAgreementStatusCode, agreementNumber: number, rowVersion: string, hasArticles: boolean, hasConditions: boolean, externalComment: string | null, note: string | null, comment: string | null, hasMatrix: boolean, name: string, routeDescription: string, sailingTypeCodes: Array<SailingTypeCode>, valid: { __typename?: 'DateRange', start: { __typename?: 'Date', isoString: string } | null, end: { __typename?: 'Date', isoString: string } | null }, writeHistory: { __typename?: 'WriteHistory', createdAt: { __typename?: 'DateTime', isoString: string }, createdBy: { __typename?: 'User', id: string, name: string }, modifiedAt: { __typename?: 'DateTime', isoString: string } | null, modifiedBy: { __typename?: 'User', id: string, name: string } | null }, currency: { __typename?: 'Currency', id: string, code: string }, headAgreement: { __typename?: 'HeadAgreement', headAgreementNumber: number, id: string, name: string, breadCrumbName: string } } | null } } };

export type RouteAgreementPageRouteAgreementFragment = { __typename?: 'RouteAgreement', id: string, statusCode: HeadAgreementStatusCode, agreementNumber: number, rowVersion: string, hasArticles: boolean, hasConditions: boolean, externalComment: string | null, note: string | null, comment: string | null, hasMatrix: boolean, name: string, routeDescription: string, sailingTypeCodes: Array<SailingTypeCode>, valid: { __typename?: 'DateRange', start: { __typename?: 'Date', isoString: string } | null, end: { __typename?: 'Date', isoString: string } | null }, writeHistory: { __typename?: 'WriteHistory', createdAt: { __typename?: 'DateTime', isoString: string }, createdBy: { __typename?: 'User', id: string, name: string }, modifiedAt: { __typename?: 'DateTime', isoString: string } | null, modifiedBy: { __typename?: 'User', id: string, name: string } | null }, currency: { __typename?: 'Currency', id: string, code: string }, headAgreement: { __typename?: 'HeadAgreement', headAgreementNumber: number, id: string, name: string, breadCrumbName: string } };

export type RateSheetTablePricesFragment = { __typename?: 'RouteAgreementPrice', id: string, volume: number | null, lengthFrom: number | null, lengthTo: number | null, weightFrom: number | null, weightTo: number | null, unaccompanied: boolean | null, lastChargedFrom: number | null, cargoStatusCode: CargoStatusCode, avgLength: number | null, additionalFrom: number | null, actual: number | null, avgGrossPrice: { __typename?: 'Price', amount: string } | null, avgNetPrice: { __typename?: 'Price', amount: string } | null, avgRebate: { __typename?: 'Price', amount: string } | null, vehicleType: { __typename?: 'VehicleType', id: string, name: string, shortDescription: string, accompanied: boolean, code: string } | null, lastPrice: { __typename?: 'Price', amount: string } | null, lastMeterPrice: { __typename?: 'Price', amount: string } | null, newPrice: { __typename?: 'Price', amount: string }, meterPrice: { __typename?: 'Price', amount: string } };

export type CustomerRouteRouteAgreementFragment = { __typename?: 'RouteAgreement', id: string, name: string, agreementNumber: number, routeDescription: string, sailingTypeCodes: Array<SailingTypeCode>, externalDescription: string | null, multiLegAgrRouteId: string | null, isSalesReady: boolean, typeCode: RouteAgreementTypeCode, statusCode: HeadAgreementStatusCode, rowVersion: string, hasConditions: boolean, currency: { __typename?: 'Currency', id: string, code: string }, valid: { __typename?: 'DateRange', start: { __typename?: 'Date', isoString: string } | null, end: { __typename?: 'Date', isoString: string } | null }, prices: Array<{ __typename?: 'RouteAgreementPrice', id: string, volume: number | null, lengthFrom: number | null, lengthTo: number | null, weightFrom: number | null, weightTo: number | null, unaccompanied: boolean | null, lastChargedFrom: number | null, cargoStatusCode: CargoStatusCode, avgLength: number | null, additionalFrom: number | null, actual: number | null, avgGrossPrice: { __typename?: 'Price', amount: string } | null, avgNetPrice: { __typename?: 'Price', amount: string } | null, avgRebate: { __typename?: 'Price', amount: string } | null, vehicleType: { __typename?: 'VehicleType', id: string, name: string, shortDescription: string, accompanied: boolean, code: string } | null, lastPrice: { __typename?: 'Price', amount: string } | null, lastMeterPrice: { __typename?: 'Price', amount: string } | null, newPrice: { __typename?: 'Price', amount: string }, meterPrice: { __typename?: 'Price', amount: string } }>, routes: Array<{ __typename?: 'Route', id: string, code: string, routeType: string, routePair: { __typename?: 'RoutePair', id: string, code: string, description: string } }> };

export type CanCustomerChangeRouteAgreementTypeQueryVariables = Exact<{
  customerId: Scalars['ID']['input'];
}>;


export type CanCustomerChangeRouteAgreementTypeQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', customers: { __typename?: 'CustomerSearchRoot', byId: { __typename?: 'Customer', id: string, canChangeRouteAgreementType: boolean, defaultRouteAgreementType: RouteAgreementTypeCode, isStandardCustomer: boolean } | null } } };

export type CreateRouteAgreementMutationVariables = Exact<{
  input: CreateRouteAgreementInput;
}>;


export type CreateRouteAgreementMutation = { __typename?: 'Mutation', productPrice: { __typename?: 'ProductPriceMutationRoot', routeAgreement: { __typename?: 'RouteAgreementMutationRoot', createRouteAgreement: { __typename?: 'CreateRouteAgreementSuccessResult', routeAgreement: { __typename?: 'RouteAgreement', id: string, routes: Array<{ __typename?: 'Route', id: string, routePair: { __typename?: 'RoutePair', id: string } }> }, headAgreement: { __typename?: 'HeadAgreement', id: string } } | { __typename?: 'ErrorResult', errors: Array<{ __typename?: 'ErrorDetail', message: string, path: string | null }> } } } };

export type UpdateMultiLegRouteAgreementMutationVariables = Exact<{
  input: UpdateRouteAgreementInput;
}>;


export type UpdateMultiLegRouteAgreementMutation = { __typename?: 'Mutation', productPrice: { __typename?: 'ProductPriceMutationRoot', routeAgreement: { __typename?: 'RouteAgreementMutationRoot', updateRouteAgreementConnectedToMultiLeg: { __typename: 'ErrorResult', errors: Array<{ __typename?: 'ErrorDetail', message: string, path: string | null }> } | { __typename: 'UpdateRouteAgreementSuccessResult', routeAgreement: { __typename?: 'RouteAgreement', id: string, statusCode: HeadAgreementStatusCode, agreementNumber: number, rowVersion: string, hasArticles: boolean, hasConditions: boolean, externalComment: string | null, note: string | null, comment: string | null, hasMatrix: boolean, name: string, routeDescription: string, sailingTypeCodes: Array<SailingTypeCode>, valid: { __typename?: 'DateRange', start: { __typename?: 'Date', isoString: string } | null, end: { __typename?: 'Date', isoString: string } | null }, prices: Array<{ __typename?: 'RouteAgreementPrice', id: string, volume: number | null, lengthFrom: number | null, lengthTo: number | null, weightFrom: number | null, weightTo: number | null, unaccompanied: boolean | null, lastChargedFrom: number | null, cargoStatusCode: CargoStatusCode, avgLength: number | null, additionalFrom: number | null, actual: number | null, avgGrossPrice: { __typename?: 'Price', amount: string } | null, avgNetPrice: { __typename?: 'Price', amount: string } | null, avgRebate: { __typename?: 'Price', amount: string } | null, vehicleType: { __typename?: 'VehicleType', id: string, name: string, shortDescription: string, accompanied: boolean, code: string } | null, lastPrice: { __typename?: 'Price', amount: string } | null, lastMeterPrice: { __typename?: 'Price', amount: string } | null, newPrice: { __typename?: 'Price', amount: string }, meterPrice: { __typename?: 'Price', amount: string } }>, writeHistory: { __typename?: 'WriteHistory', createdAt: { __typename?: 'DateTime', isoString: string }, createdBy: { __typename?: 'User', id: string, name: string }, modifiedAt: { __typename?: 'DateTime', isoString: string } | null, modifiedBy: { __typename?: 'User', id: string, name: string } | null }, currency: { __typename?: 'Currency', id: string, code: string }, headAgreement: { __typename?: 'HeadAgreement', headAgreementNumber: number, id: string, name: string, breadCrumbName: string } } } } } };

export type UpdateRouteAgreementMutationVariables = Exact<{
  input: UpdateRouteAgreementInput;
}>;


export type UpdateRouteAgreementMutation = { __typename?: 'Mutation', productPrice: { __typename?: 'ProductPriceMutationRoot', routeAgreement: { __typename?: 'RouteAgreementMutationRoot', updateRouteAgreement: { __typename: 'ErrorResult', errors: Array<{ __typename?: 'ErrorDetail', message: string, path: string | null }> } | { __typename: 'UpdateRouteAgreementSuccessResult', routeAgreement: { __typename?: 'RouteAgreement', id: string, statusCode: HeadAgreementStatusCode, agreementNumber: number, rowVersion: string, hasArticles: boolean, hasConditions: boolean, externalComment: string | null, note: string | null, comment: string | null, hasMatrix: boolean, name: string, routeDescription: string, sailingTypeCodes: Array<SailingTypeCode>, valid: { __typename?: 'DateRange', start: { __typename?: 'Date', isoString: string } | null, end: { __typename?: 'Date', isoString: string } | null }, prices: Array<{ __typename?: 'RouteAgreementPrice', id: string, volume: number | null, lengthFrom: number | null, lengthTo: number | null, weightFrom: number | null, weightTo: number | null, unaccompanied: boolean | null, lastChargedFrom: number | null, cargoStatusCode: CargoStatusCode, avgLength: number | null, additionalFrom: number | null, actual: number | null, avgGrossPrice: { __typename?: 'Price', amount: string } | null, avgNetPrice: { __typename?: 'Price', amount: string } | null, avgRebate: { __typename?: 'Price', amount: string } | null, vehicleType: { __typename?: 'VehicleType', id: string, name: string, shortDescription: string, accompanied: boolean, code: string } | null, lastPrice: { __typename?: 'Price', amount: string } | null, lastMeterPrice: { __typename?: 'Price', amount: string } | null, newPrice: { __typename?: 'Price', amount: string }, meterPrice: { __typename?: 'Price', amount: string } }>, writeHistory: { __typename?: 'WriteHistory', createdAt: { __typename?: 'DateTime', isoString: string }, createdBy: { __typename?: 'User', id: string, name: string }, modifiedAt: { __typename?: 'DateTime', isoString: string } | null, modifiedBy: { __typename?: 'User', id: string, name: string } | null }, currency: { __typename?: 'Currency', id: string, code: string }, headAgreement: { __typename?: 'HeadAgreement', headAgreementNumber: number, id: string, name: string, breadCrumbName: string } } } } } };

export type MultilegRouteAgrAgreementsFragment = { __typename?: 'MultiLegRouteAgreement', id: string, routeAgreements: Array<{ __typename?: 'RouteAgreement', id: string, name: string, agreementNumber: number, routeDescription: string, sailingTypeCodes: Array<SailingTypeCode>, externalDescription: string | null, multiLegAgrRouteId: string | null, isSalesReady: boolean, typeCode: RouteAgreementTypeCode, statusCode: HeadAgreementStatusCode, rowVersion: string, hasConditions: boolean, currency: { __typename?: 'Currency', id: string, code: string }, valid: { __typename?: 'DateRange', start: { __typename?: 'Date', isoString: string } | null, end: { __typename?: 'Date', isoString: string } | null }, prices: Array<{ __typename?: 'RouteAgreementPrice', id: string, volume: number | null, lengthFrom: number | null, lengthTo: number | null, weightFrom: number | null, weightTo: number | null, unaccompanied: boolean | null, lastChargedFrom: number | null, cargoStatusCode: CargoStatusCode, avgLength: number | null, additionalFrom: number | null, actual: number | null, avgGrossPrice: { __typename?: 'Price', amount: string } | null, avgNetPrice: { __typename?: 'Price', amount: string } | null, avgRebate: { __typename?: 'Price', amount: string } | null, vehicleType: { __typename?: 'VehicleType', id: string, name: string, shortDescription: string, accompanied: boolean, code: string } | null, lastPrice: { __typename?: 'Price', amount: string } | null, lastMeterPrice: { __typename?: 'Price', amount: string } | null, newPrice: { __typename?: 'Price', amount: string }, meterPrice: { __typename?: 'Price', amount: string } }>, routes: Array<{ __typename?: 'Route', id: string, code: string, routeType: string, routePair: { __typename?: 'RoutePair', id: string, code: string, description: string } }> }> };

export type MultilegRouteAgreementRouteAgreementFetcherQueryVariables = Exact<{
  multiLegRouteAgreementId: Scalars['ID']['input'];
}>;


export type MultilegRouteAgreementRouteAgreementFetcherQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', multiLegRouteAgreement: { __typename?: 'MultiLegRouteAgreementSearchRoot', byId: { __typename?: 'MultiLegRouteAgreement', id: string, routeAgreements: Array<{ __typename?: 'RouteAgreement', id: string, name: string, agreementNumber: number, routeDescription: string, sailingTypeCodes: Array<SailingTypeCode>, externalDescription: string | null, multiLegAgrRouteId: string | null, isSalesReady: boolean, typeCode: RouteAgreementTypeCode, statusCode: HeadAgreementStatusCode, rowVersion: string, hasConditions: boolean, currency: { __typename?: 'Currency', id: string, code: string }, valid: { __typename?: 'DateRange', start: { __typename?: 'Date', isoString: string } | null, end: { __typename?: 'Date', isoString: string } | null }, prices: Array<{ __typename?: 'RouteAgreementPrice', id: string, volume: number | null, lengthFrom: number | null, lengthTo: number | null, weightFrom: number | null, weightTo: number | null, unaccompanied: boolean | null, lastChargedFrom: number | null, cargoStatusCode: CargoStatusCode, avgLength: number | null, additionalFrom: number | null, actual: number | null, avgGrossPrice: { __typename?: 'Price', amount: string } | null, avgNetPrice: { __typename?: 'Price', amount: string } | null, avgRebate: { __typename?: 'Price', amount: string } | null, vehicleType: { __typename?: 'VehicleType', id: string, name: string, shortDescription: string, accompanied: boolean, code: string } | null, lastPrice: { __typename?: 'Price', amount: string } | null, lastMeterPrice: { __typename?: 'Price', amount: string } | null, newPrice: { __typename?: 'Price', amount: string }, meterPrice: { __typename?: 'Price', amount: string } }>, routes: Array<{ __typename?: 'Route', id: string, code: string, routeType: string, routePair: { __typename?: 'RoutePair', id: string, code: string, description: string } }> }> } | null } } };

export type ArticlePricesFragment = { __typename?: 'ArticlePrice', id: string, percent: number | null, lengthFrom: number | null, lengthTo: number | null, weightFrom: number | null, weightTo: number | null, vehicleType: { __typename?: 'VehicleType', id: string, name: string } | null, price: { __typename?: 'Price', amount: string } };

export type ArticleValiditiesFragment = { __typename?: 'ArticlePriceValidity', id: string, agrRouteArticlePriceId: string, percentage: number | null, price: number | null, validFrom: string | null };

export type RouteAgreementMatricesFragment = { __typename?: 'RouteAgreementMatrix', id: string, valid: { __typename?: 'DateRange', start: { __typename?: 'Date', isoString: string } | null, end: { __typename?: 'Date', isoString: string } | null }, matrix: { __typename?: 'Matrix', id: string, keywords: Array<string>, validityKey: string, timeslots: Array<{ __typename?: 'MatrixTimeslot', weekDay: string, timeFrom: string, timeTo: string }> } };

export type RouteAgreementArticlesFragment = { __typename?: 'RouteAgreementArticle', id: string, maxPrice: number | null, maxNumberOf: number | null, includedInPrice: boolean, articleType: { __typename?: 'ArticleType', id: string, code: string, usesPercent: boolean }, prices: Array<{ __typename?: 'ArticlePrice', id: string, percent: number | null, lengthFrom: number | null, lengthTo: number | null, weightFrom: number | null, weightTo: number | null, vehicleType: { __typename?: 'VehicleType', id: string, name: string } | null, price: { __typename?: 'Price', amount: string } }>, validities: Array<{ __typename?: 'ArticlePriceValidity', id: string, agrRouteArticlePriceId: string, percentage: number | null, price: number | null, validFrom: string | null }>, formulaType: { __typename?: 'FormulaType', id: string, name: string } | null, formulaData: { __typename?: 'FormulaData', drivers: number | null, interval1PercentValue: number | null, interval2PercentValue: number | null, interval3PercentValue: number | null, interval4PercentValue: number | null, intervalAPercentValue: number | null, intervalBPercentValue: number | null, intervalCPercentValue: number | null, intervalDPercentValue: number | null, intervalLength: number | null, maxPercent: number | null, percent: number | null, weight: number | null, width: number | null } | null };

export type RouteAgreementDetailsStateFragment = { __typename?: 'RouteAgreement', id: string, name: string, typeCode: RouteAgreementTypeCode, statusCode: HeadAgreementStatusCode, agreementNumber: number, rowVersion: string, transit: boolean, standby: boolean, sailingTypeCodes: Array<SailingTypeCode>, externalDescription: string | null, isSalesReady: boolean, routeDescription: string, note: string | null, comment: string | null, externalComment: string | null, multiLegAgrRouteId: string | null, writeHistory: { __typename?: 'WriteHistory', createdAt: { __typename?: 'DateTime', isoString: string }, createdBy: { __typename?: 'User', id: string, name: string }, modifiedAt: { __typename?: 'DateTime', isoString: string } | null, modifiedBy: { __typename?: 'User', id: string, name: string } | null }, prices: Array<{ __typename?: 'RouteAgreementPrice', id: string, volume: number | null, lengthFrom: number | null, lengthTo: number | null, weightFrom: number | null, weightTo: number | null, unaccompanied: boolean | null, lastChargedFrom: number | null, cargoStatusCode: CargoStatusCode, avgLength: number | null, additionalFrom: number | null, actual: number | null, avgGrossPrice: { __typename?: 'Price', amount: string } | null, avgNetPrice: { __typename?: 'Price', amount: string } | null, avgRebate: { __typename?: 'Price', amount: string } | null, vehicleType: { __typename?: 'VehicleType', id: string, name: string, shortDescription: string, accompanied: boolean, code: string } | null, lastPrice: { __typename?: 'Price', amount: string } | null, lastMeterPrice: { __typename?: 'Price', amount: string } | null, newPrice: { __typename?: 'Price', amount: string }, meterPrice: { __typename?: 'Price', amount: string } }>, routes: Array<{ __typename?: 'Route', id: string, code: string, routeType: string }>, senderCountries: Array<{ __typename?: 'Country', id: string }>, receiverCountries: Array<{ __typename?: 'Country', id: string }>, goods: Array<{ __typename?: 'Goods', id: string }>, matrices: Array<{ __typename?: 'RouteAgreementMatrix', id: string, valid: { __typename?: 'DateRange', start: { __typename?: 'Date', isoString: string } | null, end: { __typename?: 'Date', isoString: string } | null }, matrix: { __typename?: 'Matrix', id: string, keywords: Array<string>, validityKey: string, timeslots: Array<{ __typename?: 'MatrixTimeslot', weekDay: string, timeFrom: string, timeTo: string }> } }>, valid: { __typename?: 'DateRange', start: { __typename?: 'Date', isoString: string } | null, end: { __typename?: 'Date', isoString: string } | null }, currency: { __typename?: 'Currency', id: string, code: string }, articles: Array<{ __typename?: 'RouteAgreementArticle', id: string, maxPrice: number | null, maxNumberOf: number | null, includedInPrice: boolean, articleType: { __typename?: 'ArticleType', id: string, code: string, usesPercent: boolean }, prices: Array<{ __typename?: 'ArticlePrice', id: string, percent: number | null, lengthFrom: number | null, lengthTo: number | null, weightFrom: number | null, weightTo: number | null, vehicleType: { __typename?: 'VehicleType', id: string, name: string } | null, price: { __typename?: 'Price', amount: string } }>, validities: Array<{ __typename?: 'ArticlePriceValidity', id: string, agrRouteArticlePriceId: string, percentage: number | null, price: number | null, validFrom: string | null }>, formulaType: { __typename?: 'FormulaType', id: string, name: string } | null, formulaData: { __typename?: 'FormulaData', drivers: number | null, interval1PercentValue: number | null, interval2PercentValue: number | null, interval3PercentValue: number | null, interval4PercentValue: number | null, intervalAPercentValue: number | null, intervalBPercentValue: number | null, intervalCPercentValue: number | null, intervalDPercentValue: number | null, intervalLength: number | null, maxPercent: number | null, percent: number | null, weight: number | null, width: number | null } | null }>, headAgreement: { __typename?: 'HeadAgreement', headAgreementNumber: number, id: string, name: string, breadCrumbName: string, valid: { __typename?: 'DateRange', start: { __typename?: 'Date', isoString: string } | null } } };

export type RouteAgreementDetailsStatePopulatorQueryVariables = Exact<{
  routeAgreementId: Scalars['ID']['input'];
}>;


export type RouteAgreementDetailsStatePopulatorQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', routeAgreement: { __typename?: 'RouteAgreementSearchRoot', byId: { __typename?: 'RouteAgreement', id: string, name: string, typeCode: RouteAgreementTypeCode, statusCode: HeadAgreementStatusCode, agreementNumber: number, rowVersion: string, transit: boolean, standby: boolean, sailingTypeCodes: Array<SailingTypeCode>, externalDescription: string | null, isSalesReady: boolean, routeDescription: string, note: string | null, comment: string | null, externalComment: string | null, multiLegAgrRouteId: string | null, writeHistory: { __typename?: 'WriteHistory', createdAt: { __typename?: 'DateTime', isoString: string }, createdBy: { __typename?: 'User', id: string, name: string }, modifiedAt: { __typename?: 'DateTime', isoString: string } | null, modifiedBy: { __typename?: 'User', id: string, name: string } | null }, prices: Array<{ __typename?: 'RouteAgreementPrice', id: string, volume: number | null, lengthFrom: number | null, lengthTo: number | null, weightFrom: number | null, weightTo: number | null, unaccompanied: boolean | null, lastChargedFrom: number | null, cargoStatusCode: CargoStatusCode, avgLength: number | null, additionalFrom: number | null, actual: number | null, avgGrossPrice: { __typename?: 'Price', amount: string } | null, avgNetPrice: { __typename?: 'Price', amount: string } | null, avgRebate: { __typename?: 'Price', amount: string } | null, vehicleType: { __typename?: 'VehicleType', id: string, name: string, shortDescription: string, accompanied: boolean, code: string } | null, lastPrice: { __typename?: 'Price', amount: string } | null, lastMeterPrice: { __typename?: 'Price', amount: string } | null, newPrice: { __typename?: 'Price', amount: string }, meterPrice: { __typename?: 'Price', amount: string } }>, routes: Array<{ __typename?: 'Route', id: string, code: string, routeType: string }>, senderCountries: Array<{ __typename?: 'Country', id: string }>, receiverCountries: Array<{ __typename?: 'Country', id: string }>, goods: Array<{ __typename?: 'Goods', id: string }>, matrices: Array<{ __typename?: 'RouteAgreementMatrix', id: string, valid: { __typename?: 'DateRange', start: { __typename?: 'Date', isoString: string } | null, end: { __typename?: 'Date', isoString: string } | null }, matrix: { __typename?: 'Matrix', id: string, keywords: Array<string>, validityKey: string, timeslots: Array<{ __typename?: 'MatrixTimeslot', weekDay: string, timeFrom: string, timeTo: string }> } }>, valid: { __typename?: 'DateRange', start: { __typename?: 'Date', isoString: string } | null, end: { __typename?: 'Date', isoString: string } | null }, currency: { __typename?: 'Currency', id: string, code: string }, articles: Array<{ __typename?: 'RouteAgreementArticle', id: string, maxPrice: number | null, maxNumberOf: number | null, includedInPrice: boolean, articleType: { __typename?: 'ArticleType', id: string, code: string, usesPercent: boolean }, prices: Array<{ __typename?: 'ArticlePrice', id: string, percent: number | null, lengthFrom: number | null, lengthTo: number | null, weightFrom: number | null, weightTo: number | null, vehicleType: { __typename?: 'VehicleType', id: string, name: string } | null, price: { __typename?: 'Price', amount: string } }>, validities: Array<{ __typename?: 'ArticlePriceValidity', id: string, agrRouteArticlePriceId: string, percentage: number | null, price: number | null, validFrom: string | null }>, formulaType: { __typename?: 'FormulaType', id: string, name: string } | null, formulaData: { __typename?: 'FormulaData', drivers: number | null, interval1PercentValue: number | null, interval2PercentValue: number | null, interval3PercentValue: number | null, interval4PercentValue: number | null, intervalAPercentValue: number | null, intervalBPercentValue: number | null, intervalCPercentValue: number | null, intervalDPercentValue: number | null, intervalLength: number | null, maxPercent: number | null, percent: number | null, weight: number | null, width: number | null } | null }>, headAgreement: { __typename?: 'HeadAgreement', headAgreementNumber: number, id: string, name: string, breadCrumbName: string, valid: { __typename?: 'DateRange', start: { __typename?: 'Date', isoString: string } | null } } } | null } } };

export type CustomerCategoryFilterQueryVariables = Exact<{ [key: string]: never; }>;


export type CustomerCategoryFilterQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', customerCategory: { __typename?: 'CustomerCategorySearchRoot', all: Array<{ __typename?: 'CustomerCategory', id: string, code: string, description: string }> } } };

export type NegotiationStatusesFilterQueryVariables = Exact<{ [key: string]: never; }>;


export type NegotiationStatusesFilterQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', negotiationStatus: { __typename?: 'NegotiationStatusSearchRoot', all: Array<{ __typename?: 'NegotiationStatus', id: string, name: string }> } } };

export type NoShowLateHandlingStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type NoShowLateHandlingStatusQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', noShowLateHandlingStatus: { __typename?: 'NoShowLateHandlingStatusSearchRoot', all: Array<{ __typename?: 'NoShowLateHandlingStatus', id: string, code: string, description: string, presentationOrder: number }> } } };

export type SalesRegionFilterQueryVariables = Exact<{ [key: string]: never; }>;


export type SalesRegionFilterQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', salesRegion: { __typename?: 'SalesRegionSearchRoot', all: Array<{ __typename?: 'SalesRegion', id: string, name: string, shortName: string }> } } };

export type RouteAgreementSailingCategoryFilterQueryVariables = Exact<{ [key: string]: never; }>;


export type RouteAgreementSailingCategoryFilterQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', agrRouteSailingTypes: { __typename?: 'AgrRouteSailingTypesSearchRoot', all: Array<{ __typename?: 'AgrRouteSailingTypes', id: string, code: string, description: string }> } } };

export type SeaAreaStatusOwnFragment = { __typename?: 'SeaArea', id: string, name: string };

export type RoutePairFilterQueryVariables = Exact<{ [key: string]: never; }>;


export type RoutePairFilterQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', routePair: { __typename?: 'RoutePairSearchRoot', allWithStatusOwn: Array<{ __typename?: 'RoutePair', id: string, code: string, seaArea: { __typename?: 'SeaArea', id: string, name: string } }> } } };

export type SailingCategoryFilterQueryVariables = Exact<{ [key: string]: never; }>;


export type SailingCategoryFilterQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', sailingCategory: { __typename?: 'SailingCategorySearchRoot', all: Array<{ __typename?: 'SailingCategory', id: string, code: string, name: string }> } } };

export type SellersFilterQueryVariables = Exact<{ [key: string]: never; }>;


export type SellersFilterQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', user: { __typename?: 'UserSearchRoot', all: Array<{ __typename?: 'User', id: string, name: string }>, me: { __typename?: 'User', id: string, name: string } } } };

export type UnitTypeFilterQueryVariables = Exact<{ [key: string]: never; }>;


export type UnitTypeFilterQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', unitType: { __typename?: 'UnitTypeSearchRoot', all: Array<{ __typename?: 'UnitType', id: string, code: string, name: string }> } } };

export type VehicleTypesFilterQueryVariables = Exact<{ [key: string]: never; }>;


export type VehicleTypesFilterQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', vehicleType: { __typename?: 'VehicleTypeSearchRoot', all: Array<{ __typename?: 'VehicleType', id: string, code: string, accompanied: boolean, shortDescription: string }> } } };

export type NoShowLateHandlingTypeQueryVariables = Exact<{ [key: string]: never; }>;


export type NoShowLateHandlingTypeQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', noShowLateTypes: { __typename?: 'NoShowLateTypeSearchRoot', allCodeNoShowLateType: Array<{ __typename?: 'CodeNoShowLateType', id: string, code: string, description: string, presentationOrder: number }> } } };

export type InfoSearchBySComerNumberOrIndexFragment = { __typename?: 'Customer', id: string, custIndex: string, custNo: number, name: string, custStatus: { __typename?: 'CustomerStatus', id: string, name: string, code: CustomerStatusCode } | null, parent: { __typename?: 'Customer', id: string } | null };

export type CustomerInfoSearchQueryVariables = Exact<{
  query: Scalars['String']['input'];
}>;


export type CustomerInfoSearchQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', customers: { __typename?: 'CustomerSearchRoot', byCustomerNumberOrIndex: Array<{ __typename?: 'Customer', id: string, custIndex: string, custNo: number, name: string, custStatus: { __typename?: 'CustomerStatus', id: string, name: string, code: CustomerStatusCode } | null, parent: { __typename?: 'Customer', id: string } | null }> } } };

export type ByStatCustomerNumberOrIndexFragment = { __typename?: 'Customer', id: string, custIndex: string, custNo: number, name: string, custStatus: { __typename?: 'CustomerStatus', id: string, name: string, code: CustomerStatusCode } | null, parent: { __typename?: 'Customer', id: string } | null };

export type StatInfoSearchQueryVariables = Exact<{
  query: Scalars['String']['input'];
}>;


export type StatInfoSearchQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', customers: { __typename?: 'CustomerSearchRoot', byStatCustomerNumberOrIndex: Array<{ __typename?: 'Customer', id: string, custIndex: string, custNo: number, name: string, custStatus: { __typename?: 'CustomerStatus', id: string, name: string, code: CustomerStatusCode } | null, parent: { __typename?: 'Customer', id: string } | null }> } } };

export type StatisticsByCustomerDetailsQueryVariables = Exact<{
  customerId: Scalars['ID']['input'];
}>;


export type StatisticsByCustomerDetailsQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', customers: { __typename?: 'CustomerSearchRoot', byId: { __typename?: 'Customer', id: string, name: string, breadCrumbName: string, custIndex: string, custNo: number, isParent: boolean, isStandardCustomer: boolean, hasRebateAgreements: boolean | null, custStatus: { __typename?: 'CustomerStatus', id: string, name: string } | null, parent: { __typename?: 'Customer', id: string, preselectedHeadAgreement: { __typename?: 'HeadAgreement', id: string } | null } | null, childCustomers: Array<{ __typename?: 'Customer', id: string }>, statisticalGrouping: { __typename?: 'Customer', id: string } | null, invoiceCurrency: { __typename?: 'Currency', id: string, code: string }, seller: { __typename?: 'User', id: string, name: string }, salesRegion: { __typename?: 'SalesRegion', id: string, code: string, name: string }, writeHistory: { __typename?: 'WriteHistory', createdAt: { __typename?: 'DateTime', isoString: string }, createdBy: { __typename?: 'User', id: string, name: string }, modifiedAt: { __typename?: 'DateTime', isoString: string } | null, modifiedBy: { __typename?: 'User', id: string, name: string } | null } } | null } } };

export type StatisticsByCustomerThreeYearsStatisticsDetailsQueryVariables = Exact<{
  customerId: Scalars['ID']['input'];
  year: Scalars['Int']['input'];
  currencyCode: Scalars['String']['input'];
}>;


export type StatisticsByCustomerThreeYearsStatisticsDetailsQuery = { __typename?: 'Query', statistics: { __typename?: 'StatisticsSearchRoot', customerDetails: { __typename?: 'StatisticsCustomerDetailsSearchRoot', threeYearsTargetAndActualByCustNoAndYear: Array<{ __typename?: 'ThreeYearsTargetAndActual', routePairCode: string | null, year: number, targetInPercent: number | null, actualOutcomeInPercent: number | null }>, threeYearsPricePerMeterByCustNoYearAndCurrency: Array<{ __typename?: 'ThreeYearsPricePerMeter', routePairCode: string | null, year: number, pricePerMeter: number | null }>, threeYearsVolumeAndExpectedByCustNoAndYear: Array<{ __typename?: 'ThreeYearsVolumeAndExpected', routePairCode: string | null, year: number, volume: number | null, expectedVolume: number | null }> } } };

export type StatisticsByRouteDetailsHeaderQueryVariables = Exact<{
  routeId: Scalars['ID']['input'];
}>;


export type StatisticsByRouteDetailsHeaderQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', routePair: { __typename?: 'RoutePairSearchRoot', byId: { __typename?: 'RoutePair', id: string, code: string, description: string, seaArea: { __typename?: 'SeaArea', id: string, name: string } } | null } } };

export type StatisticsBySalesRegionDetailsHeaderQueryVariables = Exact<{
  salesRegionId: Scalars['ID']['input'];
}>;


export type StatisticsBySalesRegionDetailsHeaderQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', salesRegion: { __typename?: 'SalesRegionSearchRoot', byId: { __typename?: 'SalesRegion', id: string, code: string, name: string } | null } } };

export type StatisticsBySellerDetailsHeaderQueryVariables = Exact<{
  sellerId: Scalars['ID']['input'];
}>;


export type StatisticsBySellerDetailsHeaderQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', user: { __typename?: 'UserSearchRoot', byId: { __typename?: 'User', id: string, name: string } | null } } };

export type VolumeChangeChartDataFragment = { __typename?: 'VolumeChangeChartData', expectedVolume: { __typename?: 'VolumeChangeChartRowData', acc: number | null, unacc: number | null }, lastYearVolume: { __typename?: 'VolumeChangeChartRowData', acc: number | null, unacc: number | null } };

export type VolumeChangeTableDataFragment = { __typename?: 'VolumeChangeTableData', acc: { __typename?: 'VolumeChangeTableRowData', diff: number | null, expected: number | null, lastYear: number | null }, total: { __typename?: 'VolumeChangeTableRowData', diff: number | null, expected: number | null, lastYear: number | null }, unacc: { __typename?: 'VolumeChangeTableRowData', diff: number | null, expected: number | null, lastYear: number | null } };

export type RateChangeTableDataFragment = { __typename?: 'RateChangeTableData', total: { __typename?: 'RateChangeTableRowData', rate: number | null, target: number | null }, acc: { __typename?: 'RateChangeTableRowData', rate: number | null, target: number | null }, unacc: { __typename?: 'RateChangeTableRowData', rate: number | null, target: number | null } };

export type StatisticsDetailsFragmentFragment = { __typename?: 'StatisticsDetailsVolumeAndRatesResult', rateChange: { __typename?: 'RateChangeData', charts: { __typename?: 'RateChangeAllChartsData', total: { __typename?: 'RateChangeChartData', averageRateChange: number | null, averageTarget: number | null }, peak: { __typename?: 'RateChangeChartData', averageRateChange: number | null, averageTarget: number | null }, shoulder: { __typename?: 'RateChangeChartData', averageRateChange: number | null, averageTarget: number | null }, offPeak: { __typename?: 'RateChangeChartData', averageRateChange: number | null, averageTarget: number | null } }, tables: { __typename?: 'RateChangeAllTablesData', total: { __typename?: 'RateChangeTableData', total: { __typename?: 'RateChangeTableRowData', rate: number | null, target: number | null }, acc: { __typename?: 'RateChangeTableRowData', rate: number | null, target: number | null }, unacc: { __typename?: 'RateChangeTableRowData', rate: number | null, target: number | null } }, peak: { __typename?: 'RateChangeTableData', total: { __typename?: 'RateChangeTableRowData', rate: number | null, target: number | null }, acc: { __typename?: 'RateChangeTableRowData', rate: number | null, target: number | null }, unacc: { __typename?: 'RateChangeTableRowData', rate: number | null, target: number | null } }, shoulder: { __typename?: 'RateChangeTableData', total: { __typename?: 'RateChangeTableRowData', rate: number | null, target: number | null }, acc: { __typename?: 'RateChangeTableRowData', rate: number | null, target: number | null }, unacc: { __typename?: 'RateChangeTableRowData', rate: number | null, target: number | null } }, offPeak: { __typename?: 'RateChangeTableData', total: { __typename?: 'RateChangeTableRowData', rate: number | null, target: number | null }, acc: { __typename?: 'RateChangeTableRowData', rate: number | null, target: number | null }, unacc: { __typename?: 'RateChangeTableRowData', rate: number | null, target: number | null } } } }, volumeChange: { __typename?: 'VolumeChangeData', charts: { __typename?: 'VolumeChangeAllChartsData', total: { __typename?: 'VolumeChangeChartData', expectedVolume: { __typename?: 'VolumeChangeChartRowData', acc: number | null, unacc: number | null }, lastYearVolume: { __typename?: 'VolumeChangeChartRowData', acc: number | null, unacc: number | null } }, peak: { __typename?: 'VolumeChangeChartData', expectedVolume: { __typename?: 'VolumeChangeChartRowData', acc: number | null, unacc: number | null }, lastYearVolume: { __typename?: 'VolumeChangeChartRowData', acc: number | null, unacc: number | null } }, shoulder: { __typename?: 'VolumeChangeChartData', expectedVolume: { __typename?: 'VolumeChangeChartRowData', acc: number | null, unacc: number | null }, lastYearVolume: { __typename?: 'VolumeChangeChartRowData', acc: number | null, unacc: number | null } }, offPeak: { __typename?: 'VolumeChangeChartData', expectedVolume: { __typename?: 'VolumeChangeChartRowData', acc: number | null, unacc: number | null }, lastYearVolume: { __typename?: 'VolumeChangeChartRowData', acc: number | null, unacc: number | null } } }, tables: { __typename?: 'VolumeChangeAllTablesData', total: { __typename?: 'VolumeChangeTableData', acc: { __typename?: 'VolumeChangeTableRowData', diff: number | null, expected: number | null, lastYear: number | null }, total: { __typename?: 'VolumeChangeTableRowData', diff: number | null, expected: number | null, lastYear: number | null }, unacc: { __typename?: 'VolumeChangeTableRowData', diff: number | null, expected: number | null, lastYear: number | null } }, peak: { __typename?: 'VolumeChangeTableData', acc: { __typename?: 'VolumeChangeTableRowData', diff: number | null, expected: number | null, lastYear: number | null }, total: { __typename?: 'VolumeChangeTableRowData', diff: number | null, expected: number | null, lastYear: number | null }, unacc: { __typename?: 'VolumeChangeTableRowData', diff: number | null, expected: number | null, lastYear: number | null } }, shoulder: { __typename?: 'VolumeChangeTableData', acc: { __typename?: 'VolumeChangeTableRowData', diff: number | null, expected: number | null, lastYear: number | null }, total: { __typename?: 'VolumeChangeTableRowData', diff: number | null, expected: number | null, lastYear: number | null }, unacc: { __typename?: 'VolumeChangeTableRowData', diff: number | null, expected: number | null, lastYear: number | null } }, offPeak: { __typename?: 'VolumeChangeTableData', acc: { __typename?: 'VolumeChangeTableRowData', diff: number | null, expected: number | null, lastYear: number | null }, total: { __typename?: 'VolumeChangeTableRowData', diff: number | null, expected: number | null, lastYear: number | null }, unacc: { __typename?: 'VolumeChangeTableRowData', diff: number | null, expected: number | null, lastYear: number | null } } } } };

export type StatisticsListFragmentFragment = { __typename?: 'StatisticsDetailsSummaryResult', byVolume: { __typename?: 'StatisticsSummaryPieChart', total: number, items: Array<{ __typename?: 'NumPerNegotiationStatus', num: number | null, negotiationStatus: { __typename?: 'NegotiationStatus', id: string, name: string } }> }, byNumber: { __typename?: 'StatisticsSummaryPieChart', total: number, items: Array<{ __typename?: 'NumPerNegotiationStatus', num: number | null, negotiationStatus: { __typename?: 'NegotiationStatus', id: string, name: string } }> } };

export type CustomerStatisticsDetailsFragment = { __typename?: 'Customer', id: string, name: string, breadCrumbName: string, custIndex: string, custNo: number, isParent: boolean, isStandardCustomer: boolean, hasRebateAgreements: boolean | null, custStatus: { __typename?: 'CustomerStatus', id: string, name: string } | null, parent: { __typename?: 'Customer', id: string, preselectedHeadAgreement: { __typename?: 'HeadAgreement', id: string } | null } | null, childCustomers: Array<{ __typename?: 'Customer', id: string }>, statisticalGrouping: { __typename?: 'Customer', id: string } | null, invoiceCurrency: { __typename?: 'Currency', id: string, code: string }, seller: { __typename?: 'User', id: string, name: string }, salesRegion: { __typename?: 'SalesRegion', id: string, code: string, name: string }, writeHistory: { __typename?: 'WriteHistory', createdAt: { __typename?: 'DateTime', isoString: string }, createdBy: { __typename?: 'User', id: string, name: string }, modifiedAt: { __typename?: 'DateTime', isoString: string } | null, modifiedBy: { __typename?: 'User', id: string, name: string } | null } };

export type ThreeYearsTargetActualFragment = { __typename?: 'ThreeYearsTargetAndActual', routePairCode: string | null, year: number, targetInPercent: number | null, actualOutcomeInPercent: number | null };

export type ThreeYearsPricePerMeterFragment = { __typename?: 'ThreeYearsPricePerMeter', routePairCode: string | null, year: number, pricePerMeter: number | null };

export type ThreeYearsVolumeExpectedFragment = { __typename?: 'ThreeYearsVolumeAndExpected', routePairCode: string | null, year: number, volume: number | null, expectedVolume: number | null };

export type AgreedVolumeListItemsFragment = { __typename?: 'StatisticsByAgreedVolumeListItem', statNumber: number, statCustomerIndex: string, routePairCode: string, agreedVolume: number, shippedVolume: number, performanceInPercent: number };

export type UseAgreedVolumeListQueryVariables = Exact<{
  filterOptions: StatisticsSearchAgreedVolumeByFilterOptions;
}>;


export type UseAgreedVolumeListQuery = { __typename?: 'Query', statistics: { __typename?: 'StatisticsSearchRoot', agreedVolumeList: { __typename?: 'StatisticsAgreedVolumeListSearchRoot', byFilter: { __typename?: 'StatisticsSearchAgreedVolumeByFilterResult', items: Array<{ __typename?: 'StatisticsByAgreedVolumeListItem', statNumber: number, statCustomerIndex: string, routePairCode: string, agreedVolume: number, shippedVolume: number, performanceInPercent: number }> } | null } } };

export type SellerListVolumeAndTargetQueryVariables = Exact<{
  filterOptions: StatisticsSearchSellerListVolumeAndTargetByFilterOptions;
}>;


export type SellerListVolumeAndTargetQuery = { __typename?: 'Query', statistics: { __typename?: 'StatisticsSearchRoot', sellerList: { __typename?: 'StatisticsSellerListSearchRoot', volumeAndTarget: { __typename?: 'StatisticsSearchSellerListVolumeAndTargetByFilterResult', items: Array<{ __typename?: 'StatisticsBySellerListVolumeAndTargetItem', seller: { __typename?: 'User', id: string }, volumeAndTargetForSelected: { __typename?: 'VolumeAndTargetForSelected', averageNegotiationRate: number | null, averageTarget: number | null, expectedVolume: number | null, lastYearVolume: number, volume: number, avgMeterPrice: number | null, avgMeterPriceDiffInPercent: number | null } }> } } } };

export type UseRoutePairDetailsSummaryQueryVariables = Exact<{
  routePairId: Scalars['ID']['input'];
  year: Scalars['Int']['input'];
}>;


export type UseRoutePairDetailsSummaryQuery = { __typename?: 'Query', statistics: { __typename?: 'StatisticsSearchRoot', routePairDetails: { __typename?: 'StatisticsRoutePairDetailsSearchRoot', summary: { __typename?: 'StatisticsDetailsSummaryResult', byVolume: { __typename?: 'StatisticsSummaryPieChart', total: number, items: Array<{ __typename?: 'NumPerNegotiationStatus', num: number | null, negotiationStatus: { __typename?: 'NegotiationStatus', id: string, name: string } }> }, byNumber: { __typename?: 'StatisticsSummaryPieChart', total: number, items: Array<{ __typename?: 'NumPerNegotiationStatus', num: number | null, negotiationStatus: { __typename?: 'NegotiationStatus', id: string, name: string } }> } } } } };

export type UseRoutePairDetailsVolumeAndRatesQueryVariables = Exact<{
  routePairId: Scalars['ID']['input'];
  currencyCode: Scalars['String']['input'];
  negotiationStatuses: Array<NegotiationStatusCode> | NegotiationStatusCode;
  year: Scalars['Int']['input'];
}>;


export type UseRoutePairDetailsVolumeAndRatesQuery = { __typename?: 'Query', statistics: { __typename?: 'StatisticsSearchRoot', routePairDetails: { __typename?: 'StatisticsRoutePairDetailsSearchRoot', volumeAndRates: { __typename?: 'StatisticsDetailsVolumeAndRatesResult', rateChange: { __typename?: 'RateChangeData', charts: { __typename?: 'RateChangeAllChartsData', total: { __typename?: 'RateChangeChartData', averageRateChange: number | null, averageTarget: number | null }, peak: { __typename?: 'RateChangeChartData', averageRateChange: number | null, averageTarget: number | null }, shoulder: { __typename?: 'RateChangeChartData', averageRateChange: number | null, averageTarget: number | null }, offPeak: { __typename?: 'RateChangeChartData', averageRateChange: number | null, averageTarget: number | null } }, tables: { __typename?: 'RateChangeAllTablesData', total: { __typename?: 'RateChangeTableData', total: { __typename?: 'RateChangeTableRowData', rate: number | null, target: number | null }, acc: { __typename?: 'RateChangeTableRowData', rate: number | null, target: number | null }, unacc: { __typename?: 'RateChangeTableRowData', rate: number | null, target: number | null } }, peak: { __typename?: 'RateChangeTableData', total: { __typename?: 'RateChangeTableRowData', rate: number | null, target: number | null }, acc: { __typename?: 'RateChangeTableRowData', rate: number | null, target: number | null }, unacc: { __typename?: 'RateChangeTableRowData', rate: number | null, target: number | null } }, shoulder: { __typename?: 'RateChangeTableData', total: { __typename?: 'RateChangeTableRowData', rate: number | null, target: number | null }, acc: { __typename?: 'RateChangeTableRowData', rate: number | null, target: number | null }, unacc: { __typename?: 'RateChangeTableRowData', rate: number | null, target: number | null } }, offPeak: { __typename?: 'RateChangeTableData', total: { __typename?: 'RateChangeTableRowData', rate: number | null, target: number | null }, acc: { __typename?: 'RateChangeTableRowData', rate: number | null, target: number | null }, unacc: { __typename?: 'RateChangeTableRowData', rate: number | null, target: number | null } } } }, volumeChange: { __typename?: 'VolumeChangeData', charts: { __typename?: 'VolumeChangeAllChartsData', total: { __typename?: 'VolumeChangeChartData', expectedVolume: { __typename?: 'VolumeChangeChartRowData', acc: number | null, unacc: number | null }, lastYearVolume: { __typename?: 'VolumeChangeChartRowData', acc: number | null, unacc: number | null } }, peak: { __typename?: 'VolumeChangeChartData', expectedVolume: { __typename?: 'VolumeChangeChartRowData', acc: number | null, unacc: number | null }, lastYearVolume: { __typename?: 'VolumeChangeChartRowData', acc: number | null, unacc: number | null } }, shoulder: { __typename?: 'VolumeChangeChartData', expectedVolume: { __typename?: 'VolumeChangeChartRowData', acc: number | null, unacc: number | null }, lastYearVolume: { __typename?: 'VolumeChangeChartRowData', acc: number | null, unacc: number | null } }, offPeak: { __typename?: 'VolumeChangeChartData', expectedVolume: { __typename?: 'VolumeChangeChartRowData', acc: number | null, unacc: number | null }, lastYearVolume: { __typename?: 'VolumeChangeChartRowData', acc: number | null, unacc: number | null } } }, tables: { __typename?: 'VolumeChangeAllTablesData', total: { __typename?: 'VolumeChangeTableData', acc: { __typename?: 'VolumeChangeTableRowData', diff: number | null, expected: number | null, lastYear: number | null }, total: { __typename?: 'VolumeChangeTableRowData', diff: number | null, expected: number | null, lastYear: number | null }, unacc: { __typename?: 'VolumeChangeTableRowData', diff: number | null, expected: number | null, lastYear: number | null } }, peak: { __typename?: 'VolumeChangeTableData', acc: { __typename?: 'VolumeChangeTableRowData', diff: number | null, expected: number | null, lastYear: number | null }, total: { __typename?: 'VolumeChangeTableRowData', diff: number | null, expected: number | null, lastYear: number | null }, unacc: { __typename?: 'VolumeChangeTableRowData', diff: number | null, expected: number | null, lastYear: number | null } }, shoulder: { __typename?: 'VolumeChangeTableData', acc: { __typename?: 'VolumeChangeTableRowData', diff: number | null, expected: number | null, lastYear: number | null }, total: { __typename?: 'VolumeChangeTableRowData', diff: number | null, expected: number | null, lastYear: number | null }, unacc: { __typename?: 'VolumeChangeTableRowData', diff: number | null, expected: number | null, lastYear: number | null } }, offPeak: { __typename?: 'VolumeChangeTableData', acc: { __typename?: 'VolumeChangeTableRowData', diff: number | null, expected: number | null, lastYear: number | null }, total: { __typename?: 'VolumeChangeTableRowData', diff: number | null, expected: number | null, lastYear: number | null }, unacc: { __typename?: 'VolumeChangeTableRowData', diff: number | null, expected: number | null, lastYear: number | null } } } } }, threeYearsAverageMeterPrices: { __typename?: 'AverageMeterPricesData', averageMeterPriceRequestedYear: number | null, averageMeterPriceRequestedYearMinus1: number | null, averageMeterPriceRequestedYearMinus2: number | null, averageMeterPriceDiffInPercentFromPreviousYear: number | null, averageMeterPriceDiffInPercentFromPreviousYearMinus1: number | null, averageMeterPriceDiffInPercentFromPreviousYearMinus2: number | null } } } };

export type NumberVolumeStatisticsRoutePairFragment = { __typename?: 'NumberVolumeStatisticsItem', percentageOfAccount: number, percentageOfVolume: number };

export type RoutePairListItemsFragment = { __typename?: 'StatisticsByRoutePairListItem', routePair: { __typename?: 'RoutePair', id: string, code: string, description: string }, negotiationStatusStatistics: { __typename?: 'NegotiationStatusStatisticsItem', accounts: number, statistics: Array<{ __typename?: 'StatisticsForNegotiationStatus', negotiationStatus: { __typename?: 'NegotiationStatus', id: string, name: string }, numberVolumeStatistics: { __typename?: 'NumberVolumeStatisticsItem', percentageOfAccount: number, percentageOfVolume: number } }> } };

export type UseRoutePairListQueryVariables = Exact<{
  filterOptions: StatisticsSearchRoutePairListByFilterOptions;
}>;


export type UseRoutePairListQuery = { __typename?: 'Query', statistics: { __typename?: 'StatisticsSearchRoot', routePairList: { __typename?: 'StatisticsRoutePairListSearchRoot', byFilter: { __typename?: 'StatisticsSearchRoutePairListByFilterResult', items: Array<{ __typename?: 'StatisticsByRoutePairListItem', routePair: { __typename?: 'RoutePair', id: string, code: string, description: string }, negotiationStatusStatistics: { __typename?: 'NegotiationStatusStatisticsItem', accounts: number, statistics: Array<{ __typename?: 'StatisticsForNegotiationStatus', negotiationStatus: { __typename?: 'NegotiationStatus', id: string, name: string }, numberVolumeStatistics: { __typename?: 'NumberVolumeStatisticsItem', percentageOfAccount: number, percentageOfVolume: number } }> } }> } } } };

export type VolumeAndTargetForSelectedRoutePairFragment = { __typename?: 'StatisticsByRoutePairListVolumeAndTargetItem', routePair: { __typename?: 'RoutePair', id: string }, volumeAndTargetForSelected: { __typename?: 'VolumeAndTargetForSelected', averageNegotiationRate: number | null, averageTarget: number | null, expectedVolume: number | null, lastYearVolume: number, volume: number, avgMeterPrice: number | null, avgMeterPriceDiffInPercent: number | null } };

export type UseRoutePairListVolumeAndTargetQueryVariables = Exact<{
  filterOptions: StatisticsSearchRoutePairListVolumeAndTargetByFilterOptions;
}>;


export type UseRoutePairListVolumeAndTargetQuery = { __typename?: 'Query', statistics: { __typename?: 'StatisticsSearchRoot', routePairList: { __typename?: 'StatisticsRoutePairListSearchRoot', volumeAndTarget: { __typename?: 'StatisticsSearchRoutePairListVolumeAndTargetByFilterResult', items: Array<{ __typename?: 'StatisticsByRoutePairListVolumeAndTargetItem', routePair: { __typename?: 'RoutePair', id: string }, volumeAndTargetForSelected: { __typename?: 'VolumeAndTargetForSelected', averageNegotiationRate: number | null, averageTarget: number | null, expectedVolume: number | null, lastYearVolume: number, volume: number, avgMeterPrice: number | null, avgMeterPriceDiffInPercent: number | null } }> } } } };

export type UseSalesRegionDetailsSummaryQueryVariables = Exact<{
  salesRegionId: Scalars['ID']['input'];
  year: Scalars['Int']['input'];
}>;


export type UseSalesRegionDetailsSummaryQuery = { __typename?: 'Query', statistics: { __typename?: 'StatisticsSearchRoot', salesRegionDetails: { __typename?: 'StatisticsSalesRegionDetailsSearchRoot', summary: { __typename?: 'StatisticsDetailsSummaryResult', byVolume: { __typename?: 'StatisticsSummaryPieChart', total: number, items: Array<{ __typename?: 'NumPerNegotiationStatus', num: number | null, negotiationStatus: { __typename?: 'NegotiationStatus', id: string, name: string } }> }, byNumber: { __typename?: 'StatisticsSummaryPieChart', total: number, items: Array<{ __typename?: 'NumPerNegotiationStatus', num: number | null, negotiationStatus: { __typename?: 'NegotiationStatus', id: string, name: string } }> } } } } };

export type UseSalesRegionDetailsVolumeAndRatesQueryVariables = Exact<{
  salesRegionId: Scalars['ID']['input'];
  currencyCode: Scalars['String']['input'];
  negotiationStatuses: Array<NegotiationStatusCode> | NegotiationStatusCode;
  year: Scalars['Int']['input'];
}>;


export type UseSalesRegionDetailsVolumeAndRatesQuery = { __typename?: 'Query', statistics: { __typename?: 'StatisticsSearchRoot', salesRegionDetails: { __typename?: 'StatisticsSalesRegionDetailsSearchRoot', volumeAndRates: { __typename?: 'StatisticsDetailsVolumeAndRatesResult', rateChange: { __typename?: 'RateChangeData', charts: { __typename?: 'RateChangeAllChartsData', total: { __typename?: 'RateChangeChartData', averageRateChange: number | null, averageTarget: number | null }, peak: { __typename?: 'RateChangeChartData', averageRateChange: number | null, averageTarget: number | null }, shoulder: { __typename?: 'RateChangeChartData', averageRateChange: number | null, averageTarget: number | null }, offPeak: { __typename?: 'RateChangeChartData', averageRateChange: number | null, averageTarget: number | null } }, tables: { __typename?: 'RateChangeAllTablesData', total: { __typename?: 'RateChangeTableData', total: { __typename?: 'RateChangeTableRowData', rate: number | null, target: number | null }, acc: { __typename?: 'RateChangeTableRowData', rate: number | null, target: number | null }, unacc: { __typename?: 'RateChangeTableRowData', rate: number | null, target: number | null } }, peak: { __typename?: 'RateChangeTableData', total: { __typename?: 'RateChangeTableRowData', rate: number | null, target: number | null }, acc: { __typename?: 'RateChangeTableRowData', rate: number | null, target: number | null }, unacc: { __typename?: 'RateChangeTableRowData', rate: number | null, target: number | null } }, shoulder: { __typename?: 'RateChangeTableData', total: { __typename?: 'RateChangeTableRowData', rate: number | null, target: number | null }, acc: { __typename?: 'RateChangeTableRowData', rate: number | null, target: number | null }, unacc: { __typename?: 'RateChangeTableRowData', rate: number | null, target: number | null } }, offPeak: { __typename?: 'RateChangeTableData', total: { __typename?: 'RateChangeTableRowData', rate: number | null, target: number | null }, acc: { __typename?: 'RateChangeTableRowData', rate: number | null, target: number | null }, unacc: { __typename?: 'RateChangeTableRowData', rate: number | null, target: number | null } } } }, volumeChange: { __typename?: 'VolumeChangeData', charts: { __typename?: 'VolumeChangeAllChartsData', total: { __typename?: 'VolumeChangeChartData', expectedVolume: { __typename?: 'VolumeChangeChartRowData', acc: number | null, unacc: number | null }, lastYearVolume: { __typename?: 'VolumeChangeChartRowData', acc: number | null, unacc: number | null } }, peak: { __typename?: 'VolumeChangeChartData', expectedVolume: { __typename?: 'VolumeChangeChartRowData', acc: number | null, unacc: number | null }, lastYearVolume: { __typename?: 'VolumeChangeChartRowData', acc: number | null, unacc: number | null } }, shoulder: { __typename?: 'VolumeChangeChartData', expectedVolume: { __typename?: 'VolumeChangeChartRowData', acc: number | null, unacc: number | null }, lastYearVolume: { __typename?: 'VolumeChangeChartRowData', acc: number | null, unacc: number | null } }, offPeak: { __typename?: 'VolumeChangeChartData', expectedVolume: { __typename?: 'VolumeChangeChartRowData', acc: number | null, unacc: number | null }, lastYearVolume: { __typename?: 'VolumeChangeChartRowData', acc: number | null, unacc: number | null } } }, tables: { __typename?: 'VolumeChangeAllTablesData', total: { __typename?: 'VolumeChangeTableData', acc: { __typename?: 'VolumeChangeTableRowData', diff: number | null, expected: number | null, lastYear: number | null }, total: { __typename?: 'VolumeChangeTableRowData', diff: number | null, expected: number | null, lastYear: number | null }, unacc: { __typename?: 'VolumeChangeTableRowData', diff: number | null, expected: number | null, lastYear: number | null } }, peak: { __typename?: 'VolumeChangeTableData', acc: { __typename?: 'VolumeChangeTableRowData', diff: number | null, expected: number | null, lastYear: number | null }, total: { __typename?: 'VolumeChangeTableRowData', diff: number | null, expected: number | null, lastYear: number | null }, unacc: { __typename?: 'VolumeChangeTableRowData', diff: number | null, expected: number | null, lastYear: number | null } }, shoulder: { __typename?: 'VolumeChangeTableData', acc: { __typename?: 'VolumeChangeTableRowData', diff: number | null, expected: number | null, lastYear: number | null }, total: { __typename?: 'VolumeChangeTableRowData', diff: number | null, expected: number | null, lastYear: number | null }, unacc: { __typename?: 'VolumeChangeTableRowData', diff: number | null, expected: number | null, lastYear: number | null } }, offPeak: { __typename?: 'VolumeChangeTableData', acc: { __typename?: 'VolumeChangeTableRowData', diff: number | null, expected: number | null, lastYear: number | null }, total: { __typename?: 'VolumeChangeTableRowData', diff: number | null, expected: number | null, lastYear: number | null }, unacc: { __typename?: 'VolumeChangeTableRowData', diff: number | null, expected: number | null, lastYear: number | null } } } } }, threeYearsAverageMeterPrices: { __typename?: 'AverageMeterPricesData', averageMeterPriceRequestedYear: number | null, averageMeterPriceRequestedYearMinus1: number | null, averageMeterPriceRequestedYearMinus2: number | null, averageMeterPriceDiffInPercentFromPreviousYear: number | null, averageMeterPriceDiffInPercentFromPreviousYearMinus1: number | null, averageMeterPriceDiffInPercentFromPreviousYearMinus2: number | null } } } };

export type UseSalesRegionListQueryVariables = Exact<{
  filterOptions: StatisticsSearchSalesRegionListByFilterOptions;
}>;


export type UseSalesRegionListQuery = { __typename?: 'Query', statistics: { __typename?: 'StatisticsSearchRoot', salesRegionList: { __typename?: 'StatisticsSalesRegionListSearchRoot', byFilter: { __typename?: 'StatisticsSearchSalesRegionListByFilterResult', items: Array<{ __typename?: 'StatisticsBySalesRegionListItem', salesRegion: { __typename?: 'SalesRegion', id: string, code: string, name: string }, negotiationStatusStatistics: { __typename?: 'NegotiationStatusStatisticsItem', accounts: number, statistics: Array<{ __typename?: 'StatisticsForNegotiationStatus', negotiationStatus: { __typename?: 'NegotiationStatus', id: string, name: string }, numberVolumeStatistics: { __typename?: 'NumberVolumeStatisticsItem', percentageOfAccount: number, percentageOfVolume: number } }> } }> } } } };

export type UseSalesRegionListVolumeAndTargetQueryVariables = Exact<{
  filterOptions: StatisticsSearchSalesRegionListVolumeAndTargetByFilterOptions;
}>;


export type UseSalesRegionListVolumeAndTargetQuery = { __typename?: 'Query', statistics: { __typename?: 'StatisticsSearchRoot', salesRegionList: { __typename?: 'StatisticsSalesRegionListSearchRoot', volumeAndTarget: { __typename?: 'StatisticsSearchSalesRegionListVolumeAndTargetByFilterResult', items: Array<{ __typename?: 'StatisticsBySalesRegionListVolumeAndTargetItem', salesRegion: { __typename?: 'SalesRegion', id: string }, volumeAndTargetForSelected: { __typename?: 'VolumeAndTargetForSelected', averageNegotiationRate: number | null, averageTarget: number | null, avgMeterPrice: number | null, avgMeterPriceDiffInPercent: number | null, expectedVolume: number | null, lastYearVolume: number, volume: number } }> } } } };

export type SellerDetailsSummaryQueryVariables = Exact<{
  sellerId: Scalars['ID']['input'];
  year: Scalars['Int']['input'];
}>;


export type SellerDetailsSummaryQuery = { __typename?: 'Query', statistics: { __typename?: 'StatisticsSearchRoot', sellerDetails: { __typename?: 'StatisticsSellerDetailsSearchRoot', summary: { __typename?: 'StatisticsDetailsSummaryResult', byVolume: { __typename?: 'StatisticsSummaryPieChart', total: number, items: Array<{ __typename?: 'NumPerNegotiationStatus', num: number | null, negotiationStatus: { __typename?: 'NegotiationStatus', id: string, name: string } }> }, byNumber: { __typename?: 'StatisticsSummaryPieChart', total: number, items: Array<{ __typename?: 'NumPerNegotiationStatus', num: number | null, negotiationStatus: { __typename?: 'NegotiationStatus', id: string, name: string } }> } } } } };

export type UseSellerDetailsVolumeAndRatesQueryVariables = Exact<{
  sellerId: Scalars['ID']['input'];
  currencyCode: Scalars['String']['input'];
  negotiationStatuses: Array<NegotiationStatusCode> | NegotiationStatusCode;
  year: Scalars['Int']['input'];
}>;


export type UseSellerDetailsVolumeAndRatesQuery = { __typename?: 'Query', statistics: { __typename?: 'StatisticsSearchRoot', sellerDetails: { __typename?: 'StatisticsSellerDetailsSearchRoot', volumeAndRates: { __typename?: 'StatisticsDetailsVolumeAndRatesResult', rateChange: { __typename?: 'RateChangeData', charts: { __typename?: 'RateChangeAllChartsData', total: { __typename?: 'RateChangeChartData', averageRateChange: number | null, averageTarget: number | null }, peak: { __typename?: 'RateChangeChartData', averageRateChange: number | null, averageTarget: number | null }, shoulder: { __typename?: 'RateChangeChartData', averageRateChange: number | null, averageTarget: number | null }, offPeak: { __typename?: 'RateChangeChartData', averageRateChange: number | null, averageTarget: number | null } }, tables: { __typename?: 'RateChangeAllTablesData', total: { __typename?: 'RateChangeTableData', total: { __typename?: 'RateChangeTableRowData', rate: number | null, target: number | null }, acc: { __typename?: 'RateChangeTableRowData', rate: number | null, target: number | null }, unacc: { __typename?: 'RateChangeTableRowData', rate: number | null, target: number | null } }, peak: { __typename?: 'RateChangeTableData', total: { __typename?: 'RateChangeTableRowData', rate: number | null, target: number | null }, acc: { __typename?: 'RateChangeTableRowData', rate: number | null, target: number | null }, unacc: { __typename?: 'RateChangeTableRowData', rate: number | null, target: number | null } }, shoulder: { __typename?: 'RateChangeTableData', total: { __typename?: 'RateChangeTableRowData', rate: number | null, target: number | null }, acc: { __typename?: 'RateChangeTableRowData', rate: number | null, target: number | null }, unacc: { __typename?: 'RateChangeTableRowData', rate: number | null, target: number | null } }, offPeak: { __typename?: 'RateChangeTableData', total: { __typename?: 'RateChangeTableRowData', rate: number | null, target: number | null }, acc: { __typename?: 'RateChangeTableRowData', rate: number | null, target: number | null }, unacc: { __typename?: 'RateChangeTableRowData', rate: number | null, target: number | null } } } }, volumeChange: { __typename?: 'VolumeChangeData', charts: { __typename?: 'VolumeChangeAllChartsData', total: { __typename?: 'VolumeChangeChartData', expectedVolume: { __typename?: 'VolumeChangeChartRowData', acc: number | null, unacc: number | null }, lastYearVolume: { __typename?: 'VolumeChangeChartRowData', acc: number | null, unacc: number | null } }, peak: { __typename?: 'VolumeChangeChartData', expectedVolume: { __typename?: 'VolumeChangeChartRowData', acc: number | null, unacc: number | null }, lastYearVolume: { __typename?: 'VolumeChangeChartRowData', acc: number | null, unacc: number | null } }, shoulder: { __typename?: 'VolumeChangeChartData', expectedVolume: { __typename?: 'VolumeChangeChartRowData', acc: number | null, unacc: number | null }, lastYearVolume: { __typename?: 'VolumeChangeChartRowData', acc: number | null, unacc: number | null } }, offPeak: { __typename?: 'VolumeChangeChartData', expectedVolume: { __typename?: 'VolumeChangeChartRowData', acc: number | null, unacc: number | null }, lastYearVolume: { __typename?: 'VolumeChangeChartRowData', acc: number | null, unacc: number | null } } }, tables: { __typename?: 'VolumeChangeAllTablesData', total: { __typename?: 'VolumeChangeTableData', acc: { __typename?: 'VolumeChangeTableRowData', diff: number | null, expected: number | null, lastYear: number | null }, total: { __typename?: 'VolumeChangeTableRowData', diff: number | null, expected: number | null, lastYear: number | null }, unacc: { __typename?: 'VolumeChangeTableRowData', diff: number | null, expected: number | null, lastYear: number | null } }, peak: { __typename?: 'VolumeChangeTableData', acc: { __typename?: 'VolumeChangeTableRowData', diff: number | null, expected: number | null, lastYear: number | null }, total: { __typename?: 'VolumeChangeTableRowData', diff: number | null, expected: number | null, lastYear: number | null }, unacc: { __typename?: 'VolumeChangeTableRowData', diff: number | null, expected: number | null, lastYear: number | null } }, shoulder: { __typename?: 'VolumeChangeTableData', acc: { __typename?: 'VolumeChangeTableRowData', diff: number | null, expected: number | null, lastYear: number | null }, total: { __typename?: 'VolumeChangeTableRowData', diff: number | null, expected: number | null, lastYear: number | null }, unacc: { __typename?: 'VolumeChangeTableRowData', diff: number | null, expected: number | null, lastYear: number | null } }, offPeak: { __typename?: 'VolumeChangeTableData', acc: { __typename?: 'VolumeChangeTableRowData', diff: number | null, expected: number | null, lastYear: number | null }, total: { __typename?: 'VolumeChangeTableRowData', diff: number | null, expected: number | null, lastYear: number | null }, unacc: { __typename?: 'VolumeChangeTableRowData', diff: number | null, expected: number | null, lastYear: number | null } } } } }, threeYearsAverageMeterPrices: { __typename?: 'AverageMeterPricesData', averageMeterPriceRequestedYear: number | null, averageMeterPriceRequestedYearMinus1: number | null, averageMeterPriceRequestedYearMinus2: number | null, averageMeterPriceDiffInPercentFromPreviousYear: number | null, averageMeterPriceDiffInPercentFromPreviousYearMinus1: number | null, averageMeterPriceDiffInPercentFromPreviousYearMinus2: number | null } } } };

export type SellerListItemsFragment = { __typename?: 'StatisticsBySellerListItem', seller: { __typename?: 'User', id: string, name: string }, negotiationStatusStatistics: { __typename?: 'NegotiationStatusStatisticsItem', accounts: number, statistics: Array<{ __typename?: 'StatisticsForNegotiationStatus', negotiationStatus: { __typename?: 'NegotiationStatus', id: string, name: string }, numberVolumeStatistics: { __typename?: 'NumberVolumeStatisticsItem', percentageOfAccount: number, percentageOfVolume: number } }> } };

export type SellerListQueryVariables = Exact<{
  filterOptions: StatisticsSearchSellerListByFilterOptions;
}>;


export type SellerListQuery = { __typename?: 'Query', statistics: { __typename?: 'StatisticsSearchRoot', sellerList: { __typename?: 'StatisticsSellerListSearchRoot', byFilter: { __typename?: 'StatisticsSearchSellerListByFilterResult', items: Array<{ __typename?: 'StatisticsBySellerListItem', seller: { __typename?: 'User', id: string, name: string }, negotiationStatusStatistics: { __typename?: 'NegotiationStatusStatisticsItem', accounts: number, statistics: Array<{ __typename?: 'StatisticsForNegotiationStatus', negotiationStatus: { __typename?: 'NegotiationStatus', id: string, name: string }, numberVolumeStatistics: { __typename?: 'NumberVolumeStatisticsItem', percentageOfAccount: number, percentageOfVolume: number } }> } }> } } } };

export type UseAdvancedStatisticsDataListQueryVariables = Exact<{
  byFilterFilterOptions: StatisticsSearchAdvancedListByFilterOptions;
}>;


export type UseAdvancedStatisticsDataListQuery = { __typename?: 'Query', statistics: { __typename?: 'StatisticsSearchRoot', advancedList: { __typename?: 'StatisticsAdvancedListSearchRoot', byFilter: { __typename?: 'StatisticsSearchAdvancedListByFilterResult', items: Array<{ __typename?: 'StatisticsByAdvancedListItem', customerName: string, id: string, negotiationStatus: string | null, custNo: number, custIndex: string | null, statNo: number | null, parentNo: number | null, seller: string | null, routePairCode: string | null, sailingCategoryCode: string | null, unitCategoryCode: string | null, last12MonthVol: number, last12MonthStatVol: number | null, avgGrossMeterPrice: number | null, avgNetMeterPrice: number | null, expectedVol: number | null, targetInPercent: number | null, actualOutcomeInPercent: number | null }> } } } };

export type TotalDetailsSummaryQueryVariables = Exact<{
  year: Scalars['Int']['input'];
}>;


export type TotalDetailsSummaryQuery = { __typename?: 'Query', statistics: { __typename?: 'StatisticsSearchRoot', totalDetails: { __typename?: 'StatisticsTotalDetailsSearchRoot', summary: { __typename?: 'StatisticsDetailsSummaryResult', byVolume: { __typename?: 'StatisticsSummaryPieChart', total: number, items: Array<{ __typename?: 'NumPerNegotiationStatus', num: number | null, negotiationStatus: { __typename?: 'NegotiationStatus', id: string, name: string } }> }, byNumber: { __typename?: 'StatisticsSummaryPieChart', total: number, items: Array<{ __typename?: 'NumPerNegotiationStatus', num: number | null, negotiationStatus: { __typename?: 'NegotiationStatus', id: string, name: string } }> } } } } };

export type TotalDetailsVolumeAndRatesQueryVariables = Exact<{
  negotiationStatuses: Array<NegotiationStatusCode> | NegotiationStatusCode;
  year: Scalars['Int']['input'];
  currencyCode: Scalars['String']['input'];
}>;


export type TotalDetailsVolumeAndRatesQuery = { __typename?: 'Query', statistics: { __typename?: 'StatisticsSearchRoot', totalDetails: { __typename?: 'StatisticsTotalDetailsSearchRoot', volumeAndRates: { __typename?: 'StatisticsDetailsVolumeAndRatesResult', rateChange: { __typename?: 'RateChangeData', charts: { __typename?: 'RateChangeAllChartsData', total: { __typename?: 'RateChangeChartData', averageRateChange: number | null, averageTarget: number | null }, peak: { __typename?: 'RateChangeChartData', averageRateChange: number | null, averageTarget: number | null }, shoulder: { __typename?: 'RateChangeChartData', averageRateChange: number | null, averageTarget: number | null }, offPeak: { __typename?: 'RateChangeChartData', averageRateChange: number | null, averageTarget: number | null } }, tables: { __typename?: 'RateChangeAllTablesData', total: { __typename?: 'RateChangeTableData', total: { __typename?: 'RateChangeTableRowData', rate: number | null, target: number | null }, acc: { __typename?: 'RateChangeTableRowData', rate: number | null, target: number | null }, unacc: { __typename?: 'RateChangeTableRowData', rate: number | null, target: number | null } }, peak: { __typename?: 'RateChangeTableData', total: { __typename?: 'RateChangeTableRowData', rate: number | null, target: number | null }, acc: { __typename?: 'RateChangeTableRowData', rate: number | null, target: number | null }, unacc: { __typename?: 'RateChangeTableRowData', rate: number | null, target: number | null } }, shoulder: { __typename?: 'RateChangeTableData', total: { __typename?: 'RateChangeTableRowData', rate: number | null, target: number | null }, acc: { __typename?: 'RateChangeTableRowData', rate: number | null, target: number | null }, unacc: { __typename?: 'RateChangeTableRowData', rate: number | null, target: number | null } }, offPeak: { __typename?: 'RateChangeTableData', total: { __typename?: 'RateChangeTableRowData', rate: number | null, target: number | null }, acc: { __typename?: 'RateChangeTableRowData', rate: number | null, target: number | null }, unacc: { __typename?: 'RateChangeTableRowData', rate: number | null, target: number | null } } } }, volumeChange: { __typename?: 'VolumeChangeData', charts: { __typename?: 'VolumeChangeAllChartsData', total: { __typename?: 'VolumeChangeChartData', expectedVolume: { __typename?: 'VolumeChangeChartRowData', acc: number | null, unacc: number | null }, lastYearVolume: { __typename?: 'VolumeChangeChartRowData', acc: number | null, unacc: number | null } }, peak: { __typename?: 'VolumeChangeChartData', expectedVolume: { __typename?: 'VolumeChangeChartRowData', acc: number | null, unacc: number | null }, lastYearVolume: { __typename?: 'VolumeChangeChartRowData', acc: number | null, unacc: number | null } }, shoulder: { __typename?: 'VolumeChangeChartData', expectedVolume: { __typename?: 'VolumeChangeChartRowData', acc: number | null, unacc: number | null }, lastYearVolume: { __typename?: 'VolumeChangeChartRowData', acc: number | null, unacc: number | null } }, offPeak: { __typename?: 'VolumeChangeChartData', expectedVolume: { __typename?: 'VolumeChangeChartRowData', acc: number | null, unacc: number | null }, lastYearVolume: { __typename?: 'VolumeChangeChartRowData', acc: number | null, unacc: number | null } } }, tables: { __typename?: 'VolumeChangeAllTablesData', total: { __typename?: 'VolumeChangeTableData', acc: { __typename?: 'VolumeChangeTableRowData', diff: number | null, expected: number | null, lastYear: number | null }, total: { __typename?: 'VolumeChangeTableRowData', diff: number | null, expected: number | null, lastYear: number | null }, unacc: { __typename?: 'VolumeChangeTableRowData', diff: number | null, expected: number | null, lastYear: number | null } }, peak: { __typename?: 'VolumeChangeTableData', acc: { __typename?: 'VolumeChangeTableRowData', diff: number | null, expected: number | null, lastYear: number | null }, total: { __typename?: 'VolumeChangeTableRowData', diff: number | null, expected: number | null, lastYear: number | null }, unacc: { __typename?: 'VolumeChangeTableRowData', diff: number | null, expected: number | null, lastYear: number | null } }, shoulder: { __typename?: 'VolumeChangeTableData', acc: { __typename?: 'VolumeChangeTableRowData', diff: number | null, expected: number | null, lastYear: number | null }, total: { __typename?: 'VolumeChangeTableRowData', diff: number | null, expected: number | null, lastYear: number | null }, unacc: { __typename?: 'VolumeChangeTableRowData', diff: number | null, expected: number | null, lastYear: number | null } }, offPeak: { __typename?: 'VolumeChangeTableData', acc: { __typename?: 'VolumeChangeTableRowData', diff: number | null, expected: number | null, lastYear: number | null }, total: { __typename?: 'VolumeChangeTableRowData', diff: number | null, expected: number | null, lastYear: number | null }, unacc: { __typename?: 'VolumeChangeTableRowData', diff: number | null, expected: number | null, lastYear: number | null } } } } }, threeYearsAverageMeterPrices: { __typename?: 'AverageMeterPricesData', averageMeterPriceRequestedYear: number | null, averageMeterPriceRequestedYearMinus1: number | null, averageMeterPriceRequestedYearMinus2: number | null, averageMeterPriceDiffInPercentFromPreviousYear: number | null, averageMeterPriceDiffInPercentFromPreviousYearMinus1: number | null, averageMeterPriceDiffInPercentFromPreviousYearMinus2: number | null } } } };

export type CustomerListForStatisticsQueryVariables = Exact<{
  filterOptions: StatisticsSearchCustomerListByFilterOptions;
}>;


export type CustomerListForStatisticsQuery = { __typename?: 'Query', statistics: { __typename?: 'StatisticsSearchRoot', customerList: { __typename?: 'StatisticsCustomerListSearchRoot', byFilter: { __typename?: 'StatisticsSearchCustomerListByFilterResult', items: Array<{ __typename?: 'StatisticsByCustomerListItem', customerName: string | null, customerNumber: number, negotiationStatus: string | null, parentNumber: number | null, sellerId: string | null, statNumber: number | null, volumeAndTargetForSelected: { __typename?: 'VolumeAndTargetForSelected', averageNegotiationRate: number | null, averageTarget: number | null, avgMeterPrice: number | null, avgMeterPriceDiffInPercent: number | null, expectedVolume: number | null, lastYearVolume: number } }> } } } };

export type AdminTargetQueryVariables = Exact<{
  byYearYear: Scalars['Int']['input'];
}>;


export type AdminTargetQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', targetAdmin: { __typename?: 'TargetAdminSearchRoot', byYear: Array<{ __typename?: 'AdminTarget', id: string, year: number, routePairCode: string, offPeakAcc: number | null, peakAcc: number | null, offPeakUnAcc: number | null, peakUnAcc: number | null, shoulderUnAcc: number | null, shoulderAcc: number | null, volumeTarget: number | null, routePair: { __typename?: 'RoutePair', id: string, description: string } }> } } };

export type AdminTargetAllRoutesMutationVariables = Exact<{
  updateGroupFreightTargetsInput: Array<UpdateGroupFreightTargetInput> | UpdateGroupFreightTargetInput;
}>;


export type AdminTargetAllRoutesMutation = { __typename?: 'Mutation', productPrice: { __typename?: 'ProductPriceMutationRoot', adminTarget: { __typename?: 'AdminTargetMutationRoot', updateGroupFreightTargets: { __typename?: 'UpdateGroupFreightTargetSuccessResult', updateTargets: Array<{ __typename?: 'UpdateGroupFreightTargetResult', id: string, routePairCode: string, year: number }> } } } };

export type RouteTargetRoutePairDescriptionQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RouteTargetRoutePairDescriptionQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', routePair: { __typename?: 'RoutePairSearchRoot', byId: { __typename?: 'RoutePair', id: string, description: string } | null } } };

export type FetchRoutePairCustomerTargetFragment = { __typename?: 'TargetRoutePair', id: string, year: number, routePairCode: string, customerName: string, seller: string, custNo: number, unitCategoryCode: UnitCategoryCode, statNo: number | null, statNetworkVolume: number | null, statRouteVolume: number | null, statRouteRowVolume: number | null, custNetworkVolume: number | null, custRouteVolume: number | null, custRouteRowVolume: number | null, avgGrossMeterPrice: number | null, avgNetMeterPrice: number | null, targetInPercent: number | null, customerCategory: { __typename?: 'CustomerCategory', code: string, description: string }, salesRegion: { __typename?: 'SalesRegion', id: string, code: string, shortName: string }, sailingCategory: { __typename?: 'SailingCategory', id: string, code: string, name: string }, customerCountry: { __typename?: 'Country', id: string, code: string, name: string } };

export type UpdateRoutePairCustomerTargetMutationVariables = Exact<{
  input: UpdateRoutePairCustomerTargetInput;
  filter: TargetRoutePairInput;
}>;


export type UpdateRoutePairCustomerTargetMutation = { __typename?: 'Mutation', productPrice: { __typename?: 'ProductPriceMutationRoot', routePairCustomerTarget: { __typename?: 'RoutePairCustomerTargetMutationRoot', updateRoutePairCustomerTargets: { __typename: 'ErrorResult', errors: Array<{ __typename?: 'ErrorDetail', message: string, path: string | null }> } | { __typename: 'RoutePairCustomerTargetSuccessResult', targetRoutePairs: Array<{ __typename?: 'TargetRoutePair', id: string, year: number, routePairCode: string, customerName: string, seller: string, custNo: number, unitCategoryCode: UnitCategoryCode, statNo: number | null, statNetworkVolume: number | null, statRouteVolume: number | null, statRouteRowVolume: number | null, custNetworkVolume: number | null, custRouteVolume: number | null, custRouteRowVolume: number | null, avgGrossMeterPrice: number | null, avgNetMeterPrice: number | null, targetInPercent: number | null, customerCategory: { __typename?: 'CustomerCategory', code: string, description: string }, salesRegion: { __typename?: 'SalesRegion', id: string, code: string, shortName: string }, sailingCategory: { __typename?: 'SailingCategory', id: string, code: string, name: string }, customerCountry: { __typename?: 'Country', id: string, code: string, name: string } }> } } } };

export type CustomerDataPointsFragment = { __typename?: 'CustomerDataPoints', custNo: number, avgNetMeterPrice: number | null, avgGrossMeterPrice: number | null };

export type CategoryDataFragment = { __typename?: 'DetailedCategoryData', unitCategoryCode: string, sailingTypeCode: string, noOfAccounts: number, gmTarget: number | null, customerTarget: number | null, customerDataPoints: Array<{ __typename?: 'CustomerDataPoints', custNo: number, avgNetMeterPrice: number | null, avgGrossMeterPrice: number | null }> | null };

export type TargetSummaryQueryVariables = Exact<{
  byIdInput: InputMaybe<GetTargetSummaryInput>;
}>;


export type TargetSummaryQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', targetSummary: { __typename?: 'TargetSummarySearchRoot', byId: { __typename?: 'TargetSummary', noOfAccounts: number, volume: number | null, totalGmTarget: number | null, totalCustomerTarget: number | null, completionRate: number, categoryData: Array<{ __typename?: 'DetailedCategoryData', unitCategoryCode: string, sailingTypeCode: string, noOfAccounts: number, gmTarget: number | null, customerTarget: number | null, customerDataPoints: Array<{ __typename?: 'CustomerDataPoints', custNo: number, avgNetMeterPrice: number | null, avgGrossMeterPrice: number | null }> | null }> } | null } } };

export type RoutePairTargetQueryVariables = Exact<{
  filter: TargetRoutePairInput;
}>;


export type RoutePairTargetQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', targetRoutePair: { __typename?: 'TargetRoutePairSearchRoot', byFilter: { __typename?: 'TargetRoutePairSearchByFilterResult', items: Array<{ __typename?: 'TargetRoutePair', id: string, year: number, routePairCode: string, customerName: string, seller: string, custNo: number, unitCategoryCode: UnitCategoryCode, statNo: number | null, statNetworkVolume: number | null, statRouteVolume: number | null, statRouteRowVolume: number | null, custNetworkVolume: number | null, custRouteVolume: number | null, custRouteRowVolume: number | null, avgGrossMeterPrice: number | null, avgNetMeterPrice: number | null, targetInPercent: number | null, customerCategory: { __typename?: 'CustomerCategory', code: string, description: string }, salesRegion: { __typename?: 'SalesRegion', id: string, code: string, shortName: string }, sailingCategory: { __typename?: 'SailingCategory', id: string, code: string, name: string }, customerCountry: { __typename?: 'Country', id: string, code: string, name: string } }> } } } };

export type RoutePairNegYearStatusByRoutePairFragment = { __typename?: 'RoutePairNegotiationYear', id: string, status: string, volumeTarget: number | null, year: number, routePair: { __typename?: 'RoutePair', id: string, code: string } };

export type RoutePairNegotiationYearStatusQueryVariables = Exact<{
  routePairCode: Scalars['String']['input'];
  year: Scalars['Int']['input'];
}>;


export type RoutePairNegotiationYearStatusQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', routePairNegotiationYear: { __typename?: 'RoutePairNegotiationYearSearchRoot', byRoutePairAndYear: { __typename?: 'RoutePairNegotiationYear', id: string, status: string, volumeTarget: number | null, year: number, routePair: { __typename?: 'RoutePair', id: string, code: string } } | null } } };

export type SetTargetNegotiationStatusMutationVariables = Exact<{
  input: SetTargetNegotiationStatusInput;
}>;


export type SetTargetNegotiationStatusMutation = { __typename?: 'Mutation', productPrice: { __typename: 'ProductPriceMutationRoot', targetOverview: { __typename: 'TargetOverviewMutationRoot', setTargetNegotiationStatus: { __typename: 'SetTargetNegotiationStatusResult', targetOverview: { __typename: 'TargetOverview', id: string, negotiationStatus: { __typename: 'TargetNegotiationStatus', id: string, code: string, description: string } | null } } } } };

export type TargetOverviewByYearFragment = { __typename?: 'TargetOverview', id: string, completionRate: number, last12MonthVol: number, noOfAccounts: number, routePairCode: string, volumeTargetGm: number | null, weightedTargetCustomer: number | null, weightedTargetGm: number | null, negotiationStatus: { __typename?: 'TargetNegotiationStatus', code: string, description: string } | null, routePair: { __typename?: 'RoutePair', id: string, description: string } };

export type UseTargetOverviewsQueryVariables = Exact<{
  year: Scalars['Int']['input'];
}>;


export type UseTargetOverviewsQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', targetOverviews: { __typename?: 'TargetOverviewSearchRoot', byYear: Array<{ __typename?: 'TargetOverview', id: string, completionRate: number, last12MonthVol: number, noOfAccounts: number, routePairCode: string, volumeTargetGm: number | null, weightedTargetCustomer: number | null, weightedTargetGm: number | null, negotiationStatus: { __typename?: 'TargetNegotiationStatus', code: string, description: string } | null, routePair: { __typename?: 'RoutePair', id: string, description: string } }> } } };

export type ErrorFragmentFragment = { __typename?: 'ErrorResult', errors: Array<{ __typename?: 'ErrorDetail', message: string, path: string | null }> };

export type UseAllFormulaTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type UseAllFormulaTypesQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', formula: { __typename?: 'FormulaSearchRoot', all: Array<{ __typename?: 'FormulaType', code: string, id: string, description: Array<string>, includes: { __typename?: 'FormulaTypeIncludes', drivers: boolean | null, interval1PercentValue: boolean | null, interval2PercentValue: boolean | null, interval3PercentValue: boolean | null, interval4PercentValue: boolean | null, intervalAPercentValue: boolean | null, intervalBPercentValue: boolean | null, intervalCPercentValue: boolean | null, intervalDPercentValue: boolean | null, intervalLength: boolean | null, maxPercent: boolean | null, percent: boolean | null, weight: boolean | null, width: boolean | null } }> } } };

export type CustomerHeaderCustomersByIdFragment = { __typename?: 'Customer', id: string, name: string, breadCrumbName: string, custIndex: string, custNo: number, isParent: boolean, isStandardCustomer: boolean, hasRebateAgreements: boolean | null, custStatus: { __typename?: 'CustomerStatus', id: string, name: string } | null, parent: { __typename?: 'Customer', id: string, preselectedHeadAgreement: { __typename?: 'HeadAgreement', id: string } | null } | null, childCustomers: Array<{ __typename?: 'Customer', id: string }>, statisticalGrouping: { __typename?: 'Customer', id: string } | null, negotiationStatusByYear: { __typename?: 'NegotiationStatus', id: string, name: string } | null, invoiceCurrency: { __typename?: 'Currency', id: string, code: string }, seller: { __typename?: 'User', id: string, name: string }, salesRegion: { __typename?: 'SalesRegion', id: string, code: string, name: string }, writeHistory: { __typename?: 'WriteHistory', createdAt: { __typename?: 'DateTime', isoString: string }, createdBy: { __typename?: 'User', id: string, name: string }, modifiedAt: { __typename?: 'DateTime', isoString: string } | null, modifiedBy: { __typename?: 'User', id: string, name: string } | null } };

export type CustomerHeaderQueryVariables = Exact<{
  customerId: Scalars['ID']['input'];
  year: Scalars['Int']['input'];
}>;


export type CustomerHeaderQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', customers: { __typename?: 'CustomerSearchRoot', byId: { __typename?: 'Customer', id: string, name: string, breadCrumbName: string, custIndex: string, custNo: number, isParent: boolean, isStandardCustomer: boolean, hasRebateAgreements: boolean | null, custStatus: { __typename?: 'CustomerStatus', id: string, name: string } | null, parent: { __typename?: 'Customer', id: string, preselectedHeadAgreement: { __typename?: 'HeadAgreement', id: string } | null } | null, childCustomers: Array<{ __typename?: 'Customer', id: string }>, statisticalGrouping: { __typename?: 'Customer', id: string } | null, negotiationStatusByYear: { __typename?: 'NegotiationStatus', id: string, name: string } | null, invoiceCurrency: { __typename?: 'Currency', id: string, code: string }, seller: { __typename?: 'User', id: string, name: string }, salesRegion: { __typename?: 'SalesRegion', id: string, code: string, name: string }, writeHistory: { __typename?: 'WriteHistory', createdAt: { __typename?: 'DateTime', isoString: string }, createdBy: { __typename?: 'User', id: string, name: string }, modifiedAt: { __typename?: 'DateTime', isoString: string } | null, modifiedBy: { __typename?: 'User', id: string, name: string } | null } } | null } } };

export type AvailableYearFragment = { __typename?: 'NegotiationYear', id: string, year: number };

export type DefaultNegotiationYearSelectQueryVariables = Exact<{ [key: string]: never; }>;


export type DefaultNegotiationYearSelectQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', negotiationYear: { __typename?: 'NegotiationYearSearchRoot', availableYears: Array<{ __typename?: 'NegotiationYear', id: string, year: number }> } } };

export type AvailableYearsFragment = { __typename?: 'NegotiationYear', id: string, year: number };

export type ProfileNegotiationYearSelectQueryVariables = Exact<{ [key: string]: never; }>;


export type ProfileNegotiationYearSelectQuery = { __typename?: 'Query', productPrice: { __typename?: 'ProductPriceSearchRoot', negotiationYear: { __typename?: 'NegotiationYearSearchRoot', availableYears: Array<{ __typename?: 'NegotiationYear', id: string, year: number }> } } };
